import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: string; output: string; }
  /**
   * Datetime scalar with 3 decimals of microsecond precision fixed at 0.
   * e.g. datetime         -> "2019-07-15T04:36:57Z"
   *      precise_datetime -> "2019-07-15T04:36:57.000Z"
   */
  PreciseDateTime: { input: string; output: string; }
  /** Enum of "FINAL" or "DRAFT". */
  ReleaseType: { input: any; output: any; }
};

export type AccessCode = {
  __typename?: 'AccessCode';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
};

export type AccessCodeInput = {
  active: Scalars['Boolean']['input'];
  code: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Access group for a question */
export enum AccessGroup {
  Restricted = 'RESTRICTED',
  Subject = 'SUBJECT',
  University = 'UNIVERSITY'
}

/** Access role for a question */
export enum AccessRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/**
 * Gradebook result access summary describing the last access to a unique
 * external service via the result.
 */
export type AccessSummary = {
  __typename?: 'AccessSummary';
  accessCount: Scalars['Int']['output'];
  lastAccess: Scalars['PreciseDateTime']['output'];
  service: GradebookService;
};

export type AddQuestionBanksToAssessmentInput = {
  filter: QuestionBankFilterInput;
  questionBankNodes: Array<QuestionBankNodes>;
};

/** A representation of an answer to a question block */
export type AnswerBlock = {
  __typename?: 'AnswerBlock';
  /** Attachments to this answer block */
  blockAttachments: Array<BlockAttachment>;
  /** Special Block name, used for naming classic editor blocks. */
  blockName: Maybe<Scalars['String']['output']>;
  /** Bookmarked by the student. */
  bookmark: Maybe<Scalars['Boolean']['output']>;
  /** Explicit student confirmation on completed attempt */
  confirm: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latestBlockSnapshot: Maybe<BlockSnapshot>;
  /** Tree layout node ID for the block */
  nodeId: Scalars['ID']['output'];
  /** Numeric ordering */
  order: Maybe<Scalars['Int']['output']>;
  /** Labelled ordering */
  orderLabel: Maybe<Scalars['String']['output']>;
  /** Tree layout parent node ID for this block */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  /** Points alloted to this answer. */
  points: Maybe<Scalars['Int']['output']>;
  /** Tree layout previous node ID for this block */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  /** Question being answered by the Answer block */
  question: Maybe<Question>;
  /** Question ID that this Answer is answering */
  questionId: Maybe<Scalars['ID']['output']>;
  /** Shuffle answer options */
  shuffle: Maybe<Scalars['Boolean']['output']>;
  /** Skipped by the student. */
  skip: Maybe<Scalars['Boolean']['output']>;
};

/** API status information */
export type ApiStatusType = {
  __typename?: 'ApiStatusType';
  hasBrightspaceApi: Scalars['Boolean']['output'];
  hasCanvasApi: Scalars['Boolean']['output'];
};

/**
 * A Cadmus Assessment
 *
 * Contains information available to all roles. Wraps some Subject information
 * and the latest Instruction sheet.
 */
export type Assessment = {
  __typename?: 'Assessment';
  /** Submission due date for on-time submissions, set in the LMS. */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Assessment cut-off date, set in the LMS. */
  endDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Grading reminder date, set in the LMS. */
  gradingDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Predicate checking if at least 1 save has been made in the Assessment. */
  hasSave: Scalars['Boolean']['output'];
  /** Predicate checking if at least 1 submission has been made in the Assessment. */
  hasSubmission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** LTI Custom Parameters from source LMS. */
  ltiCustomParams: Maybe<CustomParams>;
  /** All the LTI 1.1 and 1.3 services recorded for this Assessment. */
  ltiServices: Array<LtiService>;
  /** Institutions LMS Tool Provider used to launch this Assessment. */
  ltiTool: InstitutionTool;
  name: Scalars['String']['output'];
  /** Assessment wide settings. */
  settings: Maybe<AssessmentSettings>;
  /** Assessment submission start date set in the LMS. */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  subject: Subject;
  subjectId: Scalars['ID']['output'];
  /** @deprecated Use the subject name from subject.name instead */
  subjectName: Scalars['String']['output'];
};


/**
 * A Cadmus Assessment
 *
 * Contains information available to all roles. Wraps some Subject information
 * and the latest Instruction sheet.
 */
export type AssessmentSubjectArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};

/** Settings for an Assessment */
export type AssessmentSettings = {
  __typename?: 'AssessmentSettings';
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  assessmentType: AssessmentType;
  countFootnotes: Scalars['Boolean']['output'];
  countReferences: Scalars['Boolean']['output'];
  doubleBlindMarkingEnabled: Scalars['Boolean']['output'];
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  draftEnabled: Scalars['Boolean']['output'];
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examAccessCodeEnabled: Scalars['Boolean']['output'];
  examAutoSubmissionDisabled: Scalars['Boolean']['output'];
  examBacktrackDisabled: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examLdbEnabled: Scalars['Boolean']['output'];
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examReadingTimeDisabled: Scalars['Boolean']['output'];
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  feedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  feedbackDateDisabled: Scalars['Boolean']['output'];
  groupAssessmentEnabled: Scalars['Boolean']['output'];
  groupCharterDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  groupCharterEnabled: Scalars['Boolean']['output'];
  groupDraftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  groupDraftEnabled: Scalars['Boolean']['output'];
  groupFinalised: Scalars['Boolean']['output'];
  groupHideMembersName: Scalars['Boolean']['output'];
  groupReportMaxGrade: Maybe<Scalars['Int']['output']>;
  groupReportWeight: Maybe<Scalars['Int']['output']>;
  groupSelfEnrollmentDeadline: Maybe<Scalars['PreciseDateTime']['output']>;
  groupSelfEnrollmentEnabled: Scalars['Boolean']['output'];
  groupWorkAttachmentEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  individualReportDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  individualReportEnabled: Scalars['Boolean']['output'];
  individualReportMaxGrade: Maybe<Scalars['Int']['output']>;
  individualReportWeight: Maybe<Scalars['Int']['output']>;
  individualWorkAttachmentEnabled: Scalars['Boolean']['output'];
  lateResubmissionEnabled: Scalars['Boolean']['output'];
  /** @deprecated Use `late_submission_time_limit` instead */
  lateResubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  markingAclEnabled: Scalars['Boolean']['output'];
  markingTool: Maybe<MarkingTool>;
  markingToolPdf: Maybe<MarkingToolPdf>;
  maxGrade: Scalars['Int']['output'];
  openDate: Maybe<Scalars['PreciseDateTime']['output']>;
  peerEvaluationDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  peerEvaluationEnabled: Scalars['Boolean']['output'];
  peerEvaluationMaxGrade: Maybe<Scalars['Int']['output']>;
  peerEvaluationWeight: Maybe<Scalars['Int']['output']>;
  referencingStyle: Maybe<Scalars['String']['output']>;
  referencingStyleEnabled: Scalars['Boolean']['output'];
  releaseDate: Maybe<Scalars['PreciseDateTime']['output']>;
  restrictMarkingToolPdf: Scalars['Boolean']['output'];
  selfEvaluationEnabled: Scalars['Boolean']['output'];
  selfEvaluationMaxGrade: Maybe<Scalars['Int']['output']>;
  selfEvaluationWeight: Maybe<Scalars['Int']['output']>;
  sentimentCheckEnabled: Scalars['Boolean']['output'];
  sentimentCheckIntervalInHr: Maybe<Scalars['Int']['output']>;
  smartAutomarkingEnabled: Scalars['Boolean']['output'];
  spellCheckDisabled: Scalars['Boolean']['output'];
  /** @deprecated Use `openDate` instead */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  submissionPdfDisabled: Scalars['Boolean']['output'];
  tiiDraftSViewReports: Scalars['Int']['output'];
  tiiSViewReports: Scalars['Int']['output'];
  timeLimit: Maybe<Scalars['Int']['output']>;
  timeLimitEnabled: Scalars['Boolean']['output'];
  weight: Maybe<Scalars['Float']['output']>;
  weightEnabled: Scalars['Boolean']['output'];
  wordLimit: Maybe<Scalars['Int']['output']>;
  wordLimitEnabled: Scalars['Boolean']['output'];
  wordLimitGroup: Maybe<Scalars['Int']['output']>;
};

export type AssessmentSettingsInput = {
  allowGenerativeAi?: InputMaybe<Scalars['Boolean']['input']>;
  anonymousMarking?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentType?: InputMaybe<AssessmentType>;
  countFootnotes?: InputMaybe<Scalars['Boolean']['input']>;
  countReferences?: InputMaybe<Scalars['Boolean']['input']>;
  doubleBlindMarkingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  draftDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  draftEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examAccessCodeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examAutoSubmissionDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  examBacktrackDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examLdbEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  examReadingTime?: InputMaybe<Scalars['Int']['input']>;
  examReadingTimeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  examStartDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examTiming?: InputMaybe<ExamTiming>;
  examType?: InputMaybe<Array<Scalars['String']['input']>>;
  examWritingTime?: InputMaybe<Scalars['Int']['input']>;
  feedbackDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  feedbackDateDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupAssessmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupCharterDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupCharterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupDraftDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupDraftEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupFinalised?: InputMaybe<Scalars['Boolean']['input']>;
  groupHideMembersName?: InputMaybe<Scalars['Boolean']['input']>;
  groupReportWeight?: InputMaybe<Scalars['Int']['input']>;
  groupSelfEnrollmentDeadline?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  groupSelfEnrollmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupWorkAttachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualReportDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  individualReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualReportWeight?: InputMaybe<Scalars['Int']['input']>;
  individualWorkAttachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lateResubmissionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lateSubmissionTimeLimit?: InputMaybe<Scalars['Int']['input']>;
  markingAclEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  markingTool?: InputMaybe<MarkingTool>;
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  peerEvaluationDueDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  peerEvaluationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  peerEvaluationWeight?: InputMaybe<Scalars['Int']['input']>;
  referencingStyle?: InputMaybe<Scalars['String']['input']>;
  referencingStyleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  selfEvaluationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  selfEvaluationWeight?: InputMaybe<Scalars['Int']['input']>;
  sentimentCheckEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sentimentCheckIntervalInHr?: InputMaybe<Scalars['Int']['input']>;
  spellCheckDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  submissionPdfDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  tiiDraftSViewReports?: InputMaybe<Scalars['Int']['input']>;
  tiiSViewReports?: InputMaybe<Scalars['Int']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
  wordLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wordLimitGroup?: InputMaybe<Scalars['Int']['input']>;
};

/** Cadmus assessments can be assignments or exams. */
export enum AssessmentType {
  Assignment = 'ASSIGNMENT',
  Exam = 'EXAM'
}

/** Automarking status of the field outcome */
export enum AutomarkStatus {
  Complete = 'COMPLETE',
  Processing = 'PROCESSING'
}

/** A background job running in an Assessment. */
export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  id: Scalars['ID']['output'];
  kind: BackgroundJobKind;
  state: BackgroundJobState;
};

/** Known kinds of background jobs in an Assessment. */
export enum BackgroundJobKind {
  RosterSync = 'ROSTER_SYNC'
}

/** States of a background job. */
export enum BackgroundJobState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Discarded = 'DISCARDED',
  Executing = 'EXECUTING',
  Scheduled = 'SCHEDULED'
}

/** Base type of a response. Used to determine the type of response expected. */
export enum BaseType {
  Coords = 'coords',
  DirectedPair = 'directed_pair',
  Float = 'float',
  Identifier = 'identifier',
  Range = 'range',
  Record = 'record',
  String = 'string'
}

/** A single blank in a fill-in-the-blanks response. */
export type Blank = {
  __typename?: 'Blank';
  id: Scalars['String']['output'];
  phrases: Array<Scalars['String']['output']>;
};

export type BlanksInput = {
  id: Scalars['String']['input'];
  phrases: Array<Scalars['String']['input']>;
};

/** Response as a fill-in-the-blanks type. */
export type BlanksResponse = {
  __typename?: 'BlanksResponse';
  /** Whether the matching is case sensitive */
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  matchBlanks: Array<Blank>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
};

export type BlanksResponseInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  matchBlanks: Array<BlanksInput>;
  /** Between 0.0 and 1.0 inclusive. */
  matchSimilarity?: InputMaybe<Scalars['Float']['input']>;
};

/** Block Attachment associated with an AnswerBlock */
export type BlockAttachment = {
  __typename?: 'BlockAttachment';
  fileExtension: Maybe<Scalars['String']['output']>;
  fileSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  mediaUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** A snapshot of a block inside a work */
export type BlockSnapshot = {
  __typename?: 'BlockSnapshot';
  answerBlockId: Scalars['ID']['output'];
  /** Special Block name, used for naming classic editor blocks. */
  blockName: Maybe<Scalars['String']['output']>;
  /** Special ID for client side caching. Defaults to the actual ID */
  cacheId: Scalars['ID']['output'];
  /** Serialised Snapshot contents */
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

/** Response as a binary choice. */
export type BooleanResponse = {
  __typename?: 'BooleanResponse';
  isTrue: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanResponseInput = {
  isTrue: Scalars['Boolean']['input'];
};

/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApi = {
  __typename?: 'BrightspaceApi';
  /** Brightspace Provider authorization URL */
  authorizeUrl: Scalars['String']['output'];
  authorized: Scalars['Boolean']['output'];
  groups: Array<BrightspaceGroup>;
};


/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApiAuthorizeUrlArgs = {
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
  redirectTo: InputMaybe<Scalars['String']['input']>;
};


/**
 * Query namespace for invoking the Brightspace REST API operations via OAuth2
 * authorization.
 */
export type BrightspaceApiGroupsArgs = {
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
};

/**
 * Brightspace OrgUnit object, directly mapped from the Brightspace REST API.
 *
 * See https://docs.valence.desire2learn.com/res/orgunit.html.
 */
export type BrightspaceGroup = {
  __typename?: 'BrightspaceGroup';
  code: Maybe<Scalars['String']['output']>;
  /** Brightspace Group ID. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  students: Maybe<Array<BrightspaceUser>>;
  totalStudents: Scalars['Int']['output'];
};

export enum BrightspaceScopeKeyType {
  /** Default scope */
  Default = 'DEFAULT',
  /** scope for getting groups */
  GetGroups = 'GET_GROUPS'
}

/**
 * Brightspace User object, directly mapped from the Brightspace REST API.
 *
 * See https://docs.valence.desire2learn.com/res/user.html#User.
 */
export type BrightspaceUser = {
  __typename?: 'BrightspaceUser';
  /** Brightspace User ID. */
  id: Scalars['ID']['output'];
};

/** Return type for cancelRelease mutation. */
export type CancelReleasePayload = {
  __typename?: 'CancelReleasePayload';
  /** Latest state of the task. */
  task: Task;
};

/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApi = {
  __typename?: 'CanvasApi';
  /** Canvas Provider authorization URL */
  authorizeUrl: Scalars['String']['output'];
  authorized: Scalars['Boolean']['output'];
  sections: Array<CanvasSection>;
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiAuthorizeUrlArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
  redirectTo: InputMaybe<Scalars['String']['input']>;
};


/**
 * Query namespace for invoking the Canvas REST API operations via OAuth2
 * authorization.
 */
export type CanvasApiSectionsArgs = {
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
};

export enum CanvasScopeKeyType {
  /** Default scope */
  Default = 'DEFAULT',
  /** scope for getting assignment overrides */
  GetAssignmentOverrides = 'GET_ASSIGNMENT_OVERRIDES',
  /** scope for getting section */
  GetSections = 'GET_SECTIONS'
}

/**
 * Canvas Section object, directly mapped from the Canvas REST API.
 *
 * See https://canvas.instructure.com/doc/api/sections.html.
 */
export type CanvasSection = {
  __typename?: 'CanvasSection';
  courseId: Scalars['ID']['output'];
  /** Canvas Section ID. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sisCourseId: Maybe<Scalars['ID']['output']>;
  students: Maybe<Array<CanvasUser>>;
  totalStudents: Scalars['Int']['output'];
};

/**
 * Canvas User object, directly mapped from the Canvas REST API.
 *
 * See https://canvas.instructure.com/doc/api/users.html#User.
 */
export type CanvasUser = {
  __typename?: 'CanvasUser';
  /** Canvas User ID. */
  id: Scalars['ID']['output'];
  /** Canvas User full name. */
  name: Scalars['String']['output'];
  /** Canvas SIS User ID. */
  sisUserId: Maybe<Scalars['ID']['output']>;
};

/**
 * Cardinality of the expected response in a Question as defined in the QTI spec.
 *
 * A question can have a single, multiple, or requirement for an ordered correct
 * response expressed as its cardinality.
 */
export enum Cardinality {
  Multiple = 'multiple',
  Ordered = 'ordered',
  Single = 'single'
}

/** Charter for assessment group */
export type Charter = {
  __typename?: 'Charter';
  allMembersAccepted: Scalars['Boolean']['output'];
  editors: Array<CharterEditor>;
  feedbackThreads: Array<Thread>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  latestAgreement: Maybe<CharterAgreement>;
  milestones: Array<CharterMilestone>;
};

/** Charter agreements */
export type CharterAgreement = {
  __typename?: 'CharterAgreement';
  acceptedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  studentId: Scalars['String']['output'];
  unlockedAt: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Input for student's agreemeent to the charter,
 *   the `charter_id` is passed to identify the charter and
 *   the student's `id` is taken from the context
 */
export type CharterAgreementInput = {
  charterId: Scalars['ID']['input'];
};

/** Charter editor for students */
export type CharterEditor = {
  __typename?: 'CharterEditor';
  charterFormSectionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  snapshotDoc: Maybe<Scalars['String']['output']>;
  snapshotVersion: Maybe<Scalars['Int']['output']>;
  /** Stream Identifier for Editor */
  streamUuid: Scalars['String']['output'];
};

/**
 * Input to save the editor state by passing the `editor_id`
 *   and the `snapshot_doc` and `snapshot_version` at every save of the
 *   editor
 */
export type CharterEditorInput = {
  editorId: Scalars['ID']['input'];
  snapshotDoc: Scalars['String']['input'];
  snapshotVersion: Scalars['Int']['input'];
};

/** Charter Form created by the teacher for assessment */
export type CharterForm = {
  __typename?: 'CharterForm';
  editedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  publishTimestamp: Maybe<Scalars['DateTime']['output']>;
  published: Scalars['Boolean']['output'];
  sections: Array<CharterFormSection>;
};

export type CharterFormInput = {
  charterFormId: Scalars['ID']['input'];
  sections?: InputMaybe<Array<CharterFormSectionInput>>;
};

export type CharterFormSection = {
  __typename?: 'CharterFormSection';
  /** Soft delete */
  deleted: Scalars['Boolean']['output'];
  /** Toggle if this section will be shown to students */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  milestonePresets: Maybe<Array<MilestonePresetType>>;
  /** Description of the section as a serialised ProseMirror document */
  promptDoc: Maybe<Scalars['String']['output']>;
  /** Sort order of the section */
  rank: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  type: CharterFormSectionType;
  /** Number of words allowed. Only used if it is an input type section */
  wordLimit: Maybe<Scalars['Int']['output']>;
  /** Toggle if word limit is enabled for this section. Only used if it is an input type section */
  wordLimitEnabled: Scalars['Boolean']['output'];
};

export type CharterFormSectionInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can be null for new sections */
  id?: InputMaybe<Scalars['ID']['input']>;
  milestonePresets?: InputMaybe<Array<MilestonePresetInput>>;
  promptDoc?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CharterFormSectionType>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
  wordLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Different form sections creatable in a charter form */
export enum CharterFormSectionType {
  Instruction = 'INSTRUCTION',
  Milestone = 'MILESTONE',
  Overview = 'OVERVIEW',
  TextInput = 'TEXT_INPUT'
}

/** Charter milestones */
export type CharterMilestone = {
  __typename?: 'CharterMilestone';
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  id: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

/** Charter section types that can have threads. */
export enum CharterSectionType {
  Editor = 'EDITOR',
  Milestone = 'MILESTONE'
}

/** A single choice in a response with an ID and label text. */
export type Choice = {
  __typename?: 'Choice';
  id: Scalars['String']['output'];
  isCorrect: Maybe<Scalars['Boolean']['output']>;
  text: Scalars['String']['output'];
};

export type ChoiceInput = {
  id: Scalars['String']['input'];
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};

export type ChoiceInteraction = {
  __typename?: 'ChoiceInteraction';
  choices: Array<SimpleChoice>;
  /** Optional Category label */
  label: Maybe<Scalars['String']['output']>;
  /** Maximum number of choices the user can select */
  maxChoices: Scalars['Int']['output'];
};

export type ChoiceInteractionInput = {
  choices: Array<SimpleChoiceInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
};

/** Cadmus Class information for an Assessment. */
export type Class = {
  __typename?: 'Class';
  /** How the groups were setup for the assessment. */
  groupType: GroupType;
  /** List of all groups and their members */
  groups: Array<Group>;
  /** Class assessment ID */
  id: Scalars['ID']['output'];
  /** List of student enrollments in a class, including deleted enrollments. */
  students: Array<Enrollment>;
};

/** A full Class list with works and stats. */
export type ClassList = {
  __typename?: 'ClassList';
  /** List of Enrollments in a Class */
  enrollments: Array<Enrollment>;
  id: Scalars['ID']['output'];
};

/** Enum for the different Class List tab contexts. */
export enum ClassTab {
  /** Drafts tab */
  Drafts = 'DRAFTS',
  /** Finals tab */
  Finals = 'FINALS',
  /** Students or Progress tab */
  Students = 'STUDENTS'
}

export type Comment = {
  __typename?: 'Comment';
  content: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  updatedAt: Scalars['PreciseDateTime']['output'];
};

/** CommentRelease represents a snapshot of a comment at the time of feedback release. */
export type CommentRelease = {
  __typename?: 'CommentRelease';
  content: Scalars['String']['output'];
  createdBy: User;
  /** The ID of the Comment`. */
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

/**
 * Required and Complete: When a component's `weight` is greater than `0` and
 * the `score` value exists, then this component is complete.
 *
 * Required and Incomplete: When a component's `weight` is greater than `0` and
 * the component does not have a `score` value, then this component is incomplete.
 *
 * Disabled: When a component is null, that means that the component is not enabled
 * in the AssessmentSettings.
 *
 * Optional: When a component's `weight` is `0` and not null, the
 * component is optional.
 */
export type ComponentBreakdown = {
  __typename?: 'ComponentBreakdown';
  group: Maybe<ComponentScore>;
  individual: Maybe<ComponentScore>;
  /** Peer Component relevant fields: score, max_score, weighted_score, weighted_max_score */
  peer: Maybe<ComponentScore>;
  /** self Component elevant fields: score, max_score, weighted_score, weighted_max_score */
  self: Maybe<ComponentScore>;
  total: Maybe<ComponentScore>;
};

export type ComponentScore = {
  __typename?: 'ComponentScore';
  maxScore: Maybe<Scalars['Float']['output']>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  penaltyScore: Maybe<Scalars['Float']['output']>;
  score: Maybe<Scalars['Float']['output']>;
  weight: Maybe<Scalars['Int']['output']>;
  weightedMaxScore: Maybe<Scalars['Float']['output']>;
  weightedModeratorModifier: Maybe<Scalars['Float']['output']>;
  weightedPenaltyScore: Maybe<Scalars['Float']['output']>;
  weightedScore: Maybe<Scalars['Float']['output']>;
};

/** Conversation event payload for subscriptions - can be either a comment event or title change */
export type ConversationEvent = {
  __typename?: 'ConversationEvent';
  comment: Maybe<Comment>;
  eventType: ConversationEventType;
  threadId: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
};

/** Conversation event types for subscriptions */
export enum ConversationEventType {
  CommentAdded = 'COMMENT_ADDED',
  CommentEdited = 'COMMENT_EDITED',
  TitleEdited = 'TITLE_EDITED'
}

/** Country information */
export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateGraderMarkerRubricInput = {
  fieldRubricId: Scalars['ID']['input'];
};

export type CreateGraderMarkerRubricPayload = {
  __typename?: 'CreateGraderMarkerRubricPayload';
  fieldRubric: FieldRubric;
  markerRubric: MarkerRubric;
};

export type CreateMarkerRubricInput = {
  format: MarkerRubricFormat;
  kind: MarkerRubricKind;
  reversedScale: Scalars['Boolean']['input'];
};

export type CreateQuestionBankFileOriginInput = {
  filename: Scalars['String']['input'];
  filepath: Scalars['String']['input'];
};

export type CreateQuestionBankInput = {
  /** @deprecated Deprecated. Use fields instead */
  blanksResponse?: InputMaybe<BlanksResponseInput>;
  /** @deprecated Deprecated. Use fields instead */
  booleanResponse?: InputMaybe<BooleanResponseInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  /** @deprecated Deprecated. Use fields instead */
  editorResponse?: InputMaybe<EditorResponseInput>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<InputMaybe<QuestionFieldInput>>>;
  fileOriginId?: InputMaybe<Scalars['ID']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filepath?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Deprecated. Use fields instead */
  multiResponse?: InputMaybe<MultiResponseInput>;
  points?: InputMaybe<Scalars['Int']['input']>;
  promptDoc: Scalars['String']['input'];
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage?: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  scope: QuestionBankScope;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** @deprecated Deprecated. Use fields instead */
  shortResponse?: InputMaybe<ShortResponseInput>;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateQuestionMarkerRubricInput = {
  taskBlockId: Scalars['ID']['input'];
};

export type CreateQuestionMarkerRubricPayload = {
  __typename?: 'CreateQuestionMarkerRubricPayload';
  markerRubric: MarkerRubric;
  taskBlock: TaskBlock;
};

export type CreateQuestionSelectionPayload = {
  __typename?: 'CreateQuestionSelectionPayload';
  /** Array index of incomplete rule */
  incompleteRuleIndex: Maybe<Scalars['Int']['output']>;
  /** N questions required */
  requiredQuestionCount: Maybe<Scalars['Int']['output']>;
  /** N sets required */
  requiredSetsQuantity: Maybe<Scalars['Int']['output']>;
  /** N questions found */
  selectedQuestionCount: Maybe<Scalars['Int']['output']>;
  /** Fulfilled QuestionSelection generation. */
  selection: Maybe<QuestionSelection>;
};

export type CreateSkillInput = {
  skill: Scalars['String']['input'];
};

/** Creation attributes for a TaskBlock and linked Question */
export type CreateTaskBlockInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
  questionType: QuestionType;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Criterion = {
  __typename?: 'Criterion';
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  maxScore: Maybe<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  scaleItems: Array<ScaleItem>;
  skill: Maybe<LearningOutcomeSkill>;
  /** Learning Outcome Skill with Criterion title as fallback. */
  title: Maybe<Scalars['String']['output']>;
};

export type CriterionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maxScore?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  scaleItems: Array<ScaleItemInput>;
  skillId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CriterionOutcome = {
  __typename?: 'CriterionOutcome';
  id: Scalars['ID']['output'];
  markerRubricCriterion: Criterion;
  markerRubricCriterionId: Scalars['ID']['output'];
  markerRubricScaleItemId: Scalars['ID']['output'];
  markerScore: Scalars['Float']['output'];
  /** For Peer Evaluations: the student that marked this outcome. */
  markerUserId: Maybe<Scalars['ID']['output']>;
  /** For Peer Evaluations: when the student published their evaluation. */
  publishedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** For Peer Evaluations: the student that received this outcome. */
  targetUserId: Maybe<Scalars['ID']['output']>;
};

/**
 * CriterionOutcomeRelease represents a snapshot of a criterion outcome at release time.
 * Contains the rubric-based marking for a specific criterion.
 */
export type CriterionOutcomeRelease = {
  __typename?: 'CriterionOutcomeRelease';
  id: Scalars['ID']['output'];
  markerRubricCriterionId: Scalars['ID']['output'];
  markerRubricScaleItemId: Scalars['ID']['output'];
  markerScore: Scalars['Float']['output'];
};

/** Custom params captured for a user during LTI launches. */
export type CustomParams = {
  __typename?: 'CustomParams';
  brightspaceUserId: Maybe<Scalars['ID']['output']>;
  canvasAssignmentId: Maybe<Scalars['ID']['output']>;
  canvasSubmissionId: Maybe<Scalars['ID']['output']>;
  canvasUserId: Maybe<Scalars['ID']['output']>;
  lisPersonSourcedid: Maybe<Scalars['String']['output']>;
  moodleAttemptReopenMethod: Maybe<Scalars['String']['output']>;
};

export type DeletedMember = {
  __typename?: 'DeletedMember';
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

/** All possible Disciplines in Cadmus */
export enum Discipline {
  ArchitectureBuilding = 'ARCHITECTURE_BUILDING',
  Business = 'BUSINESS',
  ComputingIt = 'COMPUTING_IT',
  Design = 'DESIGN',
  Education = 'EDUCATION',
  Engineering = 'ENGINEERING',
  HumanitiesLanguages = 'HUMANITIES_LANGUAGES',
  Law = 'LAW',
  Mathematics = 'MATHEMATICS',
  MediaCommunication = 'MEDIA_COMMUNICATION',
  MedicineHealth = 'MEDICINE_HEALTH',
  PerformingFineArts = 'PERFORMING_FINE_ARTS',
  Science = 'SCIENCE',
  SocialScience = 'SOCIAL_SCIENCE'
}

/** Response as a rich text editor. */
export type EditorResponse = {
  __typename?: 'EditorResponse';
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type EditorResponseInput = {
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Different kinds of client-side Editors */
export enum EditorType {
  Prosemirror = 'PROSEMIRROR',
  Slate = 'SLATE'
}

/** A class Enrollment. */
export type Enrollment = {
  __typename?: 'Enrollment';
  /**
   * Access code used by the Student in the enrollment.
   * @deprecated Use `verified_codes` instead
   */
  accessCode: Maybe<AccessCode>;
  /** Index of the enrollment for anonymous marking */
  anonymousIndex: Maybe<Scalars['Int']['output']>;
  /** LTI Custom params */
  customParams: CustomParams;
  deleted: Scalars['Boolean']['output'];
  deletedBy: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Source LMS' SIS ID for the enrolled user */
  sisUserId: Maybe<Scalars['String']['output']>;
  /** Enrollment synced at date if the enrollment is inserted/updated through roster sync not lti launch */
  syncedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Tags for the enrollment */
  tags: Array<Tag>;
  /** Enrolled user */
  user: User;
  /** List of all the verified access codes used by the student in the enrollment. */
  verifiedCodes: Maybe<Array<VerifiedCode>>;
  /** Work started under the Enrollment, if any */
  work: Maybe<Work>;
  workSettings: Maybe<WorkSettings>;
};

/** Entity thread event payload for subscriptions */
export type EntityThreadEvent = {
  __typename?: 'EntityThreadEvent';
  criterionId: Maybe<Scalars['ID']['output']>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<EntityType>;
  eventType: EntityThreadEventType;
  resolvedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  resolvedBy: Maybe<User>;
  status: ThreadStatus;
  threadId: Scalars['ID']['output'];
};

/** Entity thread event types for subscriptions */
export enum EntityThreadEventType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Linked = 'LINKED',
  Resolved = 'RESOLVED',
  Unlinked = 'UNLINKED',
  Unresolved = 'UNRESOLVED'
}

/** Entity types associated with threads. */
export enum EntityType {
  AnswerBlock = 'ANSWER_BLOCK',
  Charter = 'CHARTER',
  FieldOutcome = 'FIELD_OUTCOME',
  PeerOutcome = 'PEER_OUTCOME',
  SubmissionOutcome = 'SUBMISSION_OUTCOME'
}

/** Type of examination time windowing strategy. */
export enum ExamTiming {
  Live = 'LIVE',
  Window = 'WINDOW'
}

export type ExtendedInteraction = {
  __typename?: 'ExtendedInteraction';
  attachmentEnabled: Maybe<Scalars['Boolean']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type ExtendedInteractionInput = {
  attachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Valid conflic actions for extensions sync types */
export enum ExtensionConflictActionType {
  Override = 'OVERRIDE',
  Skip = 'SKIP'
}

export enum FeedbackLevel {
  Answer = 'ANSWER',
  Feedback = 'FEEDBACK',
  Mark = 'MARK'
}

/** Types of Feedback Release Rule. */
export enum FeedbackReleaseBasePool {
  All = 'ALL',
  Empty = 'EMPTY'
}

/** Feedback Release Rule to release feedback to students in the future. */
export type FeedbackReleaseRule = {
  __typename?: 'FeedbackReleaseRule';
  basePool: FeedbackReleaseBasePool;
  excludedStudentIds: Array<Scalars['ID']['output']>;
  excludedTags: Array<Scalars['String']['output']>;
  executedAt: Maybe<Scalars['DateTime']['output']>;
  executedStudentIds: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  includedGroupIds: Array<Scalars['ID']['output']>;
  includedStudentIds: Array<Scalars['ID']['output']>;
  includedTags: Array<Scalars['String']['output']>;
  releaseType: FeedbackReleaseType;
  ruleKind: RuleKind;
  scheduledAt: Maybe<Scalars['DateTime']['output']>;
};

export type FeedbackReleaseRuleInput = {
  basePool: FeedbackReleaseBasePool;
  excludedStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includedGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  releaseType?: InputMaybe<FeedbackReleaseType>;
  ruleKind: RuleKind;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum FeedbackReleaseType {
  Final = 'FINAL',
  Provisional = 'PROVISIONAL'
}

/**
 * Assessment-wide Feedback Visibility. Controls level of feedback visible to
 * the students after it is released. They are unique on AssessmentID and
 * ReleaseType.
 */
export type FeedbackVisibility = {
  __typename?: 'FeedbackVisibility';
  feedbackViewLevel: FeedbackLevel;
  id: Scalars['ID']['output'];
  jointRelease: Scalars['Boolean']['output'];
  notifyStudents: Scalars['Boolean']['output'];
  releaseType: FeedbackReleaseType;
  showPeerComments: Scalars['Boolean']['output'];
  showPeerScores: Scalars['Boolean']['output'];
  withFeedbackPdf: Scalars['Boolean']['output'];
};

export type FeedbackVisibilityInput = {
  feedbackViewLevel: FeedbackLevel;
  jointRelease?: InputMaybe<Scalars['Boolean']['input']>;
  notifyStudents?: InputMaybe<Scalars['Boolean']['input']>;
  releaseType?: InputMaybe<FeedbackReleaseType>;
  showPeerComments?: InputMaybe<Scalars['Boolean']['input']>;
  showPeerScores?: InputMaybe<Scalars['Boolean']['input']>;
  withFeedbackPdf: Scalars['Boolean']['input'];
};

/** Outcome on a single field in a question. */
export type FieldOutcome = {
  __typename?: 'FieldOutcome';
  /** Single answer if given */
  answer: Maybe<Scalars['String']['output']>;
  /** Similarity score for the answer */
  answerSimilarity: Maybe<Scalars['Float']['output']>;
  /** Multiple answers if given */
  answers: Maybe<Array<Scalars['String']['output']>>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  /** Status of the automarking */
  automarkStatus: Maybe<AutomarkStatus>;
  comments: Maybe<Array<Comment>>;
  docContent: Maybe<Scalars['String']['output']>;
  docStreamUuid: Maybe<Scalars['ID']['output']>;
  docVersion: Maybe<Scalars['Int']['output']>;
  fieldRubricId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Unique identifier within the question */
  identifier: Scalars['String']['output'];
  markerScore: Maybe<Scalars['Float']['output']>;
  /** Marking outcome from using a MarkerRubric to score the parent Outcome. */
  rubricOutcome: RubricOutcome;
  score: Maybe<Scalars['Float']['output']>;
  /** Best matched expected response value */
  targetValue: Maybe<Scalars['String']['output']>;
};

/**
 * FieldOutcomeRelease represents a snapshot of a field outcome at release time.
 * Contains the marking and feedback for a specific field within a question.
 */
export type FieldOutcomeRelease = {
  __typename?: 'FieldOutcomeRelease';
  /** Single answer if given */
  answer: Maybe<Scalars['String']['output']>;
  /** Similarity score for the answer */
  answerSimilarity: Maybe<Scalars['Float']['output']>;
  /** Multiple answers if given */
  answers: Maybe<Array<Scalars['String']['output']>>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  commentReleases: Array<CommentRelease>;
  criterionOutcomeReleases: Array<CriterionOutcomeRelease>;
  docContent: Maybe<Scalars['String']['output']>;
  docStreamUuid: Maybe<Scalars['ID']['output']>;
  docVersion: Maybe<Scalars['Int']['output']>;
  fieldRubricId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Unique identifier within the question */
  identifier: Scalars['String']['output'];
  markerScore: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  /** Best matched expected response value */
  targetValue: Maybe<Scalars['String']['output']>;
  threadReleases: Array<ThreadRelease>;
};

export type FieldResponse = {
  __typename?: 'FieldResponse';
  /** Single answer */
  answer: Maybe<Scalars['String']['output']>;
  /** Multiple answers (such as ranges) */
  answers: Maybe<Array<Scalars['String']['output']>>;
  count: Scalars['Int']['output'];
  /** If the response was correct. */
  isCorrect: Scalars['Boolean']['output'];
  /** @deprecated Use `answer` instead. */
  response: Maybe<Scalars['String']['output']>;
  /** Best similarity score from 0 to 1 if the response was not correct. */
  similarity: Maybe<Scalars['Float']['output']>;
};

/** Rubric for a single field across all questions in the assessment task. */
export type FieldRubric = {
  __typename?: 'FieldRubric';
  /** Whether the field is automarked. */
  automarked: Scalars['Boolean']['output'];
  baseType: Maybe<BaseType>;
  caseSensitive: Scalars['Boolean']['output'];
  /** List of accepted position area answers */
  correctAreas: Maybe<Array<PositionArea>>;
  /** List of accepted numerical range answers */
  correctRanges: Maybe<Array<NumericRange>>;
  errorMargin: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  markerChanges: Maybe<FieldRubricChanges>;
  markerRubric: Maybe<MarkerRubric>;
  moderatorChanges: Maybe<FieldRubricChanges>;
  partialScoring: Scalars['Boolean']['output'];
  /** Aggregate of all responses provided to the field. */
  responses: Array<FieldResponse>;
  similarity: Maybe<Scalars['Float']['output']>;
  /** String matching strategy */
  strategy: Maybe<MatchStrategy>;
  /** List of accepted answers */
  values: Maybe<Array<Scalars['String']['output']>>;
};

/** Overriding change tracking made by marker or moderator to a FieldRubric. */
export type FieldRubricChanges = {
  __typename?: 'FieldRubricChanges';
  id: Scalars['ID']['output'];
  valuesAdded: Array<Scalars['String']['output']>;
  valuesRemoved: Array<Scalars['String']['output']>;
};

export type FindSimilarQuestionsInput = {
  excludeQuestionIds: Array<Scalars['ID']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The input object which represents the global portion of the user's settings. */
export type GlobalUserSettingsInput = {
  /** User must be shown the IA onboarding */
  showIaOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  showUserpilotOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Grade information for a Result.
 *
 * A grade stored as a floating point numeric value between 0 and 1. For display
 * however, this value has to be mulitplied by the latest released maximum grade
 * point requirements. The display is also string formatted with 2-digit padding
 * and 2-decimal point accuracy.
 */
export type Grade = {
  __typename?: 'Grade';
  /** Human formatted representation of the grade */
  display: Scalars['String']['output'];
  /** Maximum score possible */
  max: Scalars['Int']['output'];
  /** Actual 0-1 grade value */
  value: Scalars['Float']['output'];
};

/** Background processing result for a Submission against a Result. */
export type GradebookReceipt = {
  __typename?: 'GradebookReceipt';
  /** Email receipt sent to student. */
  emailComplete: Scalars['Boolean']['output'];
  /** Submission PDF or Record sent to the LMS. */
  lmsComplete: Scalars['Boolean']['output'];
  /** LMS Stage is snoozed until this date. */
  lmsSnooze: Maybe<Scalars['DateTime']['output']>;
  /** PDF WorkArtifact ID for complete render of the Submission. */
  pdfArtifactId: Maybe<Scalars['ID']['output']>;
  /** Submission PDF sent to Turnitin. */
  turnitinComplete: Scalars['Boolean']['output'];
};

/** Known service integrations into the Cadmus Gradebook result */
export enum GradebookService {
  Cadmusgrader = 'CADMUSGRADER',
  Moodlegrader = 'MOODLEGRADER',
  Speedgrader = 'SPEEDGRADER',
  Turnitin = 'TURNITIN'
}

/** A group of students in an assessment */
export type Group = {
  __typename?: 'Group';
  code: Maybe<Scalars['String']['output']>;
  groupSet: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  marker: Maybe<User>;
  markerId: Maybe<Scalars['ID']['output']>;
  /** The maximum number of students that can be in a group */
  maxLimit: Maybe<Scalars['Int']['output']>;
  members: Array<User>;
  /** The minimum number of students required to be in a group */
  minLimit: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  questionId: Maybe<Scalars['String']['output']>;
};

export type GroupInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  groupSet?: InputMaybe<Scalars['String']['input']>;
  maxLimit?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  minLimit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type GroupMembershipInput = {
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GroupRule = {
  markerId?: InputMaybe<Scalars['String']['input']>;
  markerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  totalStudents?: InputMaybe<Scalars['Int']['input']>;
};

/** Purpose of the groups setup in an Assessment */
export enum GroupType {
  Question = 'QUESTION',
  Student = 'STUDENT'
}

export type GroupUpdateInput = {
  addedMembers?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  markerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removedMembers?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input for importing library question to task block */
export type ImportLibraryQuestionInput = {
  questionId: Scalars['ID']['input'];
  questionVersionId?: InputMaybe<Scalars['ID']['input']>;
  taskBlockId: Scalars['ID']['input'];
};

/** Cadmus Institution. */
export type Institution = {
  __typename?: 'Institution';
  /**
   * Institution has the Access Code feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  accessCodeFeatureEnabled: Scalars['Boolean']['output'];
  apiStatus: ApiStatusType;
  /**
   * Institution has the Cadmus Grader feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  cadmusGraderFeatureEnabled: Scalars['Boolean']['output'];
  /** Institution's country of origin information. Also known as home country. */
  country: Country;
  /** Custom declaration Rich text JSON from contentful */
  customDeclarationText: Maybe<Scalars['String']['output']>;
  /**
   * Institution has the Exams feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  examsFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Feature flags enabled for the institution.
   * @deprecated Use query-level `featureFlags`
   */
  features: InstitutionFeatures;
  /**
   * Institution has the Footnote Referencing feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  footnoteReferencingEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Institution has the LDB feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  ldbFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Institution has the Moodle Grader feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  moodlegraderFeatureEnabled: Scalars['Boolean']['output'];
  /**
   * Institution has the Multiformat Task feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  multiformatFeatureEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  /**
   * Institution has the Turnitin Feedback Studio feature pack added to their account
   * @deprecated Use query-level `featureFlags
   */
  turnitinGraderFeatureEnabled: Scalars['Boolean']['output'];
};

/** Institution feature flags. */
export type InstitutionFeatures = {
  __typename?: 'InstitutionFeatures';
  accessCode: Scalars['Boolean']['output'];
  advancedMarking: Scalars['Boolean']['output'];
  cadmusGrader: Scalars['Boolean']['output'];
  exams: Scalars['Boolean']['output'];
  extensionSyncing: Scalars['Boolean']['output'];
  footnoteReferencing: Scalars['Boolean']['output'];
  genAiDeclaration: Scalars['Boolean']['output'];
  groupAssessment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  moodleGrader: Scalars['Boolean']['output'];
  multiformat: Scalars['Boolean']['output'];
  questionLibrary: Scalars['Boolean']['output'];
  respondusLdb: Scalars['Boolean']['output'];
  smartAutomarking: Scalars['Boolean']['output'];
  timeline: Scalars['Boolean']['output'];
  turnitinGrader: Scalars['Boolean']['output'];
  workAttachment: Scalars['Boolean']['output'];
};

/** Institution LMS Tool Provider information. */
export type InstitutionTool = {
  __typename?: 'InstitutionTool';
  familyCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type IssueAssigneeInput = {
  userId: Scalars['ID']['input'];
};

export enum IssueStatus {
  Blocked = 'BLOCKED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum IssueType {
  Milestone = 'MILESTONE',
  Task = 'TASK'
}

/** Status information on a background Job */
export type Job = {
  __typename?: 'Job';
  assessmentId: Scalars['ID']['output'];
  conflict: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** Final result URL if available */
  resultUrl: Maybe<Scalars['String']['output']>;
};

export type LearningOutcomeSkill = {
  __typename?: 'LearningOutcomeSkill';
  id: Scalars['ID']['output'];
  skill: Scalars['String']['output'];
};

/** An LTI Service like AGS or NRPS. */
export type LtiService = {
  __typename?: 'LtiService';
  id: Scalars['ID']['output'];
  /** LTI Advantage (V2) services have OAuth2 token issuers */
  issuer: Maybe<Scalars['String']['output']>;
  metaUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/**
 * A Mailing List representation which can be active or in-active depending on
 * the `subscribed` field.
 */
export type MailingList = {
  __typename?: 'MailingList';
  id: Scalars['String']['output'];
  members: Array<Scalars['String']['output']>;
  subscribed: Scalars['Boolean']['output'];
};

export type MarkFieldOutcomeInput = {
  fieldOutcomeId: Scalars['ID']['input'];
  scaleItemId?: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Float']['input'];
};

export type MarkFieldOutcomePayload = {
  __typename?: 'MarkFieldOutcomePayload';
  fieldOutcome: FieldOutcome;
  questionOutcome: QuestionOutcome;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: WorkOutcome;
};

export type MarkPeerOutcomeInput = {
  scaleItemId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
};

export type MarkSubmissionOutcomeInput = {
  scaleItemId?: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Float']['input'];
  submissionOutcomeId: Scalars['Int']['input'];
};

export type MarkSubmissionOutcomePayload = {
  __typename?: 'MarkSubmissionOutcomePayload';
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

export type MarkerRubric = {
  __typename?: 'MarkerRubric';
  assessmentId: Scalars['ID']['output'];
  /** @deprecated Use `location` field instead. */
  assessmentName: Scalars['String']['output'];
  criteria: Array<Criterion>;
  format: MarkerRubricFormat;
  /** Has un-published changes over the last published version. */
  hasChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: MarkerRubricKind;
  location: MarkerRubricLocation;
  markingExists: Scalars['Boolean']['output'];
  /** Publish timestamp if the rubric is the published version */
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `location` field instead. */
  questionShortPrompt: Maybe<Scalars['String']['output']>;
  reversedScale: Scalars['Boolean']['output'];
};

/**
 * The format of the MarkerRubric determines how Scale Items are defined for
 * each Criterion:
 *
 *   * `:percentage` – Each criterion's scale items represent percentage ranges
 *   * `:points` – Each criterion defines a range of possible point values.
 *   * `:absolute` – Each criterion allows selection of a single, fixed point value.
 */
export enum MarkerRubricFormat {
  Absolute = 'ABSOLUTE',
  Percentage = 'PERCENTAGE',
  Points = 'POINTS'
}

export type MarkerRubricInput = {
  criteria: Array<CriterionInput>;
  format: MarkerRubricFormat;
  kind?: InputMaybe<MarkerRubricKind>;
  reversedScale: Scalars['Boolean']['input'];
};

/** Kinds of Marker Rubrics for different purposes. */
export enum MarkerRubricKind {
  Extended = 'EXTENDED',
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER'
}

/** Location of a MarkerRubric within an Assessment. */
export type MarkerRubricLocation = {
  __typename?: 'MarkerRubricLocation';
  /** assessment name */
  assessment: Scalars['String']['output'];
  /** path within the assessment */
  path: Scalars['String']['output'];
};

export enum MarkerRubricStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum MarkingRole {
  Marker = 'MARKER',
  Moderator = 'MODERATOR'
}

/** Marking tool used for the assessment. */
export enum MarkingTool {
  Cadmusgrader = 'CADMUSGRADER',
  Moodlegrader = 'MOODLEGRADER',
  Speedgrader = 'SPEEDGRADER',
  Turnitin = 'TURNITIN'
}

/**
 * Restrict student result view via the PDF sent to the LMS marking tool.
 *
 *   * UnmarkedOnly - Show un-marked responses only
 *
 *   * UnmarkedAndAutomarkedSummary - Show un-marked responses and auto-mark
 *     summary
 */
export enum MarkingToolPdf {
  UnmarkedAndAutomarkedSummary = 'UNMARKED_AND_AUTOMARKED_SUMMARY',
  UnmarkedOnly = 'UNMARKED_ONLY'
}

export type MatchInteraction = {
  __typename?: 'MatchInteraction';
  /** Answer options that can be selected for matching */
  sourceSet: Array<SimpleChoice>;
  /** Prompts that are matched against */
  targetSet: Array<SimpleChoice>;
};

export type MatchInteractionInput = {
  sourceSet: Array<SimpleChoiceInput>;
  targetSet: Array<SimpleChoiceInput>;
};

/** Matching strategy used to auto-mark a string Field */
export enum MatchStrategy {
  Exact = 'EXACT',
  Levdist = 'LEVDIST',
  Smart = 'SMART'
}

/** A Message sent in a Class from an enrolled user. */
export type Message = {
  __typename?: 'Message';
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  messageType: MessageRequestType;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  sourceUserId: Scalars['ID']['output'];
};

export type MessageInput = {
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  messageType: MessageRequestType;
  targetUserId?: InputMaybe<Scalars['ID']['input']>;
};

export enum MessageRequestType {
  GroupChange = 'GROUP_CHANGE'
}

export type Metadata = {
  __typename?: 'Metadata';
  /** ID of the BlockAttachment this thread is about */
  blockAttachmentId: Maybe<Scalars['Int']['output']>;
  /** Display name of the file */
  blockAttachmentName: Maybe<Scalars['String']['output']>;
  /** ID of the charter editor associated with this thread. */
  charterEditorId: Maybe<Scalars['ID']['output']>;
  /** Type of charter section this thread is associated with, can be 'Editor' or 'Milestone'. */
  charterSectionType: Maybe<CharterSectionType>;
};

/** Input for charter milestone details for updating it */
export type MilestoneInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** can be null for new milestones */
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Milestone preset type for charter form section */
export type MilestonePresetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Datetime when the milestone is due */
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Title for the milestone */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Milestone preset type for charter form section */
export type MilestonePresetType = {
  __typename?: 'MilestonePresetType';
  description: Maybe<Scalars['String']['output']>;
  /** Datetime this milestone is due */
  dueDate: Maybe<Scalars['DateTime']['output']>;
  /** Title for the milestone */
  title: Maybe<Scalars['String']['output']>;
};

/** Moderation Penalty Rule to apply penalties on feedback release. */
export type ModerationPenaltyRule = {
  __typename?: 'ModerationPenaltyRule';
  canStack: Scalars['Boolean']['output'];
  excludedStudentIds: Maybe<Array<Scalars['ID']['output']>>;
  formatUnit: Maybe<PenaltyFormatUnit>;
  id: Scalars['ID']['output'];
  includedGroupIds: Array<Scalars['ID']['output']>;
  includedTags: Maybe<Array<Scalars['String']['output']>>;
  minutesLateBy: Maybe<Scalars['Int']['output']>;
  penaltyScore: Scalars['Float']['output'];
  penaltyType: ModerationPenaltyType;
  reason: Maybe<Scalars['String']['output']>;
  ruleKind: RuleKind;
  scoreUnit: PenaltyScoreUnit;
};

export type ModerationPenaltyRuleInput = {
  canStack: Scalars['Boolean']['input'];
  excludedStudentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  formatUnit: PenaltyFormatUnit;
  id?: InputMaybe<Scalars['ID']['input']>;
  includedGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  minutesLateBy?: InputMaybe<Scalars['Int']['input']>;
  penaltyScore: Scalars['Float']['input'];
  penaltyType: ModerationPenaltyType;
  reason?: InputMaybe<Scalars['String']['input']>;
  ruleKind: RuleKind;
  scoreUnit?: InputMaybe<PenaltyScoreUnit>;
};

export enum ModerationPenaltyType {
  Custom = 'CUSTOM',
  MoreThan = 'MORE_THAN'
}

/** Response as multiple choice selections. */
export type MultiResponse = {
  __typename?: 'MultiResponse';
  cardinality: Maybe<Cardinality>;
  choices: Array<Choice>;
  partialScoring: Maybe<Scalars['Boolean']['output']>;
};

export type MultiResponseInput = {
  choices: Array<ChoiceInput>;
  /** Partial scoring for multiple choice questions. */
  partialScoring?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumericRange = {
  __typename?: 'NumericRange';
  end: Scalars['Float']['output'];
  identifier: Scalars['ID']['output'];
  start: Scalars['Float']['output'];
};

export type NumericRangeInput = {
  end: Scalars['Float']['input'];
  identifier: Scalars['String']['input'];
  start: Scalars['Float']['input'];
};

/** Mutation return for `captureOnboardingInput`. */
export type OnboardingPayload = {
  __typename?: 'OnboardingPayload';
  subject: Maybe<Subject>;
  userSettings: Maybe<UserSettings>;
};

export type OutcomesDeletedPayload = {
  __typename?: 'OutcomesDeletedPayload';
  outcomesDeleted: Scalars['Int']['output'];
};

/** A past instruction, which includes information about each assessment and its related, latest released instructions. */
export type PastInstructionSheet = {
  __typename?: 'PastInstructionSheet';
  assessment: Assessment;
  id: Scalars['ID']['output'];
  sheet: Sheet;
};

/** Marking outcome when a student peer evaluates another peer in a group. */
export type PeerOutcome = {
  __typename?: 'PeerOutcome';
  /** When the all group members published their complete evaluations of the target_user_id */
  completedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** All Criterion selections made by peers against this Peer Outcome */
  criterionOutcomes: Array<CriterionOutcome>;
  /** When the peer outcome was used for the Students Gradebook Result */
  feedbackReleasedTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Criterion selections that the current user has made on this Peer Outcome. */
  givenCriterionOutcomes: Array<CriterionOutcome>;
  id: Scalars['ID']['output'];
  /** Precomputed peer max score (max score committed at time of publish of last student in group), only available when completed_at has a value and the assessment has peer_evaluations enabled */
  peerMaxScore: Maybe<Scalars['Int']['output']>;
  /** Precomputed peer score, only available when completed_at has a value and the assessment has peer_evaluations enabled */
  peerScore: Maybe<Scalars['Float']['output']>;
  /** Precomputed self max score (max score committed at time of publish), only available when completed_at has a value, and the assessment has self_evaluations enabled */
  selfMaxScore: Maybe<Scalars['Int']['output']>;
  /** Precomputed self score, only available when completed_at has a value, and the assessment has self_evaluations enabled */
  selfScore: Maybe<Scalars['Float']['output']>;
  /** Student being evaluated */
  targetUserId: Scalars['ID']['output'];
};

export enum PenaltyFormatUnit {
  Custom = 'CUSTOM',
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

/** Format of Moderation Penalty Value Unit. */
export enum PenaltyScoreUnit {
  Percentage = 'PERCENTAGE',
  Points = 'POINTS'
}

/** A single position area in a position object response. */
export type PositionArea = {
  __typename?: 'PositionArea';
  coords: Array<Scalars['Float']['output']>;
  identifier: Scalars['ID']['output'];
  shape: Shape;
};

export type PositionAreaInput = {
  coords: Array<Scalars['Float']['input']>;
  identifier: Scalars['String']['input'];
  shape: Shape;
};

export type PositionObjectInteraction = {
  __typename?: 'PositionObjectInteraction';
  /** Label for the position object */
  label: Maybe<Scalars['String']['output']>;
  /** Maximum number of choices the user can select */
  maxChoices: Scalars['Int']['output'];
};

export type PositionObjectInteractionInput = {
  /** Label for the interaction */
  label: Scalars['String']['input'];
  maxChoices?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintArchiveInput = {
  assessmentName: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Issue for Assessment Group's Project Management Board */
export type ProjectIssue = {
  __typename?: 'ProjectIssue';
  /** List of user IDs assigned to the issue. */
  assignees: Array<Scalars['ID']['output']>;
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTime']['output']>;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  status: IssueStatus;
  title: Scalars['String']['output'];
  type: IssueType;
};

/** Input to update Project Issues for Group Assessment */
export type ProjectIssueInput = {
  assignees?: InputMaybe<Array<IssueAssigneeInput>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of an existing issue or null for new issues. */
  id?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<IssueStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IssueType>;
};

/** Image information and associated annotations. */
export type PromptImage = {
  __typename?: 'PromptImage';
  /** Image height */
  height: Scalars['Int']['output'];
  /** Image layers for annotations. */
  layers: Array<PromptImageLayer>;
  /** Image URL */
  url: Scalars['String']['output'];
  /** Image width */
  width: Scalars['Int']['output'];
};

/** Question Prompt Image attributes */
export type PromptImageInput = {
  /** Image height */
  height: Scalars['Int']['input'];
  /** Image layers attributes */
  layers?: InputMaybe<Array<PromptImageLayerInput>>;
  /** Image URL */
  url: Scalars['String']['input'];
  /** Image width */
  width: Scalars['Int']['input'];
};

/** Image layer information */
export type PromptImageLayer = {
  __typename?: 'PromptImageLayer';
  /** Layer coordinates */
  coords: Array<Scalars['Float']['output']>;
  /** Layer identifier */
  identifier: Scalars['String']['output'];
  /** Layer shape */
  shape: Shape;
};

/** Question Prompt Image Layer attributes */
export type PromptImageLayerInput = {
  /** Layer coordinates */
  coords: Array<Scalars['Float']['input']>;
  /** Layer identifier */
  identifier: Scalars['String']['input'];
  /** Layer shape */
  shape: Shape;
};

export type PublishImportedQuestionsInput = {
  assessmentId: Scalars['ID']['input'];
  questions: Array<QuestionAttributes>;
  sourceFile: SourceFileInput;
  subjectId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<TagInput>>;
};

/** A single Question as part of the Cadmus Assessments. */
export type Question = {
  __typename?: 'Question';
  accessGroup: Maybe<AccessGroup>;
  accessRole: Maybe<AccessRole>;
  /** Whether the question was deleted from the library. */
  archived: Scalars['Boolean']['output'];
  /** Retrieves the list of assessments where the question was used. */
  assessmentUsages: Array<QuestionAssessment>;
  /** Question body with prompt and fields. */
  body: Maybe<QuestionBody>;
  /** Preferred caching ID on the client. */
  cacheId: Scalars['ID']['output'];
  childrenQuestions: Array<Question>;
  createdAt: Scalars['PreciseDateTime']['output'];
  currentVersionId: Maybe<Scalars['ID']['output']>;
  difficulty: Maybe<QuestionDifficulty>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedBy: Maybe<User>;
  libraryId: Scalars['String']['output'];
  /** Order for a child sub-question. */
  order: Maybe<Scalars['Int']['output']>;
  /** Parent question ID for sub questions. */
  parentQuestionId: Maybe<Scalars['ID']['output']>;
  /** Points alloted to this question. */
  points: Maybe<Scalars['Int']['output']>;
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Maybe<Scalars['String']['output']>;
  shuffle: Scalars['Boolean']['output'];
  sourceFile: Maybe<QuestionSourceFile>;
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
  /** Attached tags of the questions */
  tags: Array<QuestionTag>;
  /** Should be used only for task block edge. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** @deprecated Version number is not relevant now as IDs are used for versioning. */
  version: Maybe<Scalars['Int']['output']>;
  /** All the versions of the question */
  versions: Array<QuestionVersion>;
};

export type QuestionAssessment = {
  __typename?: 'QuestionAssessment';
  /** When and how the question was used in an assessment. */
  assessment: Assessment;
  points: Maybe<Scalars['Int']['output']>;
  releaseTimestamp: Scalars['PreciseDateTime']['output'];
};

export type QuestionAttributes = {
  /** Difficulty level of the question */
  difficulty?: InputMaybe<QuestionDifficulty>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<QuestionFieldInput>>;
  /** Order of the question in the parent question */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Parent question ID if this is a child of sub question */
  parentQuestionId?: InputMaybe<Scalars['ID']['input']>;
  /** Points for the question */
  points?: InputMaybe<Scalars['Int']['input']>;
  /** Question prompt prosemirror contents */
  promptDoc: Scalars['String']['input'];
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage?: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** Shuffle the choices in the question */
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updatable attributes for a question */
export type QuestionAttributesInput = {
  currentVersionId?: InputMaybe<Scalars['ID']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  points?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionBank = {
  __typename?: 'QuestionBank';
  assessmentId: Maybe<Scalars['ID']['output']>;
  category: Maybe<QuestionBankCategory>;
  createdBy: User;
  difficulty: Maybe<QuestionDifficulty>;
  fileOrigin: Maybe<QuestionBankFileOrigin>;
  id: Scalars['ID']['output'];
  points: Maybe<Scalars['Int']['output']>;
  question: Question;
  questionBankId: Scalars['ID']['output'];
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
};

export type QuestionBankCategory = {
  __typename?: 'QuestionBankCategory';
  assessmentId: Maybe<Scalars['ID']['output']>;
  createdBy: User;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subjectGroupId: Maybe<Scalars['ID']['output']>;
  subjectId: Maybe<Scalars['ID']['output']>;
};

export type QuestionBankCategoryInput = {
  category: Scalars['String']['input'];
  scope: QuestionBankScope;
};

export type QuestionBankFileOrigin = {
  __typename?: 'QuestionBankFileOrigin';
  filename: Maybe<Scalars['String']['output']>;
  filepath: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type QuestionBankFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  questionBankIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionType?: InputMaybe<QuestionType>;
};

export type QuestionBankNodes = {
  nodeId: Scalars['ID']['input'];
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
  questionBankId: Scalars['ID']['input'];
};

export type QuestionBankScope = {
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId?: InputMaybe<Scalars['ID']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};

/** A node (or sub-tree) in the QuestionTree */
export type QuestionBlock = {
  __typename?: 'QuestionBlock';
  /** e.g. Question 1 */
  longLabel: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the node */
  nodeId: Scalars['ID']['output'];
  /** Type of the node */
  nodeType: QuestionTreeNodeType;
  /** Order position of this node among siblings */
  order: Scalars['Int']['output'];
  /** ID of the parent node, if any */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  /** Total points below this tree node */
  points: Maybe<Scalars['Int']['output']>;
  /** Question attached to this node */
  question: Maybe<Question>;
  questionId: Maybe<Scalars['ID']['output']>;
  questionSetId: Maybe<Scalars['ID']['output']>;
  /** e.g. Q1 */
  shortLabel: Maybe<Scalars['String']['output']>;
  /** Whether to shuffle this node's children */
  shuffle: Maybe<Scalars['Boolean']['output']>;
};

/** Saved contents of the Question. */
export type QuestionBody = {
  __typename?: 'QuestionBody';
  feedback: Maybe<Scalars['String']['output']>;
  /** Interactions and their response declaration in the question. */
  fields: Maybe<Array<QuestionField>>;
  /** Question Body ID used for caching body separately, not expected to be used. */
  id: Scalars['ID']['output'];
  /** Serialised ProseMirror document */
  promptDoc: Maybe<Scalars['String']['output']>;
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage: Maybe<PromptImage>;
  /** @deprecated Use `fields` */
  response: Maybe<QuestionResponse>;
};

export enum QuestionDifficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

/** A single Question field. */
export type QuestionField = {
  __typename?: 'QuestionField';
  identifier: Scalars['String']['output'];
  /** How the student interacts with the field. */
  interaction: QuestionInteraction;
  /** How the response should be interpreted and marked. */
  response: Maybe<ResponseDeclaration>;
};

export type QuestionFieldInput = {
  choiceInteraction?: InputMaybe<ChoiceInteractionInput>;
  extendedInteraction?: InputMaybe<ExtendedInteractionInput>;
  identifier: Scalars['String']['input'];
  matchInteraction?: InputMaybe<MatchInteractionInput>;
  positionObjectInteraction?: InputMaybe<PositionObjectInteractionInput>;
  response: ResponseDeclarationInput;
  textEntryInteraction?: InputMaybe<TextEntryInteractionInput>;
};

/** Different kinds of interactions expected for a question. */
export type QuestionInteraction = ChoiceInteraction | ExtendedInteraction | MatchInteraction | PositionObjectInteraction | TextEntryInteraction;

/**
 * Outcome recorded for a single question possibly answered by the student in
 * their work.
 */
export type QuestionOutcome = {
  __typename?: 'QuestionOutcome';
  /** Answer snapshot submitted for marking by the student. */
  blockSnapshot: Maybe<BlockSnapshot>;
  fieldOutcomes: Array<FieldOutcome>;
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  /** Question outcome score breakdowns */
  scoreBreakdown: ScoreBreakdown;
};

/** QuestionOutcomeRelease represents a snapshot of a question outcome at release time. */
export type QuestionOutcomeRelease = {
  __typename?: 'QuestionOutcomeRelease';
  answerBlockId: Scalars['ID']['output'];
  /** Answer snapshot submitted for marking by the student. */
  blockSnapshot: Maybe<BlockSnapshot>;
  blockSnapshotId: Scalars['ID']['output'];
  fieldOutcomeReleases: Array<FieldOutcomeRelease>;
  /** The ID of the QuestionOutcome. */
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  questionOutcomeId: Scalars['ID']['output'];
};

/** Different kinds of responses expected for a question. */
export type QuestionResponse = BlanksResponse | BooleanResponse | EditorResponse | MultiResponse | ShortResponse;

export type QuestionResponseCounts = {
  __typename?: 'QuestionResponseCounts';
  /** Count of provided responses. */
  responseCount: Scalars['Int']['output'];
  /** Count of responses that achieved 100% of the outcomes. */
  successCount: Scalars['Int']['output'];
};

/** A Question's marking rubric. */
export type QuestionRubric = {
  __typename?: 'QuestionRubric';
  /** Metrics on the responses provided to the marked question. */
  counts: QuestionResponseCounts;
  fieldRubrics: Array<FieldRubric>;
  id: Scalars['ID']['output'];
  maxScore: Scalars['Float']['output'];
  questionId: Scalars['ID']['output'];
};

export type QuestionSelection = {
  __typename?: 'QuestionSelection';
  id: Scalars['ID']['output'];
  rules: Array<QuestionSelectionRule>;
  sets: Maybe<Array<QuestionSet>>;
  setsQuantity: Scalars['Int']['output'];
};

export type QuestionSelectionFilterInput = {
  selectedSetId: Scalars['Int']['input'];
  selectionId: Scalars['ID']['input'];
};

export type QuestionSelectionInput = {
  excludeQuestionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  overlap?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionsPerSet?: InputMaybe<Scalars['Int']['input']>;
  rules: Array<QuestionSelectionRuleInput>;
  setsQuantity: Scalars['Int']['input'];
  usedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  usedTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionSelectionRule = {
  __typename?: 'QuestionSelectionRule';
  createdBy: Maybe<Scalars['ID']['output']>;
  difficulty: Maybe<QuestionDifficulty>;
  id: Scalars['ID']['output'];
  includeUsed: Maybe<Scalars['Boolean']['output']>;
  points: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  questionType: QuestionType;
  usedFrom: Maybe<Scalars['DateTime']['output']>;
  usedTo: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionSelectionRuleInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  includeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  points: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  questionType: QuestionType;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  usedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  usedTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestionSet = {
  __typename?: 'QuestionSet';
  id: Scalars['ID']['output'];
  label: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  questions: Array<QuestionSetQuestion>;
};

export type QuestionSetQuestion = {
  __typename?: 'QuestionSetQuestion';
  id: Scalars['ID']['output'];
  /** Tree layout node Id for the question inside question set */
  nodeId: Scalars['ID']['output'];
  /** Tree layout previous node Id for the question inside question set */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  points: Maybe<Scalars['Int']['output']>;
  /** Tree layout parent node Id for the question inside question set */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  question: Question;
  /** Id of the question version used in this question set question */
  questionVersionId: Maybe<Scalars['ID']['output']>;
  shuffle: Scalars['Boolean']['output'];
};

/** A source file for imported question in the library. */
export type QuestionSourceFile = {
  __typename?: 'QuestionSourceFile';
  filename: Maybe<Scalars['String']['output']>;
  filepath: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type QuestionTag = {
  __typename?: 'QuestionTag';
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type QuestionTagCategory = {
  __typename?: 'QuestionTagCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Type of tree-node in the QuestionTree */
export enum QuestionTreeNodeType {
  Overview = 'OVERVIEW',
  Question = 'QUESTION',
  Section = 'SECTION',
  Selection = 'SELECTION',
  Set = 'SET',
  Sub = 'SUB'
}

/** Valid Question types */
export enum QuestionType {
  Blanks = 'BLANKS',
  Extended = 'EXTENDED',
  Hotspot = 'HOTSPOT',
  Matching = 'MATCHING',
  Mcq = 'MCQ',
  Numerical = 'NUMERICAL',
  Overview = 'OVERVIEW',
  Section = 'SECTION',
  Short = 'SHORT',
  Sub = 'SUB',
  Truefalse = 'TRUEFALSE'
}

export type QuestionVersion = {
  __typename?: 'QuestionVersion';
  /** Question body with prompt and fields. */
  body: Maybe<QuestionBody>;
  childrenQuestions: Array<QuestionVersion>;
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  order: Maybe<Scalars['Int']['output']>;
  parentQuestionId: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  questionType: QuestionType;
  shortPrompt: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
  /** @deprecated Version number is not relevant now as IDs are used for versioning. */
  version: Maybe<Scalars['Int']['output']>;
};

export type RegenerateQuestionSetInput = {
  allowOverlappingSets?: InputMaybe<Scalars['Boolean']['input']>;
  questionSetId: Scalars['ID']['input'];
  questionSetQuestionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RegenerateQuestionSetPayload = {
  __typename?: 'RegenerateQuestionSetPayload';
  /** True if the replacement set is incomplete */
  incompleteReplacement: Maybe<Scalars['Boolean']['output']>;
  /** Updated Question Set. May be nil if the replacement set is incomplete. */
  questionSet: Maybe<QuestionSet>;
};

export type RegisterQuestionSourceFileInput = {
  filename: Scalars['String']['input'];
  filepath: Scalars['String']['input'];
};

/** Return type for cancelRelease mutation. */
export type ReleaseAssessmentPayload = {
  __typename?: 'ReleaseAssessmentPayload';
  assessment: Assessment;
  sheets: Array<Sheet>;
};

export type ReleaseFeedbackForEveryonePayload = {
  __typename?: 'ReleaseFeedbackForEveryonePayload';
  feedbackReleaseRules: Array<FeedbackReleaseRule>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type RemoveQuestionsUniformlyInput = {
  /** ID of the Question Selection to remove questions from */
  questionSelectionId: Scalars['ID']['input'];
  /** List of selected question set question IDs to remove. These questions will be used to determine which questions to remove from the other sets. */
  questionSetQuestionIds: Array<Scalars['ID']['input']>;
};

export type ReplaceQuestionInSetInput = {
  /** ID of the Question to use as replacement */
  questionId: Scalars['ID']['input'];
  /** ID of the Question Set to update */
  questionSetId: Scalars['ID']['input'];
  /** ID of the QuestionSetQuestion to update */
  questionSetQuestionId: Scalars['ID']['input'];
  /** ID of the specific Question Version to use as replacement (optional) */
  questionVersionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Assessment Task requirements. */
export type Requirements = {
  __typename?: 'Requirements';
  /** Allow the use of Generative AI or not. */
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  /** Allow late re-submissions or not. */
  allowLateResubmission: Scalars['Boolean']['output'];
  /** If anonymous marking is selected. */
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  assessmentType: AssessmentType;
  countFootnotes: Scalars['Boolean']['output'];
  countReferences: Scalars['Boolean']['output'];
  disableExamBacktrack: Maybe<Scalars['Boolean']['output']>;
  disableSpellCheck: Scalars['Boolean']['output'];
  /** Drafting due date with Institution timezone */
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Are students allowed to view draft similarity scores/reports.
   *
   * 0 - Never
   * 1 - Only After the final due date
   * 2 - Always
   */
  draftSViewReports: Scalars['Int']['output'];
  /** Final due date with Institution timezone. */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  enableExamAccessCode: Scalars['Boolean']['output'];
  enableExamAutoSubmission: Scalars['Boolean']['output'];
  enableExamLdb: Maybe<Scalars['Boolean']['output']>;
  /** Enable or disable PDF attachment in submission receipts. */
  enableSubmissionPdf: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examFeedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  /** Selected grading integration. Either `turnitin` or `speedgrader` or `moodlegrader` currently. */
  gradingService: Scalars['String']['output'];
  /**
   * Has the set of requirements been altered by a user?
   *
   * This checks whether we have saved any requirements against the assessment
   */
  hasChanged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  /** Restrict student result view in LMS marking tool. */
  markingToolPdf: Maybe<MarkingToolPdf>;
  /** Maximum grade points. */
  maxGrade: Scalars['Int']['output'];
  noDraft: Scalars['Boolean']['output'];
  noExamFeedbackDate: Scalars['Boolean']['output'];
  noExamReadingTime: Scalars['Boolean']['output'];
  noLimit: Scalars['Boolean']['output'];
  noReferencing: Scalars['Boolean']['output'];
  /** Do students need to work in a limited time window */
  noTimeLimit: Scalars['Boolean']['output'];
  noWeight: Scalars['Boolean']['output'];
  referencingStyle: Maybe<Scalars['String']['output']>;
  /** If student result view is restricted. */
  restrictMarkingToolPdf: Scalars['Boolean']['output'];
  /** Final grade and feedback return date date with Institution timezone. */
  returnDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Are students allowed to view final similarity scores/reports.
   *
   * 0 - Never
   * 1 - Only After the final due date
   * 2 - Always
   */
  sViewReports: Scalars['Int']['output'];
  /** Allowed working time in minutes */
  timeLimit: Maybe<Scalars['Int']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

export type RequirementsInput = {
  allowGenerativeAi?: InputMaybe<Scalars['Boolean']['input']>;
  allowLateResubmission?: InputMaybe<Scalars['Boolean']['input']>;
  anonymousMarking?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentType?: InputMaybe<AssessmentType>;
  countFootnotes?: InputMaybe<Scalars['Boolean']['input']>;
  countReferences?: InputMaybe<Scalars['Boolean']['input']>;
  disableExamBacktrack?: InputMaybe<Scalars['Boolean']['input']>;
  disableSpellCheck?: InputMaybe<Scalars['Boolean']['input']>;
  draftDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  draftSViewReports?: InputMaybe<Scalars['Int']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  enableExamAccessCode?: InputMaybe<Scalars['Boolean']['input']>;
  enableExamAutoSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  enableExamLdb?: InputMaybe<Scalars['Boolean']['input']>;
  enableSubmissionPdf?: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examFeedbackDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examReadingTime?: InputMaybe<Scalars['Int']['input']>;
  examStartDate?: InputMaybe<Scalars['PreciseDateTime']['input']>;
  examTiming?: InputMaybe<ExamTiming>;
  examType?: InputMaybe<Array<Scalars['String']['input']>>;
  examWritingTime?: InputMaybe<Scalars['Int']['input']>;
  gradingService?: InputMaybe<Scalars['String']['input']>;
  lateSubmissionTimeLimit?: InputMaybe<Scalars['Int']['input']>;
  markingToolPdf?: InputMaybe<MarkingToolPdf>;
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  noDraft?: InputMaybe<Scalars['Boolean']['input']>;
  noExamFeedbackDate?: InputMaybe<Scalars['Boolean']['input']>;
  noExamReadingTime?: InputMaybe<Scalars['Boolean']['input']>;
  noLimit?: InputMaybe<Scalars['Boolean']['input']>;
  noReferencing?: InputMaybe<Scalars['Boolean']['input']>;
  noTimeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  noWeight?: InputMaybe<Scalars['Boolean']['input']>;
  referencingStyle?: InputMaybe<Scalars['String']['input']>;
  restrictMarkingToolPdf?: InputMaybe<Scalars['Boolean']['input']>;
  returnDate?: InputMaybe<Scalars['DateTime']['input']>;
  sViewReports?: InputMaybe<Scalars['Int']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  wordLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type ResetQuestionModerationChangesPayload = {
  __typename?: 'ResetQuestionModerationChangesPayload';
  fieldRubrics: Array<FieldRubric>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubrics: Array<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type ResetRubricOutcomeForFieldPayload = {
  __typename?: 'ResetRubricOutcomeForFieldPayload';
  criterionOutcomesDeleted: Scalars['Int']['output'];
  fieldOutcome: FieldOutcome;
  questionOutcome: QuestionOutcome;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: WorkOutcome;
};

export type ResetRubricOutcomeForSubmissionPayload = {
  __typename?: 'ResetRubricOutcomeForSubmissionPayload';
  criterionOutcomesDeleted: Scalars['Int']['output'];
  studentOutcomes: Array<StudentOutcome>;
  submissionOutcome: SubmissionOutcome;
  workOutcome: WorkOutcome;
};

export type ResetScoreModerationChangesPayload = {
  __typename?: 'ResetScoreModerationChangesPayload';
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/** A Task resource. */
export type Resource = {
  __typename?: 'Resource';
  /** File size in bytes */
  fileSize: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invalidated: Scalars['Boolean']['output'];
  isFreshlyUploaded: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Additional notes on this resource */
  notes: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

/** Response declaration for a question field. */
export type ResponseDeclaration = {
  __typename?: 'ResponseDeclaration';
  /** Data type of the student response */
  baseType: Maybe<BaseType>;
  /** How many correct answers expected */
  cardinality: Maybe<Cardinality>;
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  correctAreas: Array<PositionArea>;
  correctRanges: Array<NumericRange>;
  correctValues: Array<Scalars['String']['output']>;
  /** Accepted margin of error */
  errorMargin: Maybe<Scalars['Float']['output']>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
  partialScoring: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseDeclarationInput = {
  baseType?: InputMaybe<BaseType>;
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  correctAreas?: InputMaybe<Array<PositionAreaInput>>;
  correctRanges?: InputMaybe<Array<NumericRangeInput>>;
  correctValues: Array<Scalars['String']['input']>;
  errorMargin?: InputMaybe<Scalars['Float']['input']>;
  matchSimilarity?: InputMaybe<Scalars['Float']['input']>;
  partialScoring?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Gradebook Result. */
export type Result = {
  __typename?: 'Result';
  /** Canvas LTI API url for a successfully recorded submission in Canvas. */
  canvasResultUrl: Maybe<Scalars['String']['output']>;
  /**
   * Find the last access summary for launching this result with the configured
   * external grading service.
   */
  feedbackAccess: Maybe<AccessSummary>;
  /** Grade information on the Result. */
  grade: Maybe<Grade>;
  /** Connection to Hera for a successfully recorded submission in Hera and Turnitin. */
  heraResultId: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Is the hera connection complete?
   * @deprecated Use receipt edge instead.
   */
  isReady: Scalars['Boolean']['output'];
  /** Moodle LTI API url for a successfully recorder submission in Moodle. */
  moodleGraderUrl: Maybe<Scalars['String']['output']>;
  /**
   * Submission pipeline processing receipt for the latest submission made in
   * this Result.
   */
  receipt: Maybe<GradebookReceipt>;
  /** When Student grades were sent to the LMS */
  returnedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Similarity information on the Result. */
  similarity: Maybe<Similarity>;
  /** Latest submission tracked in the Result */
  submission: Maybe<Submission>;
  /** Type of the Submission that the Result belongs to. */
  submissionType: SubmissionType;
  /** ID of the Work that the Result belongs to. */
  workId: Scalars['String']['output'];
};

/** Criterion with fields for reuse */
export type ReuseCriterion = {
  __typename?: 'ReuseCriterion';
  /** Parent MarkerRubric's assessment */
  assessmentName: Scalars['String']['output'];
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Parent MarkerRubric's kind */
  kind: MarkerRubricKind;
  maxScore: Maybe<Scalars['Int']['output']>;
  /** Parent MarkerRubric's published_at */
  publishedAt: Scalars['DateTime']['output'];
  scaleItems: Array<ScaleItem>;
  skill: LearningOutcomeSkill;
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Accept the charter agreement */
  acceptStudentCharter: CharterAgreement;
  /**
   * Add questions from library to the task.
   *
   * Returns newly created TaskBlocks with library questions' data copied over.
   */
  addLibraryQuestionsToTask: Array<TaskBlock>;
  /** Add questions from question bank as TaskBlocks */
  addQuestionBanksToAssessment: Array<TaskBlock>;
  /**
   * Add question selection to the task which will allow to use question sets.
   *
   * Returns created TaskBlock with question selection associated with it.
   */
  addQuestionSelectionToTask: TaskBlock;
  /** Add a tag to an enrollment */
  addTag: Tag;
  /** Append groups using group setup rules for an assessment. */
  appendGroups: Array<Group>;
  /** Append tags to the questions in given questions set, if tag's name doesn't exist in question */
  appendTagsForQuestions: Array<Question>;
  archiveQuestion: Maybe<Question>;
  assignMarkerToGroups: Maybe<Array<Group>>;
  /** Auto fill groups with students */
  autoAssignGroups: Maybe<Array<Group>>;
  /** Add a tag to multiple enrollments. */
  bulkAddTag: Array<Tag>;
  /** Remove a tag from multiple enrollments. */
  bulkRemoveTag: Scalars['Boolean']['output'];
  /** Cancel an existing Instruction Sheet release. */
  cancelRelease: CancelReleasePayload;
  /** Update user settings in a Subject context during an onboarding flow. */
  captureOnboardingInput: OnboardingPayload;
  /**
   * Finalise all submitted Criterion selection against the current student's
   * peers in the group.
   */
  completePeerOutcomes: Array<PeerOutcome>;
  /**
   * Copy Assessment accessories, which include resources, state and
   * settings from another assessment.
   */
  copyAssessment: Task;
  copyQuestion: Question;
  /** Create an attachment from an answer block. */
  createBlockAttachment: BlockAttachment;
  /** Create a draft Charter Form */
  createCharterForm: CharterForm;
  /** Create a new comment under a thread. */
  createComment: Comment;
  /** Register a file imported for question bank as an origin */
  createFileOrigin: QuestionBankFileOrigin;
  /** Create Marker Rubric via Cadmus Grader */
  createGraderMarkerRubric: CreateGraderMarkerRubricPayload;
  /** Create a new group. */
  createGroup: Group;
  /** Create multiple groups. */
  createGroups: Array<Group>;
  /** Create Marker Rubric */
  createMarkerRubric: MarkerRubric;
  createPrintArchive: Scalars['String']['output'];
  /**
   * Create a new question in the question library. It's possible to add an
   * array of children question for SUB question type. Returns the array of
   * questions created.
   */
  createQuestion: Question;
  /** Create a new question bank */
  createQuestionBank: QuestionBank;
  /** Create a new question bank category */
  createQuestionBankCategory: QuestionBankCategory;
  /** Create Marker Rubric for MFA Question via Task Builder */
  createQuestionMarkerRubric: CreateQuestionMarkerRubricPayload;
  /** Create a new Question Selection with pre-generated Question Sets */
  createQuestionSelection: CreateQuestionSelectionPayload;
  /** Create a new Link/Url Resource. */
  createResource: Resource;
  /** Create Skill */
  createSkill: LearningOutcomeSkill;
  /** Create tag with given name */
  createTag: QuestionTag;
  /** Creating a task block */
  createTaskBlock: TaskBlock;
  /**
   * Save new Task instructions for the given Assessment.
   * @deprecated Use `create_task_save_v2` instead
   */
  createTaskSave: SaveState;
  /** Save new Task instructions. */
  createTaskSaveV2: SaveState;
  /** Create a new thread. */
  createThread: Thread;
  /** Delete an existing group. */
  deleteGroup: Scalars['Boolean']['output'];
  /** Delete a member from a group. */
  deleteGroupMember: Maybe<DeletedMember>;
  /** Delete multiple groups. */
  deleteGroups: Maybe<Scalars['Int']['output']>;
  /** Invalidate an existing Link/Url Resource. */
  deleteResource: Resource;
  /** Delete a thread. */
  deleteThread: Thread;
  /** Generate a pre-signed download URL for the given save */
  downloadSavePdf: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given submissions in the
   * Assessment.
   */
  downloadSubmissions: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given work artifacts ids and filenames.
   * Single artifact will download a pdf. Multiple will create a presigned url for zip.
   */
  downloadWorkArtifacts: Scalars['String']['output'];
  /**
   * Generate a pre-signed download URL for the given work file attachments.
   * Single attachment will download the file. Multiple will create a presigned url for zip.
   */
  downloadWorkAttachments: Scalars['String']['output'];
  /** Duplicating a task block and children task blocks */
  duplicateTaskBlock: Array<TaskBlock>;
  /** Edit an existing comment. */
  editComment: Comment;
  /**
   * Change Task status to editing.
   * @deprecated Use `edit_task_v2` instead
   */
  editTask: Task;
  /** Change Task status to editing. */
  editTaskV2: Task;
  /** Edit an existing thread's title. */
  editThreadTitle: Thread;
  /**
   * Select similar questions that can be used to replace the given questions
   * in the selection.
   *
   * Similar questions are selected based on question type and points. Tags can
   * be also provided to filter the questions.
   *
   * If not enough similar questions are found, the replacement is considered
   * incomplete.
   */
  findSimilarQuestions: SimilarQuestionsPayload;
  /**
   * Make submissions for Student's works on their behalf.
   *
   * This mutation is used by the Teacher to batch submit student's latest save
   * if they haven't submitted their work on their own.
   */
  forceSubmissions: Array<Result>;
  /**
   * Make submissions for Student's works on their behalf.
   *
   * This mutation is used by the Teacher to batch submit student's latest save
   * if they haven't submitted their work on their own.
   */
  forceSubmissionsV2: Array<Result>;
  /** Generate Assessment and Student reports. */
  generateReport: Job;
  /**
   * Imports library question to the task block. If :question_version_id is not provided,
   * the task block will be populated with the :current_version of the library question.
   *
   * Returns the updated TaskBlock with library question references set.
   */
  importLibraryQuestion: TaskBlock;
  /** Queue a RosterSyncing background job for the Assessment. */
  insertSyncRosterJob: BackgroundJob;
  /** Join an existing group as a student */
  joinGroup: Group;
  /** Leave group as a student */
  leaveGroup: Group;
  /** Link a comment thread to a marking criterion. */
  linkCommentThread: Thread;
  /** Marking a Field Outcome for Marker Rubric. */
  markFieldOutcome: MarkFieldOutcomePayload;
  /** Mark a Peer student as the current student. */
  markPeerOutcome: PeerOutcome;
  /** Mark a SubmissionOutcome connected to a MarkOutcome, optionally using a Rubric. */
  markSubmissionOutcome: MarkSubmissionOutcomePayload;
  /** Publish a Charter Form */
  publishCharterForm: CharterForm;
  /** Import questions to the Question Library */
  publishImportedQuestions: Array<Question>;
  /** Publish Marker Rubric */
  publishMarkerRubric: MarkerRubric;
  /**
   * Update Question Set by replacing its questions with similar ones.
   *
   * Similar questions are selected based on the rules of the original set. If
   * no rules were defined, similar questions are selected based on the
   * question type and points. Tags can be also provided to filter the questions.
   *
   * If not enough similar questions are found, the replacement is considered
   * incomplete.
   */
  regenerateQuestionSet: RegenerateQuestionSetPayload;
  /** Register the source file with the given path and name */
  registerQuestionSourceFile: QuestionSourceFile;
  /** Release the Assessment, releasing all Tasks and publishing draft MarkerRubrics. */
  releaseAssessment: ReleaseAssessmentPayload;
  releaseFeedbackForEveryone: ReleaseFeedbackForEveryonePayload;
  /** Release the given Task, returning a new latest Instruction Sheet. */
  releaseTask: Sheet;
  /** Remove an attachment from an AnswerBlock. */
  removeBlockAttachment: BlockAttachment;
  /** Remove Marker Rubric */
  removeMarkerRubric: MarkerRubric;
  /** Remove outcomes for marker rubric */
  removeMarkerRubricOutcomes: OutcomesDeletedPayload;
  /** remove a question bank category */
  removeQuestionBankCategory: Maybe<Scalars['Boolean']['output']>;
  /**
   * Remove questions uniformly across all sets in a Question Selection.
   *
   * This mutation removes the same number of questions from each set based on
   * the similarity rules derived from the provided Question Set Questions. If
   * no explicit Question Selection Rule rules are defined, the removal is
   * guided by matching question type and points.
   */
  removeQuestionsUniformly: QuestionSelection;
  /** Remove a tag from an enrollment */
  removeTag: Scalars['Boolean']['output'];
  /** Replace a question in a Question Set with another question. */
  replaceQuestionInSet: QuestionSet;
  /** Reset all the student's given peer evaluation outcomes. */
  resetCriterionOutcomes: Scalars['Int']['output'];
  /** Remove all unexecuted feedback release rules for an assessment. */
  resetFeedbackReleaseRules: Array<FeedbackReleaseRule>;
  /** Delete all groups in an assessment. */
  resetGroups: Scalars['Boolean']['output'];
  /** Reset any un-published changes on the Marker Rubric. */
  resetMarkerRubric: MarkerRubric;
  resetModerationPenaltyRules: Array<ModerationPenaltyRule>;
  /** Reset all moderation changes made against marking rubrics for all questions. */
  resetQuestionModerationChanges: ResetQuestionModerationChangesPayload;
  /** Reset rubric outcome and related field outcomes from marker rubric */
  resetRubricOutcomeForField: ResetRubricOutcomeForFieldPayload;
  /** Reset rubric outcome and related submission outcomes from marker rubric */
  resetRubricOutcomeForSubmission: ResetRubricOutcomeForSubmissionPayload;
  /** Reset all moderation changes made against the scores of the work outcomes. */
  resetScoreModerationChanges: ResetScoreModerationChangesPayload;
  /** Resolve messages by their IDs. */
  resolveMessages: Array<Message>;
  /** Cloud save for a Work. */
  save: Save;
  /** Save a new block snapshot against an answer block. */
  saveBlockSnapshot: SaveBlockSnapshotResponse;
  /**
   * Save the editor state by updating the `snapshot_doc`
   *     and `snapshot_version`
   */
  saveCharterEditor: CharterEditor;
  /** Save Institution wide settings for the current user. */
  saveGlobalUserSettings: SaveGlobalUserSettingsPayload;
  /** Append new state to the question in a task block */
  saveQuestionState: Question;
  /**
   * Send emails to students in class with a work artifact.
   *
   * This mutation is used by the teacher to batch send Automarked PDF (`complete_pdf`s)
   * to students in their class. The submission ids are provided by the client.
   */
  sendEmailsToClass: Scalars['String']['output'];
  /** Create a new pending message in the Assessment. */
  sendMessage: Message;
  /** Create or update a Access code */
  setupAccessCode: AccessCode;
  /** Create or access the latest student Group Charter. */
  setupCharter: Charter;
  /** Setup Work document for a finalised Student group. */
  setupGroupWork: WorkGroup;
  /** Initial wizard flow setup for groups in an assessment. */
  setupGroups: Array<Group>;
  /** Create a new Task for the given Assessment. */
  setupTask: Task;
  snapshotFieldOutcome: FieldOutcome;
  /** Save new snapshot for a SubmissionOutcome feedback. */
  snapshotSubmissionOutcome: SubmissionOutcome;
  /** Mark start of a work with time limit. */
  start: Work;
  /** Draft or final Submission. */
  submit: Submission;
  /** Make a server-side submission attempt. */
  submitAttempt: Result;
  /** Submit a new sentiment check */
  submitSentimentCheck: SentimentCheck;
  /** Draft or final Submission (v2) */
  submitV2: Submission;
  /** Swap the order of two Resources. */
  swapResource: Scalars['Boolean']['output'];
  /**
   * Pass all existing final grades to the source LMS of an Assessment.
   *
   * This process happens asynchronously in the background, while the mutation
   * returns immediately.
   */
  syncGrades: Maybe<Scalars['Boolean']['output']>;
  /**
   * Perform a Roster Sync with the source LMS of an Assessment.
   *
   * Returns the list of new enrollments created, if any. The roster sync will
   * fail if the source LMS does not support it or has not provided service
   * params to sync with.
   */
  syncRoster: Array<Maybe<Enrollment>>;
  /** Unlink a comment thread from its current marking criterion. */
  unlinkCommentThread: Thread;
  /** Unlink library question references from the task block. */
  unlinkLibraryQuestion: TaskBlock;
  /** Unlock the charter agreement */
  unlockStudentCharter: CharterAgreement;
  /** Unsubmission, which is really to allow Re-submissions. */
  unsubmit: Submission;
  /** Update a existing answer block. */
  updateAnswerBlock: AnswerBlock;
  /** Update an Assessment name. */
  updateAssessmentName: Assessment;
  updateAssessmentSettings: Assessment;
  /** Update an existing Charter Form and its fields */
  updateCharterForm: CharterForm;
  /**
   * Update enrollment status(deleted/withdrawn) of a list of enrollment ids on an assessment.
   *
   * This mutation is used by the Teacher to batch withdrawn/un-withdrawn students from the classlist
   * due to the fact that NRPS is not returning the right list of students on some LMS
   */
  updateEnrollmentsStatus: Array<Enrollment>;
  /** Update the cadmus experience survey score. */
  updateExperience: Survey;
  /** Update assessment's feedback release rules as a whole. */
  updateFeedbackReleaseRules: Array<FeedbackReleaseRule>;
  updateFeedbackVisibility: FeedbackVisibility;
  /** Update the marking rubric user for a single field. */
  updateFieldRubricResponse: UpdateFieldRubricPayload;
  /** Update a file origin name */
  updateFileOrigin: QuestionBankFileOrigin;
  /** Update an existing group. */
  updateGroup: Group;
  /**
   * Bulk update user memberships across multiple existing groups.
   *
   * Returns the new complete list of an Assessment's marking groups.
   */
  updateGroupMemberships: Array<Group>;
  /** Updates the existing Insights Mailing List for the given assessment. */
  updateInsightsMailingList: MailingList;
  /** Update Marker Rubric */
  updateMarkerRubric: MarkerRubric;
  /** Upsert the milestones of a charter */
  updateMilestones: Charter;
  updateModerationPenaltyRules: Array<ModerationPenaltyRule>;
  /** Update all project issues for a Student Group to reflect the latest input state. */
  updateProjectIssue: Array<ProjectIssue>;
  updateQuestion: Question;
  /** Bulk edit attributes questions without creating a new version. */
  updateQuestionAttributes: Array<Question>;
  /** Update a question bank */
  updateQuestionBank: QuestionBank;
  /** Update (set or remove) category of a list of question banks */
  updateQuestionBanksCategory: Array<QuestionBank>;
  /**
   * Update automarking conditions for a question.
   *
   * This mutation updates automark settings at the question level, which are applied
   * to all field rubrics within the given question rubric.
   *
   * Changes trigger recalculation of student outcomes.
   */
  updateQuestionRubric: UpdateQuestionRubricPayload;
  /** Update a source file name */
  updateQuestionSourceFile: QuestionSourceFile;
  /** Update a question to save a new version */
  updateQuestionVersion: Question;
  /** Partial Requirements update. */
  updateRequirements: Requirements;
  /** Update an existing Link/Url Resource. */
  updateResource: Resource;
  /** Update the moderator modifier score on a student outcome. */
  updateStudentOutcomeScore: UpdateStudentOutcomeScorePayload;
  /** Batch update student settings. */
  updateStudentSettings: Array<Maybe<WorkSettings>>;
  /** Update all tags for a question */
  updateTagsForQuestion: Question;
  /** Update TaskBlock attributes */
  updateTaskBlock: TaskBlock;
  /** Update TaskBlocks ordering/deleted flag. Returns the updated TaskBlock */
  updateTaskBlocks: Array<TaskBlock>;
  /** Update Task Format. */
  updateTaskFormat: Task;
  /** Update thread resolution status. */
  updateThreadResolution: Thread;
  /** Update the moderator modifier score on a work outcome. */
  updateWorkOutcomeScore: UpdateWorkOutcomeScorePayload;
  /** Update a Work's settings. */
  updateWorkSettings: WorkSettings;
  verifyAccessCode: Session;
  /**
   * Withdraw feedback for the Students. Withdraws all `final`
   * WorkOutcomeReleases for the Student and Student's Group
   * (if applicable). Removes grades from the Gradebook.Result
   * for the Students.
   */
  withdrawFeedback: Array<StudentOutcome>;
};


export type RootMutationTypeAcceptStudentCharterArgs = {
  input: CharterAgreementInput;
};


export type RootMutationTypeAddLibraryQuestionsToTaskArgs = {
  questionIds: Array<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddQuestionBanksToAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
  input: Array<AddQuestionBanksToAssessmentInput>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddQuestionSelectionToTaskArgs = {
  questionSelectionId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeAddTagArgs = {
  column: InputMaybe<Scalars['Int']['input']>;
  enrollmentId: Scalars['ID']['input'];
  tab: InputMaybe<ClassTab>;
  text: Scalars['String']['input'];
};


export type RootMutationTypeAppendGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
  userIds: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootMutationTypeAppendTagsForQuestionsArgs = {
  input: Array<TagInput>;
  questionIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeArchiveQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeAssignMarkerToGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: InputMaybe<Array<Scalars['ID']['input']>>;
  markerId: Scalars['ID']['input'];
};


export type RootMutationTypeAutoAssignGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeBulkAddTagArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tab: ClassTab;
  text: Scalars['String']['input'];
};


export type RootMutationTypeBulkRemoveTagArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tab: ClassTab;
  text: Scalars['String']['input'];
};


export type RootMutationTypeCancelReleaseArgs = {
  assessmentId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type RootMutationTypeCaptureOnboardingInputArgs = {
  discipline: InputMaybe<Discipline>;
  subjectId: Scalars['ID']['input'];
  subjectRole: InputMaybe<SubjectRole>;
};


export type RootMutationTypeCompletePeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCopyAssessmentArgs = {
  destinationAssessmentId: Scalars['ID']['input'];
  sourceInstructionSheetId: Scalars['ID']['input'];
};


export type RootMutationTypeCopyQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateBlockAttachmentArgs = {
  answerBlockId: Scalars['ID']['input'];
  mediaId: Scalars['ID']['input'];
  mediaUrl: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateCharterFormArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateCommentArgs = {
  content: Scalars['String']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateFileOriginArgs = {
  input: CreateQuestionBankFileOriginInput;
};


export type RootMutationTypeCreateGraderMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateGraderMarkerRubricInput;
};


export type RootMutationTypeCreateGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  group: GroupInput;
};


export type RootMutationTypeCreateGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groups: Array<GroupInput>;
};


export type RootMutationTypeCreateMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateMarkerRubricInput;
};


export type RootMutationTypeCreatePrintArchiveArgs = {
  input: PrintArchiveInput;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateQuestionArgs = {
  assessmentId: Scalars['ID']['input'];
  childrenQuestions: InputMaybe<Array<QuestionAttributes>>;
  input: QuestionAttributes;
  subjectId: Scalars['ID']['input'];
  tags: InputMaybe<Array<TagInput>>;
};


export type RootMutationTypeCreateQuestionBankArgs = {
  questionBank: CreateQuestionBankInput;
};


export type RootMutationTypeCreateQuestionBankCategoryArgs = {
  input: QuestionBankCategoryInput;
};


export type RootMutationTypeCreateQuestionMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateQuestionMarkerRubricInput;
};


export type RootMutationTypeCreateQuestionSelectionArgs = {
  input: QuestionSelectionInput;
};


export type RootMutationTypeCreateResourceArgs = {
  assessmentId: Scalars['ID']['input'];
  fileSize: InputMaybe<Scalars['Int']['input']>;
  mediaId: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes: InputMaybe<Scalars['String']['input']>;
  taskId: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
};


export type RootMutationTypeCreateSkillArgs = {
  assessmentId: Scalars['ID']['input'];
  input: CreateSkillInput;
};


export type RootMutationTypeCreateTagArgs = {
  name: Scalars['String']['input'];
};


export type RootMutationTypeCreateTaskBlockArgs = {
  input: InputMaybe<CreateTaskBlockInput>;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateTaskSaveArgs = {
  assessmentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  editor: InputMaybe<EditorType>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeCreateTaskSaveV2Args = {
  content: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeCreateThreadArgs = {
  input: ThreadInput;
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupMemberArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  groupIds: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RootMutationTypeDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadSavePdfArgs = {
  saveId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeDownloadSubmissionsArgs = {
  assessmentId: Scalars['ID']['input'];
  preferPdf: InputMaybe<Scalars['Boolean']['input']>;
  submissions: Array<SubmissionDetailInput>;
};


export type RootMutationTypeDownloadWorkArtifactsArgs = {
  assessmentId: Scalars['ID']['input'];
  workArtifacts: Array<WorkArtifactDetailInput>;
};


export type RootMutationTypeDownloadWorkAttachmentsArgs = {
  answerBlockId: Scalars['ID']['input'];
  blockAttachmentIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeDuplicateTaskBlockArgs = {
  taskBlockId: Scalars['ID']['input'];
};


export type RootMutationTypeEditCommentArgs = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type RootMutationTypeEditTaskArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeEditTaskV2Args = {
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeEditThreadTitleArgs = {
  threadId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeFindSimilarQuestionsArgs = {
  input: FindSimilarQuestionsInput;
};


export type RootMutationTypeForceSubmissionsArgs = {
  assessmentId: Scalars['ID']['input'];
  submittedAt: Scalars['DateTime']['input'];
  type: SubmissionType;
  workIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeForceSubmissionsV2Args = {
  assessmentId: Scalars['ID']['input'];
  submittedAt: Scalars['DateTime']['input'];
  type: SubmissionType;
  workIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeGenerateReportArgs = {
  anonymousName: InputMaybe<Scalars['String']['input']>;
  assessmentId: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeImportLibraryQuestionArgs = {
  input: ImportLibraryQuestionInput;
};


export type RootMutationTypeInsertSyncRosterJobArgs = {
  assessmentId: Scalars['ID']['input'];
  extensionConflictAction?: InputMaybe<ExtensionConflictActionType>;
  withExtensions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeJoinGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeLeaveGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeLinkCommentThreadArgs = {
  assessmentId: Scalars['ID']['input'];
  criterionId: Scalars['Int']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeMarkFieldOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkFieldOutcomeInput;
};


export type RootMutationTypeMarkPeerOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkPeerOutcomeInput;
};


export type RootMutationTypeMarkSubmissionOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: MarkSubmissionOutcomeInput;
};


export type RootMutationTypePublishCharterFormArgs = {
  charterFormId: Scalars['ID']['input'];
};


export type RootMutationTypePublishImportedQuestionsArgs = {
  input: PublishImportedQuestionsInput;
};


export type RootMutationTypePublishMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRegenerateQuestionSetArgs = {
  input: RegenerateQuestionSetInput;
};


export type RootMutationTypeRegisterQuestionSourceFileArgs = {
  input: RegisterQuestionSourceFileInput;
};


export type RootMutationTypeReleaseAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypeReleaseFeedbackForEveryoneArgs = {
  assessmentId: Scalars['ID']['input'];
  feedbackVisibility: InputMaybe<FeedbackVisibilityInput>;
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeReleaseTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<Scalars['ReleaseType']['input']>;
  saveId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootMutationTypeRemoveBlockAttachmentArgs = {
  blockAttachmentId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveMarkerRubricOutcomesArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveQuestionBankCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveQuestionsUniformlyArgs = {
  input: RemoveQuestionsUniformlyInput;
};


export type RootMutationTypeRemoveTagArgs = {
  column: InputMaybe<Scalars['Int']['input']>;
  enrollmentId: Scalars['ID']['input'];
  tab: InputMaybe<ClassTab>;
  text: Scalars['String']['input'];
};


export type RootMutationTypeReplaceQuestionInSetArgs = {
  input: ReplaceQuestionInSetInput;
};


export type RootMutationTypeResetCriterionOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeResetGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetMarkerRubricArgs = {
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetQuestionModerationChangesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeForFieldArgs = {
  assessmentId: Scalars['ID']['input'];
  fieldOutcomeId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeResetRubricOutcomeForSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  submissionOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeResetScoreModerationChangesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeResolveMessagesArgs = {
  assessmentId: Scalars['ID']['input'];
  messageIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeSaveArgs = {
  content: Scalars['String']['input'];
  dispatchedAt: Scalars['DateTime']['input'];
  editor: InputMaybe<EditorType>;
  metadata: InputMaybe<SaveMetadataInput>;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveBlockSnapshotArgs = {
  answerBlockId: Scalars['ID']['input'];
  previousBlockSnapshotId: InputMaybe<Scalars['ID']['input']>;
  snapshotContent: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  wordCountChange: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSaveCharterEditorArgs = {
  input: CharterEditorInput;
};


export type RootMutationTypeSaveGlobalUserSettingsArgs = {
  userSettingsInput: GlobalUserSettingsInput;
};


export type RootMutationTypeSaveQuestionStateArgs = {
  input: SaveQuestionStateInput;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeSendEmailsToClassArgs = {
  assessmentId: Scalars['ID']['input'];
  submissionIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type RootMutationTypeSendMessageArgs = {
  assessmentId: Scalars['ID']['input'];
  message: MessageInput;
};


export type RootMutationTypeSetupAccessCodeArgs = {
  assessmentId: Scalars['ID']['input'];
  input: AccessCodeInput;
};


export type RootMutationTypeSetupCharterArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupGroupWorkArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootMutationTypeSetupGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
};


export type RootMutationTypeSetupTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: TaskKind;
};


export type RootMutationTypeSnapshotFieldOutcomeArgs = {
  fieldOutcomeId: Scalars['ID']['input'];
  input: SnapshotFieldOutcomeInput;
};


export type RootMutationTypeSnapshotSubmissionOutcomeArgs = {
  input: SnapshotSubmissionOutcomeInput;
  submissionOutcomeId: Scalars['ID']['input'];
};


export type RootMutationTypeStartArgs = {
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitArgs = {
  acceptedDeclaration: Scalars['Boolean']['input'];
  editor: InputMaybe<EditorType>;
  saveId: Scalars['ID']['input'];
  sessionId: InputMaybe<Scalars['String']['input']>;
  submittedAt: InputMaybe<Scalars['DateTime']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitAttemptArgs = {
  attemptNumber: Scalars['Int']['input'];
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitSentimentCheckArgs = {
  assessmentId: Scalars['ID']['input'];
  input: SentimentCheckInput;
};


export type RootMutationTypeSubmitV2Args = {
  blockSnapshotIds: Array<Scalars['ID']['input']>;
  forceSubmitted: InputMaybe<Scalars['Boolean']['input']>;
  submittedAt: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy: InputMaybe<Scalars['String']['input']>;
  type: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeSwapResourceArgs = {
  firstId: Scalars['ID']['input'];
  secondId: Scalars['ID']['input'];
};


export type RootMutationTypeSyncGradesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootMutationTypeSyncRosterArgs = {
  assessmentId: Scalars['ID']['input'];
  extensionConflictAction?: InputMaybe<ExtensionConflictActionType>;
  withExtensions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootMutationTypeUnlinkCommentThreadArgs = {
  assessmentId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeUnlinkLibraryQuestionArgs = {
  input: UnlinkLibraryQuestionInput;
};


export type RootMutationTypeUnlockStudentCharterArgs = {
  input: CharterAgreementInput;
};


export type RootMutationTypeUnsubmitArgs = {
  submissionId: Scalars['ID']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateAnswerBlockArgs = {
  answerBlockId: Scalars['ID']['input'];
  input: UpdateAnswerBlockInput;
};


export type RootMutationTypeUpdateAssessmentNameArgs = {
  assessmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type RootMutationTypeUpdateAssessmentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  input: AssessmentSettingsInput;
};


export type RootMutationTypeUpdateCharterFormArgs = {
  input: CharterFormInput;
};


export type RootMutationTypeUpdateEnrollmentsStatusArgs = {
  assessmentId: Scalars['ID']['input'];
  enrollmentIds: Array<Scalars['ID']['input']>;
  withdrawn: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateExperienceArgs = {
  score: Scalars['Int']['input'];
  workId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
  rules: Array<FeedbackReleaseRuleInput>;
};


export type RootMutationTypeUpdateFeedbackVisibilityArgs = {
  assessmentId: Scalars['ID']['input'];
  input: FeedbackVisibilityInput;
  releaseType: InputMaybe<FeedbackReleaseType>;
};


export type RootMutationTypeUpdateFieldRubricResponseArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateFieldRubricInput;
};


export type RootMutationTypeUpdateFileOriginArgs = {
  input: UpdateQuestionBankFileOriginInput;
};


export type RootMutationTypeUpdateGroupArgs = {
  assessmentId: Scalars['ID']['input'];
  group: GroupUpdateInput;
};


export type RootMutationTypeUpdateGroupMembershipsArgs = {
  assessmentId: Scalars['ID']['input'];
  memberships: Array<GroupMembershipInput>;
};


export type RootMutationTypeUpdateInsightsMailingListArgs = {
  assessmentId: Scalars['ID']['input'];
  members: Array<Scalars['String']['input']>;
  subscribed: Scalars['Boolean']['input'];
};


export type RootMutationTypeUpdateMarkerRubricArgs = {
  input: MarkerRubricInput;
  markerRubricId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateMilestonesArgs = {
  input: UpdateMilestonesInput;
};


export type RootMutationTypeUpdateModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
  rules: Array<ModerationPenaltyRuleInput>;
};


export type RootMutationTypeUpdateProjectIssueArgs = {
  input: UpdateProjectIssueInput;
};


export type RootMutationTypeUpdateQuestionArgs = {
  input: QuestionAttributesInput;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateQuestionAttributesArgs = {
  input: QuestionAttributesInput;
  questionIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeUpdateQuestionBankArgs = {
  questionBank: UpdateQuestionBankInput;
};


export type RootMutationTypeUpdateQuestionBanksCategoryArgs = {
  input: UpdateQuestionBanksCategoryInput;
};


export type RootMutationTypeUpdateQuestionRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateQuestionRubricInput;
};


export type RootMutationTypeUpdateQuestionSourceFileArgs = {
  input: UpdateQuestionSourceFileInput;
};


export type RootMutationTypeUpdateQuestionVersionArgs = {
  childrenQuestions: InputMaybe<Array<UpdateQuestionVersionInput>>;
  input: UpdateQuestionVersionInput;
};


export type RootMutationTypeUpdateRequirementsArgs = {
  assessmentId: Scalars['ID']['input'];
  requirements: RequirementsInput;
};


export type RootMutationTypeUpdateResourceArgs = {
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateStudentOutcomeScoreArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateStudentOutcomeScoreInput;
  studentId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateStudentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  settings: Array<InputMaybe<StudentSettingsInput>>;
};


export type RootMutationTypeUpdateTagsForQuestionArgs = {
  input: Array<TagInput>;
  questionId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateTaskBlockArgs = {
  input: UpdateTaskBlockInput;
  taskBlockId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateTaskBlocksArgs = {
  taskBlockList: Array<UpdateTaskBlocksInput>;
};


export type RootMutationTypeUpdateTaskFormatArgs = {
  format: TaskFormat;
  taskId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateThreadResolutionArgs = {
  resolved: Scalars['Boolean']['input'];
  threadId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateWorkOutcomeScoreArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateWorkOutcomeScoreInput;
};


export type RootMutationTypeUpdateWorkSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
  draftExamEndDate: InputMaybe<Scalars['String']['input']>;
  draftExamStartDate: InputMaybe<Scalars['String']['input']>;
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  enrollmentId: Scalars['ID']['input'];
  examDeferred: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate: InputMaybe<Scalars['DateTime']['input']>;
  examReadingTime: InputMaybe<Scalars['Int']['input']>;
  examStartDate: InputMaybe<Scalars['DateTime']['input']>;
  examWritingTime: InputMaybe<Scalars['Int']['input']>;
  timeLimit: InputMaybe<Scalars['Int']['input']>;
  updateReason: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeVerifyAccessCodeArgs = {
  assessmentId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};


export type RootMutationTypeWithdrawFeedbackArgs = {
  assessmentId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Token to use for making API calls to all Cadmus services */
  apiToken: Scalars['String']['output'];
  /** A single assessment. */
  assessment: Assessment;
  assessmentAccessCodes: Maybe<Array<AccessCode>>;
  /** All Student Group Charter documents in the Assessment. */
  assessmentCharters: Array<Charter>;
  assessmentProjectIssues: Array<ProjectIssue>;
  /** List all Sentiment Checks submitted by students in an Assessment. */
  assessmentSentimentChecks: Array<SentimentCheck>;
  /** Lookup existing background job. */
  backgroundJob: Maybe<BackgroundJob>;
  /** Access the Brightspace REST API as the current user via OAuth2 interface. */
  brightspaceApi: BrightspaceApi;
  /** Access the Canvas REST API as the current user via OAuth2 interface. */
  canvasApi: CanvasApi;
  /** Student group charter document */
  charter: Charter;
  /** Assessment's Group Charter form (draft or published) */
  charterForm: Maybe<CharterForm>;
  /** Complete Class information for an Assessment's cohort. */
  class: Class;
  /**
   * A full Class list for the given Assessment.
   * @deprecated Use `class` query field instead
   */
  classList: ClassList;
  /** All Peer Outcomes in a Class, for teacher eyes only. */
  classPeerOutcomes: Array<PeerOutcome>;
  /** All Work Groups in a Group Assessment. */
  classWorkGroups: Array<WorkGroup>;
  /** Reusing Scale Items by Skill */
  criteriaBySkill: Array<ReuseCriterion>;
  /** Fetch threads by entity ID and type. */
  entityThreads: Array<Thread>;
  /** MarkerRubric lookup by ID and document status. */
  extendedRubric: Maybe<MarkerRubric>;
  /** Feature flags enabled in the user's context. */
  featureFlags: InstitutionFeatures;
  /** Feedback Release Rule: schedule feedback release based on filters. */
  feedbackReleaseRules: Array<FeedbackReleaseRule>;
  /**
   * feedback visibility for assessment
   * @deprecated Use `feedback_visibility_for_type` instead
   */
  feedbackVisibility: FeedbackVisibility;
  /** feedback visibility for assessment */
  feedbackVisibilityForType: FeedbackVisibility;
  /** Future scheduled Instruction sheet, if any */
  futureSheet: Maybe<Sheet>;
  groupList: Array<Group>;
  /** Peer Outcomes for members of a Student Group. */
  groupPeerOutcomes: Array<PeerOutcome>;
  /** List Sentiment Checks submitted by students in a group. */
  groupSentimentChecks: Array<SentimentCheck>;
  /** Work Outcome for a Student Group in an assessment. */
  groupWorkOutcome: Maybe<WorkOutcome>;
  /**
   * Groups for assessment.
   * @deprecated Use `class` query field instead
   */
  groups: Array<Group>;
  /**
   * Assessment's latest Insights mailing list consisting of teacher emails who
   * want to receive Insight updates via email.
   */
  insightsMailingList: MailingList;
  /** Current user Institution. */
  institution: Institution;
  /** InstructionSheet within an Assessment defaulting to the latest. */
  instructionSheet: Maybe<Sheet>;
  /**
   * Latest Gradebook result for a particular submission type.
   *
   * This field always tries to resolve to the most up to date information, and
   * can also query Hera (and in turn Turnitin) to get it.
   */
  latestResult: Result;
  /** List of lecturers for an assessment */
  lecturers: Array<User>;
  /** Lists all library questions viewable by the current user. */
  libraryQuestions: Array<Question>;
  /** MarkerRubric lookup in an Assessment for a given kind and document status. */
  markerRubric: Maybe<MarkerRubric>;
  /** Current logged in User profile */
  me: User;
  /** List messages receivable by current user. */
  messageInbox: Array<Message>;
  /** Moderation Penalty Rule: penalties to apply on feedback release. */
  moderationPenaltyRules: Maybe<Array<ModerationPenaltyRule>>;
  /** Past instruction sheets that the user has been involved in. */
  pastInstructionSheets: Array<PastInstructionSheet>;
  /** Past Marker Rubrics */
  pastMarkerRubrics: Array<MarkerRubric>;
  /** Peer Rubric for Students */
  peerRubric: Maybe<MarkerRubric>;
  /** URL for a expected PrintInstruction archive, if it is ready. */
  printArchiveUrl: Maybe<Scalars['String']['output']>;
  /** List of issues in a student Group's project board. */
  projectIssues: Array<ProjectIssue>;
  /** Single library published question */
  question: Maybe<Question>;
  questionBankCategories: Array<QuestionBankCategory>;
  questionBanks: Array<QuestionBank>;
  /** Single question rubric. */
  questionRubric: QuestionRubric;
  questionSelection: Maybe<QuestionSelection>;
  /** All Tag categories in the Question Library for the current Tenant */
  questionTagCategories: Array<QuestionTagCategory>;
  /** List of all selected question blocks in the Task. */
  questionTree: Array<QuestionBlock>;
  /** Select a known past Question version */
  questionVersion: Maybe<QuestionVersion>;
  /** Assessment's marking rubrics. */
  rubric: Maybe<Rubric>;
  /** @deprecated Please use :api_token instead, which is more scoped */
  serviceToken: Scalars['String']['output'];
  /** User's session information. */
  session: Session;
  /**
   * Current Session ID tied to the user's authenticated session.
   * @deprecated Please use the `session` field instead.
   */
  sessionId: Scalars['String']['output'];
  /** Learning Outcome Skills for the Tenant. */
  skills: Array<LearningOutcomeSkill>;
  /** Learning Outcome Skills used in the Assessment. */
  skillsByAssessment: Array<LearningOutcomeSkill>;
  /** Student Outcome in an Assessment */
  studentOutcome: StudentOutcome;
  /** Student Outcomes in an Assessment */
  studentOutcomes: Array<StudentOutcome>;
  /** The current student's Peer Outcome in the Assessment. */
  studentPeerOutcome: Maybe<PeerOutcome>;
  /** Current student users' Work Group in the Assessment. */
  studentWorkGroup: Maybe<WorkGroup>;
  /** Work Outcome for a Student in an assessment. */
  studentWorkOutcome: Maybe<WorkOutcome>;
  /** A single assessment task of a specific kind. */
  task: Maybe<Task>;
  /** Fetch a thread by ID. */
  thread: Thread;
  /** Fetch multiple threads by IDs. */
  threads: Array<Thread>;
  /** Token for Current User token authentication with Phoenix channels. */
  token: Scalars['String']['output'];
  /** Lookup complete user settings for an asseessment */
  userSettings: Maybe<UserSettings>;
  /** A single Work. */
  work: Work;
  /** Outcome recorded for a student's work. */
  workOutcome: Maybe<WorkOutcome>;
  /** Work Outcomes in an Assessment. */
  workOutcomes: Array<WorkOutcome>;
};


export type RootQueryTypeApiTokenArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentAccessCodesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentChartersArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentProjectIssuesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeAssessmentSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeBackgroundJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type RootQueryTypeBrightspaceApiArgs = {
  assessmentId: Scalars['ID']['input'];
  brightspaceScopeFor?: InputMaybe<BrightspaceScopeKeyType>;
};


export type RootQueryTypeCanvasApiArgs = {
  assessmentId: Scalars['ID']['input'];
  canvasScopeFor?: InputMaybe<CanvasScopeKeyType>;
};


export type RootQueryTypeCharterArgs = {
  charterId: Scalars['ID']['input'];
};


export type RootQueryTypeCharterFormArgs = {
  assessmentId: Scalars['ID']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeClassArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassPeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeClassWorkGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeCriteriaBySkillArgs = {
  assessmentId: Scalars['ID']['input'];
  skillId: Scalars['ID']['input'];
};


export type RootQueryTypeEntityThreadsArgs = {
  entityId: InputMaybe<Scalars['ID']['input']>;
  entityIds: InputMaybe<Array<Scalars['ID']['input']>>;
  entityType: EntityType;
};


export type RootQueryTypeExtendedRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  status: MarkerRubricStatus;
};


export type RootQueryTypeFeatureFlagsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeFeedbackReleaseRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeFeedbackVisibilityArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeFeedbackVisibilityForTypeArgs = {
  assessmentId: Scalars['ID']['input'];
  releaseType: FeedbackReleaseType;
};


export type RootQueryTypeFutureSheetArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
};


export type RootQueryTypeGroupListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeGroupPeerOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGroupSentimentChecksArgs = {
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};


export type RootQueryTypeGroupWorkOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeGroupsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeInsightsMailingListArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeInstructionSheetArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
  sheetId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeLatestResultArgs = {
  submissionType: SubmissionType;
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeLecturersArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeMarkerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
  status: MarkerRubricStatus;
};


export type RootQueryTypeMessageInboxArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeModerationPenaltyRulesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePastMarkerRubricsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePeerRubricArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypePrintArchiveUrlArgs = {
  archiveId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeProjectIssuesArgs = {
  groupId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionBankCategoriesArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId: InputMaybe<Scalars['ID']['input']>;
  subjectId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeQuestionBanksArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
  subjectGroupId: InputMaybe<Scalars['ID']['input']>;
  subjectId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeQuestionRubricArgs = {
  questionRubricId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionSelectionArgs = {
  questionSelectionId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionTreeArgs = {
  selectionInput: Array<QuestionSelectionFilterInput>;
  taskId: Scalars['ID']['input'];
};


export type RootQueryTypeQuestionVersionArgs = {
  questionId: InputMaybe<Scalars['ID']['input']>;
  version: InputMaybe<Scalars['Int']['input']>;
  versionId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeRubricArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeSkillsByAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentPeerOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentWorkGroupArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootQueryTypeStudentWorkOutcomeArgs = {
  assessmentId: Scalars['ID']['input'];
  studentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeTaskArgs = {
  assessmentId: Scalars['ID']['input'];
  kind: InputMaybe<TaskKind>;
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootQueryTypeThreadsArgs = {
  threadIds: Array<Scalars['ID']['input']>;
};


export type RootQueryTypeUserSettingsArgs = {
  assessmentId: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeWorkArgs = {
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeWorkOutcomeArgs = {
  workId: Scalars['ID']['input'];
};


export type RootQueryTypeWorkOutcomesArgs = {
  assessmentId: Scalars['ID']['input'];
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** Subscribe to updates for AssessmentSettings */
  assessmentSettings: AssessmentSettings;
  /** Notification on number of enrollments updated */
  enrollmentsUpdated: Scalars['Int']['output'];
  /** Subscribe to thread updates for a specific entity (e.g., answer block). Receives lightweight thread lifecycle events. */
  entityThreadsUpdated: EntityThreadEvent;
  /** Subscription for field outcome batch updates. */
  fieldOutcomesUpdated: Maybe<Array<Maybe<FieldOutcome>>>;
  /** Subscription for field_rubric updates. */
  fieldRubricsUpdated: Array<FieldRubric>;
  /** Future sheet release schedule timestamp */
  futureReleaseSchedule: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Subscription for when a group is updated by self enrollment. */
  groupUpdated: Group;
  /** At least one submission has been made in the Assessment. */
  hasSubmission: Scalars['Boolean']['output'];
  /**
   * A Gradebook Result update in an Assessment.
   * @deprecated Use `results_updated` instead
   */
  resultUpdated: Result;
  /** Multiple Gradebook Results updated in an Assessment. */
  resultsUpdated: Array<Result>;
  /** New Instruction Sheet release. */
  sheetReleased: Sheet;
  /** Subscription for student outcomes updates for an assessment */
  studentOutcomesUpdated: Array<StudentOutcome>;
  /** Subscribe to conversation updates for a specific thread. Receives comment additions, edits, and title changes. */
  threadConversationUpdated: ConversationEvent;
  /** [DEPRECATED] Subscribe to thread updates. Use entity_threads_updated for thread lifecycle events or thread_conversation_updated for comment events. */
  threadUpdated: Thread;
  /**
   * Subscription for work outcome batch updates.
   * @deprecated use `student_outcomes_updated`
   */
  workOutcomesUpdated: Array<WorkOutcome>;
  /** Pdf Artifact created in an assessment. */
  workPdfCreated: WorkArtifact;
  /** Update for a Gradebook result for a particular Work only. */
  workResultUpdated: Result;
  /** Update for a Work Settings. */
  workSettingsUpdated: WorkSettings;
  /** Update for work started */
  workStarted: Work;
  /** A Work has a new submission. */
  workSubmitted: Submission;
  /** A Work has been updated. Usually it's the settings that update for a work. */
  workUpdated: Work;
  /** A list of works' settings has been updated */
  worksSettingsUpdated: Array<Maybe<WorkSettings>>;
  /**
   * Multiple Works were submitted in the assessment.
   * @deprecated Use `results_updated` instead for updates on multiple submissions.
   */
  worksSubmitted: Array<Submission>;
};


export type RootSubscriptionTypeAssessmentSettingsArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEnrollmentsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeEntityThreadsUpdatedArgs = {
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
};


export type RootSubscriptionTypeFieldOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeFieldRubricsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeFutureReleaseScheduleArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeGroupUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeHasSubmissionArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeResultUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeResultsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeSheetReleasedArgs = {
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
};


export type RootSubscriptionTypeStudentOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeThreadConversationUpdatedArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeThreadUpdatedArgs = {
  threadId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkOutcomesUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkPdfCreatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkResultUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkSettingsUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkStartedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkSubmittedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkUpdatedArgs = {
  workId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorksSettingsUpdatedArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorksSubmittedArgs = {
  assessmentId: Scalars['ID']['input'];
};

/** An Assessment's marking rubrics. */
export type Rubric = {
  __typename?: 'Rubric';
  id: Scalars['ID']['output'];
  questions: Array<QuestionRubric>;
};

/** Marking outcome from using a MarkerRubric to score the parent Outcome. */
export type RubricOutcome = {
  __typename?: 'RubricOutcome';
  criterionOutcomes: Array<CriterionOutcome>;
  score: Maybe<Scalars['Float']['output']>;
};

export enum RuleKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Joint = 'JOINT'
}

/** A Save for a work. */
export type Save = {
  __typename?: 'Save';
  /** Fetched contents of the embedded S3 Store reference. */
  content: Scalars['String']['output'];
  dispatchedAt: Scalars['PreciseDateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Database ID of the persisted save.
   *
   * This always reflects the actual table primary key of the Save, even when the
   * the `:id` value is some constant string. Sometimes the `:id` field has to
   * resolve to a constant string to make the client side cache always hit.
   */
  serverId: Scalars['ID']['output'];
  /** S3 object version ID. */
  version: Scalars['String']['output'];
};

/** Response for saving a block snapshot */
export type SaveBlockSnapshotResponse = {
  __typename?: 'SaveBlockSnapshotResponse';
  blockSnapshot: BlockSnapshot;
};

/** Mutation return for `saveGlobalUserSettings`. */
export type SaveGlobalUserSettingsPayload = {
  __typename?: 'SaveGlobalUserSettingsPayload';
  userSettings: Maybe<UserSettings>;
};

export type SaveMetadataInput = {
  assessmentId: Scalars['String']['input'];
  prevSaveId?: InputMaybe<Scalars['String']['input']>;
  prevVersionId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated will be automatically added from session */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['String']['input'];
};

/** Question state append attributes */
export type SaveQuestionStateInput = {
  feedback: Scalars['String']['input'];
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<QuestionFieldInput>>;
  /** Question prompt prosemirror contents */
  promptDoc?: InputMaybe<Scalars['String']['input']>;
  /** Question Prompt Image information and associated layers for a question prompt. */
  promptImage?: InputMaybe<PromptImageInput>;
  /** Question type */
  questionType: QuestionType;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
};

/** Latest Task content save. */
export type SaveState = {
  __typename?: 'SaveState';
  /** Latest Task save ID. */
  id: Scalars['ID']['output'];
  /** JSON serialised raw content in this save. */
  rawContent: Maybe<Scalars['String']['output']>;
  /** The persisted TaskState server ID */
  serverId: Scalars['ID']['output'];
  updatedAt: Scalars['PreciseDateTime']['output'];
  version: Scalars['Int']['output'];
};

export type ScaleItem = {
  __typename?: 'ScaleItem';
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  order: Scalars['Int']['output'];
  rangeFrom: Maybe<Scalars['Float']['output']>;
  rangeTo: Maybe<Scalars['Float']['output']>;
  scaleLabel: Maybe<Scalars['String']['output']>;
};

export type ScaleItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  rangeFrom?: InputMaybe<Scalars['Int']['input']>;
  rangeTo?: InputMaybe<Scalars['Int']['input']>;
  scaleLabel?: InputMaybe<Scalars['String']['input']>;
};

/** Score Breakdown */
export type ScoreBreakdown = {
  __typename?: 'ScoreBreakdown';
  automark: Maybe<Scalars['Float']['output']>;
  automarkScore: Maybe<Scalars['Float']['output']>;
  marker: Maybe<Scalars['Float']['output']>;
  markerModifier: Maybe<Scalars['Float']['output']>;
  markerScore: Maybe<Scalars['Float']['output']>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  score: Maybe<Scalars['Float']['output']>;
};

/** A sentiment check */
export type SentimentCheck = {
  __typename?: 'SentimentCheck';
  comment: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  level: Maybe<SentimentCheckLevel>;
  order: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  user: User;
};

export type SentimentCheckInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<SentimentCheckLevel>;
  skipped: Scalars['Boolean']['input'];
};

/** Enum of sentiment check levels */
export enum SentimentCheckLevel {
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED'
}

/** Session information */
export type Session = {
  __typename?: 'Session';
  /** Session ID */
  id: Scalars['ID']['output'];
  /** Verification status for a session tied to an enrollment. */
  verified: Scalars['Boolean']['output'];
};


/** Session information */
export type SessionVerifiedArgs = {
  assessmentId: Scalars['ID']['input'];
};

export type SetupGroupInput = {
  divideEqually?: InputMaybe<Scalars['Boolean']['input']>;
  excludedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  groupAssessmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupRules?: InputMaybe<Array<GroupRule>>;
  groupSelfEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  groupSelfEnrollmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  groupType: GroupType;
  maxLimit?: InputMaybe<Scalars['Int']['input']>;
  minLimit?: InputMaybe<Scalars['Int']['input']>;
};

export enum Shape {
  Ellipse = 'ellipse',
  Point = 'point',
  Polygon = 'polygon',
  Rectangle = 'rectangle'
}

/** Latest Instruction sheet for an Assessment. */
export type Sheet = {
  __typename?: 'Sheet';
  /** If generative AI is allowed */
  allowGenerativeAi: Maybe<Scalars['Boolean']['output']>;
  /** Allow late re-submissions or not. */
  allowLateResubmission: Scalars['Boolean']['output'];
  /** If anonymous marking is enabled */
  anonymousMarking: Maybe<Scalars['Boolean']['output']>;
  /** Assessment Type */
  assessmentType: AssessmentType;
  /**
   * List of released TaskBlocks in the Sheet
   * @deprecated Use the `question_blocks` field instead
   */
  blocks: Array<TaskBlock>;
  /** If footnotes should be counted as part of the word limit. */
  countFootnotes: Scalars['Boolean']['output'];
  /** If references should be counted as part of the word limit. */
  countReferences: Scalars['Boolean']['output'];
  /**
   * Type of submissions currently being accepted.
   *
   * This can never be `nil` as the `:sheet` should always have a Final due date.
   *
   * Note that the comparison with the draft due date allows a grace period of 1
   * hour.
   * @deprecated Use client side logic to determine submission type based on due dates.
   */
  currentSubmissionType: SubmissionType;
  /** Whether backtrack navigation is disabled in exam */
  disableExamBacktrack: Maybe<Scalars['Boolean']['output']>;
  /** Whether students cannot use the Cadmus Spell Check feature. */
  disableSpellCheck: Scalars['Boolean']['output'];
  /** Draft submission due date if drafting is enabled */
  draftDueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Latest setting value for draft_s_view_reports. */
  draftSViewReports: Scalars['Int']['output'];
  /** Final Submission due date. */
  dueDate: Scalars['PreciseDateTime']['output'];
  /** Whether to enable access code for exam */
  enableExamAccessCode: Scalars['Boolean']['output'];
  enableExamAutoSubmission: Scalars['Boolean']['output'];
  /** Whether to enable exam LDB flow for student */
  enableExamLdb: Maybe<Scalars['Boolean']['output']>;
  /** Enable or disable PDF attachment in submission receipts. */
  enableSubmissionPdf: Scalars['Boolean']['output'];
  examEndDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examFeedbackDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examStartDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examTiming: ExamTiming;
  examType: Array<Scalars['String']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  /** Released task format */
  format: TaskFormat;
  /** Selected grading integration. Either `turnitin` or `speedgrader` or `moodlegrader` currently. */
  gradingService: Scalars['String']['output'];
  /**
   * Task ID for which this sheet is released.
   *
   * NOTE: this is the Task ID and not the actual sheet ID which changes from
   * sheet to sheet. Use `serverId` for the actual sheet ID. This was done for
   * automatic cache replacement in apollo client for new sheets.
   */
  id: Scalars['String']['output'];
  kind: TaskKind;
  lateSubmissionTimeLimit: Maybe<Scalars['Int']['output']>;
  /** If not restricted then the student result view only unmarked or unmarked and automarked. */
  markingToolPdf: Maybe<MarkingToolPdf>;
  /** Maximum grade points. */
  maxGrade: Scalars['Int']['output'];
  /** When the next sheet, if any, will be released. */
  nextReleaseTimestamp: Maybe<Scalars['PreciseDateTime']['output']>;
  noExamFeedbackDate: Scalars['Boolean']['output'];
  /** Flattened Question Tree */
  questionBlocks: Array<QuestionBlock>;
  /** Serialised Editor contents of the Task body with other embedded metadata */
  rawContent: Maybe<Scalars['String']['output']>;
  /** The style of referencing to be used for the assessment. */
  referencingStyle: Maybe<Scalars['String']['output']>;
  /** When the sheet was released. */
  releaseTimestamp: Scalars['PreciseDateTime']['output'];
  /** List of released resources. */
  resources: Array<Resource>;
  /** Feedback return date. */
  returnDate: Scalars['PreciseDateTime']['output'];
  /** Latest setting value for s_view_reports. */
  sViewReports: Scalars['Int']['output'];
  /** Actual TaskHistory primary ID. */
  serverId: Scalars['ID']['output'];
  /** Source Task ID for the Sheet */
  taskId: Scalars['ID']['output'];
  timeLimit: Maybe<Scalars['Int']['output']>;
  /** Task save version number from which the Sheet was created. */
  version: Scalars['Int']['output'];
  weight: Maybe<Scalars['Float']['output']>;
  wordLimit: Maybe<Scalars['Int']['output']>;
};

/** Response as a plain text short phrase. */
export type ShortResponse = {
  __typename?: 'ShortResponse';
  /** Whether the matching is case sensitive */
  caseSensitive: Maybe<Scalars['Boolean']['output']>;
  /** Expected answer matches */
  matchPhrases: Maybe<Array<Scalars['String']['output']>>;
  /** Similarity threshold between 0.0 and 1.0 inclusive */
  matchSimilarity: Maybe<Scalars['Float']['output']>;
};

export type ShortResponseInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  matchPhrases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Between 0.0 and 1.0 inclusive. */
  matchSimilarity?: InputMaybe<Scalars['Float']['input']>;
};

export type SimilarQuestionsPayload = {
  __typename?: 'SimilarQuestionsPayload';
  /** True if the replacement set is incomplete */
  incompleteReplacement: Maybe<Scalars['Boolean']['output']>;
  /** List of similar questions found */
  questions: Maybe<Array<Question>>;
};

/**
 * Similarity information for a Result.
 *
 * Currently a Turnitin similarity score is available in the gradebook. This
 * score is a floating point percentage value.
 */
export type Similarity = {
  __typename?: 'Similarity';
  /** Human formatted representation */
  display: Scalars['String']['output'];
  /** Label color for the similarity score */
  label: Scalars['String']['output'];
  /** Actual similarity score value between 0-100 */
  value: Scalars['Float']['output'];
};

export type SimpleChoice = {
  __typename?: 'SimpleChoice';
  content: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
};

export type SimpleChoiceInput = {
  content: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type SnapshotFieldOutcomeInput = {
  /** JSON ProseMirror Document */
  doc: Scalars['String']['input'];
  /** Version of the document */
  version: Scalars['Int']['input'];
};

export type SnapshotSubmissionOutcomeInput = {
  /** 'body' or 'references' */
  blockName: Scalars['String']['input'];
  /** JSON ProseMirror Document */
  doc: Scalars['String']['input'];
  /** Version of the document */
  version: Scalars['Int']['input'];
};

export type SourceFileInput = {
  /** Imported file name set by the user */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** File path of imported file */
  filepath?: InputMaybe<Scalars['String']['input']>;
  /** ID of the file source */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** All possible Task release states. */
export enum Status {
  Editing = 'EDITING',
  Released = 'RELEASED'
}

/** Marking outcome targetting a single student in the assessment. */
export type StudentOutcome = {
  __typename?: 'StudentOutcome';
  base: ComponentBreakdown;
  /** Moderator modifier applied on the final score. */
  final: ComponentBreakdown;
  /**
   * Final calculated score including all penalties and moderator modifiers.
   *
   * Each component is scaled to the AssessmentSetting weights at the time of
   * submission (for Individual and Group WorkOutcomes). Self and Peer Scores
   * depend on the PeerOutcome and AssessmentSettings.
   * @deprecated Use `studentOutcome.base.total.weightedScore` or
   * `studentOutcome.base.final.weightedScore`
   *
   */
  finalScore: Maybe<Scalars['Float']['output']>;
  /**
   * Penalty applied to group WorkOutcome.
   *
   * This penalty can be prospective or a final score if the feedback was
   * released.
   * @deprecated Use `studentOutcome.base.group.penaltyScore` for prospective,
   * Use `studentOutcome.final.group.penaltyScore` for final.
   *
   */
  groupPenalty: Maybe<Scalars['Float']['output']>;
  groupWorkOutcome: Maybe<WorkOutcome>;
  id: Scalars['ID']['output'];
  /**
   * Penalty applied to individual WorkOutcome.
   *
   * This penalty can be prospective or a final score if the feedback was
   * released.
   * @deprecated Use `studentOutcome.base.individual.penaltyScore` for prospective,
   * Use `studentOutcome.final.individual.penaltyScore` for final.
   *
   */
  individualPenalty: Maybe<Scalars['Float']['output']>;
  individualWorkOutcome: Maybe<WorkOutcome>;
  /**
   * Maximum score the student was graded on.
   * @deprecated Use `studentOutcome.base.total.weightedMaxScore`
   */
  maxScore: Scalars['Int']['output'];
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  peerOutcome: Maybe<PeerOutcome>;
  provisional: ComponentBreakdown;
  studentId: Scalars['ID']['output'];
};

/** Input object for updating a student's settings within an assessment context. */
export type StudentSettingsInput = {
  draftExamEndDate?: InputMaybe<Scalars['String']['input']>;
  draftExamStartDate?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  examDeferred?: InputMaybe<Scalars['Boolean']['input']>;
  examEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  examReadingTime?: InputMaybe<Scalars['Int']['input']>;
  examStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  examWritingTime?: InputMaybe<Scalars['Int']['input']>;
  studentId: Scalars['ID']['input'];
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  updateReason?: InputMaybe<Scalars['String']['input']>;
};

/** A Cadmus Subject. */
export type Subject = {
  __typename?: 'Subject';
  discipline: Maybe<Discipline>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum SubjectRole {
  ExternalExaminer = 'EXTERNAL_EXAMINER',
  FacultyLeader = 'FACULTY_LEADER',
  LearningDesigner = 'LEARNING_DESIGNER',
  LearningTechnologist = 'LEARNING_TECHNOLOGIST',
  Lecturer = 'LECTURER',
  Marker = 'MARKER',
  Other = 'OTHER',
  SubjectCoordinator = 'SUBJECT_COORDINATOR',
  Tutor = 'TUTOR',
  UniversityLeader = 'UNIVERSITY_LEADER'
}

/** A Final or Draft Submission. */
export type Submission = {
  __typename?: 'Submission';
  /** Attempt number if provided during submission. */
  attemptNumber: Maybe<Scalars['Int']['output']>;
  /** A representation of an answer to a question block */
  blockSnapshots: Array<BlockSnapshot>;
  /**
   * If the submission was forcefully submitted on behalf of the student.
   *
   * Use the `submittedBy` field to know who submitted the submission.
   */
  forceSubmitted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Last marking PDF artifact sent to the marking tool. */
  markingPdf: Maybe<WorkArtifact>;
  /** PDF artifact associated for the submission. */
  pdf: Maybe<WorkArtifact>;
  /**
   * Gradebook result on the submission.
   * @deprecated Use Work.result directly instead. Result should be the parent of Submission.
   */
  result: Result;
  /** Save attached to the submission. */
  save: Maybe<Save>;
  submittedAt: Scalars['PreciseDateTime']['output'];
  /**
   * The User who made the submission.
   *
   * If the value is null, the user should be assumed to be the student who owns
   * the Work.
   */
  submittedBy: Maybe<User>;
  /** Type of Submission. */
  type: SubmissionType;
  unsubmittedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  workId: Scalars['ID']['output'];
};

/**
 * Input to downloadSubmissions mutation to add a submission's PDF to the
 * archive.
 */
export type SubmissionDetailInput = {
  /** Submission ID */
  id: Scalars['ID']['input'];
  /** Filename inside the archive */
  name: Scalars['String']['input'];
};

/** Outcome recorded for a student's submission. */
export type SubmissionOutcome = {
  __typename?: 'SubmissionOutcome';
  bodyBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  bodyDoc: Maybe<Scalars['String']['output']>;
  bodyDocStreamUuid: Maybe<Scalars['ID']['output']>;
  bodyDocVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Scalars['Int']['output'];
  /** Marking outcome from using a MarkerRubric to score the parent Outcome. */
  rubricOutcome: RubricOutcome;
  score: Maybe<Scalars['Float']['output']>;
  submissionId: Scalars['ID']['output'];
};

/**
 * SubmissionOutcomeRelease represents a snapshot of a submission outcome at release time.
 * Contains the overall submission marking and documentation.
 */
export type SubmissionOutcomeRelease = {
  __typename?: 'SubmissionOutcomeRelease';
  bodyBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  bodyDoc: Maybe<Scalars['String']['output']>;
  bodyDocStreamUuid: Scalars['ID']['output'];
  bodyDocVersion: Scalars['Int']['output'];
  criterionOutcomeReleases: Array<CriterionOutcomeRelease>;
  id: Scalars['ID']['output'];
  referencesBlockSnapshotId: Maybe<Scalars['ID']['output']>;
  referencesDoc: Maybe<Scalars['String']['output']>;
  referencesDocStreamUuid: Maybe<Scalars['ID']['output']>;
  referencesDocVersion: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  submissionId: Scalars['ID']['output'];
  threadReleases: Array<ThreadRelease>;
};

/** Types of submissions the client can make. */
export enum SubmissionType {
  Draft = 'DRAFT',
  Final = 'FINAL'
}

/** A recorded Survey response. */
export type Survey = {
  __typename?: 'Survey';
  /** Is the survey open for accepting new answers? */
  active: Scalars['Boolean']['output'];
  answer: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  score: Maybe<Scalars['Int']['output']>;
};

/** A Tag attached to an Enrollment */
export type Tag = {
  __typename?: 'Tag';
  /** @deprecated Use an explicit `tab` instead of column */
  column: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  tab: ClassTab;
  text: Scalars['String']['output'];
};

export type TagInput = {
  /** Link tag to a category */
  categoryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/**
 * An Assessment's Task.
 *
 * A single `Task` document is edited by a teacher and released as `Sheet` to
 * their Assessment. An Assessment can have multiple Tasks, one of each
 * `TaskKind`. The `INDIVIDUAL` kinded Task is the default and always-present
 * Task.
 *
 * A Task has a latest `SaveState` which is the latest content saved by the
 * teacher.
 *
 * A Task has attached `Resources`.
 *
 * DEPRECATED A Task has settings in the form of `Requirements`. Use `settings`
 * edge on `Assessment` instead.
 */
export type Task = {
  __typename?: 'Task';
  /** List of all multi-format Task blocks. */
  blocks: Array<TaskBlock>;
  format: Maybe<TaskFormat>;
  /** Task has a linked Marker Rubric. */
  hasMarkerRubric: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: TaskKind;
  /** Latest Task requirement values. */
  requirements: Requirements;
  /** Latest Task resources. */
  resources: Array<Resource>;
  /** Latest Task save state. */
  saveState: SaveState;
  /** Task is in a released state or not. */
  status: Status;
};

/**
 * A block inside a Task or TaskHistory.
 *
 * Task blocks convey a question or bunch of questions within a Task. A list of
 * blocks within a Task have a Tree structure with nesting. This Tree structure
 * is constructed using the 3 fields:
 *
 *   1. `nodeId` required
 *   2. `parentNodeId` optional
 *   3. `previousNodeId` optional
 *
 * Task blocks can also be flattened and given a fixed ordering using the `order`
 * field. The flattened tree numbering is preserved in `orderLabel` field.
 */
export type TaskBlock = {
  __typename?: 'TaskBlock';
  deleted: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Library Question ID linked to this block */
  libraryQuestionId: Maybe<Scalars['ID']['output']>;
  /** Library Question Version ID linked to this block */
  libraryQuestionVersionId: Maybe<Scalars['ID']['output']>;
  markerRubric: Maybe<MarkerRubric>;
  /** Tree layout node ID for the block. */
  nodeId: Scalars['ID']['output'];
  order: Maybe<Scalars['Int']['output']>;
  orderLabel: Maybe<Scalars['String']['output']>;
  /** @deprecated Use parentNodeId */
  parentId: Maybe<Scalars['ID']['output']>;
  /** Tree layout parent node ID for this block. */
  parentNodeId: Maybe<Scalars['ID']['output']>;
  points: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use previousNodeId */
  previousId: Maybe<Scalars['ID']['output']>;
  /** Tree layout previous node ID for this block. */
  previousNodeId: Maybe<Scalars['ID']['output']>;
  /** Number of questions referenced by the TaskBlock */
  quantity: Maybe<Scalars['Int']['output']>;
  /** Question attached to a Task block. */
  question: Maybe<Question>;
  /** QuestionSelection with sets attached this block */
  questionSelection: Maybe<QuestionSelection>;
  shuffle: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Enum of format of task */
export enum TaskFormat {
  Classic = 'CLASSIC',
  Multiformat = 'MULTIFORMAT'
}

/** Kinds of Tasks created in an Assessment. */
export enum TaskKind {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL',
  Peer = 'PEER'
}

export type TextEntryInteraction = {
  __typename?: 'TextEntryInteraction';
  /** Allow file attachments */
  attachmentEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Base type of the student's answer */
  baseType: Maybe<BaseType>;
  /** Expected length of the text entry */
  expectedLength: Maybe<Scalars['Int']['output']>;
};

export type TextEntryInteractionInput = {
  attachmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  expectedLength?: InputMaybe<Scalars['Int']['input']>;
};

export type Thread = {
  __typename?: 'Thread';
  comments: Array<Comment>;
  createdBy: User;
  criterion: Maybe<Criterion>;
  /** Linked rubric Criterion */
  criterionId: Maybe<Scalars['ID']['output']>;
  entityId: Maybe<Scalars['ID']['output']>;
  entityType: Maybe<EntityType>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['PreciseDateTime']['output'];
  metadata: Maybe<Metadata>;
  resolvedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  resolvedBy: Maybe<User>;
  status: ThreadStatus;
  title: Maybe<Scalars['String']['output']>;
};

export type ThreadInput = {
  /** Initial comment content as HTML string */
  comment?: InputMaybe<Scalars['String']['input']>;
  criterionId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the associated entity. */
  entityId: Scalars['ID']['input'];
  /** Type of the associated entity. */
  entityType: EntityType;
  /** ID of the group the thread belongs to. */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<ThreadMetadataInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ThreadMetadataInput = {
  /** ID of the BlockAttachment this thread is about */
  blockAttachmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the file */
  blockAttachmentName?: InputMaybe<Scalars['String']['input']>;
  charterEditorId?: InputMaybe<Scalars['ID']['input']>;
  charterSectionType?: InputMaybe<CharterSectionType>;
};

/**
 * ThreadRelease represents a snapshot of a thread at the time of feedback release.
 * Contains the thread information and its comments at release time.
 */
export type ThreadRelease = {
  __typename?: 'ThreadRelease';
  commentReleases: Array<CommentRelease>;
  /** Linked rubric Criterion */
  criterionId: Maybe<Scalars['ID']['output']>;
  /** The ID of the Thread. */
  id: Scalars['ID']['output'];
  metadata: Maybe<Metadata>;
  threadInsertedAt: Scalars['PreciseDateTime']['output'];
  title: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Thread states. */
export enum ThreadStatus {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Editing = 'EDITING'
}

/** Input for unlinking library question references */
export type UnlinkLibraryQuestionInput = {
  taskBlockId: Scalars['ID']['input'];
  unlinkVersionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAnswerBlockInput = {
  bookmark?: InputMaybe<Scalars['Boolean']['input']>;
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFieldRubricInput = {
  fieldRubricId: Scalars['ID']['input'];
  role: MarkingRole;
  valuesAdded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  valuesRemoved?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateFieldRubricPayload = {
  __typename?: 'UpdateFieldRubricPayload';
  fieldOutcomes: Array<FieldOutcome>;
  fieldRubric: Maybe<FieldRubric>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubric: Maybe<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

/**
 * Input to update the milestones of a charter by passing
 *   the `charter_id` and the list of `milestones`
 */
export type UpdateMilestonesInput = {
  charterId: Scalars['ID']['input'];
  milestones?: InputMaybe<Array<MilestoneInput>>;
};

export type UpdateProjectIssueInput = {
  groupId: Scalars['ID']['input'];
  issues?: InputMaybe<Array<ProjectIssueInput>>;
};

export type UpdateQuestionBankFileOriginInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateQuestionBankInput = {
  /** @deprecated Deprecated. Use fields instead */
  blanksResponse?: InputMaybe<BlanksResponseInput>;
  /** @deprecated Deprecated. Use fields instead */
  booleanResponse?: InputMaybe<BooleanResponseInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<QuestionDifficulty>;
  /** @deprecated Deprecated. Use fields instead */
  editorResponse?: InputMaybe<EditorResponseInput>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Question fields with response declaration and interaction type */
  fields?: InputMaybe<Array<InputMaybe<QuestionFieldInput>>>;
  /** @deprecated Deprecated. Use fields instead */
  multiResponse?: InputMaybe<MultiResponseInput>;
  points?: InputMaybe<Scalars['Int']['input']>;
  promptDoc: Scalars['String']['input'];
  questionBankId: Scalars['ID']['input'];
  /** Question type */
  questionType: QuestionType;
  scope: QuestionBankScope;
  /** Short plain text prompt description */
  shortPrompt: Scalars['String']['input'];
  /** @deprecated Deprecated. Use fields instead */
  shortResponse?: InputMaybe<ShortResponseInput>;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateQuestionBanksCategoryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  questionBankIds: Array<Scalars['ID']['input']>;
  scope: QuestionBankScope;
};

export type UpdateQuestionRubricInput = {
  caseSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  errorMargin?: InputMaybe<Scalars['Float']['input']>;
  partialScoring?: InputMaybe<Scalars['Boolean']['input']>;
  questionRubricId: Scalars['ID']['input'];
  role: MarkingRole;
  similarity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateQuestionRubricPayload = {
  __typename?: 'UpdateQuestionRubricPayload';
  fieldOutcomes: Array<FieldOutcome>;
  questionOutcomes: Array<QuestionOutcome>;
  questionRubric: Maybe<QuestionRubric>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcomes: Array<WorkOutcome>;
};

export type UpdateQuestionSourceFileInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateQuestionVersionInput = {
  /** The attributes to update the question with */
  attributes: QuestionAttributes;
  /** The ID of the question to be updated */
  id: Scalars['ID']['input'];
  /** The version of the question to be updated */
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStudentOutcomeScoreInput = {
  moderatorModifier?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStudentOutcomeScorePayload = {
  __typename?: 'UpdateStudentOutcomeScorePayload';
  studentOutcome: StudentOutcome;
};

/** Updatable attributes for a TaskBlock */
export type UpdateTaskBlockInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shuffle?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updatable attributes for a TaskBlock for UpdateTaskBlocks */
export type UpdateTaskBlocksInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  previousNodeId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkOutcomeScoreInput = {
  moderatorModifier: Scalars['Float']['input'];
  workOutcomeId: Scalars['ID']['input'];
};

export type UpdateWorkOutcomeScorePayload = {
  __typename?: 'UpdateWorkOutcomeScorePayload';
  fieldOutcome: Maybe<FieldOutcome>;
  fieldRubric: Maybe<FieldRubric>;
  questionOutcome: Maybe<QuestionOutcome>;
  studentOutcomes: Array<StudentOutcome>;
  workOutcome: Maybe<WorkOutcome>;
};

/** Cadmus User profile */
export type User = {
  __typename?: 'User';
  /** Optional user colourset index for group context. */
  colourset: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['String']['output']>;
  /** User family name to be used for sorting. */
  familyName: Scalars['String']['output'];
  /** User given name to be used as a short display name. */
  givenName: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Full name, parsed from the LMS request which created the user. */
  name: Scalars['String']['output'];
  /** Has the user seen the latest onboarding manual screens? */
  onboardingSeen: Scalars['Boolean']['output'];
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Personal settings of a user. */
export type UserSettings = {
  __typename?: 'UserSettings';
  id: Scalars['ID']['output'];
  /** Integrity Assuranceonboarding flag */
  showIaOnboarding: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No more UserPilot */
  showUserpilotOnboarding: Maybe<Scalars['Boolean']['output']>;
  /** User provided role in the subject */
  subjectRole: Maybe<SubjectRole>;
};

export type VerifiedCode = {
  __typename?: 'VerifiedCode';
  code: Scalars['String']['output'];
  insertedAt: Maybe<Scalars['PreciseDateTime']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

/** A Student's Work with submissions and saves. */
export type Work = {
  __typename?: 'Work';
  /** Answer blocks linked to a Work */
  answerBlocks: Array<AnswerBlock>;
  /** Current attempt count: not 1 to 1 for Submissions */
  attemptCount: Scalars['Int']['output'];
  /**
   * Latest draft submission.
   * @deprecated Follow Work.result(type=DRAFT).submission instead.
   */
  draft: Maybe<Submission>;
  /**
   * Individual final due date for this work if one has been set. Will override
   * the assessment final due date.
   */
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Student's Cadmus experience survey response related to this work */
  experience: Survey;
  /** Feature flags enabled on a Work */
  features: WorkFeatures;
  /**
   * Latest final submission
   * @deprecated Follow Work.result(type=FINAL).submission instead.
   */
  final: Maybe<Submission>;
  /** Group that owns the work in group assessments. */
  group: Maybe<Group>;
  id: Scalars['ID']['output'];
  /**
   * Last save timestamp if there is a last save.
   *
   * NOTE: This field is optimised for batch loading
   */
  lastSaveTime: Maybe<Scalars['PreciseDateTime']['output']>;
  /**
   * Latest save for the Work, if any.
   *
   * NOTE: This field is not optimised for batch loading on multiple works.
   */
  latestSave: Maybe<Save>;
  /** Latest sentiment check for a work */
  latestSentimentCheck: Maybe<SentimentCheck>;
  /** Latest Gradebook result for the Work. */
  result: Maybe<Result>;
  /** Settings specific to the Work that override the Assessment's released sheet. */
  settings: Maybe<WorkSettings>;
  /** Instruction Sheet released to the Student. */
  sheet: Maybe<Sheet>;
  /** Start date for a timed Work that the student has to manually trigger. */
  startDate: Maybe<Scalars['PreciseDateTime']['output']>;
  /** Student with access to the work. */
  student: User;
  /** Last update timestamp. */
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};


/** A Student's Work with submissions and saves. */
export type WorkResultArgs = {
  submissionType: SubmissionType;
};

/** Work Artifacts Associated with this Work. */
export type WorkArtifact = {
  __typename?: 'WorkArtifact';
  /** Marking service or AGS receipt date */
  agsSentAt: Maybe<Scalars['PreciseDateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Email receipt date */
  studentSentAt: Maybe<Scalars['PreciseDateTime']['output']>;
  submissionId: Scalars['ID']['output'];
  taskHistoryId: Scalars['ID']['output'];
  workId: Scalars['ID']['output'];
};

/**
 * Input to downloadWorkArtifacts mutation to add an artifact's PDF to the
 * archive.
 */
export type WorkArtifactDetailInput = {
  /** Filename inside the archive */
  filename: Scalars['String']['input'];
  /** Work Artifact ID */
  id: Scalars['ID']['input'];
  /** Force regenerate the WorkArtifact */
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Feature flags enabled on a Work */
export type WorkFeatures = {
  __typename?: 'WorkFeatures';
  /** Enable usage of Work Authority API */
  enableWorkAuthority: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

/** A Working Group of students in a group assessment. */
export type WorkGroup = {
  __typename?: 'WorkGroup';
  /** Group's charter, if created */
  charter: Maybe<Charter>;
  /** Finalised status of the current group. */
  finalised: Scalars['Boolean']['output'];
  /** Student's current group in the Assessment. */
  group: Group;
  id: Scalars['ID']['output'];
  /** Student's individual Work, if created. */
  individualWork: Maybe<Work>;
  /**
   * ID for Individual work report if enabled for the group assessment.
   * @deprecated Use `individual_work` edge.
   */
  individualWorkId: Maybe<Scalars['ID']['output']>;
  /** Latest group change request of the current user. */
  latestGroupChangeRequest: Maybe<Message>;
  /** Group's Work document, if created. */
  work: Maybe<Work>;
};


/** A Working Group of students in a group assessment. */
export type WorkGroupLatestGroupChangeRequestArgs = {
  assessmentId: Scalars['ID']['input'];
};

/** Outcome recorded for a student's work. */
export type WorkOutcome = {
  __typename?: 'WorkOutcome';
  /** Answer blocks seen by the connected Work. */
  answerBlocks: Array<AnswerBlock>;
  assessmentId: Scalars['ID']['output'];
  /** If there are FieldOutcomes still being automarked. */
  automarkPending: Maybe<Scalars['Boolean']['output']>;
  enableProvisionalRelease: Scalars['Boolean']['output'];
  /** Indicates whether final feedback has been released for the work outcome. */
  feedbackReleased: Scalars['Boolean']['output'];
  feedbackReleasedTimestamp: Maybe<Scalars['DateTime']['output']>;
  finalRelease: Maybe<WorkOutcomeRelease>;
  /** The final score of the most recent final feedback. */
  finalScore: Maybe<Scalars['Float']['output']>;
  /** The final score penalty of the most recent final feedback. */
  finalScorePenalty: Maybe<Scalars['Float']['output']>;
  groupId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  latestSubmissionOutcome: Maybe<SubmissionOutcome>;
  maxScore: Scalars['Int']['output'];
  moderationPenaltyRules: Array<ModerationPenaltyRule>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  provisionalRelease: Maybe<WorkOutcomeRelease>;
  questionOutcomes: Array<QuestionOutcome>;
  /** Work outcome score breakdowns */
  scoreBreakdown: ScoreBreakdown;
  studentId: Maybe<Scalars['ID']['output']>;
  /** Submission scored in this work outcome. */
  submission: Submission;
  workId: Scalars['ID']['output'];
  /** Latest released feedback */
  workOutcomeRelease: Maybe<WorkOutcomeRelease>;
};

/**
 * WorkOutcomeRelease represents a snapshot of a WorkOutcome at the time of feedback release.
 * Each release event (provisional or final) creates a new WorkOutcomeRelease record.
 *
 * This edge can also be resolve by any `WorkOutcomeRelease.t()`.
 */
export type WorkOutcomeRelease = {
  __typename?: 'WorkOutcomeRelease';
  feedbackVisibility: FeedbackVisibility;
  finalScore: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  moderationPenaltyRules: Array<ModerationPenaltyRule>;
  moderatorModifier: Maybe<Scalars['Float']['output']>;
  penaltyScore: Scalars['Float']['output'];
  questionOutcomeReleases: Array<QuestionOutcomeRelease>;
  releaseType: FeedbackReleaseType;
  releasedAt: Scalars['DateTime']['output'];
  submissionOutcomeRelease: Maybe<SubmissionOutcomeRelease>;
};

/** Settings for a work */
export type WorkSettings = {
  __typename?: 'WorkSettings';
  assessmentId: Scalars['ID']['output'];
  draftExamEndDate: Maybe<Scalars['String']['output']>;
  draftExamStartDate: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['PreciseDateTime']['output']>;
  examDeferred: Maybe<Scalars['Boolean']['output']>;
  examEndDate: Maybe<Scalars['DateTime']['output']>;
  examReadingTime: Maybe<Scalars['Int']['output']>;
  examStartDate: Maybe<Scalars['DateTime']['output']>;
  examWritingTime: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastUpdatedBy: Maybe<User>;
  studentId: Scalars['ID']['output'];
  timeLimit: Maybe<Scalars['Int']['output']>;
  updateReason: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['PreciseDateTime']['output']>;
};

export type ApiTokenQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
}>;


export type ApiTokenQuery = { __typename?: 'RootQueryType', apiToken: string };

export type BackgroundJobFragment = { __typename?: 'BackgroundJob', id: string, kind: BackgroundJobKind, state: BackgroundJobState };

export type BackgroundJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type BackgroundJobQuery = { __typename?: 'RootQueryType', backgroundJob: { __typename?: 'BackgroundJob', id: string, kind: BackgroundJobKind, state: BackgroundJobState } | null };

export type BrightspaceAuthorizationQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  redirectTo: Scalars['String']['input'];
  brightspaceScopeFor: InputMaybe<BrightspaceScopeKeyType>;
}>;


export type BrightspaceAuthorizationQuery = { __typename?: 'RootQueryType', brightspaceApi: { __typename?: 'BrightspaceApi', authorizeUrl: string, authorized: boolean } };

export type CanvasAuthorizationQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  redirectTo: Scalars['String']['input'];
  canvasScopeFor: InputMaybe<CanvasScopeKeyType>;
}>;


export type CanvasAuthorizationQuery = { __typename?: 'RootQueryType', canvasApi: { __typename?: 'CanvasApi', authorizeUrl: string, authorized: boolean } };

export type AssessmentChartersQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentChartersQuery = { __typename?: 'RootQueryType', assessmentCharters: Array<{ __typename?: 'Charter', id: string, groupId: string }> };

export type CharterEditorFragment = { __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string };

export type CharterFormFragment = { __typename?: 'CharterForm', id: string, published: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', description: string | null, dueDate: string | null, title: string | null }> | null }> };

export type CharterFormMilestonePresetFragment = { __typename?: 'MilestonePresetType', description: string | null, dueDate: string | null, title: string | null };

export type CharterFormQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CharterFormQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, peerEvaluationEnabled: boolean } | null }, draftForm: { __typename?: 'CharterForm', id: string, published: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', description: string | null, dueDate: string | null, title: string | null }> | null }> } | null, publishedForm: { __typename?: 'CharterForm', id: string, published: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', description: string | null, dueDate: string | null, title: string | null }> | null }> } | null };

export type CharterFormSectionFragment = { __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, promptDoc: string | null, rank: number | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', description: string | null, dueDate: string | null, title: string | null }> | null };

export type CharterFragment = { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> };

export type CharterMilestoneFragment = { __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean };

export type CharterQueryVariables = Exact<{
  charterId: Scalars['ID']['input'];
}>;


export type CharterQuery = { __typename?: 'RootQueryType', charter: { __typename?: 'Charter', id: string, groupId: string, milestones: Array<{ __typename?: 'CharterMilestone', id: string | null, title: string, description: string | null, dueDate: string, deleted: boolean }>, editors: Array<{ __typename?: 'CharterEditor', id: string, charterFormSectionId: string, snapshotDoc: string | null, snapshotVersion: number | null, streamUuid: string }>, feedbackThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> } };

export type CreateCharterFormMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type CreateCharterFormMutation = { __typename?: 'RootMutationType', createCharterForm: { __typename?: 'CharterForm', id: string, published: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', description: string | null, dueDate: string | null, title: string | null }> | null }> } };

export type UpdateCharterFormMutationVariables = Exact<{
  input: CharterFormInput;
}>;


export type UpdateCharterFormMutation = { __typename?: 'RootMutationType', updateCharterForm: { __typename?: 'CharterForm', id: string, sections: Array<{ __typename?: 'CharterFormSection', id: string, rank: number | null, type: CharterFormSectionType, title: string | null, enabled: boolean, deleted: boolean, promptDoc: string | null, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', title: string | null, description: string | null, dueDate: string | null }> | null }> } };

export type ClassQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ClassQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, email: string | null }, institution: { __typename?: 'Institution', id: string, tenant: string, country: { __typename?: 'Country', code: string, name: string } }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, questionLibrary: boolean, extensionSyncing: boolean, advancedMarking: boolean, workAttachment: boolean, timeline: boolean }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null }, class: { __typename?: 'Class', id: string, groupType: GroupType, students: Array<{ __typename?: 'Enrollment', id: string, syncedAt: string | null, deleted: boolean, sisUserId: string | null, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> }, classWorkGroups: Array<{ __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null }>, individualSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, groupSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, futureSheet: { __typename?: 'Sheet', id: string, releaseTimestamp: string } | null, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null };

export type CountryFragment = { __typename?: 'Country', code: string, name: string };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'RootQueryType', sessionId: string, me: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, institution: { __typename?: 'Institution', id: string, tenant: string } };

export type FeatureFlagsFragment = { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, questionLibrary: boolean, extensionSyncing: boolean, advancedMarking: boolean, workAttachment: boolean, timeline: boolean };

export type AppendGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: SetupGroupInput;
}>;


export type AppendGroupsMutation = { __typename?: 'RootMutationType', appendGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> };

export type AutoAssignGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: InputMaybe<Scalars['ID']['input']>;
}>;


export type AutoAssignGroupsMutation = { __typename?: 'RootMutationType', autoAssignGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> | null };

export type BrightspaceGroupFragment = { __typename?: 'BrightspaceGroup', id: string, name: string, code: string | null, totalStudents: number, students: Array<{ __typename?: 'BrightspaceUser', id: string }> | null };

export type BrightspaceGroupsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  brightspaceScopeFor: BrightspaceScopeKeyType;
}>;


export type BrightspaceGroupsQuery = { __typename?: 'RootQueryType', brightspaceApi: { __typename?: 'BrightspaceApi', groups: Array<{ __typename?: 'BrightspaceGroup', id: string, name: string, code: string | null, totalStudents: number, students: Array<{ __typename?: 'BrightspaceUser', id: string }> | null }> }, class: { __typename?: 'Class', students: Array<{ __typename?: 'Enrollment', sisUserId: string | null, customParams: { __typename?: 'CustomParams', brightspaceUserId: string | null }, user: { __typename?: 'User', id: string, name: string } }> } };

export type CanvasSectionFragment = { __typename?: 'CanvasSection', id: string, courseId: string, name: string, sisCourseId: string | null, totalStudents: number, students: Array<{ __typename?: 'CanvasUser', id: string, name: string, sisUserId: string | null }> | null };

export type CanvasSectionsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  canvasScopeFor: CanvasScopeKeyType;
}>;


export type CanvasSectionsQuery = { __typename?: 'RootQueryType', canvasApi: { __typename?: 'CanvasApi', sections: Array<{ __typename?: 'CanvasSection', id: string, courseId: string, name: string, sisCourseId: string | null, totalStudents: number, students: Array<{ __typename?: 'CanvasUser', id: string, name: string, sisUserId: string | null }> | null }> }, class: { __typename?: 'Class', students: Array<{ __typename?: 'Enrollment', sisUserId: string | null, customParams: { __typename?: 'CustomParams', canvasUserId: string | null }, user: { __typename?: 'User', id: string, name: string } }> } };

export type ClassGroupsFragment = { __typename?: 'Class', id: string, groupType: GroupType, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> };

export type CreateGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groups: Array<GroupInput> | GroupInput;
}>;


export type CreateGroupsMutation = { __typename?: 'RootMutationType', createGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> };

export type DeletedMemberFragment = { __typename?: 'DeletedMember', id: string, groupId: string };

export type DeleteGroupMemberMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type DeleteGroupMemberMutation = { __typename?: 'RootMutationType', deleteGroupMember: { __typename?: 'DeletedMember', id: string, groupId: string } | null };

export type DeleteGroupMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type DeleteGroupMutation = { __typename?: 'RootMutationType', deleteGroup: boolean };

export type DeleteGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteGroupsMutation = { __typename?: 'RootMutationType', deleteGroups: number | null };

export type GroupEnrollmentFragment = { __typename?: 'Enrollment', id: string, deleted: boolean, user: { __typename?: 'User', id: string }, workSettings: { __typename?: 'WorkSettings', id: string, examDeferred: boolean | null } | null };

export type GroupFragment = { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> };

export type GroupUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupUpdatedSubscription = { __typename?: 'RootSubscriptionType', groupUpdated: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> } };

export type GroupsRouteQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupsRouteQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, email: string | null }, lecturers: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }>, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null }, class: { __typename?: 'Class', id: string, groupType: GroupType, students: Array<{ __typename?: 'Enrollment', id: string, syncedAt: string | null, deleted: boolean, sisUserId: string | null, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> }, messageInbox: Array<{ __typename?: 'Message', id: string, sourceUserId: string, messageType: MessageRequestType }>, individualSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, institution: { __typename?: 'Institution', id: string, apiStatus: { __typename?: 'ApiStatusType', hasBrightspaceApi: boolean, hasCanvasApi: boolean } } };

export type LtiServiceFragment = { __typename?: 'LtiService', id: string, issuer: string | null, name: string, version: string };

export type ResetGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResetGroupsMutation = { __typename?: 'RootMutationType', resetGroups: boolean };

export type ResolveMessagesMutationVariables = Exact<{
  messageIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type ResolveMessagesMutation = { __typename?: 'RootMutationType', resolveMessages: Array<{ __typename?: 'Message', id: string, sourceUserId: string, messageType: MessageRequestType }> };

export type SetupGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: SetupGroupInput;
}>;


export type SetupGroupsMutation = { __typename?: 'RootMutationType', setupGroups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> };

export type UpdateGroupMembershipsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  memberships: Array<GroupMembershipInput> | GroupMembershipInput;
}>;


export type UpdateGroupMembershipsMutation = { __typename?: 'RootMutationType', updateGroupMemberships: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> };

export type UpdateGroupMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  group: GroupUpdateInput;
}>;


export type UpdateGroupMutation = { __typename?: 'RootMutationType', updateGroup: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> } };

export type UpdateGroupNameMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: GroupUpdateInput;
}>;


export type UpdateGroupNameMutation = { __typename?: 'RootMutationType', updateGroup: { __typename?: 'Group', id: string, name: string } };

export type AssignMarkerToGroupsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  markerId: Scalars['ID']['input'];
}>;


export type AssignMarkerToGroupsMutation = { __typename?: 'RootMutationType', assignMarkerToGroups: Array<{ __typename?: 'Group', id: string, markerId: string | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null }> | null };

export type WorkGroupFragment = { __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null };

export type GroupHubNavigationQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupHubNavigationQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, releaseDate: string | null, openDate: string | null, dueDate: string | null, feedbackDate: string | null, individualReportEnabled: boolean, peerEvaluationEnabled: boolean, selfEvaluationEnabled: boolean, groupCharterEnabled: boolean, referencingStyleEnabled: boolean, wordLimitEnabled: boolean, sentimentCheckEnabled: boolean, groupReportWeight: number | null, individualReportWeight: number | null, peerEvaluationWeight: number | null, selfEvaluationWeight: number | null, individualReportDueDate: string | null, groupCharterDueDate: string | null, peerEvaluationDueDate: string | null, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, maxGrade: number } | null } };

export type GroupHubQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GroupHubQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, releaseDate: string | null, openDate: string | null, dueDate: string | null, feedbackDate: string | null, individualReportEnabled: boolean, peerEvaluationEnabled: boolean, selfEvaluationEnabled: boolean, groupCharterEnabled: boolean, referencingStyleEnabled: boolean, wordLimitEnabled: boolean, sentimentCheckEnabled: boolean, groupReportWeight: number | null, individualReportWeight: number | null, peerEvaluationWeight: number | null, selfEvaluationWeight: number | null, individualReportDueDate: string | null, groupCharterDueDate: string | null, peerEvaluationDueDate: string | null, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, maxGrade: number } | null }, messageInbox: Array<{ __typename?: 'Message', id: string, sourceUserId: string, messageType: MessageRequestType }>, class: { __typename?: 'Class', id: string, students: Array<{ __typename?: 'Enrollment', id: string, deleted: boolean, user: { __typename?: 'User', id: string }, workSettings: { __typename?: 'WorkSettings', id: string, examDeferred: boolean | null } | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> }, charterDraft: { __typename?: 'CharterForm', id: string, published: boolean, publishTimestamp: string | null, editedAt: string | null, sections: Array<{ __typename?: 'CharterFormSection', id: string, deleted: boolean, enabled: boolean, rank: number | null, promptDoc: string | null, title: string | null, type: CharterFormSectionType, wordLimit: number | null, wordLimitEnabled: boolean, milestonePresets: Array<{ __typename?: 'MilestonePresetType', description: string | null, dueDate: string | null, title: string | null }> | null }> } | null, charterPublished: { __typename?: 'CharterForm', id: string, publishTimestamp: string | null } | null, groupTask: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null } } | null, individualTask: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null } } | null, peerTask: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null } } | null, groupRubricMarkingStatus: { __typename?: 'MarkerRubric', markingExists: boolean } | null, individualRubricMarkingStatus: { __typename?: 'MarkerRubric', markingExists: boolean } | null, peerRubricMarkingStatus: { __typename?: 'MarkerRubric', markingExists: boolean } | null };

export type HomeQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type HomeQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, institution: { __typename?: 'Institution', id: string, tenant: string, timezone: string }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, questionLibrary: boolean, extensionSyncing: boolean, advancedMarking: boolean, workAttachment: boolean, timeline: boolean }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null }, class: { __typename?: 'Class', id: string, students: Array<{ __typename?: 'Enrollment', id: string, deleted: boolean, user: { __typename?: 'User', id: string }, workSettings: { __typename?: 'WorkSettings', id: string, examDeferred: boolean | null } | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> }, task: { __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, blocks: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, groupTask: { __typename?: 'Task', id: string } | null, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, futureSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableSubmissionPdf: boolean, enableExamLdb: boolean | null, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, allowLateResubmission: boolean, allowGenerativeAi: boolean | null, dueDate: string, returnDate: string, maxGrade: number, draftDueDate: string | null, wordLimit: number | null, timeLimit: number | null, weight: number | null, referencingStyle: string | null, countFootnotes: boolean, sViewReports: number, draftSViewReports: number, countReferences: boolean, anonymousMarking: boolean | null, gradingService: string, noExamFeedbackDate: boolean, enableExamAccessCode: boolean, markingToolPdf: MarkingToolPdf | null, disableExamBacktrack: boolean | null, disableSpellCheck: boolean, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null, assessmentAccessCodes: Array<{ __typename?: 'AccessCode', code: string, label: string | null, active: boolean }> | null };

export type HubAssessmentSettingsFragment = { __typename?: 'AssessmentSettings', id: string, releaseDate: string | null, openDate: string | null, dueDate: string | null, feedbackDate: string | null, individualReportEnabled: boolean, peerEvaluationEnabled: boolean, selfEvaluationEnabled: boolean, groupCharterEnabled: boolean, referencingStyleEnabled: boolean, wordLimitEnabled: boolean, sentimentCheckEnabled: boolean, groupReportWeight: number | null, individualReportWeight: number | null, peerEvaluationWeight: number | null, selfEvaluationWeight: number | null, individualReportDueDate: string | null, groupCharterDueDate: string | null, peerEvaluationDueDate: string | null, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, maxGrade: number };

export type MarkerRubricsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
}>;


export type MarkerRubricsQuery = { __typename?: 'RootQueryType', publishedMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, draftMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type MessageFragment = { __typename?: 'Message', id: string, sourceUserId: string, messageType: MessageRequestType };

export type ReleaseAssessmentMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ReleaseAssessmentMutation = { __typename?: 'RootMutationType', releaseAssessment: { __typename?: 'ReleaseAssessmentPayload', assessment: { __typename?: 'Assessment', id: string, settings: { __typename?: 'AssessmentSettings', id: string, openDate: string | null } | null }, sheets: Array<{ __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> }> } };

export type SettingsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type SettingsQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, institution: { __typename?: 'Institution', id: string, tenant: string, timezone: string }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, questionLibrary: boolean, extensionSyncing: boolean, advancedMarking: boolean, workAttachment: boolean, timeline: boolean }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null }, task: { __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, blocks: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null };

export type InsightsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type InsightsQuery = { __typename?: 'RootQueryType', token: string, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null }, futureSheet: { __typename?: 'Sheet', id: string, releaseTimestamp: string } | null, class: { __typename?: 'Class', groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> }, institution: { __typename?: 'Institution', id: string, timezone: string } };

export type MailingListFragment = { __typename?: 'MailingList', id: string, subscribed: boolean, members: Array<string> };

export type MailingListQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type MailingListQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', email: string | null }, insightsMailingList: { __typename?: 'MailingList', id: string, subscribed: boolean, members: Array<string> } };

export type UpdateInsightsMailingListMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  subscribed: Scalars['Boolean']['input'];
  members: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateInsightsMailingListMutation = { __typename?: 'RootMutationType', updateInsightsMailingList: { __typename?: 'MailingList', id: string, subscribed: boolean, members: Array<string> } };

export type InstitutionFragment = { __typename?: 'Institution', id: string, tenant: string, timezone: string };

export type AnswerBlockFragment = { __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> };

export type AssessmentOverviewFragment = { __typename?: 'Assessment', id: string, name: string, subject: { __typename?: 'Subject', name: string } };

export type BlockAttachmentFragment = { __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null };

export type ClassListEnrollmentsFragment = { __typename?: 'ClassList', id: string, enrollments: Array<{ __typename?: 'Enrollment', id: string, syncedAt: string | null, deleted: boolean, sisUserId: string | null, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }> };

export type ClassOutcomesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ClassOutcomesQuery = { __typename?: 'RootQueryType', workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null }> };

export type ClassicMarkingQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type ClassicMarkingQuery = { __typename?: 'RootQueryType', me: { __typename?: 'User', id: string, email: string | null }, individualMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, groupMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, peerMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, studentWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, automarkPending: boolean | null, feedbackReleased: boolean, feedbackReleasedTimestamp: string | null, finalScore: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, latestSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, automarkPending: boolean | null, feedbackReleased: boolean, feedbackReleasedTimestamp: string | null, finalScore: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, latestSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null };

export type ComponentBreakdownFragment = { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null };

export type ComponentScoreFragment = { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null };

export type CreateGraderMarkerRubricMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: CreateGraderMarkerRubricInput;
}>;


export type CreateGraderMarkerRubricMutation = { __typename?: 'RootMutationType', createGraderMarkerRubric: { __typename?: 'CreateGraderMarkerRubricPayload', markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } } };

export type CreateMarkerRubricMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: CreateMarkerRubricInput;
}>;


export type CreateMarkerRubricMutation = { __typename?: 'RootMutationType', createMarkerRubric: { __typename?: 'MarkerRubric', format: MarkerRubricFormat, reversedScale: boolean, hasChanges: boolean, id: string, kind: MarkerRubricKind, publishedAt: string | null } };

export type CreateQuestionMarkerRubricMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: CreateQuestionMarkerRubricInput;
}>;


export type CreateQuestionMarkerRubricMutation = { __typename?: 'RootMutationType', createQuestionMarkerRubric: { __typename?: 'CreateQuestionMarkerRubricPayload', markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } } };

export type CreateSkillMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: CreateSkillInput;
}>;


export type CreateSkillMutation = { __typename?: 'RootMutationType', createSkill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } };

export type CreateThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  input: ThreadInput;
}>;


export type CreateThreadMutation = { __typename?: 'RootMutationType', createThread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> } };

export type CriteriaBySkillQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  skillId: Scalars['ID']['input'];
}>;


export type CriteriaBySkillQuery = { __typename?: 'RootQueryType', criteriaBySkill: Array<{ __typename?: 'ReuseCriterion', assessmentName: string, color: string | null, description: string | null, kind: MarkerRubricKind, maxScore: number | null, publishedAt: string, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string }, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> };

export type CriterionFragment = { __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> };

export type CriterionOutcomeFragment = { __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null };

export type DeleteThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type DeleteThreadMutation = { __typename?: 'RootMutationType', deleteThread: { __typename?: 'Thread', id: string } };

export type DownloadWorkAttachmentsMutationVariables = Exact<{
  answerBlockId: Scalars['ID']['input'];
  blockAttachmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DownloadWorkAttachmentsMutation = { __typename?: 'RootMutationType', downloadWorkAttachments: string };

export type EditCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type EditCommentMutation = { __typename?: 'RootMutationType', editComment: { __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } } };

export type EditThreadTitleMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type EditThreadTitleMutation = { __typename?: 'RootMutationType', editThreadTitle: { __typename?: 'Thread', id: string, title: string | null } };

export type EntityThreadEventFragment = { __typename?: 'EntityThreadEvent', eventType: EntityThreadEventType, threadId: string, status: ThreadStatus, entityId: string | null, entityType: EntityType | null, resolvedAt: string | null, criterionId: string | null, resolvedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null };

export type EntityThreadsQueryVariables = Exact<{
  entityType: EntityType;
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EntityThreadsQuery = { __typename?: 'RootQueryType', entityThreads: Array<{ __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> }> };

export type OnEntityThreadsUpdatedSubscriptionVariables = Exact<{
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
}>;


export type OnEntityThreadsUpdatedSubscription = { __typename?: 'RootSubscriptionType', entityThreadsUpdated: { __typename?: 'EntityThreadEvent', eventType: EntityThreadEventType, threadId: string, status: ThreadStatus, entityId: string | null, entityType: EntityType | null, resolvedAt: string | null, criterionId: string | null, resolvedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } };

export type ExtendedRubricQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  status: MarkerRubricStatus;
  markerRubricId: Scalars['ID']['input'];
}>;


export type ExtendedRubricQuery = { __typename?: 'RootQueryType', extendedRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type FeedbackReleaseRuleFragment = { __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: RuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType };

export type FeedbackVisibilityFragment = { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, withFeedbackPdf: boolean, notifyStudents: boolean, showPeerScores: boolean, showPeerComments: boolean, jointRelease: boolean, releaseType: FeedbackReleaseType };

export type FieldOutcomeFragment = { __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } };

export type FieldOutcomeScoreFragment = { __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, markerScore: number | null, automarkScore: number | null };

export type FieldResponseFragment = { __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null };

export type FieldRubricChangesFragment = { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> };

export type FieldRubricFragment = { __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type FieldRubricResponseFragment = { __typename?: 'FieldRubric', id: string, identifier: string, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> };

export type GradebookReceiptFragment = { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean };

export type GraderRouteQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GraderRouteQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string }, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null }, individualSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, releaseTimestamp: string, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, rubric: { __typename?: 'Rubric', id: string, questions: Array<{ __typename?: 'QuestionRubric', id: string, questionId: string, maxScore: number, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number }, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> }> } | null, class: { __typename?: 'Class', groupType: GroupType, students: Array<{ __typename?: 'Enrollment', id: string, syncedAt: string | null, deleted: boolean, sisUserId: string | null, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> } };

export type GroupPeerOutcomesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type GroupPeerOutcomesQuery = { __typename?: 'RootQueryType', groupPeerOutcomes: Array<{ __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> }> };

export type LearningOutcomeSkillFragment = { __typename?: 'LearningOutcomeSkill', id: string, skill: string };

export type LinkCommentThreadMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
  criterionId: Scalars['Int']['input'];
}>;


export type LinkCommentThreadMutation = { __typename?: 'RootMutationType', linkCommentThread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> } };

export type MarkFieldOutcomeMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: MarkFieldOutcomeInput;
}>;


export type MarkFieldOutcomeMutation = { __typename?: 'RootMutationType', markFieldOutcome: { __typename?: 'MarkFieldOutcomePayload', fieldOutcome: { __typename?: 'FieldOutcome', id: string, score: number | null, markerScore: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }, questionOutcome: { __typename?: 'QuestionOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }, workOutcome: { __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } } } };

export type MfaMarkingQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type MfaMarkingQuery = { __typename?: 'RootQueryType', studentWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, automarkPending: boolean | null, feedbackReleased: boolean, feedbackReleasedTimestamp: string | null, finalScore: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, latestSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null };

export type MarkRouteQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type MarkRouteQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, email: string | null }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null }, class: { __typename?: 'Class', groupType: GroupType, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }>, students: Array<{ __typename?: 'Enrollment', id: string, syncedAt: string | null, deleted: boolean, sisUserId: string | null, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }> }, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, individualSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, releaseTimestamp: string, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, groupSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, releaseTimestamp: string, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> } | null, rubric: { __typename?: 'Rubric', id: string, questions: Array<{ __typename?: 'QuestionRubric', id: string, questionId: string, maxScore: number, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number }, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> }> } | null };

export type MarkSubmissionOutcomeMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: MarkSubmissionOutcomeInput;
}>;


export type MarkSubmissionOutcomeMutation = { __typename?: 'RootMutationType', markSubmissionOutcome: { __typename?: 'MarkSubmissionOutcomePayload', submissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }, workOutcome: { __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } } } };

export type MarkerRubricFragment = { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> };

export type MarkerRubricQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
  status: MarkerRubricStatus;
}>;


export type MarkerRubricQuery = { __typename?: 'RootQueryType', markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type MarkerRubricRouteQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  kind: MarkerRubricKind;
}>;


export type MarkerRubricRouteQuery = { __typename?: 'RootQueryType', draftMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, publishedMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type ExtendedRubricRouteQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
}>;


export type ExtendedRubricRouteQuery = { __typename?: 'RootQueryType', draftExtendedRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, publishedExtendedRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type MarkingSheetFragment = { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, releaseTimestamp: string, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> };

export type ModerationPenaltyRuleFragment = { __typename?: 'ModerationPenaltyRule', canStack: boolean, excludedStudentIds: Array<string> | null, includedTags: Array<string> | null, id: string, minutesLateBy: number | null, penaltyScore: number, scoreUnit: PenaltyScoreUnit, penaltyType: ModerationPenaltyType, reason: string | null, formatUnit: PenaltyFormatUnit | null, ruleKind: RuleKind, includedGroupIds: Array<string> };

export type ModerationQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ModerationQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string }, classWorkGroups: Array<{ __typename?: 'WorkGroup', id: string, group: { __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null }>, feedbackReleaseRules: Array<{ __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: RuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType }>, moderationPenaltyRules: Array<{ __typename?: 'ModerationPenaltyRule', canStack: boolean, excludedStudentIds: Array<string> | null, includedTags: Array<string> | null, id: string, minutesLateBy: number | null, penaltyScore: number, scoreUnit: PenaltyScoreUnit, penaltyType: ModerationPenaltyType, reason: string | null, formatUnit: PenaltyFormatUnit | null, ruleKind: RuleKind, includedGroupIds: Array<string> }> | null, finalFeedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, withFeedbackPdf: boolean, notifyStudents: boolean, showPeerScores: boolean, showPeerComments: boolean, jointRelease: boolean, releaseType: FeedbackReleaseType }, provisionalFeedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, withFeedbackPdf: boolean, notifyStudents: boolean, showPeerScores: boolean, showPeerComments: boolean, jointRelease: boolean, releaseType: FeedbackReleaseType }, studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, individualPenalty: number | null, groupPenalty: number | null, finalScore: number | null, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null } }>, peerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null };

export type ModeratorUpdateFieldRubricResponseMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: UpdateFieldRubricInput;
}>;


export type ModeratorUpdateFieldRubricResponseMutation = { __typename?: 'RootMutationType', updateFieldRubricResponse: { __typename?: 'UpdateFieldRubricPayload', fieldRubric: { __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> } | null, questionRubric: { __typename?: 'QuestionRubric', id: string, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number } } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, markerScore: number | null, automarkScore: number | null }>, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }> } };

export type PastMarkerRubricFragment = { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> };

export type PastMarkerRubricsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type PastMarkerRubricsQuery = { __typename?: 'RootQueryType', pastMarkerRubrics: Array<{ __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> }> };

export type PeerOutcomeFragment = { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> };

export type PublishMarkerRubricMutationVariables = Exact<{
  markerRubricId: Scalars['ID']['input'];
}>;


export type PublishMarkerRubricMutation = { __typename?: 'RootMutationType', publishMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } };

export type QuestionOutcomeFragment = { __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } };

export type QuestionOutcomeScoreFragment = { __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } };

export type QuestionOutcomeSubscriptionFragment = { __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }> };

export type QuestionResponseCountsFragment = { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number };

export type QuestionRubricFragment = { __typename?: 'QuestionRubric', id: string, questionId: string, maxScore: number, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number }, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null }> };

export type QuestionRubricQueryVariables = Exact<{
  questionRubricId: Scalars['ID']['input'];
}>;


export type QuestionRubricQuery = { __typename?: 'RootQueryType', questionRubric: { __typename?: 'QuestionRubric', fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> }> } };

export type ReleaseFeedbackForEveryoneMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  feedbackVisibility: InputMaybe<FeedbackVisibilityInput>;
  releaseType: InputMaybe<FeedbackReleaseType>;
}>;


export type ReleaseFeedbackForEveryoneMutation = { __typename?: 'RootMutationType', releaseFeedbackForEveryone: { __typename?: 'ReleaseFeedbackForEveryonePayload', feedbackReleaseRules: Array<{ __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: RuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType }>, studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, individualPenalty: number | null, groupPenalty: number | null, finalScore: number | null, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null } }> } };

export type RemoveMarkerRubricMutationVariables = Exact<{
  markerRubricId: Scalars['ID']['input'];
}>;


export type RemoveMarkerRubricMutation = { __typename?: 'RootMutationType', removeMarkerRubric: { __typename?: 'MarkerRubric', id: string } };

export type RemoveMarkerRubricOutcomesMutationVariables = Exact<{
  markerRubricId: Scalars['ID']['input'];
}>;


export type RemoveMarkerRubricOutcomesMutation = { __typename?: 'RootMutationType', removeMarkerRubricOutcomes: { __typename?: 'OutcomesDeletedPayload', outcomesDeleted: number } };

export type ResetFeedbackReleaseRuleMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  releaseType: InputMaybe<FeedbackReleaseType>;
}>;


export type ResetFeedbackReleaseRuleMutation = { __typename?: 'RootMutationType', resetFeedbackReleaseRules: Array<{ __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: RuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType }> };

export type ResetQuestionModerationChangesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResetQuestionModerationChangesMutation = { __typename?: 'RootMutationType', resetQuestionModerationChanges: { __typename?: 'ResetQuestionModerationChangesPayload', fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> }>, studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, individualPenalty: number | null, groupPenalty: number | null, finalScore: number | null, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null } }>, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, questionRubrics: Array<{ __typename?: 'QuestionRubric', id: string, counts: { __typename?: 'QuestionResponseCounts', responseCount: number, successCount: number } }> } };

export type ResetRubricOutcomeForFieldMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  fieldOutcomeId: Scalars['ID']['input'];
}>;


export type ResetRubricOutcomeForFieldMutation = { __typename?: 'RootMutationType', resetRubricOutcomeForField: { __typename?: 'ResetRubricOutcomeForFieldPayload', criterionOutcomesDeleted: number, fieldOutcome: { __typename?: 'FieldOutcome', id: string, score: number | null, markerScore: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }, questionOutcome: { __typename?: 'QuestionOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }, workOutcome: { __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } } } };

export type ResetRubricOutcomeForSubmissionMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  markerRubricId: Scalars['ID']['input'];
  submissionOutcomeId: Scalars['ID']['input'];
}>;


export type ResetRubricOutcomeForSubmissionMutation = { __typename?: 'RootMutationType', resetRubricOutcomeForSubmission: { __typename?: 'ResetRubricOutcomeForSubmissionPayload', criterionOutcomesDeleted: number, submissionOutcome: { __typename?: 'SubmissionOutcome', id: string, score: number | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }, workOutcome: { __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } } } };

export type ResetScoreModerationChangesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResetScoreModerationChangesMutation = { __typename?: 'RootMutationType', resetScoreModerationChanges: { __typename?: 'ResetScoreModerationChangesPayload', studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, individualPenalty: number | null, groupPenalty: number | null, finalScore: number | null, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null } }>, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }> } };

export type ReuseCriterionFragment = { __typename?: 'ReuseCriterion', assessmentName: string, color: string | null, description: string | null, kind: MarkerRubricKind, maxScore: number | null, publishedAt: string, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string }, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> };

export type SaveFragment = { __typename?: 'Save', id: string, serverId: string, version: string, content: string, dispatchedAt: string };

export type ScaleItemFragment = { __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null };

export type ScoreBreakdownFragment = { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null };

export type SimilarityQueryVariables = Exact<{
  submissionType: SubmissionType;
  workId: Scalars['ID']['input'];
}>;


export type SimilarityQuery = { __typename?: 'RootQueryType', latestResult: { __typename?: 'Result', id: string, heraResultId: number | null, similarity: { __typename?: 'Similarity', display: string, label: string, value: number } | null } };

export type SkillFragment = { __typename?: 'LearningOutcomeSkill', id: string, skill: string };

export type SkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type SkillsQuery = { __typename?: 'RootQueryType', skills: Array<{ __typename?: 'LearningOutcomeSkill', id: string, skill: string }> };

export type SkillsByAssessmentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type SkillsByAssessmentQuery = { __typename?: 'RootQueryType', skillsByAssessment: Array<{ __typename?: 'LearningOutcomeSkill', id: string, skill: string }> };

export type SnapshotFieldOutcomeMutationVariables = Exact<{
  fieldOutcomeId: Scalars['ID']['input'];
  input: SnapshotFieldOutcomeInput;
}>;


export type SnapshotFieldOutcomeMutation = { __typename?: 'RootMutationType', snapshotFieldOutcome: { __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } };

export type SnapshotSubmissionOutcomeMutationVariables = Exact<{
  submissionOutcomeId: Scalars['ID']['input'];
  input: SnapshotSubmissionOutcomeInput;
}>;


export type SnapshotSubmissionOutcomeMutation = { __typename?: 'RootMutationType', snapshotSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } };

export type StudentOutcomeFragment = { __typename?: 'StudentOutcome', id: string, studentId: string, individualPenalty: number | null, groupPenalty: number | null, finalScore: number | null, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null } };

export type StudentOutcomesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type StudentOutcomesQuery = { __typename?: 'RootQueryType', studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, individualPenalty: number | null, groupPenalty: number | null, finalScore: number | null, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null } }> };

export type StudentOutcomesUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type StudentOutcomesUpdatedSubscription = { __typename?: 'RootSubscriptionType', studentOutcomesUpdated: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, individualPenalty: number | null, groupPenalty: number | null, finalScore: number | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, finalScore: number | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, latestSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }> }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, finalScore: number | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, latestSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }> }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null } }> };

export type SubmissionOutcomeFragment = { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } };

export type ThreadFragment = { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, insertedAt: string, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null, blockAttachmentId: number | null, blockAttachmentName: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> };

export type UnlinkCommentThreadMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
}>;


export type UnlinkCommentThreadMutation = { __typename?: 'RootMutationType', unlinkCommentThread: { __typename?: 'Thread', id: string, title: string | null, entityType: EntityType | null, entityId: string | null, criterionId: string | null, createdBy: { __typename?: 'User', id: string }, metadata: { __typename?: 'Metadata', charterSectionType: CharterSectionType | null, charterEditorId: string | null } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string, updatedAt: string, createdBy: { __typename?: 'User', id: string, name: string, colourset: number | null } }> } };

export type UpdateFeedbackReleaseRulesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  rules: Array<FeedbackReleaseRuleInput> | FeedbackReleaseRuleInput;
  releaseType: InputMaybe<FeedbackReleaseType>;
}>;


export type UpdateFeedbackReleaseRulesMutation = { __typename?: 'RootMutationType', updateFeedbackReleaseRules: Array<{ __typename?: 'FeedbackReleaseRule', id: string, basePool: FeedbackReleaseBasePool, excludedStudentIds: Array<string>, excludedTags: Array<string>, executedAt: string | null, includedStudentIds: Array<string>, scheduledAt: string | null, executedStudentIds: Array<string> | null, ruleKind: RuleKind, includedGroupIds: Array<string>, releaseType: FeedbackReleaseType }> };

export type UpdateFeedbackVisibilityMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: FeedbackVisibilityInput;
  releaseType: InputMaybe<FeedbackReleaseType>;
}>;


export type UpdateFeedbackVisibilityMutation = { __typename?: 'RootMutationType', updateFeedbackVisibility: { __typename?: 'FeedbackVisibility', id: string, feedbackViewLevel: FeedbackLevel, withFeedbackPdf: boolean, notifyStudents: boolean, showPeerScores: boolean, showPeerComments: boolean, jointRelease: boolean, releaseType: FeedbackReleaseType } };

export type UpdateFieldRubricResponseMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: UpdateFieldRubricInput;
}>;


export type UpdateFieldRubricResponseMutation = { __typename?: 'RootMutationType', updateFieldRubricResponse: { __typename?: 'UpdateFieldRubricPayload', fieldRubric: { __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', answer: string | null, answers: Array<string> | null, id: string, identifier: string, fieldRubricId: string, score: number | null, markerScore: number | null, automarkScore: number | null }>, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }> } };

export type UpdateMarkerRubricMutationVariables = Exact<{
  input: MarkerRubricInput;
  markerRubricId: Scalars['ID']['input'];
}>;


export type UpdateMarkerRubricMutation = { __typename?: 'RootMutationType', updateMarkerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } };

export type UpdateModerationPenaltyRulesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  rules: Array<ModerationPenaltyRuleInput> | ModerationPenaltyRuleInput;
}>;


export type UpdateModerationPenaltyRulesMutation = { __typename?: 'RootMutationType', updateModerationPenaltyRules: Array<{ __typename?: 'ModerationPenaltyRule', canStack: boolean, excludedStudentIds: Array<string> | null, includedTags: Array<string> | null, id: string, minutesLateBy: number | null, penaltyScore: number, scoreUnit: PenaltyScoreUnit, penaltyType: ModerationPenaltyType, reason: string | null, formatUnit: PenaltyFormatUnit | null, ruleKind: RuleKind, includedGroupIds: Array<string> }> };

export type UpdateQuestionRubricMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: UpdateQuestionRubricInput;
}>;


export type UpdateQuestionRubricMutation = { __typename?: 'RootMutationType', updateQuestionRubric: { __typename?: 'UpdateQuestionRubricPayload', questionRubric: { __typename?: 'QuestionRubric', id: string, fieldRubrics: Array<{ __typename?: 'FieldRubric', id: string, identifier: string, baseType: BaseType | null, values: Array<string> | null, automarked: boolean, strategy: MatchStrategy | null, similarity: number | null, errorMargin: number | null, caseSensitive: boolean, partialScoring: boolean, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }> | null, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> | null, markerChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, moderatorChanges: { __typename?: 'FieldRubricChanges', id: string, valuesAdded: Array<string>, valuesRemoved: Array<string> } | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, responses: Array<{ __typename?: 'FieldResponse', answer: string | null, answers: Array<string> | null, count: number, isCorrect: boolean, similarity: number | null }> }> } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', answer: string | null, answers: Array<string> | null, id: string, identifier: string, fieldRubricId: string, score: number | null, markerScore: number | null, automarkScore: number | null }>, workOutcomes: Array<{ __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }> } };

export type UpdateStudentOutcomeScoreMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  input: UpdateStudentOutcomeScoreInput;
}>;


export type UpdateStudentOutcomeScoreMutation = { __typename?: 'RootMutationType', updateStudentOutcomeScore: { __typename?: 'UpdateStudentOutcomeScorePayload', studentOutcome: { __typename?: 'StudentOutcome', id: string, studentId: string, individualPenalty: number | null, groupPenalty: number | null, finalScore: number | null, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null } } } };

export type UpdateWorkOutcomeScoreMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: UpdateWorkOutcomeScoreInput;
}>;


export type UpdateWorkOutcomeScoreMutation = { __typename?: 'RootMutationType', updateWorkOutcomeScore: { __typename?: 'UpdateWorkOutcomeScorePayload', studentOutcomes: Array<{ __typename?: 'StudentOutcome', id: string, studentId: string, individualPenalty: number | null, groupPenalty: number | null, finalScore: number | null, moderatorModifier: number | null, peerOutcome: { __typename?: 'PeerOutcome', id: string, targetUserId: string, selfScore: number | null, selfMaxScore: number | null, peerScore: number | null, peerMaxScore: number | null, completedAt: string | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } | null, groupWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, individualWorkOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null } | null, base: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, provisional: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null }, final: { __typename?: 'ComponentBreakdown', total: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, group: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, individual: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, self: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null, peer: { __typename?: 'ComponentScore', score: number | null, maxScore: number | null, moderatorModifier: number | null, penaltyScore: number | null, weight: number | null, weightedScore: number | null, weightedMaxScore: number | null, weightedModeratorModifier: number | null, weightedPenaltyScore: number | null } | null } }> } };

export type WorkOutcomeClassFragment = { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, finalScore: number | null, maxScore: number, automarkPending: boolean | null, feedbackReleasedTimestamp: string | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null };

export type WorkOutcomeFragment = { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, automarkPending: boolean | null, feedbackReleased: boolean, feedbackReleasedTimestamp: string | null, finalScore: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, latestSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> };

export type WorkOutcomeQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type WorkOutcomeQuery = { __typename?: 'RootQueryType', workOutcome: { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, automarkPending: boolean | null, feedbackReleased: boolean, feedbackReleasedTimestamp: string | null, finalScore: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, blockSnapshot: { __typename?: 'BlockSnapshot', id: string, content: string, blockName: string | null } | null, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }>, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } }>, latestSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } | null, workOutcomeRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, work: { __typename?: 'Work', student: { __typename?: 'User', id: string }, group: { __typename?: 'Group', id: string, members: Array<{ __typename?: 'User', id: string }> } | null, answerBlocks: Array<{ __typename?: 'AnswerBlock', nodeId: string, id: string }> } };

export type WorkOutcomeReleaseFragment = { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null };

export type WorkOutcomeScoreFragment = { __typename?: 'WorkOutcome', id: string, workId: string, studentId: string | null, groupId: string | null, maxScore: number, automarkPending: boolean | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null } };

export type WorkOutcomeSubmissionQueryVariables = Exact<{
  workId: Scalars['ID']['input'];
}>;


export type WorkOutcomeSubmissionQuery = { __typename?: 'RootQueryType', workOutcome: { __typename?: 'WorkOutcome', id: string, latestSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } | null } | null };

export type WorkOutcomeUpdatedFragment = { __typename?: 'WorkOutcome', id: string, workId: string, groupId: string | null, studentId: string | null, maxScore: number, finalScore: number | null, finalScorePenalty: number | null, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, latestSubmissionOutcome: { __typename?: 'SubmissionOutcome', id: string, submissionId: string, bodyBlockSnapshotId: string | null, bodyDocVersion: number, bodyDoc: string | null, referencesBlockSnapshotId: string | null, referencesDocVersion: number, referencesDoc: string | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } } | null, questionOutcomes: Array<{ __typename?: 'QuestionOutcome', id: string, questionId: string, scoreBreakdown: { __typename?: 'ScoreBreakdown', score: number | null, marker: number | null, automark: number | null, markerModifier: number | null, moderatorModifier: number | null }, fieldOutcomes: Array<{ __typename?: 'FieldOutcome', id: string, identifier: string, fieldRubricId: string, score: number | null, automarkScore: number | null, automarkStatus: AutomarkStatus | null, answer: string | null, answers: Array<string> | null, answerSimilarity: number | null, docContent: string | null, docVersion: number | null, comments: Array<{ __typename?: 'Comment', id: string }> | null, rubricOutcome: { __typename?: 'RubricOutcome', score: number | null, criterionOutcomes: Array<{ __typename?: 'CriterionOutcome', id: string, markerUserId: string | null, markerScore: number, markerRubricCriterionId: string, markerRubricScaleItemId: string, targetUserId: string | null }> } }> }>, provisionalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null, finalRelease: { __typename?: 'WorkOutcomeRelease', id: string, releaseType: FeedbackReleaseType, releasedAt: string, finalScore: number, penaltyScore: number, moderatorModifier: number | null } | null };

export type OnboardingPayloadFragment = { __typename?: 'OnboardingPayload', subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string } | null, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null };

export type CaptureOnboardingInputMutationVariables = Exact<{
  subjectId: Scalars['ID']['input'];
  subjectRole: SubjectRole;
  discipline: InputMaybe<Discipline>;
}>;


export type CaptureOnboardingInputMutation = { __typename?: 'RootMutationType', captureOnboardingInput: { __typename?: 'OnboardingPayload', subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string } | null, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null } };

export type SaveGlobalUserSettingsMutationVariables = Exact<{
  userSettingsInput: GlobalUserSettingsInput;
}>;


export type SaveGlobalUserSettingsMutation = { __typename?: 'RootMutationType', saveGlobalUserSettings: { __typename?: 'SaveGlobalUserSettingsPayload', userSettings: { __typename?: 'UserSettings', showIaOnboarding: boolean | null } | null } };

export type UserSettingsFragment = { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null };

export type AddTagMutationVariables = Exact<{
  enrollmentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  column: Scalars['Int']['input'];
}>;


export type AddTagMutation = { __typename?: 'RootMutationType', addTag: { __typename?: 'Tag', text: string, column: number } };

export type AssessmentProjectIssuesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentProjectIssuesQuery = { __typename?: 'RootQueryType', assessmentProjectIssues: Array<{ __typename?: 'ProjectIssue', id: string, type: IssueType, status: IssueStatus, dueDate: string | null, parentId: string | null, assignees: Array<string>, groupId: string }> };

export type BulkAddTagMutationVariables = Exact<{
  enrollmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  text: Scalars['String']['input'];
  tab: ClassTab;
}>;


export type BulkAddTagMutation = { __typename?: 'RootMutationType', bulkAddTag: Array<{ __typename?: 'Tag', text: string, tab: ClassTab }> };

export type BulkRemoveTagMutationVariables = Exact<{
  enrollmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  text: Scalars['String']['input'];
  tab: ClassTab;
}>;


export type BulkRemoveTagMutation = { __typename?: 'RootMutationType', bulkRemoveTag: boolean };

export type DownloadSubmissionsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  submissions: Array<SubmissionDetailInput> | SubmissionDetailInput;
  preferPdf: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DownloadSubmissionsMutation = { __typename?: 'RootMutationType', downloadSubmissions: string };

export type DownloadWorkArtifactsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workArtifacts: Array<WorkArtifactDetailInput> | WorkArtifactDetailInput;
}>;


export type DownloadWorkArtifactsMutation = { __typename?: 'RootMutationType', downloadWorkArtifacts: string };

export type EnrollmentFragment = { __typename?: 'Enrollment', id: string, syncedAt: string | null, deleted: boolean, sisUserId: string | null, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null };

export type EnrollmentTagsFragment = { __typename?: 'Enrollment', id: string, tags: Array<{ __typename?: 'Tag', text: string, column: number, tab: ClassTab }> };

export type EnrollmentsUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type EnrollmentsUpdatedSubscription = { __typename?: 'RootSubscriptionType', enrollmentsUpdated: number };

export type ForceSubmissionsV2MutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  type: SubmissionType;
  submittedAt: Scalars['DateTime']['input'];
}>;


export type ForceSubmissionsV2Mutation = { __typename?: 'RootMutationType', forceSubmissionsV2: Array<{ __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null }> };

export type ForceSubmissionsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  workIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  type: SubmissionType;
  submittedAt: Scalars['DateTime']['input'];
}>;


export type ForceSubmissionsMutation = { __typename?: 'RootMutationType', forceSubmissions: Array<{ __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null }> };

export type InsertSyncRosterJobMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  withExtensions: InputMaybe<Scalars['Boolean']['input']>;
  extensionConflictAction: InputMaybe<ExtensionConflictActionType>;
}>;


export type InsertSyncRosterJobMutation = { __typename?: 'RootMutationType', insertSyncRosterJob: { __typename?: 'BackgroundJob', id: string, kind: BackgroundJobKind, state: BackgroundJobState } };

export type ProjectIssueFragment = { __typename?: 'ProjectIssue', id: string, type: IssueType, status: IssueStatus, dueDate: string | null, parentId: string | null, assignees: Array<string>, groupId: string };

export type RemoveTagMutationVariables = Exact<{
  enrollmentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  column: Scalars['Int']['input'];
}>;


export type RemoveTagMutation = { __typename?: 'RootMutationType', removeTag: boolean };

export type ResultFragment = { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null };

export type ResultsUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type ResultsUpdatedSubscription = { __typename?: 'RootSubscriptionType', resultsUpdated: Array<{ __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null }> };

export type SendEmailsToClassMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  submissionIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type SendEmailsToClassMutation = { __typename?: 'RootMutationType', sendEmailsToClass: string };

export type SubmissionFragment = { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null };

export type SyncGradesMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type SyncGradesMutation = { __typename?: 'RootMutationType', syncGrades: boolean | null };

export type SyncRosterMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  withExtensions: InputMaybe<Scalars['Boolean']['input']>;
  extensionConflictAction: InputMaybe<ExtensionConflictActionType>;
}>;


export type SyncRosterMutation = { __typename?: 'RootMutationType', syncRoster: Array<{ __typename?: 'Enrollment', id: string, syncedAt: string | null, deleted: boolean, sisUserId: string | null, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null } | null> };

export type UpdateStudentSettingsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  settings: Array<InputMaybe<StudentSettingsInput>> | InputMaybe<StudentSettingsInput>;
}>;


export type UpdateStudentSettingsMutation = { __typename?: 'RootMutationType', updateStudentSettings: Array<{ __typename?: 'WorkSettings', studentId: string, id: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null> };

export type UpdateWorkSettingsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  enrollmentId: Scalars['ID']['input'];
  dueDate: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateWorkSettingsMutation = { __typename?: 'RootMutationType', updateWorkSettings: { __typename?: 'WorkSettings', id: string, dueDate: string | null, timeLimit: number | null } };

export type UpdateEnrollmentsStatusMutationVariables = Exact<{
  enrollmentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  withdrawn: Scalars['Boolean']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type UpdateEnrollmentsStatusMutation = { __typename?: 'RootMutationType', updateEnrollmentsStatus: Array<{ __typename?: 'Enrollment', id: string, syncedAt: string | null, deleted: boolean, sisUserId: string | null, anonymousIndex: number | null, deletedBy: { __typename?: 'User', id: string, name: string } | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, work: { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> } | null, tags: Array<{ __typename?: 'Tag', id: string, text: string, column: number, tab: ClassTab }>, workSettings: { __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null, accessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean } | null, verifiedCodes: Array<{ __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null }> | null }> };

export type VerifiedCodeFragment = { __typename?: 'VerifiedCode', label: string | null, insertedAt: string | null };

export type WorkArtifactFragment = { __typename?: 'WorkArtifact', id: string, name: string, taskHistoryId: string, submissionId: string, workId: string, studentSentAt: string | null, agsSentAt: string | null };

export type WorkFeaturesFragment = { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean };

export type WorkFragment = { __typename?: 'Work', id: string, startDate: string | null, updatedAt: string | null, lastSaveTime: string | null, attemptCount: number, finalResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, draftResult: { __typename?: 'Result', id: string, workId: string, submissionType: SubmissionType, isReady: boolean, heraResultId: number | null, canvasResultUrl: string | null, moodleGraderUrl: string | null, grade: { __typename?: 'Grade', display: string, value: number, max: number } | null, similarity: { __typename?: 'Similarity', display: string, value: number, label: string } | null, feedbackAccess: { __typename?: 'AccessSummary', lastAccess: string, accessCount: number } | null, submission: { __typename?: 'Submission', id: string, workId: string, submittedAt: string, forceSubmitted: boolean, type: SubmissionType, submittedBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null } | null, receipt: { __typename?: 'GradebookReceipt', pdfArtifactId: string | null, turnitinComplete: boolean, lmsSnooze: string | null, lmsComplete: boolean, emailComplete: boolean } | null } | null, features: { __typename?: 'WorkFeatures', id: string, enableWorkAuthority: boolean }, answerBlocks: Array<{ __typename?: 'AnswerBlock', id: string, nodeId: string, blockName: string | null, blockAttachments: Array<{ __typename?: 'BlockAttachment', id: string, name: string, mediaUrl: string | null, fileSize: number | null, fileExtension: string | null }> }> };

export type WorkSettingsFragment = { __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null };

export type WorksSettingsUpdatedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type WorksSettingsUpdatedSubscription = { __typename?: 'RootSubscriptionType', worksSettingsUpdated: Array<{ __typename?: 'WorkSettings', id: string, studentId: string, dueDate: string | null, timeLimit: number | null, examReadingTime: number | null, examWritingTime: number | null, examStartDate: string | null, examEndDate: string | null, examDeferred: boolean | null, updatedAt: string | null, updateReason: string | null, draftExamStartDate: string | null, draftExamEndDate: string | null, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null } | null> };

export type AppendTagsForQuestionsMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: Array<TagInput> | TagInput;
}>;


export type AppendTagsForQuestionsMutation = { __typename?: 'RootMutationType', appendTagsForQuestions: Array<{ __typename?: 'Question', id: string, cacheId: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string }> }> };

export type ArchiveQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type ArchiveQuestionMutation = { __typename?: 'RootMutationType', archiveQuestion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } | null };

export type ChildQuestionFragment = { __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> };

export type ChildQuestionVersionFragment = { __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, version: number | null, order: number | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, user: { __typename?: 'User', id: string, name: string } };

export type CopyQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type CopyQuestionMutation = { __typename?: 'RootMutationType', copyQuestion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type CreateQuestionMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  childrenQuestions: InputMaybe<Array<QuestionAttributes> | QuestionAttributes>;
  input: QuestionAttributes;
  subjectId: Scalars['ID']['input'];
}>;


export type CreateQuestionMutation = { __typename?: 'RootMutationType', createQuestion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type CreateQuestionSelectionMutationVariables = Exact<{
  input: QuestionSelectionInput;
}>;


export type CreateQuestionSelectionMutation = { __typename?: 'RootMutationType', createQuestionSelection: { __typename?: 'CreateQuestionSelectionPayload', incompleteRuleIndex: number | null, selectedQuestionCount: number | null, requiredQuestionCount: number | null, selection: { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> } | null } };

export type CreateTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTagMutation = { __typename?: 'RootMutationType', createTag: { __typename?: 'QuestionTag', id: string, name: string } };

export type FindSimilarQuestionsMutationVariables = Exact<{
  input: FindSimilarQuestionsInput;
}>;


export type FindSimilarQuestionsMutation = { __typename?: 'RootMutationType', findSimilarQuestions: { __typename?: 'SimilarQuestionsPayload', incompleteReplacement: boolean | null, questions: Array<{ __typename?: 'Question', id: string, cacheId: string }> | null } };

export type LibraryQuestionFragment = { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null };

export type LibraryQuestionOverviewFragment = { __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null };

export type LibraryQuestionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LibraryQuestionQuery = { __typename?: 'RootQueryType', question: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } | null, questionTagCategories: Array<{ __typename?: 'QuestionTagCategory', id: string, name: string }> };

export type LibraryQuestionsQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type LibraryQuestionsQuery = { __typename?: 'RootQueryType', libraryQuestions: Array<{ __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null }>, assessment: { __typename?: 'Assessment', subjectId: string, name: string }, task: { __typename?: 'Task', id: string, blocks: Array<{ __typename?: 'TaskBlock', id: string, libraryQuestionId: string | null, questionSelection: { __typename?: 'QuestionSelection', sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }> } | null };

export type PublishImportedQuestionsMutationVariables = Exact<{
  input: PublishImportedQuestionsInput;
}>;


export type PublishImportedQuestionsMutation = { __typename?: 'RootMutationType', publishImportedQuestions: Array<{ __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null }> };

export type QuestionAssessmentFragment = { __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } };

export type QuestionContentQueryVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type QuestionContentQuery = { __typename?: 'RootQueryType', question: { __typename?: 'Question', id: string, cacheId: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null }> } | null };

export type QuestionSelectionFragment = { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> };

export type QuestionSelectionQueryVariables = Exact<{
  questionSelectionId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type QuestionSelectionQuery = { __typename?: 'RootQueryType', questionSelection: { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> } | null, assessment: { __typename?: 'Assessment', subjectId: string, name: string }, task: { __typename?: 'Task', id: string } | null };

export type QuestionSelectionRuleFragment = { __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null };

export type QuestionSetFragment = { __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> };

export type QuestionSetQuestionFragment = { __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type QuestionSourceFileFragment = { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null };

export type QuestionTagCategoryFragment = { __typename?: 'QuestionTagCategory', id: string, name: string };

export type QuestionTagFragment = { __typename?: 'QuestionTag', id: string, name: string, categoryId: string };

export type QuestionVersionFragment = { __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, user: { __typename?: 'User', id: string, name: string }, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, version: number | null, order: number | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, user: { __typename?: 'User', id: string, name: string } }> };

export type QuestionVersionQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type QuestionVersionQuery = { __typename?: 'RootQueryType', questionVersion: { __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, user: { __typename?: 'User', id: string, name: string }, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, parentQuestionId: string | null, questionId: string, questionType: QuestionType, shortPrompt: string | null, version: number | null, order: number | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, user: { __typename?: 'User', id: string, name: string } }> } | null };

export type QuestionVersionSummaryFragment = { __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } };

export type RegenerateQuestionSetMutationVariables = Exact<{
  input: RegenerateQuestionSetInput;
}>;


export type RegenerateQuestionSetMutation = { __typename?: 'RootMutationType', regenerateQuestionSet: { __typename?: 'RegenerateQuestionSetPayload', incompleteReplacement: boolean | null, questionSet: { __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> } | null } };

export type RegisterQuestionSourceFileMutationVariables = Exact<{
  input: RegisterQuestionSourceFileInput;
}>;


export type RegisterQuestionSourceFileMutation = { __typename?: 'RootMutationType', registerQuestionSourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } };

export type RemoveQuestionsUniformlyMutationVariables = Exact<{
  input: RemoveQuestionsUniformlyInput;
}>;


export type RemoveQuestionsUniformlyMutation = { __typename?: 'RootMutationType', removeQuestionsUniformly: { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> } };

export type ReplaceQuestionInSetMutationVariables = Exact<{
  input: ReplaceQuestionInSetInput;
}>;


export type ReplaceQuestionInSetMutation = { __typename?: 'RootMutationType', replaceQuestionInSet: { __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> } };

export type UpdateQuestionAttributesMutationVariables = Exact<{
  questionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: QuestionAttributesInput;
}>;


export type UpdateQuestionAttributesMutation = { __typename?: 'RootMutationType', updateQuestionAttributes: Array<{ __typename?: 'Question', id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null }> };

export type UpdateQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
  input: QuestionAttributesInput;
}>;


export type UpdateQuestionMutation = { __typename?: 'RootMutationType', updateQuestion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type UpdateQuestionSourceFileMutationVariables = Exact<{
  input: UpdateQuestionSourceFileInput;
}>;


export type UpdateQuestionSourceFileMutation = { __typename?: 'RootMutationType', updateQuestionSourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } };

export type UpdateQuestionVersionMutationVariables = Exact<{
  input: UpdateQuestionVersionInput;
  childrenQuestions: Array<UpdateQuestionVersionInput> | UpdateQuestionVersionInput;
}>;


export type UpdateQuestionVersionMutation = { __typename?: 'RootMutationType', updateQuestionVersion: { __typename?: 'Question', id: string, cacheId: string, libraryId: string, parentQuestionId: string | null, currentVersionId: string | null, questionType: QuestionType, shortPrompt: string | null, points: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, order: number | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, childrenQuestions: Array<{ __typename?: 'Question', id: string, parentQuestionId: string | null, libraryId: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, order: number | null, shuffle: boolean, difficulty: QuestionDifficulty | null, currentVersionId: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }> }>, versions: Array<{ __typename?: 'QuestionVersion', id: string, insertedAt: string, version: number | null, user: { __typename?: 'User', id: string, name: string } }>, lastUpdatedBy: { __typename?: 'User', id: string, name: string } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } };

export type UpdateTagsForQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
  input: Array<TagInput> | TagInput;
}>;


export type UpdateTagsForQuestionMutation = { __typename?: 'RootMutationType', updateTagsForQuestion: { __typename?: 'Question', id: string, cacheId: string, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }> } };

export type AssessmentSentimentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentSentimentQuery = { __typename?: 'RootQueryType', assessmentSentimentChecks: Array<{ __typename?: 'SentimentCheck', id: string, skipped: boolean, level: SentimentCheckLevel | null, order: number, comment: string | null, insertedAt: string | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } }> };

export type SentimentCheckFragment = { __typename?: 'SentimentCheck', id: string, skipped: boolean, level: SentimentCheckLevel | null, order: number, comment: string | null, insertedAt: string | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } };

export type SentimentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type SentimentQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null }, groupSentimentChecks: Array<{ __typename?: 'SentimentCheck', id: string, skipped: boolean, level: SentimentCheckLevel | null, order: number, comment: string | null, insertedAt: string | null, user: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } }>, class: { __typename?: 'Class', groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> } };

export type AccessCodeFragment = { __typename?: 'AccessCode', code: string, label: string | null, active: boolean };

export type AddLibraryQuestionsToTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddLibraryQuestionsToTaskMutation = { __typename?: 'RootMutationType', addLibraryQuestionsToTask: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }> };

export type AddQuestionBanksToAssessmentMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  input: Array<AddQuestionBanksToAssessmentInput> | AddQuestionBanksToAssessmentInput;
}>;


export type AddQuestionBanksToAssessmentMutation = { __typename?: 'RootMutationType', addQuestionBanksToAssessment: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }> };

export type AddQuestionSelectionToTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  questionSelectionId: Scalars['ID']['input'];
}>;


export type AddQuestionSelectionToTaskMutation = { __typename?: 'RootMutationType', addQuestionSelectionToTask: { __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null } };

export type AssessmentAccessCodesQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentAccessCodesQuery = { __typename?: 'RootQueryType', assessmentAccessCodes: Array<{ __typename?: 'AccessCode', code: string, label: string | null, active: boolean }> | null };

export type AssessmentFragment = { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null };

export type AssessmentSettingsFragment = { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean };

export type AssessmentSettingsSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type AssessmentSettingsSubscription = { __typename?: 'RootSubscriptionType', assessmentSettings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } };

export type CancelReleaseMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
}>;


export type CancelReleaseMutation = { __typename?: 'RootMutationType', cancelRelease: { __typename?: 'CancelReleasePayload', task: { __typename?: 'Task', id: string, status: Status } } };

export type CreatePrintArchiveMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  input: PrintArchiveInput;
}>;


export type CreatePrintArchiveMutation = { __typename?: 'RootMutationType', createPrintArchive: string };

export type CreateResourceMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskId: InputMaybe<Scalars['ID']['input']>;
  url: Scalars['String']['input'];
  name: Scalars['String']['input'];
  mediaId: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateResourceMutation = { __typename?: 'RootMutationType', createResource: { __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean } };

export type CreateTaskBlockMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  input: CreateTaskBlockInput;
}>;


export type CreateTaskBlockMutation = { __typename?: 'RootMutationType', createTaskBlock: { __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null } };

export type CreateTaskSaveMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  editor: InputMaybe<EditorType>;
  taskId: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTaskSaveMutation = { __typename?: 'RootMutationType', createTaskSave: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null } };

export type DeleteResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteResourceMutation = { __typename?: 'RootMutationType', deleteResource: { __typename?: 'Resource', id: string, invalidated: boolean } };

export type DuplicateTaskBlockMutationVariables = Exact<{
  taskBlockId: Scalars['ID']['input'];
}>;


export type DuplicateTaskBlockMutation = { __typename?: 'RootMutationType', duplicateTaskBlock: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }> };

export type EditTaskMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type EditTaskMutation = { __typename?: 'RootMutationType', editTask: { __typename?: 'Task', id: string, status: Status } };

export type EditTaskV2MutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type EditTaskV2Mutation = { __typename?: 'RootMutationType', editTaskV2: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null } } };

export type GenerateReportMutationVariables = Exact<{
  kind: Scalars['String']['input'];
  assessmentId: Scalars['ID']['input'];
  workId: InputMaybe<Scalars['ID']['input']>;
  anonymousName: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateReportMutation = { __typename?: 'RootMutationType', generateReport: { __typename?: 'Job', id: string, assessmentId: string, conflict: boolean, resultUrl: string | null, insertedAt: string } };

export type HasSubmissionSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type HasSubmissionSubscription = { __typename?: 'RootSubscriptionType', hasSubmission: boolean };

export type HubTaskFragment = { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null } };

export type ImportLibraryQuestionMutationVariables = Exact<{
  input: ImportLibraryQuestionInput;
}>;


export type ImportLibraryQuestionMutation = { __typename?: 'RootMutationType', importLibraryQuestion: { __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null } };

export type InstructionSheetFragment = { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> };

export type InstructionSheetQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskId: InputMaybe<Scalars['ID']['input']>;
  taskKind: InputMaybe<TaskKind>;
}>;


export type InstructionSheetQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', name: string, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null }, task: { __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, blocks: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, futureSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableSubmissionPdf: boolean, enableExamLdb: boolean | null, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, allowLateResubmission: boolean, allowGenerativeAi: boolean | null, dueDate: string, returnDate: string, maxGrade: number, draftDueDate: string | null, wordLimit: number | null, timeLimit: number | null, weight: number | null, referencingStyle: string | null, countFootnotes: boolean, sViewReports: number, draftSViewReports: number, countReferences: boolean, anonymousMarking: boolean | null, gradingService: string, noExamFeedbackDate: boolean, enableExamAccessCode: boolean, markingToolPdf: MarkingToolPdf | null, disableExamBacktrack: boolean | null, disableSpellCheck: boolean, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null };

export type InstructionSheetWithRequirementsFragment = { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableSubmissionPdf: boolean, enableExamLdb: boolean | null, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, allowLateResubmission: boolean, allowGenerativeAi: boolean | null, dueDate: string, returnDate: string, maxGrade: number, draftDueDate: string | null, wordLimit: number | null, timeLimit: number | null, weight: number | null, referencingStyle: string | null, countFootnotes: boolean, sViewReports: number, draftSViewReports: number, countReferences: boolean, anonymousMarking: boolean | null, gradingService: string, noExamFeedbackDate: boolean, enableExamAccessCode: boolean, markingToolPdf: MarkingToolPdf | null, disableExamBacktrack: boolean | null, disableSpellCheck: boolean, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> };

export type PrintArchiveUrlQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  archiveId: Scalars['ID']['input'];
}>;


export type PrintArchiveUrlQuery = { __typename?: 'RootQueryType', printArchiveUrl: string | null };

export type CreateFileOriginMutationVariables = Exact<{
  input: CreateQuestionBankFileOriginInput;
}>;


export type CreateFileOriginMutation = { __typename?: 'RootMutationType', createFileOrigin: { __typename?: 'QuestionBankFileOrigin', id: string, filename: string | null, filepath: string | null } };

export type CreateQuestionBankMutationVariables = Exact<{
  questionBank: CreateQuestionBankInput;
}>;


export type CreateQuestionBankMutation = { __typename?: 'RootMutationType', createQuestionBank: { __typename?: 'QuestionBank', id: string, subjectId: string | null, assessmentId: string | null, subjectGroupId: string | null, difficulty: QuestionDifficulty | null, points: number | null, createdBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, response: { __typename?: 'BlanksResponse', matchSimilarity: number | null, caseSensitive: boolean | null, matchBlanks: Array<{ __typename?: 'Blank', id: string, phrases: Array<string> }> } | { __typename?: 'BooleanResponse', isTrue: boolean | null } | { __typename?: 'EditorResponse', wordLimit: number | null } | { __typename?: 'MultiResponse', partialScoring: boolean | null, choices: Array<{ __typename?: 'Choice', id: string, isCorrect: boolean | null, text: string }> } | { __typename?: 'ShortResponse', matchPhrases: Array<string> | null, matchSimilarity: number | null, caseSensitive: boolean | null } | null } | null }, category: { __typename?: 'QuestionBankCategory', id: string, subjectId: string | null, assessmentId: string | null, subjectGroupId: string | null, name: string, deleted: boolean, createdBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } } | null, fileOrigin: { __typename?: 'QuestionBankFileOrigin', id: string, filename: string | null, filepath: string | null } | null } };

export type FileOriginFragment = { __typename?: 'QuestionBankFileOrigin', id: string, filename: string | null, filepath: string | null };

export type QuestionBankFileOriginFragment = { __typename?: 'QuestionBankFileOrigin', id: string, filename: string | null, filepath: string | null };

export type QuestionBankFragment = { __typename?: 'QuestionBank', id: string, subjectId: string | null, assessmentId: string | null, subjectGroupId: string | null, difficulty: QuestionDifficulty | null, points: number | null, createdBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, response: { __typename?: 'BlanksResponse', matchSimilarity: number | null, caseSensitive: boolean | null, matchBlanks: Array<{ __typename?: 'Blank', id: string, phrases: Array<string> }> } | { __typename?: 'BooleanResponse', isTrue: boolean | null } | { __typename?: 'EditorResponse', wordLimit: number | null } | { __typename?: 'MultiResponse', partialScoring: boolean | null, choices: Array<{ __typename?: 'Choice', id: string, isCorrect: boolean | null, text: string }> } | { __typename?: 'ShortResponse', matchPhrases: Array<string> | null, matchSimilarity: number | null, caseSensitive: boolean | null } | null } | null }, category: { __typename?: 'QuestionBankCategory', id: string, subjectId: string | null, assessmentId: string | null, subjectGroupId: string | null, name: string, deleted: boolean, createdBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } } | null, fileOrigin: { __typename?: 'QuestionBankFileOrigin', id: string, filename: string | null, filepath: string | null } | null };

export type QuestionBankCategoryFragment = { __typename?: 'QuestionBankCategory', id: string, subjectId: string | null, assessmentId: string | null, subjectGroupId: string | null, name: string, deleted: boolean, createdBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } };

export type QuestionWithResponseFragment = { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, response: { __typename?: 'BlanksResponse', matchSimilarity: number | null, caseSensitive: boolean | null, matchBlanks: Array<{ __typename?: 'Blank', id: string, phrases: Array<string> }> } | { __typename?: 'BooleanResponse', isTrue: boolean | null } | { __typename?: 'EditorResponse', wordLimit: number | null } | { __typename?: 'MultiResponse', partialScoring: boolean | null, choices: Array<{ __typename?: 'Choice', id: string, isCorrect: boolean | null, text: string }> } | { __typename?: 'ShortResponse', matchPhrases: Array<string> | null, matchSimilarity: number | null, caseSensitive: boolean | null } | null } | null };

export type UpdateFileOriginMutationVariables = Exact<{
  input: UpdateQuestionBankFileOriginInput;
}>;


export type UpdateFileOriginMutation = { __typename?: 'RootMutationType', updateFileOrigin: { __typename?: 'QuestionBankFileOrigin', id: string, filename: string | null, filepath: string | null } };

export type UpdateQuestionBanksCategoryMutationVariables = Exact<{
  input: UpdateQuestionBanksCategoryInput;
}>;


export type UpdateQuestionBanksCategoryMutation = { __typename?: 'RootMutationType', updateQuestionBanksCategory: Array<{ __typename?: 'QuestionBank', id: string, subjectId: string | null, assessmentId: string | null, subjectGroupId: string | null, difficulty: QuestionDifficulty | null, points: number | null, createdBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, body: { __typename?: 'QuestionBody', id: string, feedback: string | null, promptDoc: string | null, response: { __typename?: 'BlanksResponse', matchSimilarity: number | null, caseSensitive: boolean | null, matchBlanks: Array<{ __typename?: 'Blank', id: string, phrases: Array<string> }> } | { __typename?: 'BooleanResponse', isTrue: boolean | null } | { __typename?: 'EditorResponse', wordLimit: number | null } | { __typename?: 'MultiResponse', partialScoring: boolean | null, choices: Array<{ __typename?: 'Choice', id: string, isCorrect: boolean | null, text: string }> } | { __typename?: 'ShortResponse', matchPhrases: Array<string> | null, matchSimilarity: number | null, caseSensitive: boolean | null } | null } | null }, category: { __typename?: 'QuestionBankCategory', id: string, subjectId: string | null, assessmentId: string | null, subjectGroupId: string | null, name: string, deleted: boolean, createdBy: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } } | null, fileOrigin: { __typename?: 'QuestionBankFileOrigin', id: string, filename: string | null, filepath: string | null } | null }> };

export type QuestionBlockFragment = { __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null };

export type QuestionBodyFragment = { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null };

export type QuestionFieldFragment = { __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } };

export type QuestionFragment = { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null };

export type TaskQuestionSelectionFragment = { __typename?: 'QuestionSelection', id: string, setsQuantity: number, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } }> }> | null, rules: Array<{ __typename?: 'QuestionSelectionRule', id: string, points: number, quantity: number, questionType: QuestionType, difficulty: QuestionDifficulty | null }> };

export type TaskQuestionSetFragment = { __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } }> };

export type TaskQuestionSetQuestionFragment = { __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } };

export type QuestionTreeQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  input: Array<QuestionSelectionFilterInput> | QuestionSelectionFilterInput;
}>;


export type QuestionTreeQuery = { __typename?: 'RootQueryType', assessment: { __typename?: 'Assessment', id: string, name: string }, questionTree: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }> };

export type ReleaseTaskMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  saveId: Scalars['ID']['input'];
  scheduleTimestamp: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ReleaseTaskMutation = { __typename?: 'RootMutationType', releaseTask: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableSubmissionPdf: boolean, enableExamLdb: boolean | null, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, allowLateResubmission: boolean, allowGenerativeAi: boolean | null, dueDate: string, returnDate: string, maxGrade: number, draftDueDate: string | null, wordLimit: number | null, timeLimit: number | null, weight: number | null, referencingStyle: string | null, countFootnotes: boolean, sViewReports: number, draftSViewReports: number, countReferences: boolean, anonymousMarking: boolean | null, gradingService: string, noExamFeedbackDate: boolean, enableExamAccessCode: boolean, markingToolPdf: MarkingToolPdf | null, disableExamBacktrack: boolean | null, disableSpellCheck: boolean, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } };

export type ReleasedRequirementsFragment = { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableSubmissionPdf: boolean, enableExamLdb: boolean | null, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, allowLateResubmission: boolean, allowGenerativeAi: boolean | null, dueDate: string, returnDate: string, maxGrade: number, draftDueDate: string | null, wordLimit: number | null, timeLimit: number | null, weight: number | null, referencingStyle: string | null, countFootnotes: boolean, sViewReports: number, draftSViewReports: number, countReferences: boolean, anonymousMarking: boolean | null, gradingService: string, noExamFeedbackDate: boolean, enableExamAccessCode: boolean, markingToolPdf: MarkingToolPdf | null, disableExamBacktrack: boolean | null, disableSpellCheck: boolean };

export type RequirementsFragment = { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean };

export type ResourceFragment = { __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean };

export type ResponseDeclarationFragment = { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> };

export type SaveQuestionStateMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
  input: SaveQuestionStateInput;
}>;


export type SaveQuestionStateMutation = { __typename?: 'RootMutationType', saveQuestionState: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } };

export type SaveStateFragment = { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string };

export type SetupAccessCodeMutationVariables = Exact<{
  input: AccessCodeInput;
  assessmentId: Scalars['ID']['input'];
}>;


export type SetupAccessCodeMutation = { __typename?: 'RootMutationType', setupAccessCode: { __typename?: 'AccessCode', code: string, label: string | null, active: boolean } };

export type SetupTaskMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  kind: TaskKind;
}>;


export type SetupTaskMutation = { __typename?: 'RootMutationType', setupTask: { __typename?: 'Task', id: string, kind: TaskKind, status: Status, saveState: { __typename?: 'SaveState', id: string, version: number, rawContent: string | null } } };

export type SheetReleasedSubscriptionVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type SheetReleasedSubscription = { __typename?: 'RootSubscriptionType', sheetReleased: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } };

export type SimpleChoiceFragment = { __typename?: 'SimpleChoice', identifier: string, content: string };

export type SubjectFragment = { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string };

export type SwapResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  swapId: Scalars['ID']['input'];
}>;


export type SwapResourceMutation = { __typename?: 'RootMutationType', swapResource: boolean };

export type TaskBlockBaseFragment = { __typename?: 'TaskBlock', id: string, nodeId: string, parentNodeId: string | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null };

export type TaskBlockFragment = { __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null };

export type TaskBlockReleasedFragment = { __typename?: 'TaskBlock', order: number | null, orderLabel: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null };

export type TaskFormatFragment = { __typename?: 'Task', id: string, format: TaskFormat | null };

export type TaskFragment = { __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, blocks: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> };

export type TaskQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  taskId: InputMaybe<Scalars['ID']['input']>;
}>;


export type TaskQuery = { __typename?: 'RootQueryType', token: string, me: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }, institution: { __typename?: 'Institution', id: string, tenant: string, timezone: string }, featureFlags: { __typename?: 'InstitutionFeatures', id: string, accessCode: boolean, exams: boolean, respondusLdb: boolean, moodleGrader: boolean, multiformat: boolean, turnitinGrader: boolean, cadmusGrader: boolean, groupAssessment: boolean, genAiDeclaration: boolean, questionLibrary: boolean, extensionSyncing: boolean, advancedMarking: boolean, workAttachment: boolean, timeline: boolean }, assessment: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null }, class: { __typename?: 'Class', id: string, students: Array<{ __typename?: 'Enrollment', id: string, deleted: boolean, user: { __typename?: 'User', id: string }, workSettings: { __typename?: 'WorkSettings', id: string, examDeferred: boolean | null } | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, markerId: string | null, code: string | null, questionId: string | null, maxLimit: number | null, minLimit: number | null, marker: { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null } | null, members: Array<{ __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null }> }> }, task: { __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, blocks: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, futureSheet: { __typename?: 'Sheet', id: string, serverId: string, format: TaskFormat, taskId: string, rawContent: string | null, releaseTimestamp: string, version: number, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableSubmissionPdf: boolean, enableExamLdb: boolean | null, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, allowLateResubmission: boolean, allowGenerativeAi: boolean | null, dueDate: string, returnDate: string, maxGrade: number, draftDueDate: string | null, wordLimit: number | null, timeLimit: number | null, weight: number | null, referencingStyle: string | null, countFootnotes: boolean, sViewReports: number, draftSViewReports: number, countReferences: boolean, anonymousMarking: boolean | null, gradingService: string, noExamFeedbackDate: boolean, enableExamAccessCode: boolean, markingToolPdf: MarkingToolPdf | null, disableExamBacktrack: boolean | null, disableSpellCheck: boolean, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null, userSettings: { __typename?: 'UserSettings', id: string, subjectRole: SubjectRole | null, showIaOnboarding: boolean | null } | null };

export type TaskStatusFragment = { __typename?: 'Task', id: string, status: Status };

export type UnlinkLibraryQuestionMutationVariables = Exact<{
  input: UnlinkLibraryQuestionInput;
}>;


export type UnlinkLibraryQuestionMutation = { __typename?: 'RootMutationType', unlinkLibraryQuestion: { __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null } };

export type UpdateAssessmentNameMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateAssessmentNameMutation = { __typename?: 'RootMutationType', updateAssessmentName: { __typename?: 'Assessment', id: string, name: string } };

export type UpdateAssessmentSettingsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  input: AssessmentSettingsInput;
}>;


export type UpdateAssessmentSettingsMutation = { __typename?: 'RootMutationType', updateAssessmentSettings: { __typename?: 'Assessment', id: string, name: string, subjectName: string, subjectId: string, dueDate: string | null, gradingDueDate: string | null, startDate: string | null, endDate: string | null, hasSubmission: boolean, hasSave: boolean, subject: { __typename?: 'Subject', id: string, name: string, discipline: Discipline | null }, ltiTool: { __typename?: 'InstitutionTool', id: string, name: string | null, familyCode: string | null }, ltiServices: Array<{ __typename?: 'LtiService', id: string, name: string, version: string, issuer: string | null, metaUrl: string | null }>, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null, ltiCustomParams: { __typename?: 'CustomParams', moodleAttemptReopenMethod: string | null } | null } };

export type UpdateRequirementsMutationVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  requirements: RequirementsInput;
}>;


export type UpdateRequirementsMutation = { __typename?: 'RootMutationType', updateRequirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean } };

export type UpdateResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
  notes: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateResourceMutation = { __typename?: 'RootMutationType', updateResource: { __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean } };

export type UpdateTaskBlockMutationVariables = Exact<{
  taskBlockId: Scalars['ID']['input'];
  input: UpdateTaskBlockInput;
}>;


export type UpdateTaskBlockMutation = { __typename?: 'RootMutationType', updateTaskBlock: { __typename?: 'TaskBlock', id: string, points: number | null, deleted: boolean, hidden: boolean, shuffle: boolean } };

export type UpdateTaskBlocksMutationVariables = Exact<{
  taskBlocksList: Array<UpdateTaskBlocksInput> | UpdateTaskBlocksInput;
}>;


export type UpdateTaskBlocksMutation = { __typename?: 'RootMutationType', updateTaskBlocks: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }> };

export type UpdateTaskFormatMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  format: TaskFormat;
}>;


export type UpdateTaskFormatMutation = { __typename?: 'RootMutationType', updateTaskFormat: { __typename?: 'Task', id: string, format: TaskFormat | null } };

export type CopyAssessmentMutationVariables = Exact<{
  destinationAssessmentId: Scalars['ID']['input'];
  sourceInstructionSheetId: Scalars['ID']['input'];
}>;


export type CopyAssessmentMutation = { __typename?: 'RootMutationType', copyAssessment: { __typename?: 'Task', id: string, status: Status, kind: TaskKind, format: TaskFormat | null, blocks: Array<{ __typename?: 'TaskBlock', previousNodeId: string | null, deleted: boolean, hidden: boolean, quantity: number | null, shuffle: boolean, order: number | null, orderLabel: string | null, updatedAt: string | null, libraryQuestionId: string | null, libraryQuestionVersionId: string | null, id: string, nodeId: string, parentNodeId: string | null, points: number | null, markerRubric: { __typename?: 'MarkerRubric', id: string, kind: MarkerRubricKind, format: MarkerRubricFormat, reversedScale: boolean, publishedAt: string | null, assessmentId: string, markingExists: boolean, location: { __typename?: 'MarkerRubricLocation', assessment: string, path: string }, criteria: Array<{ __typename?: 'Criterion', id: string | null, title: string | null, color: string | null, order: number, maxScore: number | null, description: string | null, skill: { __typename?: 'LearningOutcomeSkill', id: string, skill: string } | null, scaleItems: Array<{ __typename?: 'ScaleItem', id: string | null, order: number, scaleLabel: string | null, description: string | null, rangeFrom: number | null, rangeTo: number | null }> }> } | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null, questionSelection: { __typename?: 'QuestionSelection', id: string, sets: Array<{ __typename?: 'QuestionSet', id: string, label: string | null, order: number | null, questions: Array<{ __typename?: 'QuestionSetQuestion', id: string, points: number | null, shuffle: boolean, parentNodeId: string | null, previousNodeId: string | null, nodeId: string, questionVersionId: string | null, question: { __typename?: 'Question', updatedAt: string | null, id: string, cacheId: string, libraryId: string, questionType: QuestionType, shortPrompt: string | null, points: number | null, difficulty: QuestionDifficulty | null, createdAt: string, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, categoryId: string }>, assessmentUsages: Array<{ __typename?: 'QuestionAssessment', points: number | null, releaseTimestamp: string, assessment: { __typename?: 'Assessment', id: string, name: string } }>, sourceFile: { __typename?: 'QuestionSourceFile', id: number, filename: string | null, filepath: string | null } | null } }> }> | null } | null }>, requirements: { __typename?: 'Requirements', id: string, assessmentType: AssessmentType, enableExamAutoSubmission: boolean, enableExamLdb: boolean | null, enableSubmissionPdf: boolean, enableExamAccessCode: boolean, examEndDate: string | null, examFeedbackDate: string | null, examReadingTime: number | null, examStartDate: string | null, examTiming: ExamTiming, examType: Array<string>, examWritingTime: number | null, lateSubmissionTimeLimit: number | null, noExamReadingTime: boolean, noExamFeedbackDate: boolean, dueDate: string | null, returnDate: string | null, maxGrade: number, sViewReports: number, anonymousMarking: boolean | null, gradingService: string, allowLateResubmission: boolean, draftDueDate: string | null, noDraft: boolean, draftSViewReports: number, weight: number | null, noWeight: boolean, wordLimit: number | null, noLimit: boolean, timeLimit: number | null, noTimeLimit: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, disableSpellCheck: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, referencingStyle: string | null, noReferencing: boolean, disableExamBacktrack: boolean | null, hasChanged: boolean }, saveState: { __typename?: 'SaveState', id: string, serverId: string, version: number, rawContent: string | null, updatedAt: string }, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } };

export type PastAssessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PastAssessmentsQuery = { __typename?: 'RootQueryType', pastInstructionSheets: Array<{ __typename?: 'PastInstructionSheet', assessment: { __typename?: 'Assessment', name: string, id: string, subject: { __typename?: 'Subject', id: string, discipline: Discipline | null, name: string }, settings: { __typename?: 'AssessmentSettings', id: string, assessmentType: AssessmentType, releaseDate: string | null, openDate: string | null, dueDate: string | null, draftDueDate: string | null, draftEnabled: boolean, submissionPdfDisabled: boolean, lateSubmissionTimeLimit: number | null, lateResubmissionEnabled: boolean, markingTool: MarkingTool | null, feedbackDate: string | null, feedbackDateDisabled: boolean, maxGrade: number, anonymousMarking: boolean | null, doubleBlindMarkingEnabled: boolean, markingAclEnabled: boolean, restrictMarkingToolPdf: boolean, markingToolPdf: MarkingToolPdf | null, tiiSViewReports: number, tiiDraftSViewReports: number, timeLimit: number | null, timeLimitEnabled: boolean, examType: Array<string>, examTiming: ExamTiming, examStartDate: string | null, examEndDate: string | null, examReadingTime: number | null, examReadingTimeDisabled: boolean, examWritingTime: number | null, examAutoSubmissionDisabled: boolean, examBacktrackDisabled: boolean, examLdbEnabled: boolean, examAccessCodeEnabled: boolean, weight: number | null, weightEnabled: boolean, wordLimit: number | null, wordLimitEnabled: boolean, wordLimitGroup: number | null, referencingStyle: string | null, referencingStyleEnabled: boolean, countReferences: boolean, countFootnotes: boolean, allowGenerativeAi: boolean | null, spellCheckDisabled: boolean, groupAssessmentEnabled: boolean, groupSelfEnrollmentEnabled: boolean, groupSelfEnrollmentDeadline: string | null, groupFinalised: boolean, groupHideMembersName: boolean, sentimentCheckEnabled: boolean, sentimentCheckIntervalInHr: number | null, individualReportEnabled: boolean, individualReportWeight: number | null, individualReportMaxGrade: number | null, individualReportDueDate: string | null, peerEvaluationEnabled: boolean, peerEvaluationWeight: number | null, peerEvaluationMaxGrade: number | null, peerEvaluationDueDate: string | null, selfEvaluationEnabled: boolean, selfEvaluationWeight: number | null, selfEvaluationMaxGrade: number | null, groupCharterEnabled: boolean, groupCharterDueDate: string | null, groupReportWeight: number | null, groupReportMaxGrade: number | null, smartAutomarkingEnabled: boolean, individualWorkAttachmentEnabled: boolean, groupWorkAttachmentEnabled: boolean } | null }, sheet: { __typename?: 'Sheet', id: string, serverId: string, kind: TaskKind, format: TaskFormat } }> };

export type PastInstructionSheetQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
}>;


export type PastInstructionSheetQuery = { __typename?: 'RootQueryType', instructionSheet: { __typename?: 'Sheet', id: string, serverId: string, taskId: string, kind: TaskKind, format: TaskFormat, rawContent: string | null, releaseTimestamp: string, version: number, questionBlocks: Array<{ __typename?: 'QuestionBlock', nodeId: string, parentNodeId: string | null, nodeType: QuestionTreeNodeType, order: number, shortLabel: string | null, longLabel: string | null, shuffle: boolean | null, points: number | null, question: { __typename?: 'Question', id: string, cacheId: string, questionType: QuestionType, shortPrompt: string | null, updatedAt: string | null, body: { __typename?: 'QuestionBody', feedback: string | null, promptDoc: string | null, promptImage: { __typename?: 'PromptImage', url: string, width: number, height: number, layers: Array<{ __typename?: 'PromptImageLayer', identifier: string, shape: Shape, coords: Array<number> }> } | null, fields: Array<{ __typename?: 'QuestionField', identifier: string, response: { __typename?: 'ResponseDeclaration', partialScoring: boolean | null, matchSimilarity: number | null, errorMargin: number | null, correctValues: Array<string>, caseSensitive: boolean | null, cardinality: Cardinality | null, baseType: BaseType | null, correctRanges: Array<{ __typename?: 'NumericRange', identifier: string, start: number, end: number }>, correctAreas: Array<{ __typename?: 'PositionArea', identifier: string, shape: Shape, coords: Array<number> }> } | null, interaction: { __typename?: 'ChoiceInteraction', label: string | null, maxChoices: number, choices: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'ExtendedInteraction', wordLimit: number | null, attachmentEnabled: boolean | null } | { __typename?: 'MatchInteraction', targetSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }>, sourceSet: Array<{ __typename?: 'SimpleChoice', identifier: string, content: string }> } | { __typename?: 'PositionObjectInteraction', label: string | null, maxChoices: number } | { __typename?: 'TextEntryInteraction', expectedLength: number | null, baseType: BaseType | null, attachmentEnabled: boolean | null } }> | null } | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, name: string | null, url: string | null, invalidated: boolean, order: number | null, notes: string | null, fileSize: number | null, isFreshlyUploaded: boolean }> } | null };

export type UserFragment = { __typename?: 'User', id: string, name: string, givenName: string, familyName: string, email: string | null, tags: Array<string | null> | null, colourset: number | null };

export const BackgroundJobFragmentDoc = gql`
    fragment BackgroundJob on BackgroundJob {
  id
  kind
  state
}
    `;
export const CharterFormFragmentDoc = gql`
    fragment CharterForm on CharterForm {
  id
  published
  publishTimestamp
  editedAt
  sections {
    id
    deleted
    enabled
    rank
    milestonePresets {
      description
      dueDate
      title
    }
    promptDoc
    rank
    title
    type
    wordLimit
    wordLimitEnabled
  }
}
    `;
export const CharterFormMilestonePresetFragmentDoc = gql`
    fragment CharterFormMilestonePreset on MilestonePresetType {
  description
  dueDate
  title
}
    `;
export const CharterFormSectionFragmentDoc = gql`
    fragment CharterFormSection on CharterFormSection {
  id
  deleted
  enabled
  milestonePresets {
    ...CharterFormMilestonePreset
  }
  promptDoc
  rank
  title
  type
  wordLimit
  wordLimitEnabled
}
    ${CharterFormMilestonePresetFragmentDoc}`;
export const CharterMilestoneFragmentDoc = gql`
    fragment CharterMilestone on CharterMilestone {
  id
  title
  description
  dueDate
  deleted
}
    `;
export const CharterEditorFragmentDoc = gql`
    fragment CharterEditor on CharterEditor {
  id
  charterFormSectionId
  snapshotDoc
  snapshotVersion
  streamUuid
}
    `;
export const ThreadFragmentDoc = gql`
    fragment Thread on Thread {
  id
  title
  entityType
  entityId
  criterionId
  createdBy {
    id
  }
  insertedAt
  metadata {
    charterSectionType
    charterEditorId
    blockAttachmentId
    blockAttachmentName
  }
  comments {
    id
    content
    updatedAt
    createdBy {
      id
      name
      colourset
    }
  }
}
    `;
export const CharterFragmentDoc = gql`
    fragment Charter on Charter {
  id
  groupId
  milestones {
    ...CharterMilestone
  }
  editors {
    ...CharterEditor
  }
  feedbackThreads {
    ...Thread
  }
}
    ${CharterMilestoneFragmentDoc}
${CharterEditorFragmentDoc}
${ThreadFragmentDoc}`;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  code
  name
}
    `;
export const FeatureFlagsFragmentDoc = gql`
    fragment FeatureFlags on InstitutionFeatures {
  id
  accessCode
  exams
  respondusLdb
  moodleGrader
  multiformat
  turnitinGrader
  cadmusGrader
  groupAssessment
  genAiDeclaration
  questionLibrary
  extensionSyncing
  advancedMarking
  workAttachment
  timeline
}
    `;
export const BrightspaceGroupFragmentDoc = gql`
    fragment BrightspaceGroup on BrightspaceGroup {
  id
  name
  code
  students {
    id
  }
  totalStudents
}
    `;
export const CanvasSectionFragmentDoc = gql`
    fragment CanvasSection on CanvasSection {
  id
  courseId
  name
  sisCourseId
  students {
    id
    name
    sisUserId
  }
  totalStudents
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  givenName
  familyName
  email
  tags @client
  colourset
}
    `;
export const GroupFragmentDoc = gql`
    fragment Group on Group {
  id
  name
  markerId
  code
  marker {
    ...User
  }
  questionId
  members {
    ...User
  }
  maxLimit
  minLimit
}
    ${UserFragmentDoc}`;
export const ClassGroupsFragmentDoc = gql`
    fragment ClassGroups on Class {
  id
  groups {
    ...Group
  }
  groupType
}
    ${GroupFragmentDoc}`;
export const DeletedMemberFragmentDoc = gql`
    fragment DeletedMember on DeletedMember {
  id
  groupId
}
    `;
export const GroupEnrollmentFragmentDoc = gql`
    fragment GroupEnrollment on Enrollment {
  id
  deleted
  user {
    id
  }
  workSettings {
    id
    examDeferred
  }
}
    `;
export const LtiServiceFragmentDoc = gql`
    fragment LtiService on LtiService {
  id
  issuer
  name
  version
}
    `;
export const SubmissionFragmentDoc = gql`
    fragment Submission on Submission {
  id
  workId
  submittedAt
  forceSubmitted
  submittedBy {
    ...User
  }
  type
}
    ${UserFragmentDoc}`;
export const GradebookReceiptFragmentDoc = gql`
    fragment GradebookReceipt on GradebookReceipt {
  pdfArtifactId
  turnitinComplete
  lmsSnooze
  lmsComplete
  emailComplete
}
    `;
export const ResultFragmentDoc = gql`
    fragment Result on Result {
  id
  workId
  submissionType
  isReady
  heraResultId
  canvasResultUrl
  moodleGraderUrl
  grade {
    display
    value
    max
  }
  similarity {
    display
    value
    label
  }
  feedbackAccess {
    lastAccess
    accessCount
  }
  submission {
    ...Submission
  }
  receipt {
    ...GradebookReceipt
  }
}
    ${SubmissionFragmentDoc}
${GradebookReceiptFragmentDoc}`;
export const WorkFeaturesFragmentDoc = gql`
    fragment WorkFeatures on WorkFeatures {
  id
  enableWorkAuthority
}
    `;
export const BlockAttachmentFragmentDoc = gql`
    fragment BlockAttachment on BlockAttachment {
  id
  name
  mediaUrl
  fileSize
  fileExtension
}
    `;
export const AnswerBlockFragmentDoc = gql`
    fragment AnswerBlock on AnswerBlock {
  id
  nodeId
  blockName
  blockAttachments {
    ...BlockAttachment
  }
}
    ${BlockAttachmentFragmentDoc}`;
export const WorkFragmentDoc = gql`
    fragment Work on Work {
  id
  startDate
  updatedAt
  lastSaveTime
  finalResult: result(submissionType: FINAL) {
    ...Result
  }
  draftResult: result(submissionType: DRAFT) {
    ...Result
  }
  attemptCount
  features {
    ...WorkFeatures
  }
  answerBlocks {
    ...AnswerBlock
  }
}
    ${ResultFragmentDoc}
${WorkFeaturesFragmentDoc}
${AnswerBlockFragmentDoc}`;
export const WorkGroupFragmentDoc = gql`
    fragment WorkGroup on WorkGroup {
  id
  group {
    ...Group
  }
  work {
    ...Work
  }
}
    ${GroupFragmentDoc}
${WorkFragmentDoc}`;
export const HubAssessmentSettingsFragmentDoc = gql`
    fragment HubAssessmentSettings on AssessmentSettings {
  id
  releaseDate
  openDate
  dueDate
  feedbackDate
  individualReportEnabled
  peerEvaluationEnabled
  selfEvaluationEnabled
  groupCharterEnabled
  referencingStyleEnabled
  wordLimitEnabled
  sentimentCheckEnabled
  groupReportWeight
  individualReportWeight
  peerEvaluationWeight
  selfEvaluationWeight
  individualReportDueDate
  groupCharterDueDate
  peerEvaluationDueDate
  groupSelfEnrollmentEnabled
  groupSelfEnrollmentDeadline
  maxGrade
}
    `;
export const MessageFragmentDoc = gql`
    fragment Message on Message {
  id
  sourceUserId
  messageType
}
    `;
export const MailingListFragmentDoc = gql`
    fragment MailingList on MailingList {
  id
  subscribed
  members
}
    `;
export const InstitutionFragmentDoc = gql`
    fragment Institution on Institution {
  id
  tenant
  timezone
}
    `;
export const AssessmentOverviewFragmentDoc = gql`
    fragment AssessmentOverview on Assessment {
  id
  name
  subject {
    name
  }
}
    `;
export const WorkSettingsFragmentDoc = gql`
    fragment WorkSettings on WorkSettings {
  id
  studentId
  dueDate
  timeLimit
  examReadingTime
  examWritingTime
  examStartDate
  examEndDate
  examDeferred
  updatedAt
  lastUpdatedBy {
    id
    name
  }
  updateReason
  draftExamStartDate
  draftExamEndDate
}
    `;
export const AccessCodeFragmentDoc = gql`
    fragment AccessCode on AccessCode {
  code
  label
  active
}
    `;
export const VerifiedCodeFragmentDoc = gql`
    fragment VerifiedCode on VerifiedCode {
  label
  insertedAt
}
    `;
export const EnrollmentFragmentDoc = gql`
    fragment Enrollment on Enrollment {
  id
  syncedAt
  deleted
  deletedBy {
    id
    name
  }
  user {
    ...User
  }
  work {
    ...Work
  }
  tags {
    id
    text
    column
    tab
  }
  workSettings {
    ...WorkSettings
  }
  sisUserId
  accessCode {
    ...AccessCode
  }
  verifiedCodes {
    ...VerifiedCode
  }
  anonymousIndex
}
    ${UserFragmentDoc}
${WorkFragmentDoc}
${WorkSettingsFragmentDoc}
${AccessCodeFragmentDoc}
${VerifiedCodeFragmentDoc}`;
export const ClassListEnrollmentsFragmentDoc = gql`
    fragment ClassListEnrollments on ClassList {
  id
  enrollments {
    ...Enrollment
  }
}
    ${EnrollmentFragmentDoc}`;
export const EntityThreadEventFragmentDoc = gql`
    fragment EntityThreadEvent on EntityThreadEvent {
  eventType
  threadId
  status
  entityId
  entityType
  resolvedAt
  resolvedBy {
    ...User
  }
  criterionId
}
    ${UserFragmentDoc}`;
export const FeedbackReleaseRuleFragmentDoc = gql`
    fragment FeedbackReleaseRule on FeedbackReleaseRule {
  id
  basePool
  excludedStudentIds
  excludedTags
  executedAt
  includedStudentIds
  scheduledAt
  executedStudentIds
  ruleKind
  includedGroupIds
  releaseType
}
    `;
export const FeedbackVisibilityFragmentDoc = gql`
    fragment FeedbackVisibility on FeedbackVisibility {
  id
  feedbackViewLevel
  withFeedbackPdf
  notifyStudents
  showPeerScores
  showPeerComments
  jointRelease
  releaseType
}
    `;
export const FieldOutcomeScoreFragmentDoc = gql`
    fragment FieldOutcomeScore on FieldOutcome {
  id
  identifier
  fieldRubricId
  score
  markerScore
  automarkScore
}
    `;
export const FieldResponseFragmentDoc = gql`
    fragment FieldResponse on FieldResponse {
  answer
  answers
  count
  isCorrect
  similarity
}
    `;
export const FieldRubricResponseFragmentDoc = gql`
    fragment FieldRubricResponse on FieldRubric {
  id
  identifier
  responses {
    ...FieldResponse
  }
}
    ${FieldResponseFragmentDoc}`;
export const ResponseDeclarationFragmentDoc = gql`
    fragment ResponseDeclaration on ResponseDeclaration {
  partialScoring
  matchSimilarity
  errorMargin
  correctValues
  correctRanges {
    identifier
    start
    end
  }
  correctAreas {
    ... on PositionArea {
      identifier
      shape
      coords
    }
  }
  caseSensitive
  cardinality
  baseType
}
    `;
export const SimpleChoiceFragmentDoc = gql`
    fragment SimpleChoice on SimpleChoice {
  identifier
  content
}
    `;
export const QuestionFieldFragmentDoc = gql`
    fragment QuestionField on QuestionField {
  identifier
  response {
    ...ResponseDeclaration
  }
  interaction {
    ... on ChoiceInteraction {
      choices {
        ...SimpleChoice
      }
      label
      maxChoices
    }
    ... on MatchInteraction {
      targetSet {
        ...SimpleChoice
      }
      sourceSet {
        ...SimpleChoice
      }
    }
    ... on ExtendedInteraction {
      wordLimit
      attachmentEnabled
    }
    ... on TextEntryInteraction {
      expectedLength
      baseType
      attachmentEnabled
    }
    ... on PositionObjectInteraction {
      label
      maxChoices
    }
  }
}
    ${ResponseDeclarationFragmentDoc}
${SimpleChoiceFragmentDoc}`;
export const QuestionBodyFragmentDoc = gql`
    fragment QuestionBody on QuestionBody {
  feedback
  promptDoc
  promptImage {
    ... on PromptImage {
      url
      width
      height
      layers {
        ... on PromptImageLayer {
          identifier
          shape
          coords
        }
      }
    }
  }
  fields {
    ...QuestionField
  }
}
    ${QuestionFieldFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment Question on Question {
  id
  cacheId
  questionType
  shortPrompt
  body {
    ...QuestionBody
  }
  updatedAt
}
    ${QuestionBodyFragmentDoc}`;
export const QuestionBlockFragmentDoc = gql`
    fragment QuestionBlock on QuestionBlock {
  nodeId
  parentNodeId
  nodeType
  order
  shortLabel
  longLabel
  shuffle
  points
  question {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export const MarkingSheetFragmentDoc = gql`
    fragment MarkingSheet on Sheet {
  id
  serverId
  format
  releaseTimestamp
  questionBlocks {
    ...QuestionBlock
  }
}
    ${QuestionBlockFragmentDoc}`;
export const ModerationPenaltyRuleFragmentDoc = gql`
    fragment ModerationPenaltyRule on ModerationPenaltyRule {
  canStack
  excludedStudentIds
  includedTags
  id
  minutesLateBy
  penaltyScore
  scoreUnit
  penaltyType
  reason
  formatUnit
  ruleKind
  includedGroupIds
}
    `;
export const LearningOutcomeSkillFragmentDoc = gql`
    fragment LearningOutcomeSkill on LearningOutcomeSkill {
  id
  skill
}
    `;
export const ScaleItemFragmentDoc = gql`
    fragment ScaleItem on ScaleItem {
  id
  order
  scaleLabel
  description
  rangeFrom
  rangeTo
}
    `;
export const CriterionFragmentDoc = gql`
    fragment Criterion on Criterion {
  id
  title
  color
  order
  maxScore
  description
  skill {
    ...LearningOutcomeSkill
  }
  scaleItems {
    ...ScaleItem
  }
}
    ${LearningOutcomeSkillFragmentDoc}
${ScaleItemFragmentDoc}`;
export const PastMarkerRubricFragmentDoc = gql`
    fragment PastMarkerRubric on MarkerRubric {
  id
  kind
  format
  reversedScale
  publishedAt
  assessmentId
  location {
    assessment
    path
  }
  criteria {
    ...Criterion
  }
}
    ${CriterionFragmentDoc}`;
export const QuestionResponseCountsFragmentDoc = gql`
    fragment QuestionResponseCounts on QuestionResponseCounts {
  responseCount
  successCount
}
    `;
export const FieldRubricChangesFragmentDoc = gql`
    fragment FieldRubricChanges on FieldRubricChanges {
  id
  valuesAdded
  valuesRemoved
}
    `;
export const MarkerRubricFragmentDoc = gql`
    fragment MarkerRubric on MarkerRubric {
  id
  kind
  format
  reversedScale
  publishedAt
  assessmentId
  location {
    assessment
    path
  }
  markingExists
  criteria {
    ...Criterion
  }
}
    ${CriterionFragmentDoc}`;
export const FieldRubricFragmentDoc = gql`
    fragment FieldRubric on FieldRubric {
  id
  identifier
  baseType
  values
  automarked
  strategy
  correctRanges {
    identifier
    start
    end
  }
  correctAreas {
    ... on PositionArea {
      identifier
      shape
      coords
    }
  }
  similarity
  errorMargin
  caseSensitive
  partialScoring
  markerChanges {
    ...FieldRubricChanges
  }
  moderatorChanges {
    ...FieldRubricChanges
  }
  markerRubric {
    ...MarkerRubric
  }
}
    ${FieldRubricChangesFragmentDoc}
${MarkerRubricFragmentDoc}`;
export const QuestionRubricFragmentDoc = gql`
    fragment QuestionRubric on QuestionRubric {
  id
  questionId
  maxScore
  counts {
    ...QuestionResponseCounts
  }
  fieldRubrics {
    ...FieldRubric
  }
}
    ${QuestionResponseCountsFragmentDoc}
${FieldRubricFragmentDoc}`;
export const ReuseCriterionFragmentDoc = gql`
    fragment ReuseCriterion on ReuseCriterion {
  assessmentName
  color
  description
  kind
  maxScore
  publishedAt
  skill {
    ...LearningOutcomeSkill
  }
  scaleItems {
    ...ScaleItem
  }
}
    ${LearningOutcomeSkillFragmentDoc}
${ScaleItemFragmentDoc}`;
export const SaveFragmentDoc = gql`
    fragment Save on Save {
  id
  serverId
  version
  content
  dispatchedAt
}
    `;
export const SkillFragmentDoc = gql`
    fragment Skill on LearningOutcomeSkill {
  id
  skill
}
    `;
export const CriterionOutcomeFragmentDoc = gql`
    fragment CriterionOutcome on CriterionOutcome {
  id
  markerUserId
  markerScore
  markerRubricCriterionId
  markerRubricScaleItemId
  targetUserId
}
    `;
export const PeerOutcomeFragmentDoc = gql`
    fragment PeerOutcome on PeerOutcome {
  id
  targetUserId
  selfScore
  selfMaxScore
  peerScore
  peerMaxScore
  completedAt
  criterionOutcomes {
    ...CriterionOutcome
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const ScoreBreakdownFragmentDoc = gql`
    fragment ScoreBreakdown on ScoreBreakdown {
  score
  marker
  automark
  markerModifier
  moderatorModifier
}
    `;
export const QuestionOutcomeScoreFragmentDoc = gql`
    fragment QuestionOutcomeScore on QuestionOutcome {
  id
  questionId
  scoreBreakdown {
    ...ScoreBreakdown
  }
}
    ${ScoreBreakdownFragmentDoc}`;
export const WorkOutcomeReleaseFragmentDoc = gql`
    fragment WorkOutcomeRelease on WorkOutcomeRelease {
  id
  releaseType
  releasedAt
  finalScore
  penaltyScore
  moderatorModifier
}
    `;
export const WorkOutcomeClassFragmentDoc = gql`
    fragment WorkOutcomeClass on WorkOutcome {
  id
  workId
  studentId
  groupId
  finalScore
  maxScore
  scoreBreakdown {
    ...ScoreBreakdown
  }
  automarkPending
  feedbackReleasedTimestamp
  finalScore
  finalScorePenalty
  questionOutcomes {
    ...QuestionOutcomeScore
  }
  provisionalRelease {
    ...WorkOutcomeRelease
  }
  finalRelease {
    ...WorkOutcomeRelease
  }
}
    ${ScoreBreakdownFragmentDoc}
${QuestionOutcomeScoreFragmentDoc}
${WorkOutcomeReleaseFragmentDoc}`;
export const ComponentScoreFragmentDoc = gql`
    fragment ComponentScore on ComponentScore {
  score
  maxScore
  moderatorModifier
  penaltyScore
  weight
  weightedScore
  weightedMaxScore
  weightedModeratorModifier
  weightedPenaltyScore
}
    `;
export const ComponentBreakdownFragmentDoc = gql`
    fragment ComponentBreakdown on ComponentBreakdown {
  total {
    ...ComponentScore
  }
  group {
    ...ComponentScore
  }
  individual {
    ...ComponentScore
  }
  self {
    ...ComponentScore
  }
  peer {
    ...ComponentScore
  }
}
    ${ComponentScoreFragmentDoc}`;
export const StudentOutcomeFragmentDoc = gql`
    fragment StudentOutcome on StudentOutcome {
  id
  studentId
  individualPenalty
  groupPenalty
  finalScore
  peerOutcome {
    ...PeerOutcome
  }
  groupWorkOutcome {
    ...WorkOutcomeClass
  }
  individualWorkOutcome {
    ...WorkOutcomeClass
  }
  moderatorModifier
  base {
    ...ComponentBreakdown
  }
  provisional {
    ...ComponentBreakdown
  }
  final {
    ...ComponentBreakdown
  }
}
    ${PeerOutcomeFragmentDoc}
${WorkOutcomeClassFragmentDoc}
${ComponentBreakdownFragmentDoc}`;
export const FieldOutcomeFragmentDoc = gql`
    fragment FieldOutcome on FieldOutcome {
  id
  identifier
  fieldRubricId
  score
  automarkScore
  automarkStatus
  answer
  answers
  answerSimilarity
  comments {
    id
  }
  docContent
  docVersion
  rubricOutcome {
    criterionOutcomes {
      ...CriterionOutcome
    }
    score
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const QuestionOutcomeFragmentDoc = gql`
    fragment QuestionOutcome on QuestionOutcome {
  ...QuestionOutcomeScore
  blockSnapshot {
    id
    content
    blockName
  }
  fieldOutcomes {
    ...FieldOutcome
  }
}
    ${QuestionOutcomeScoreFragmentDoc}
${FieldOutcomeFragmentDoc}`;
export const SubmissionOutcomeFragmentDoc = gql`
    fragment SubmissionOutcome on SubmissionOutcome {
  id
  submissionId
  bodyBlockSnapshotId
  bodyDocVersion
  bodyDoc
  referencesBlockSnapshotId
  referencesDocVersion
  referencesDoc
  rubricOutcome {
    criterionOutcomes {
      ...CriterionOutcome
    }
    score
  }
}
    ${CriterionOutcomeFragmentDoc}`;
export const WorkOutcomeFragmentDoc = gql`
    fragment WorkOutcome on WorkOutcome {
  id
  workId
  groupId
  studentId
  maxScore
  automarkPending
  feedbackReleased
  feedbackReleasedTimestamp
  finalScore
  scoreBreakdown {
    ...ScoreBreakdown
  }
  questionOutcomes {
    ...QuestionOutcome
  }
  latestSubmissionOutcome {
    ...SubmissionOutcome
  }
  workOutcomeRelease {
    ...WorkOutcomeRelease
  }
  answerBlocks {
    ...AnswerBlock
  }
}
    ${ScoreBreakdownFragmentDoc}
${QuestionOutcomeFragmentDoc}
${SubmissionOutcomeFragmentDoc}
${WorkOutcomeReleaseFragmentDoc}
${AnswerBlockFragmentDoc}`;
export const WorkOutcomeScoreFragmentDoc = gql`
    fragment WorkOutcomeScore on WorkOutcome {
  id
  workId
  studentId
  groupId
  maxScore
  automarkPending
  scoreBreakdown {
    ...ScoreBreakdown
  }
}
    ${ScoreBreakdownFragmentDoc}`;
export const QuestionOutcomeSubscriptionFragmentDoc = gql`
    fragment QuestionOutcomeSubscription on QuestionOutcome {
  id
  questionId
  scoreBreakdown {
    ...ScoreBreakdown
  }
  fieldOutcomes {
    ...FieldOutcome
  }
}
    ${ScoreBreakdownFragmentDoc}
${FieldOutcomeFragmentDoc}`;
export const WorkOutcomeUpdatedFragmentDoc = gql`
    fragment WorkOutcomeUpdated on WorkOutcome {
  id
  workId
  groupId
  studentId
  maxScore
  finalScore
  finalScorePenalty
  scoreBreakdown {
    ...ScoreBreakdown
  }
  latestSubmissionOutcome {
    ...SubmissionOutcome
  }
  questionOutcomes {
    ...QuestionOutcomeSubscription
  }
  provisionalRelease {
    ...WorkOutcomeRelease
  }
  finalRelease {
    ...WorkOutcomeRelease
  }
}
    ${ScoreBreakdownFragmentDoc}
${SubmissionOutcomeFragmentDoc}
${QuestionOutcomeSubscriptionFragmentDoc}
${WorkOutcomeReleaseFragmentDoc}`;
export const SubjectFragmentDoc = gql`
    fragment Subject on Subject {
  id
  discipline
  name
}
    `;
export const UserSettingsFragmentDoc = gql`
    fragment UserSettings on UserSettings {
  id
  subjectRole
  showIaOnboarding
}
    `;
export const OnboardingPayloadFragmentDoc = gql`
    fragment OnboardingPayload on OnboardingPayload {
  subject {
    ...Subject
  }
  userSettings {
    ...UserSettings
  }
}
    ${SubjectFragmentDoc}
${UserSettingsFragmentDoc}`;
export const EnrollmentTagsFragmentDoc = gql`
    fragment EnrollmentTags on Enrollment {
  id
  tags {
    text
    column
    tab
  }
}
    `;
export const ProjectIssueFragmentDoc = gql`
    fragment ProjectIssue on ProjectIssue {
  id
  type
  status
  dueDate
  parentId
  assignees
  groupId
}
    `;
export const WorkArtifactFragmentDoc = gql`
    fragment WorkArtifact on WorkArtifact {
  id
  name
  taskHistoryId
  submissionId
  workId
  studentSentAt
  agsSentAt
}
    `;
export const QuestionVersionSummaryFragmentDoc = gql`
    fragment QuestionVersionSummary on QuestionVersion {
  id
  user {
    id
    name
  }
  insertedAt
  version
}
    `;
export const ChildQuestionFragmentDoc = gql`
    fragment ChildQuestion on Question {
  id
  parentQuestionId
  libraryId
  cacheId
  questionType
  shortPrompt
  points
  order
  shuffle
  body {
    ...QuestionBody
  }
  difficulty
  currentVersionId
  versions {
    ...QuestionVersionSummary
  }
}
    ${QuestionBodyFragmentDoc}
${QuestionVersionSummaryFragmentDoc}`;
export const QuestionTagFragmentDoc = gql`
    fragment QuestionTag on QuestionTag {
  id
  name
  categoryId
}
    `;
export const QuestionAssessmentFragmentDoc = gql`
    fragment QuestionAssessment on QuestionAssessment {
  assessment {
    id
    name
  }
  points
  releaseTimestamp
}
    `;
export const QuestionSourceFileFragmentDoc = gql`
    fragment QuestionSourceFile on QuestionSourceFile {
  id
  filename
  filepath
}
    `;
export const LibraryQuestionFragmentDoc = gql`
    fragment LibraryQuestion on Question {
  id
  cacheId
  libraryId
  parentQuestionId
  currentVersionId
  questionType
  shortPrompt
  points
  shuffle
  body {
    ...QuestionBody
  }
  difficulty
  order
  updatedAt
  childrenQuestions {
    ...ChildQuestion
  }
  versions {
    ...QuestionVersionSummary
  }
  lastUpdatedBy {
    id
    name
  }
  tags {
    ...QuestionTag
  }
  assessmentUsages {
    ...QuestionAssessment
  }
  sourceFile {
    ...QuestionSourceFile
  }
}
    ${QuestionBodyFragmentDoc}
${ChildQuestionFragmentDoc}
${QuestionVersionSummaryFragmentDoc}
${QuestionTagFragmentDoc}
${QuestionAssessmentFragmentDoc}
${QuestionSourceFileFragmentDoc}`;
export const LibraryQuestionOverviewFragmentDoc = gql`
    fragment LibraryQuestionOverview on Question {
  id
  cacheId
  libraryId
  questionType
  shortPrompt
  points
  difficulty
  tags {
    ...QuestionTag
  }
  assessmentUsages {
    ...QuestionAssessment
  }
  sourceFile {
    ...QuestionSourceFile
  }
  createdAt
}
    ${QuestionTagFragmentDoc}
${QuestionAssessmentFragmentDoc}
${QuestionSourceFileFragmentDoc}`;
export const QuestionSetQuestionFragmentDoc = gql`
    fragment QuestionSetQuestion on QuestionSetQuestion {
  id
  points
  shuffle
  parentNodeId
  previousNodeId
  nodeId
  questionVersionId
  question {
    ...LibraryQuestionOverview
    updatedAt
    body {
      ...QuestionBody
    }
  }
}
    ${LibraryQuestionOverviewFragmentDoc}
${QuestionBodyFragmentDoc}`;
export const QuestionSetFragmentDoc = gql`
    fragment QuestionSet on QuestionSet {
  id
  label
  order
  questions {
    ...QuestionSetQuestion
  }
}
    ${QuestionSetQuestionFragmentDoc}`;
export const QuestionSelectionRuleFragmentDoc = gql`
    fragment QuestionSelectionRule on QuestionSelectionRule {
  id
  points
  quantity
  questionType
  difficulty
}
    `;
export const QuestionSelectionFragmentDoc = gql`
    fragment QuestionSelection on QuestionSelection {
  id
  setsQuantity
  sets {
    ...QuestionSet
  }
  rules {
    ...QuestionSelectionRule
  }
}
    ${QuestionSetFragmentDoc}
${QuestionSelectionRuleFragmentDoc}`;
export const QuestionTagCategoryFragmentDoc = gql`
    fragment QuestionTagCategory on QuestionTagCategory {
  id
  name
}
    `;
export const ChildQuestionVersionFragmentDoc = gql`
    fragment ChildQuestionVersion on QuestionVersion {
  id
  body {
    ...QuestionBody
  }
  insertedAt
  parentQuestionId
  questionId
  questionType
  shortPrompt
  version
  order
  user {
    id
    name
  }
}
    ${QuestionBodyFragmentDoc}`;
export const QuestionVersionFragmentDoc = gql`
    fragment QuestionVersion on QuestionVersion {
  id
  insertedAt
  parentQuestionId
  questionId
  questionType
  shortPrompt
  user {
    id
    name
  }
  body {
    ...QuestionBody
  }
  childrenQuestions {
    ...ChildQuestionVersion
  }
}
    ${QuestionBodyFragmentDoc}
${ChildQuestionVersionFragmentDoc}`;
export const SentimentCheckFragmentDoc = gql`
    fragment SentimentCheck on SentimentCheck {
  id
  skipped
  level
  order
  user {
    ...User
  }
  comment
  insertedAt
}
    ${UserFragmentDoc}`;
export const AssessmentSettingsFragmentDoc = gql`
    fragment AssessmentSettings on AssessmentSettings {
  id
  assessmentType
  releaseDate
  openDate
  dueDate
  draftDueDate
  draftEnabled
  submissionPdfDisabled
  lateSubmissionTimeLimit
  lateResubmissionEnabled
  markingTool
  feedbackDate
  feedbackDateDisabled
  maxGrade
  anonymousMarking
  doubleBlindMarkingEnabled
  markingAclEnabled
  restrictMarkingToolPdf
  markingToolPdf
  tiiSViewReports
  tiiDraftSViewReports
  timeLimit
  timeLimitEnabled
  examType
  examTiming
  examStartDate
  examEndDate
  examReadingTime
  examReadingTimeDisabled
  examWritingTime
  examAutoSubmissionDisabled
  examBacktrackDisabled
  examLdbEnabled
  examAccessCodeEnabled
  weight
  weightEnabled
  wordLimit
  wordLimitEnabled
  wordLimitGroup
  referencingStyle
  referencingStyleEnabled
  countReferences
  countFootnotes
  allowGenerativeAi
  spellCheckDisabled
  groupAssessmentEnabled
  groupSelfEnrollmentEnabled
  groupSelfEnrollmentDeadline
  groupFinalised
  groupHideMembersName
  sentimentCheckEnabled
  sentimentCheckIntervalInHr
  individualReportEnabled
  individualReportWeight
  individualReportMaxGrade
  individualReportDueDate
  peerEvaluationEnabled
  peerEvaluationWeight
  peerEvaluationMaxGrade
  peerEvaluationDueDate
  selfEvaluationEnabled
  selfEvaluationWeight
  selfEvaluationMaxGrade
  groupCharterEnabled
  groupCharterDueDate
  groupReportWeight
  groupReportMaxGrade
  smartAutomarkingEnabled
  individualWorkAttachmentEnabled
  groupWorkAttachmentEnabled
}
    `;
export const AssessmentFragmentDoc = gql`
    fragment Assessment on Assessment {
  id
  name
  subjectName
  subjectId
  dueDate
  gradingDueDate
  startDate
  endDate
  subject {
    id
    name
    discipline
  }
  hasSubmission
  hasSave
  ltiTool {
    id
    name
    familyCode
  }
  ltiServices {
    id
    name
    version
    issuer
    metaUrl
  }
  settings {
    ...AssessmentSettings
  }
  ltiCustomParams {
    moodleAttemptReopenMethod
  }
}
    ${AssessmentSettingsFragmentDoc}`;
export const HubTaskFragmentDoc = gql`
    fragment HubTask on Task {
  id
  kind
  status
  saveState {
    id
    version
    rawContent
  }
}
    `;
export const ResourceFragmentDoc = gql`
    fragment Resource on Resource {
  id
  name
  url
  invalidated
  order
  notes
  fileSize
  isFreshlyUploaded @client
}
    `;
export const InstructionSheetFragmentDoc = gql`
    fragment InstructionSheet on Sheet {
  id
  serverId
  taskId
  kind
  format
  rawContent
  releaseTimestamp
  version
  questionBlocks {
    ...QuestionBlock
  }
  resources {
    ...Resource
  }
}
    ${QuestionBlockFragmentDoc}
${ResourceFragmentDoc}`;
export const ReleasedRequirementsFragmentDoc = gql`
    fragment ReleasedRequirements on Sheet {
  id
  serverId
  format
  assessmentType
  enableExamAutoSubmission
  enableSubmissionPdf
  enableExamLdb
  examEndDate
  examFeedbackDate
  examReadingTime
  examStartDate
  examTiming
  examType
  examWritingTime
  lateSubmissionTimeLimit
  allowLateResubmission
  allowGenerativeAi
  dueDate
  returnDate
  maxGrade
  draftDueDate
  wordLimit
  timeLimit
  weight
  referencingStyle
  countFootnotes
  sViewReports
  draftSViewReports
  countReferences
  anonymousMarking
  gradingService
  noExamFeedbackDate
  enableExamAccessCode
  markingToolPdf
  disableExamBacktrack
  disableSpellCheck
}
    `;
export const InstructionSheetWithRequirementsFragmentDoc = gql`
    fragment InstructionSheetWithRequirements on Sheet {
  id
  serverId
  format
  taskId
  rawContent
  releaseTimestamp
  version
  questionBlocks {
    ...QuestionBlock
  }
  resources {
    ...Resource
  }
  ...ReleasedRequirements
}
    ${QuestionBlockFragmentDoc}
${ResourceFragmentDoc}
${ReleasedRequirementsFragmentDoc}`;
export const FileOriginFragmentDoc = gql`
    fragment fileOrigin on QuestionBankFileOrigin {
  id
  filename
  filepath
}
    `;
export const QuestionWithResponseFragmentDoc = gql`
    fragment QuestionWithResponse on Question {
  id
  cacheId
  questionType
  shortPrompt
  body {
    id
    feedback
    promptDoc
    response {
      ... on BooleanResponse {
        isTrue
      }
      ... on EditorResponse {
        wordLimit
      }
      ... on MultiResponse {
        choices {
          id
          isCorrect
          text
        }
        partialScoring
      }
      ... on ShortResponse {
        matchPhrases
        matchSimilarity
        caseSensitive
      }
      ... on BlanksResponse {
        matchBlanks {
          id
          phrases
        }
        matchSimilarity
        caseSensitive
      }
    }
  }
}
    `;
export const QuestionBankCategoryFragmentDoc = gql`
    fragment QuestionBankCategory on QuestionBankCategory {
  id
  subjectId
  assessmentId
  subjectGroupId
  name
  deleted
  createdBy {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const QuestionBankFileOriginFragmentDoc = gql`
    fragment QuestionBankFileOrigin on QuestionBankFileOrigin {
  id
  filename
  filepath
}
    `;
export const QuestionBankFragmentDoc = gql`
    fragment QuestionBank on QuestionBank {
  id
  subjectId
  assessmentId
  subjectGroupId
  createdBy {
    ...User
  }
  difficulty
  points
  question {
    ...QuestionWithResponse
  }
  category {
    ...QuestionBankCategory
  }
  fileOrigin {
    ...QuestionBankFileOrigin
  }
}
    ${UserFragmentDoc}
${QuestionWithResponseFragmentDoc}
${QuestionBankCategoryFragmentDoc}
${QuestionBankFileOriginFragmentDoc}`;
export const TaskQuestionSetQuestionFragmentDoc = gql`
    fragment TaskQuestionSetQuestion on QuestionSetQuestion {
  id
  points
  shuffle
  parentNodeId
  previousNodeId
  nodeId
  question {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export const TaskQuestionSetFragmentDoc = gql`
    fragment TaskQuestionSet on QuestionSet {
  id
  label
  order
  questions {
    ...TaskQuestionSetQuestion
  }
}
    ${TaskQuestionSetQuestionFragmentDoc}`;
export const TaskQuestionSelectionFragmentDoc = gql`
    fragment TaskQuestionSelection on QuestionSelection {
  id
  setsQuantity
  sets {
    ...TaskQuestionSet
  }
  rules {
    ...QuestionSelectionRule
  }
}
    ${TaskQuestionSetFragmentDoc}
${QuestionSelectionRuleFragmentDoc}`;
export const TaskBlockBaseFragmentDoc = gql`
    fragment TaskBlockBase on TaskBlock {
  id
  nodeId
  parentNodeId
  points
  question {
    ...Question
  }
  questionSelection {
    id
    sets {
      ...QuestionSet
    }
  }
}
    ${QuestionFragmentDoc}
${QuestionSetFragmentDoc}`;
export const TaskBlockReleasedFragmentDoc = gql`
    fragment TaskBlockReleased on TaskBlock {
  order
  orderLabel
  ...TaskBlockBase
}
    ${TaskBlockBaseFragmentDoc}`;
export const TaskFormatFragmentDoc = gql`
    fragment TaskFormat on Task {
  id
  format
}
    `;
export const TaskBlockFragmentDoc = gql`
    fragment TaskBlock on TaskBlock {
  previousNodeId
  deleted
  hidden
  quantity
  shuffle
  order
  orderLabel
  updatedAt
  libraryQuestionId
  libraryQuestionVersionId
  markerRubric {
    ...MarkerRubric
  }
  ...TaskBlockBase
}
    ${MarkerRubricFragmentDoc}
${TaskBlockBaseFragmentDoc}`;
export const RequirementsFragmentDoc = gql`
    fragment Requirements on Requirements {
  id
  assessmentType
  enableExamAutoSubmission
  enableExamLdb
  enableSubmissionPdf
  enableExamAccessCode
  examEndDate
  examFeedbackDate
  examReadingTime
  examStartDate
  examTiming
  examType
  examWritingTime
  lateSubmissionTimeLimit
  noExamReadingTime
  noExamFeedbackDate
  dueDate
  returnDate
  maxGrade
  sViewReports
  anonymousMarking
  gradingService
  allowLateResubmission
  draftDueDate
  noDraft
  draftSViewReports
  weight
  noWeight
  wordLimit
  noLimit
  timeLimit
  noTimeLimit
  countReferences
  countFootnotes
  allowGenerativeAi
  disableSpellCheck
  restrictMarkingToolPdf
  markingToolPdf
  referencingStyle
  noReferencing
  disableExamBacktrack
  hasChanged
}
    `;
export const SaveStateFragmentDoc = gql`
    fragment SaveState on SaveState {
  id
  serverId
  version
  rawContent
  updatedAt
}
    `;
export const TaskFragmentDoc = gql`
    fragment Task on Task {
  id
  status
  kind
  format
  blocks {
    ...TaskBlock
  }
  requirements {
    ...Requirements
  }
  saveState {
    ...SaveState
  }
  resources {
    ...Resource
  }
}
    ${TaskBlockFragmentDoc}
${RequirementsFragmentDoc}
${SaveStateFragmentDoc}
${ResourceFragmentDoc}`;
export const TaskStatusFragmentDoc = gql`
    fragment TaskStatus on Task {
  id
  status
}
    `;
export const ApiTokenDocument = gql`
    query ApiToken($assessmentId: ID!, $workId: ID) {
  apiToken(assessmentId: $assessmentId, workId: $workId)
}
    `;

/**
 * __useApiTokenQuery__
 *
 * To run a query within a React component, call `useApiTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokenQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useApiTokenQuery(baseOptions: Apollo.QueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables> & ({ variables: ApiTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
      }
export function useApiTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export function useApiTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiTokenQuery, ApiTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiTokenQuery, ApiTokenQueryVariables>(ApiTokenDocument, options);
        }
export type ApiTokenQueryHookResult = ReturnType<typeof useApiTokenQuery>;
export type ApiTokenLazyQueryHookResult = ReturnType<typeof useApiTokenLazyQuery>;
export type ApiTokenSuspenseQueryHookResult = ReturnType<typeof useApiTokenSuspenseQuery>;
export type ApiTokenQueryResult = Apollo.QueryResult<ApiTokenQuery, ApiTokenQueryVariables>;
export const BackgroundJobDocument = gql`
    query BackgroundJob($jobId: ID!) {
  backgroundJob(jobId: $jobId) {
    ...BackgroundJob
  }
}
    ${BackgroundJobFragmentDoc}`;

/**
 * __useBackgroundJobQuery__
 *
 * To run a query within a React component, call `useBackgroundJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useBackgroundJobQuery(baseOptions: Apollo.QueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables> & ({ variables: BackgroundJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BackgroundJobQuery, BackgroundJobQueryVariables>(BackgroundJobDocument, options);
      }
export function useBackgroundJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BackgroundJobQuery, BackgroundJobQueryVariables>(BackgroundJobDocument, options);
        }
export function useBackgroundJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BackgroundJobQuery, BackgroundJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BackgroundJobQuery, BackgroundJobQueryVariables>(BackgroundJobDocument, options);
        }
export type BackgroundJobQueryHookResult = ReturnType<typeof useBackgroundJobQuery>;
export type BackgroundJobLazyQueryHookResult = ReturnType<typeof useBackgroundJobLazyQuery>;
export type BackgroundJobSuspenseQueryHookResult = ReturnType<typeof useBackgroundJobSuspenseQuery>;
export type BackgroundJobQueryResult = Apollo.QueryResult<BackgroundJobQuery, BackgroundJobQueryVariables>;
export const BrightspaceAuthorizationDocument = gql`
    query BrightspaceAuthorization($assessmentId: ID!, $redirectTo: String!, $brightspaceScopeFor: BrightspaceScopeKeyType) {
  brightspaceApi(
    assessmentId: $assessmentId
    brightspaceScopeFor: $brightspaceScopeFor
  ) {
    authorizeUrl(redirectTo: $redirectTo, brightspaceScopeFor: $brightspaceScopeFor)
    authorized
  }
}
    `;

/**
 * __useBrightspaceAuthorizationQuery__
 *
 * To run a query within a React component, call `useBrightspaceAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrightspaceAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrightspaceAuthorizationQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      redirectTo: // value for 'redirectTo'
 *      brightspaceScopeFor: // value for 'brightspaceScopeFor'
 *   },
 * });
 */
export function useBrightspaceAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables> & ({ variables: BrightspaceAuthorizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>(BrightspaceAuthorizationDocument, options);
      }
export function useBrightspaceAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>(BrightspaceAuthorizationDocument, options);
        }
export function useBrightspaceAuthorizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>(BrightspaceAuthorizationDocument, options);
        }
export type BrightspaceAuthorizationQueryHookResult = ReturnType<typeof useBrightspaceAuthorizationQuery>;
export type BrightspaceAuthorizationLazyQueryHookResult = ReturnType<typeof useBrightspaceAuthorizationLazyQuery>;
export type BrightspaceAuthorizationSuspenseQueryHookResult = ReturnType<typeof useBrightspaceAuthorizationSuspenseQuery>;
export type BrightspaceAuthorizationQueryResult = Apollo.QueryResult<BrightspaceAuthorizationQuery, BrightspaceAuthorizationQueryVariables>;
export const CanvasAuthorizationDocument = gql`
    query CanvasAuthorization($assessmentId: ID!, $redirectTo: String!, $canvasScopeFor: CanvasScopeKeyType) {
  canvasApi(assessmentId: $assessmentId, canvasScopeFor: $canvasScopeFor) {
    authorizeUrl(redirectTo: $redirectTo, canvasScopeFor: $canvasScopeFor)
    authorized
  }
}
    `;

/**
 * __useCanvasAuthorizationQuery__
 *
 * To run a query within a React component, call `useCanvasAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvasAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvasAuthorizationQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      redirectTo: // value for 'redirectTo'
 *      canvasScopeFor: // value for 'canvasScopeFor'
 *   },
 * });
 */
export function useCanvasAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables> & ({ variables: CanvasAuthorizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>(CanvasAuthorizationDocument, options);
      }
export function useCanvasAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>(CanvasAuthorizationDocument, options);
        }
export function useCanvasAuthorizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>(CanvasAuthorizationDocument, options);
        }
export type CanvasAuthorizationQueryHookResult = ReturnType<typeof useCanvasAuthorizationQuery>;
export type CanvasAuthorizationLazyQueryHookResult = ReturnType<typeof useCanvasAuthorizationLazyQuery>;
export type CanvasAuthorizationSuspenseQueryHookResult = ReturnType<typeof useCanvasAuthorizationSuspenseQuery>;
export type CanvasAuthorizationQueryResult = Apollo.QueryResult<CanvasAuthorizationQuery, CanvasAuthorizationQueryVariables>;
export const AssessmentChartersDocument = gql`
    query AssessmentCharters($assessmentId: ID!) {
  assessmentCharters(assessmentId: $assessmentId) {
    id
    groupId
  }
}
    `;

/**
 * __useAssessmentChartersQuery__
 *
 * To run a query within a React component, call `useAssessmentChartersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentChartersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentChartersQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentChartersQuery(baseOptions: Apollo.QueryHookOptions<AssessmentChartersQuery, AssessmentChartersQueryVariables> & ({ variables: AssessmentChartersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentChartersQuery, AssessmentChartersQueryVariables>(AssessmentChartersDocument, options);
      }
export function useAssessmentChartersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentChartersQuery, AssessmentChartersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentChartersQuery, AssessmentChartersQueryVariables>(AssessmentChartersDocument, options);
        }
export function useAssessmentChartersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentChartersQuery, AssessmentChartersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentChartersQuery, AssessmentChartersQueryVariables>(AssessmentChartersDocument, options);
        }
export type AssessmentChartersQueryHookResult = ReturnType<typeof useAssessmentChartersQuery>;
export type AssessmentChartersLazyQueryHookResult = ReturnType<typeof useAssessmentChartersLazyQuery>;
export type AssessmentChartersSuspenseQueryHookResult = ReturnType<typeof useAssessmentChartersSuspenseQuery>;
export type AssessmentChartersQueryResult = Apollo.QueryResult<AssessmentChartersQuery, AssessmentChartersQueryVariables>;
export const CharterFormDocument = gql`
    query CharterForm($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      id
      peerEvaluationEnabled
    }
  }
  draftForm: charterForm(assessmentId: $assessmentId, published: false) {
    ...CharterForm
  }
  publishedForm: charterForm(assessmentId: $assessmentId, published: true) {
    ...CharterForm
  }
}
    ${CharterFormFragmentDoc}`;

/**
 * __useCharterFormQuery__
 *
 * To run a query within a React component, call `useCharterFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharterFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharterFormQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCharterFormQuery(baseOptions: Apollo.QueryHookOptions<CharterFormQuery, CharterFormQueryVariables> & ({ variables: CharterFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharterFormQuery, CharterFormQueryVariables>(CharterFormDocument, options);
      }
export function useCharterFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharterFormQuery, CharterFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharterFormQuery, CharterFormQueryVariables>(CharterFormDocument, options);
        }
export function useCharterFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CharterFormQuery, CharterFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharterFormQuery, CharterFormQueryVariables>(CharterFormDocument, options);
        }
export type CharterFormQueryHookResult = ReturnType<typeof useCharterFormQuery>;
export type CharterFormLazyQueryHookResult = ReturnType<typeof useCharterFormLazyQuery>;
export type CharterFormSuspenseQueryHookResult = ReturnType<typeof useCharterFormSuspenseQuery>;
export type CharterFormQueryResult = Apollo.QueryResult<CharterFormQuery, CharterFormQueryVariables>;
export const CharterDocument = gql`
    query Charter($charterId: ID!) {
  charter(charterId: $charterId) {
    ...Charter
  }
}
    ${CharterFragmentDoc}`;

/**
 * __useCharterQuery__
 *
 * To run a query within a React component, call `useCharterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharterQuery({
 *   variables: {
 *      charterId: // value for 'charterId'
 *   },
 * });
 */
export function useCharterQuery(baseOptions: Apollo.QueryHookOptions<CharterQuery, CharterQueryVariables> & ({ variables: CharterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
      }
export function useCharterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharterQuery, CharterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
        }
export function useCharterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CharterQuery, CharterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharterQuery, CharterQueryVariables>(CharterDocument, options);
        }
export type CharterQueryHookResult = ReturnType<typeof useCharterQuery>;
export type CharterLazyQueryHookResult = ReturnType<typeof useCharterLazyQuery>;
export type CharterSuspenseQueryHookResult = ReturnType<typeof useCharterSuspenseQuery>;
export type CharterQueryResult = Apollo.QueryResult<CharterQuery, CharterQueryVariables>;
export const CreateCharterFormDocument = gql`
    mutation CreateCharterForm($assessmentId: ID!) {
  createCharterForm(assessmentId: $assessmentId) {
    ...CharterForm
  }
}
    ${CharterFormFragmentDoc}`;
export type CreateCharterFormMutationFn = Apollo.MutationFunction<CreateCharterFormMutation, CreateCharterFormMutationVariables>;

/**
 * __useCreateCharterFormMutation__
 *
 * To run a mutation, you first call `useCreateCharterFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCharterFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCharterFormMutation, { data, loading, error }] = useCreateCharterFormMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCreateCharterFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateCharterFormMutation, CreateCharterFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCharterFormMutation, CreateCharterFormMutationVariables>(CreateCharterFormDocument, options);
      }
export type CreateCharterFormMutationHookResult = ReturnType<typeof useCreateCharterFormMutation>;
export type CreateCharterFormMutationResult = Apollo.MutationResult<CreateCharterFormMutation>;
export type CreateCharterFormMutationOptions = Apollo.BaseMutationOptions<CreateCharterFormMutation, CreateCharterFormMutationVariables>;
export const UpdateCharterFormDocument = gql`
    mutation UpdateCharterForm($input: CharterFormInput!) {
  updateCharterForm(input: $input) {
    id
    sections {
      id
      rank
      type
      title
      enabled
      deleted
      promptDoc
      wordLimit
      wordLimitEnabled
      milestonePresets {
        title
        description
        dueDate
      }
    }
  }
}
    `;
export type UpdateCharterFormMutationFn = Apollo.MutationFunction<UpdateCharterFormMutation, UpdateCharterFormMutationVariables>;

/**
 * __useUpdateCharterFormMutation__
 *
 * To run a mutation, you first call `useUpdateCharterFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCharterFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCharterFormMutation, { data, loading, error }] = useUpdateCharterFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCharterFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCharterFormMutation, UpdateCharterFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCharterFormMutation, UpdateCharterFormMutationVariables>(UpdateCharterFormDocument, options);
      }
export type UpdateCharterFormMutationHookResult = ReturnType<typeof useUpdateCharterFormMutation>;
export type UpdateCharterFormMutationResult = Apollo.MutationResult<UpdateCharterFormMutation>;
export type UpdateCharterFormMutationOptions = Apollo.BaseMutationOptions<UpdateCharterFormMutation, UpdateCharterFormMutationVariables>;
export const ClassDocument = gql`
    query Class($assessmentId: ID!) {
  token
  me {
    id
    email
  }
  institution {
    id
    tenant
    country {
      ...Country
    }
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...Enrollment
    }
    groupType
    groups {
      ...Group
    }
  }
  classWorkGroups(assessmentId: $assessmentId) {
    ...WorkGroup
  }
  individualSheet: instructionSheet(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...InstructionSheet
  }
  groupSheet: instructionSheet(assessmentId: $assessmentId, kind: GROUP) {
    ...InstructionSheet
  }
  futureSheet(assessmentId: $assessmentId) {
    id
    releaseTimestamp
  }
  userSettings(assessmentId: $assessmentId) {
    ...UserSettings
  }
}
    ${CountryFragmentDoc}
${FeatureFlagsFragmentDoc}
${AssessmentFragmentDoc}
${EnrollmentFragmentDoc}
${GroupFragmentDoc}
${WorkGroupFragmentDoc}
${InstructionSheetFragmentDoc}
${UserSettingsFragmentDoc}`;

/**
 * __useClassQuery__
 *
 * To run a query within a React component, call `useClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useClassQuery(baseOptions: Apollo.QueryHookOptions<ClassQuery, ClassQueryVariables> & ({ variables: ClassQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassQuery, ClassQueryVariables>(ClassDocument, options);
      }
export function useClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassQuery, ClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassQuery, ClassQueryVariables>(ClassDocument, options);
        }
export function useClassSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassQuery, ClassQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassQuery, ClassQueryVariables>(ClassDocument, options);
        }
export type ClassQueryHookResult = ReturnType<typeof useClassQuery>;
export type ClassLazyQueryHookResult = ReturnType<typeof useClassLazyQuery>;
export type ClassSuspenseQueryHookResult = ReturnType<typeof useClassSuspenseQuery>;
export type ClassQueryResult = Apollo.QueryResult<ClassQuery, ClassQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  sessionId
  me {
    ...User
  }
  institution {
    id
    tenant
  }
}
    ${UserFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const AppendGroupsDocument = gql`
    mutation AppendGroups($assessmentId: ID!, $userIds: [ID!]!, $input: SetupGroupInput!) {
  appendGroups(assessmentId: $assessmentId, userIds: $userIds, input: $input) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type AppendGroupsMutationFn = Apollo.MutationFunction<AppendGroupsMutation, AppendGroupsMutationVariables>;

/**
 * __useAppendGroupsMutation__
 *
 * To run a mutation, you first call `useAppendGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendGroupsMutation, { data, loading, error }] = useAppendGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      userIds: // value for 'userIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppendGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AppendGroupsMutation, AppendGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendGroupsMutation, AppendGroupsMutationVariables>(AppendGroupsDocument, options);
      }
export type AppendGroupsMutationHookResult = ReturnType<typeof useAppendGroupsMutation>;
export type AppendGroupsMutationResult = Apollo.MutationResult<AppendGroupsMutation>;
export type AppendGroupsMutationOptions = Apollo.BaseMutationOptions<AppendGroupsMutation, AppendGroupsMutationVariables>;
export const AutoAssignGroupsDocument = gql`
    mutation AutoAssignGroups($assessmentId: ID!, $groupId: ID) {
  autoAssignGroups(assessmentId: $assessmentId, groupId: $groupId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type AutoAssignGroupsMutationFn = Apollo.MutationFunction<AutoAssignGroupsMutation, AutoAssignGroupsMutationVariables>;

/**
 * __useAutoAssignGroupsMutation__
 *
 * To run a mutation, you first call `useAutoAssignGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoAssignGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoAssignGroupsMutation, { data, loading, error }] = useAutoAssignGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useAutoAssignGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AutoAssignGroupsMutation, AutoAssignGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoAssignGroupsMutation, AutoAssignGroupsMutationVariables>(AutoAssignGroupsDocument, options);
      }
export type AutoAssignGroupsMutationHookResult = ReturnType<typeof useAutoAssignGroupsMutation>;
export type AutoAssignGroupsMutationResult = Apollo.MutationResult<AutoAssignGroupsMutation>;
export type AutoAssignGroupsMutationOptions = Apollo.BaseMutationOptions<AutoAssignGroupsMutation, AutoAssignGroupsMutationVariables>;
export const BrightspaceGroupsDocument = gql`
    query BrightspaceGroups($assessmentId: ID!, $brightspaceScopeFor: BrightspaceScopeKeyType!) {
  brightspaceApi(
    assessmentId: $assessmentId
    brightspaceScopeFor: $brightspaceScopeFor
  ) {
    groups {
      ...BrightspaceGroup
    }
  }
  class(assessmentId: $assessmentId) {
    students {
      customParams {
        brightspaceUserId
      }
      sisUserId
      user {
        id
        name
      }
    }
  }
}
    ${BrightspaceGroupFragmentDoc}`;

/**
 * __useBrightspaceGroupsQuery__
 *
 * To run a query within a React component, call `useBrightspaceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrightspaceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrightspaceGroupsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      brightspaceScopeFor: // value for 'brightspaceScopeFor'
 *   },
 * });
 */
export function useBrightspaceGroupsQuery(baseOptions: Apollo.QueryHookOptions<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables> & ({ variables: BrightspaceGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>(BrightspaceGroupsDocument, options);
      }
export function useBrightspaceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>(BrightspaceGroupsDocument, options);
        }
export function useBrightspaceGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>(BrightspaceGroupsDocument, options);
        }
export type BrightspaceGroupsQueryHookResult = ReturnType<typeof useBrightspaceGroupsQuery>;
export type BrightspaceGroupsLazyQueryHookResult = ReturnType<typeof useBrightspaceGroupsLazyQuery>;
export type BrightspaceGroupsSuspenseQueryHookResult = ReturnType<typeof useBrightspaceGroupsSuspenseQuery>;
export type BrightspaceGroupsQueryResult = Apollo.QueryResult<BrightspaceGroupsQuery, BrightspaceGroupsQueryVariables>;
export const CanvasSectionsDocument = gql`
    query CanvasSections($assessmentId: ID!, $canvasScopeFor: CanvasScopeKeyType!) {
  canvasApi(assessmentId: $assessmentId, canvasScopeFor: $canvasScopeFor) {
    sections {
      ...CanvasSection
    }
  }
  class(assessmentId: $assessmentId) {
    students {
      customParams {
        canvasUserId
      }
      sisUserId
      user {
        id
        name
      }
    }
  }
}
    ${CanvasSectionFragmentDoc}`;

/**
 * __useCanvasSectionsQuery__
 *
 * To run a query within a React component, call `useCanvasSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanvasSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanvasSectionsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      canvasScopeFor: // value for 'canvasScopeFor'
 *   },
 * });
 */
export function useCanvasSectionsQuery(baseOptions: Apollo.QueryHookOptions<CanvasSectionsQuery, CanvasSectionsQueryVariables> & ({ variables: CanvasSectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanvasSectionsQuery, CanvasSectionsQueryVariables>(CanvasSectionsDocument, options);
      }
export function useCanvasSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanvasSectionsQuery, CanvasSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanvasSectionsQuery, CanvasSectionsQueryVariables>(CanvasSectionsDocument, options);
        }
export function useCanvasSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanvasSectionsQuery, CanvasSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanvasSectionsQuery, CanvasSectionsQueryVariables>(CanvasSectionsDocument, options);
        }
export type CanvasSectionsQueryHookResult = ReturnType<typeof useCanvasSectionsQuery>;
export type CanvasSectionsLazyQueryHookResult = ReturnType<typeof useCanvasSectionsLazyQuery>;
export type CanvasSectionsSuspenseQueryHookResult = ReturnType<typeof useCanvasSectionsSuspenseQuery>;
export type CanvasSectionsQueryResult = Apollo.QueryResult<CanvasSectionsQuery, CanvasSectionsQueryVariables>;
export const CreateGroupsDocument = gql`
    mutation CreateGroups($assessmentId: ID!, $groups: [GroupInput!]!) {
  createGroups(assessmentId: $assessmentId, groups: $groups) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type CreateGroupsMutationFn = Apollo.MutationFunction<CreateGroupsMutation, CreateGroupsMutationVariables>;

/**
 * __useCreateGroupsMutation__
 *
 * To run a mutation, you first call `useCreateGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupsMutation, { data, loading, error }] = useCreateGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useCreateGroupsMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupsMutation, CreateGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupsMutation, CreateGroupsMutationVariables>(CreateGroupsDocument, options);
      }
export type CreateGroupsMutationHookResult = ReturnType<typeof useCreateGroupsMutation>;
export type CreateGroupsMutationResult = Apollo.MutationResult<CreateGroupsMutation>;
export type CreateGroupsMutationOptions = Apollo.BaseMutationOptions<CreateGroupsMutation, CreateGroupsMutationVariables>;
export const DeleteGroupMemberDocument = gql`
    mutation DeleteGroupMember($assessmentId: ID!, $userId: ID!, $groupId: ID!) {
  deleteGroupMember(
    assessmentId: $assessmentId
    userId: $userId
    groupId: $groupId
  ) {
    ...DeletedMember
  }
}
    ${DeletedMemberFragmentDoc}`;
export type DeleteGroupMemberMutationFn = Apollo.MutationFunction<DeleteGroupMemberMutation, DeleteGroupMemberMutationVariables>;

/**
 * __useDeleteGroupMemberMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMemberMutation, { data, loading, error }] = useDeleteGroupMemberMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMemberMutation, DeleteGroupMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMemberMutation, DeleteGroupMemberMutationVariables>(DeleteGroupMemberDocument, options);
      }
export type DeleteGroupMemberMutationHookResult = ReturnType<typeof useDeleteGroupMemberMutation>;
export type DeleteGroupMemberMutationResult = Apollo.MutationResult<DeleteGroupMemberMutation>;
export type DeleteGroupMemberMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMemberMutation, DeleteGroupMemberMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($assessmentId: ID!, $groupId: ID!) {
  deleteGroup(assessmentId: $assessmentId, groupId: $groupId)
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const DeleteGroupsDocument = gql`
    mutation DeleteGroups($assessmentId: ID!, $groupIds: [ID!]!) {
  deleteGroups(assessmentId: $assessmentId, groupIds: $groupIds)
}
    `;
export type DeleteGroupsMutationFn = Apollo.MutationFunction<DeleteGroupsMutation, DeleteGroupsMutationVariables>;

/**
 * __useDeleteGroupsMutation__
 *
 * To run a mutation, you first call `useDeleteGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupsMutation, { data, loading, error }] = useDeleteGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useDeleteGroupsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupsMutation, DeleteGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupsMutation, DeleteGroupsMutationVariables>(DeleteGroupsDocument, options);
      }
export type DeleteGroupsMutationHookResult = ReturnType<typeof useDeleteGroupsMutation>;
export type DeleteGroupsMutationResult = Apollo.MutationResult<DeleteGroupsMutation>;
export type DeleteGroupsMutationOptions = Apollo.BaseMutationOptions<DeleteGroupsMutation, DeleteGroupsMutationVariables>;
export const GroupUpdatedDocument = gql`
    subscription groupUpdated($assessmentId: ID!) {
  groupUpdated(assessmentId: $assessmentId) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;

/**
 * __useGroupUpdatedSubscription__
 *
 * To run a query within a React component, call `useGroupUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGroupUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables> & ({ variables: GroupUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GroupUpdatedSubscription, GroupUpdatedSubscriptionVariables>(GroupUpdatedDocument, options);
      }
export type GroupUpdatedSubscriptionHookResult = ReturnType<typeof useGroupUpdatedSubscription>;
export type GroupUpdatedSubscriptionResult = Apollo.SubscriptionResult<GroupUpdatedSubscription>;
export const GroupsRouteDocument = gql`
    query GroupsRoute($assessmentId: ID!) {
  token
  me {
    id
    email
  }
  lecturers(assessmentId: $assessmentId) {
    ...User
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...Enrollment
    }
    groupType
    groups {
      ...Group
    }
  }
  messageInbox(assessmentId: $assessmentId) {
    ...Message
  }
  individualSheet: instructionSheet(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...InstructionSheet
  }
  institution {
    id
    apiStatus {
      hasBrightspaceApi
      hasCanvasApi
    }
  }
}
    ${UserFragmentDoc}
${AssessmentFragmentDoc}
${EnrollmentFragmentDoc}
${GroupFragmentDoc}
${MessageFragmentDoc}
${InstructionSheetFragmentDoc}`;

/**
 * __useGroupsRouteQuery__
 *
 * To run a query within a React component, call `useGroupsRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsRouteQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupsRouteQuery(baseOptions: Apollo.QueryHookOptions<GroupsRouteQuery, GroupsRouteQueryVariables> & ({ variables: GroupsRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsRouteQuery, GroupsRouteQueryVariables>(GroupsRouteDocument, options);
      }
export function useGroupsRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsRouteQuery, GroupsRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsRouteQuery, GroupsRouteQueryVariables>(GroupsRouteDocument, options);
        }
export function useGroupsRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsRouteQuery, GroupsRouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupsRouteQuery, GroupsRouteQueryVariables>(GroupsRouteDocument, options);
        }
export type GroupsRouteQueryHookResult = ReturnType<typeof useGroupsRouteQuery>;
export type GroupsRouteLazyQueryHookResult = ReturnType<typeof useGroupsRouteLazyQuery>;
export type GroupsRouteSuspenseQueryHookResult = ReturnType<typeof useGroupsRouteSuspenseQuery>;
export type GroupsRouteQueryResult = Apollo.QueryResult<GroupsRouteQuery, GroupsRouteQueryVariables>;
export const ResetGroupsDocument = gql`
    mutation resetGroups($assessmentId: ID!) {
  resetGroups(assessmentId: $assessmentId)
}
    `;
export type ResetGroupsMutationFn = Apollo.MutationFunction<ResetGroupsMutation, ResetGroupsMutationVariables>;

/**
 * __useResetGroupsMutation__
 *
 * To run a mutation, you first call `useResetGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetGroupsMutation, { data, loading, error }] = useResetGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResetGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ResetGroupsMutation, ResetGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetGroupsMutation, ResetGroupsMutationVariables>(ResetGroupsDocument, options);
      }
export type ResetGroupsMutationHookResult = ReturnType<typeof useResetGroupsMutation>;
export type ResetGroupsMutationResult = Apollo.MutationResult<ResetGroupsMutation>;
export type ResetGroupsMutationOptions = Apollo.BaseMutationOptions<ResetGroupsMutation, ResetGroupsMutationVariables>;
export const ResolveMessagesDocument = gql`
    mutation ResolveMessages($messageIds: [ID!]!, $assessmentId: ID!) {
  resolveMessages(messageIds: $messageIds, assessmentId: $assessmentId) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;
export type ResolveMessagesMutationFn = Apollo.MutationFunction<ResolveMessagesMutation, ResolveMessagesMutationVariables>;

/**
 * __useResolveMessagesMutation__
 *
 * To run a mutation, you first call `useResolveMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveMessagesMutation, { data, loading, error }] = useResolveMessagesMutation({
 *   variables: {
 *      messageIds: // value for 'messageIds'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResolveMessagesMutation(baseOptions?: Apollo.MutationHookOptions<ResolveMessagesMutation, ResolveMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveMessagesMutation, ResolveMessagesMutationVariables>(ResolveMessagesDocument, options);
      }
export type ResolveMessagesMutationHookResult = ReturnType<typeof useResolveMessagesMutation>;
export type ResolveMessagesMutationResult = Apollo.MutationResult<ResolveMessagesMutation>;
export type ResolveMessagesMutationOptions = Apollo.BaseMutationOptions<ResolveMessagesMutation, ResolveMessagesMutationVariables>;
export const SetupGroupsDocument = gql`
    mutation SetupGroups($assessmentId: ID!, $input: SetupGroupInput!) {
  setupGroups(assessmentId: $assessmentId, input: $input) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type SetupGroupsMutationFn = Apollo.MutationFunction<SetupGroupsMutation, SetupGroupsMutationVariables>;

/**
 * __useSetupGroupsMutation__
 *
 * To run a mutation, you first call `useSetupGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupGroupsMutation, { data, loading, error }] = useSetupGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupGroupsMutation(baseOptions?: Apollo.MutationHookOptions<SetupGroupsMutation, SetupGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupGroupsMutation, SetupGroupsMutationVariables>(SetupGroupsDocument, options);
      }
export type SetupGroupsMutationHookResult = ReturnType<typeof useSetupGroupsMutation>;
export type SetupGroupsMutationResult = Apollo.MutationResult<SetupGroupsMutation>;
export type SetupGroupsMutationOptions = Apollo.BaseMutationOptions<SetupGroupsMutation, SetupGroupsMutationVariables>;
export const UpdateGroupMembershipsDocument = gql`
    mutation UpdateGroupMemberships($assessmentId: ID!, $memberships: [GroupMembershipInput!]!) {
  updateGroupMemberships(assessmentId: $assessmentId, memberships: $memberships) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type UpdateGroupMembershipsMutationFn = Apollo.MutationFunction<UpdateGroupMembershipsMutation, UpdateGroupMembershipsMutationVariables>;

/**
 * __useUpdateGroupMembershipsMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMembershipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMembershipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMembershipsMutation, { data, loading, error }] = useUpdateGroupMembershipsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      memberships: // value for 'memberships'
 *   },
 * });
 */
export function useUpdateGroupMembershipsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMembershipsMutation, UpdateGroupMembershipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMembershipsMutation, UpdateGroupMembershipsMutationVariables>(UpdateGroupMembershipsDocument, options);
      }
export type UpdateGroupMembershipsMutationHookResult = ReturnType<typeof useUpdateGroupMembershipsMutation>;
export type UpdateGroupMembershipsMutationResult = Apollo.MutationResult<UpdateGroupMembershipsMutation>;
export type UpdateGroupMembershipsMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMembershipsMutation, UpdateGroupMembershipsMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($assessmentId: ID!, $group: GroupUpdateInput!) {
  updateGroup(assessmentId: $assessmentId, group: $group) {
    ...Group
  }
}
    ${GroupFragmentDoc}`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateGroupNameDocument = gql`
    mutation UpdateGroupName($assessmentId: ID!, $input: GroupUpdateInput!) {
  updateGroup(assessmentId: $assessmentId, group: $input) {
    id
    name
  }
}
    `;
export type UpdateGroupNameMutationFn = Apollo.MutationFunction<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>;

/**
 * __useUpdateGroupNameMutation__
 *
 * To run a mutation, you first call `useUpdateGroupNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupNameMutation, { data, loading, error }] = useUpdateGroupNameMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>(UpdateGroupNameDocument, options);
      }
export type UpdateGroupNameMutationHookResult = ReturnType<typeof useUpdateGroupNameMutation>;
export type UpdateGroupNameMutationResult = Apollo.MutationResult<UpdateGroupNameMutation>;
export type UpdateGroupNameMutationOptions = Apollo.BaseMutationOptions<UpdateGroupNameMutation, UpdateGroupNameMutationVariables>;
export const AssignMarkerToGroupsDocument = gql`
    mutation assignMarkerToGroups($assessmentId: ID!, $groupIds: [ID!]!, $markerId: ID!) {
  assignMarkerToGroups(
    assessmentId: $assessmentId
    groupIds: $groupIds
    markerId: $markerId
  ) {
    id
    markerId
    marker {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type AssignMarkerToGroupsMutationFn = Apollo.MutationFunction<AssignMarkerToGroupsMutation, AssignMarkerToGroupsMutationVariables>;

/**
 * __useAssignMarkerToGroupsMutation__
 *
 * To run a mutation, you first call `useAssignMarkerToGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMarkerToGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMarkerToGroupsMutation, { data, loading, error }] = useAssignMarkerToGroupsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupIds: // value for 'groupIds'
 *      markerId: // value for 'markerId'
 *   },
 * });
 */
export function useAssignMarkerToGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AssignMarkerToGroupsMutation, AssignMarkerToGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignMarkerToGroupsMutation, AssignMarkerToGroupsMutationVariables>(AssignMarkerToGroupsDocument, options);
      }
export type AssignMarkerToGroupsMutationHookResult = ReturnType<typeof useAssignMarkerToGroupsMutation>;
export type AssignMarkerToGroupsMutationResult = Apollo.MutationResult<AssignMarkerToGroupsMutation>;
export type AssignMarkerToGroupsMutationOptions = Apollo.BaseMutationOptions<AssignMarkerToGroupsMutation, AssignMarkerToGroupsMutationVariables>;
export const GroupHubNavigationDocument = gql`
    query GroupHubNavigation($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      ...HubAssessmentSettings
    }
  }
}
    ${HubAssessmentSettingsFragmentDoc}`;

/**
 * __useGroupHubNavigationQuery__
 *
 * To run a query within a React component, call `useGroupHubNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupHubNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupHubNavigationQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupHubNavigationQuery(baseOptions: Apollo.QueryHookOptions<GroupHubNavigationQuery, GroupHubNavigationQueryVariables> & ({ variables: GroupHubNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>(GroupHubNavigationDocument, options);
      }
export function useGroupHubNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>(GroupHubNavigationDocument, options);
        }
export function useGroupHubNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>(GroupHubNavigationDocument, options);
        }
export type GroupHubNavigationQueryHookResult = ReturnType<typeof useGroupHubNavigationQuery>;
export type GroupHubNavigationLazyQueryHookResult = ReturnType<typeof useGroupHubNavigationLazyQuery>;
export type GroupHubNavigationSuspenseQueryHookResult = ReturnType<typeof useGroupHubNavigationSuspenseQuery>;
export type GroupHubNavigationQueryResult = Apollo.QueryResult<GroupHubNavigationQuery, GroupHubNavigationQueryVariables>;
export const GroupHubDocument = gql`
    query GroupHub($assessmentId: ID!) {
  assessment(assessmentId: $assessmentId) {
    id
    settings {
      ...HubAssessmentSettings
    }
  }
  messageInbox(assessmentId: $assessmentId) {
    ...Message
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...GroupEnrollment
    }
    groups {
      ...Group
    }
  }
  charterDraft: charterForm(assessmentId: $assessmentId) {
    ...CharterForm
  }
  charterPublished: charterForm(assessmentId: $assessmentId, published: true) {
    id
    publishTimestamp
  }
  groupTask: task(assessmentId: $assessmentId, kind: GROUP) {
    ...HubTask
  }
  individualTask: task(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...HubTask
  }
  peerTask: task(assessmentId: $assessmentId, kind: PEER) {
    ...HubTask
  }
  groupRubricMarkingStatus: markerRubric(
    assessmentId: $assessmentId
    kind: GROUP
    status: DRAFT
  ) {
    markingExists
  }
  individualRubricMarkingStatus: markerRubric(
    assessmentId: $assessmentId
    kind: INDIVIDUAL
    status: DRAFT
  ) {
    markingExists
  }
  peerRubricMarkingStatus: markerRubric(
    assessmentId: $assessmentId
    kind: PEER
    status: DRAFT
  ) {
    markingExists
  }
}
    ${HubAssessmentSettingsFragmentDoc}
${MessageFragmentDoc}
${GroupEnrollmentFragmentDoc}
${GroupFragmentDoc}
${CharterFormFragmentDoc}
${HubTaskFragmentDoc}`;

/**
 * __useGroupHubQuery__
 *
 * To run a query within a React component, call `useGroupHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupHubQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupHubQuery(baseOptions: Apollo.QueryHookOptions<GroupHubQuery, GroupHubQueryVariables> & ({ variables: GroupHubQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupHubQuery, GroupHubQueryVariables>(GroupHubDocument, options);
      }
export function useGroupHubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupHubQuery, GroupHubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupHubQuery, GroupHubQueryVariables>(GroupHubDocument, options);
        }
export function useGroupHubSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupHubQuery, GroupHubQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupHubQuery, GroupHubQueryVariables>(GroupHubDocument, options);
        }
export type GroupHubQueryHookResult = ReturnType<typeof useGroupHubQuery>;
export type GroupHubLazyQueryHookResult = ReturnType<typeof useGroupHubLazyQuery>;
export type GroupHubSuspenseQueryHookResult = ReturnType<typeof useGroupHubSuspenseQuery>;
export type GroupHubQueryResult = Apollo.QueryResult<GroupHubQuery, GroupHubQueryVariables>;
export const HomeDocument = gql`
    query Home($assessmentId: ID!) {
  token
  me {
    ...User
  }
  institution {
    ...Institution
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...GroupEnrollment
    }
    groups {
      ...Group
    }
  }
  task(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...Task
  }
  groupTask: task(assessmentId: $assessmentId, kind: GROUP) {
    id
  }
  instructionSheet(assessmentId: $assessmentId) {
    ...InstructionSheet
  }
  futureSheet(assessmentId: $assessmentId) {
    ...InstructionSheetWithRequirements
  }
  userSettings(assessmentId: $assessmentId) {
    ...UserSettings
  }
  assessmentAccessCodes(assessmentId: $assessmentId) {
    ...AccessCode
  }
}
    ${UserFragmentDoc}
${InstitutionFragmentDoc}
${FeatureFlagsFragmentDoc}
${AssessmentFragmentDoc}
${GroupEnrollmentFragmentDoc}
${GroupFragmentDoc}
${TaskFragmentDoc}
${InstructionSheetFragmentDoc}
${InstructionSheetWithRequirementsFragmentDoc}
${UserSettingsFragmentDoc}
${AccessCodeFragmentDoc}`;

/**
 * __useHomeQuery__
 *
 * To run a query within a React component, call `useHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useHomeQuery(baseOptions: Apollo.QueryHookOptions<HomeQuery, HomeQueryVariables> & ({ variables: HomeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
      }
export function useHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeQuery, HomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
        }
export function useHomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeQuery, HomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
        }
export type HomeQueryHookResult = ReturnType<typeof useHomeQuery>;
export type HomeLazyQueryHookResult = ReturnType<typeof useHomeLazyQuery>;
export type HomeSuspenseQueryHookResult = ReturnType<typeof useHomeSuspenseQuery>;
export type HomeQueryResult = Apollo.QueryResult<HomeQuery, HomeQueryVariables>;
export const MarkerRubricsDocument = gql`
    query MarkerRubrics($assessmentId: ID!, $kind: MarkerRubricKind!) {
  publishedMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: $kind
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  draftMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: $kind
    status: DRAFT
  ) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __useMarkerRubricsQuery__
 *
 * To run a query within a React component, call `useMarkerRubricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkerRubricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkerRubricsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useMarkerRubricsQuery(baseOptions: Apollo.QueryHookOptions<MarkerRubricsQuery, MarkerRubricsQueryVariables> & ({ variables: MarkerRubricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkerRubricsQuery, MarkerRubricsQueryVariables>(MarkerRubricsDocument, options);
      }
export function useMarkerRubricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkerRubricsQuery, MarkerRubricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkerRubricsQuery, MarkerRubricsQueryVariables>(MarkerRubricsDocument, options);
        }
export function useMarkerRubricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarkerRubricsQuery, MarkerRubricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarkerRubricsQuery, MarkerRubricsQueryVariables>(MarkerRubricsDocument, options);
        }
export type MarkerRubricsQueryHookResult = ReturnType<typeof useMarkerRubricsQuery>;
export type MarkerRubricsLazyQueryHookResult = ReturnType<typeof useMarkerRubricsLazyQuery>;
export type MarkerRubricsSuspenseQueryHookResult = ReturnType<typeof useMarkerRubricsSuspenseQuery>;
export type MarkerRubricsQueryResult = Apollo.QueryResult<MarkerRubricsQuery, MarkerRubricsQueryVariables>;
export const ReleaseAssessmentDocument = gql`
    mutation ReleaseAssessment($assessmentId: ID!) {
  releaseAssessment(assessmentId: $assessmentId) {
    assessment {
      id
      settings {
        id
        openDate
      }
    }
    sheets {
      ...InstructionSheet
    }
  }
}
    ${InstructionSheetFragmentDoc}`;
export type ReleaseAssessmentMutationFn = Apollo.MutationFunction<ReleaseAssessmentMutation, ReleaseAssessmentMutationVariables>;

/**
 * __useReleaseAssessmentMutation__
 *
 * To run a mutation, you first call `useReleaseAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseAssessmentMutation, { data, loading, error }] = useReleaseAssessmentMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useReleaseAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseAssessmentMutation, ReleaseAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseAssessmentMutation, ReleaseAssessmentMutationVariables>(ReleaseAssessmentDocument, options);
      }
export type ReleaseAssessmentMutationHookResult = ReturnType<typeof useReleaseAssessmentMutation>;
export type ReleaseAssessmentMutationResult = Apollo.MutationResult<ReleaseAssessmentMutation>;
export type ReleaseAssessmentMutationOptions = Apollo.BaseMutationOptions<ReleaseAssessmentMutation, ReleaseAssessmentMutationVariables>;
export const SettingsDocument = gql`
    query Settings($assessmentId: ID!) {
  token
  me {
    ...User
  }
  institution {
    ...Institution
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  task(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...Task
  }
  instructionSheet(assessmentId: $assessmentId) {
    ...InstructionSheet
  }
}
    ${UserFragmentDoc}
${InstitutionFragmentDoc}
${FeatureFlagsFragmentDoc}
${AssessmentFragmentDoc}
${TaskFragmentDoc}
${InstructionSheetFragmentDoc}`;

/**
 * __useSettingsQuery__
 *
 * To run a query within a React component, call `useSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useSettingsQuery(baseOptions: Apollo.QueryHookOptions<SettingsQuery, SettingsQueryVariables> & ({ variables: SettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
      }
export function useSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
        }
export function useSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
        }
export type SettingsQueryHookResult = ReturnType<typeof useSettingsQuery>;
export type SettingsLazyQueryHookResult = ReturnType<typeof useSettingsLazyQuery>;
export type SettingsSuspenseQueryHookResult = ReturnType<typeof useSettingsSuspenseQuery>;
export type SettingsQueryResult = Apollo.QueryResult<SettingsQuery, SettingsQueryVariables>;
export const InsightsDocument = gql`
    query Insights($assessmentId: ID!) {
  token
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  futureSheet(assessmentId: $assessmentId) {
    id
    releaseTimestamp
  }
  class(assessmentId: $assessmentId) {
    groups {
      ...Group
    }
  }
  institution {
    id
    timezone
  }
}
    ${AssessmentFragmentDoc}
${GroupFragmentDoc}`;

/**
 * __useInsightsQuery__
 *
 * To run a query within a React component, call `useInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useInsightsQuery(baseOptions: Apollo.QueryHookOptions<InsightsQuery, InsightsQueryVariables> & ({ variables: InsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
      }
export function useInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
export function useInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
export type InsightsQueryHookResult = ReturnType<typeof useInsightsQuery>;
export type InsightsLazyQueryHookResult = ReturnType<typeof useInsightsLazyQuery>;
export type InsightsSuspenseQueryHookResult = ReturnType<typeof useInsightsSuspenseQuery>;
export type InsightsQueryResult = Apollo.QueryResult<InsightsQuery, InsightsQueryVariables>;
export const MailingListDocument = gql`
    query MailingList($assessmentId: ID!) {
  me {
    email
  }
  insightsMailingList(assessmentId: $assessmentId) {
    ...MailingList
  }
}
    ${MailingListFragmentDoc}`;

/**
 * __useMailingListQuery__
 *
 * To run a query within a React component, call `useMailingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailingListQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useMailingListQuery(baseOptions: Apollo.QueryHookOptions<MailingListQuery, MailingListQueryVariables> & ({ variables: MailingListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailingListQuery, MailingListQueryVariables>(MailingListDocument, options);
      }
export function useMailingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailingListQuery, MailingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailingListQuery, MailingListQueryVariables>(MailingListDocument, options);
        }
export function useMailingListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailingListQuery, MailingListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailingListQuery, MailingListQueryVariables>(MailingListDocument, options);
        }
export type MailingListQueryHookResult = ReturnType<typeof useMailingListQuery>;
export type MailingListLazyQueryHookResult = ReturnType<typeof useMailingListLazyQuery>;
export type MailingListSuspenseQueryHookResult = ReturnType<typeof useMailingListSuspenseQuery>;
export type MailingListQueryResult = Apollo.QueryResult<MailingListQuery, MailingListQueryVariables>;
export const UpdateInsightsMailingListDocument = gql`
    mutation UpdateInsightsMailingList($assessmentId: ID!, $subscribed: Boolean!, $members: [String!]!) {
  updateInsightsMailingList(
    assessmentId: $assessmentId
    subscribed: $subscribed
    members: $members
  ) {
    ...MailingList
  }
}
    ${MailingListFragmentDoc}`;
export type UpdateInsightsMailingListMutationFn = Apollo.MutationFunction<UpdateInsightsMailingListMutation, UpdateInsightsMailingListMutationVariables>;

/**
 * __useUpdateInsightsMailingListMutation__
 *
 * To run a mutation, you first call `useUpdateInsightsMailingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightsMailingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightsMailingListMutation, { data, loading, error }] = useUpdateInsightsMailingListMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      subscribed: // value for 'subscribed'
 *      members: // value for 'members'
 *   },
 * });
 */
export function useUpdateInsightsMailingListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightsMailingListMutation, UpdateInsightsMailingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightsMailingListMutation, UpdateInsightsMailingListMutationVariables>(UpdateInsightsMailingListDocument, options);
      }
export type UpdateInsightsMailingListMutationHookResult = ReturnType<typeof useUpdateInsightsMailingListMutation>;
export type UpdateInsightsMailingListMutationResult = Apollo.MutationResult<UpdateInsightsMailingListMutation>;
export type UpdateInsightsMailingListMutationOptions = Apollo.BaseMutationOptions<UpdateInsightsMailingListMutation, UpdateInsightsMailingListMutationVariables>;
export const ClassOutcomesDocument = gql`
    query ClassOutcomes($assessmentId: ID!) {
  workOutcomes(assessmentId: $assessmentId) {
    ...WorkOutcomeClass
  }
}
    ${WorkOutcomeClassFragmentDoc}`;

/**
 * __useClassOutcomesQuery__
 *
 * To run a query within a React component, call `useClassOutcomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassOutcomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassOutcomesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useClassOutcomesQuery(baseOptions: Apollo.QueryHookOptions<ClassOutcomesQuery, ClassOutcomesQueryVariables> & ({ variables: ClassOutcomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassOutcomesQuery, ClassOutcomesQueryVariables>(ClassOutcomesDocument, options);
      }
export function useClassOutcomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassOutcomesQuery, ClassOutcomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassOutcomesQuery, ClassOutcomesQueryVariables>(ClassOutcomesDocument, options);
        }
export function useClassOutcomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassOutcomesQuery, ClassOutcomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassOutcomesQuery, ClassOutcomesQueryVariables>(ClassOutcomesDocument, options);
        }
export type ClassOutcomesQueryHookResult = ReturnType<typeof useClassOutcomesQuery>;
export type ClassOutcomesLazyQueryHookResult = ReturnType<typeof useClassOutcomesLazyQuery>;
export type ClassOutcomesSuspenseQueryHookResult = ReturnType<typeof useClassOutcomesSuspenseQuery>;
export type ClassOutcomesQueryResult = Apollo.QueryResult<ClassOutcomesQuery, ClassOutcomesQueryVariables>;
export const ClassicMarkingDocument = gql`
    query ClassicMarking($assessmentId: ID!, $studentId: ID!) {
  me {
    id
    email
  }
  individualMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: INDIVIDUAL
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  groupMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: GROUP
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  peerMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: PEER
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
  studentWorkOutcome(assessmentId: $assessmentId, studentId: $studentId) {
    ...WorkOutcome
  }
  groupWorkOutcome(assessmentId: $assessmentId, studentId: $studentId) {
    ...WorkOutcome
  }
}
    ${MarkerRubricFragmentDoc}
${WorkOutcomeFragmentDoc}`;

/**
 * __useClassicMarkingQuery__
 *
 * To run a query within a React component, call `useClassicMarkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassicMarkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassicMarkingQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useClassicMarkingQuery(baseOptions: Apollo.QueryHookOptions<ClassicMarkingQuery, ClassicMarkingQueryVariables> & ({ variables: ClassicMarkingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassicMarkingQuery, ClassicMarkingQueryVariables>(ClassicMarkingDocument, options);
      }
export function useClassicMarkingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassicMarkingQuery, ClassicMarkingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassicMarkingQuery, ClassicMarkingQueryVariables>(ClassicMarkingDocument, options);
        }
export function useClassicMarkingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassicMarkingQuery, ClassicMarkingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassicMarkingQuery, ClassicMarkingQueryVariables>(ClassicMarkingDocument, options);
        }
export type ClassicMarkingQueryHookResult = ReturnType<typeof useClassicMarkingQuery>;
export type ClassicMarkingLazyQueryHookResult = ReturnType<typeof useClassicMarkingLazyQuery>;
export type ClassicMarkingSuspenseQueryHookResult = ReturnType<typeof useClassicMarkingSuspenseQuery>;
export type ClassicMarkingQueryResult = Apollo.QueryResult<ClassicMarkingQuery, ClassicMarkingQueryVariables>;
export const CreateGraderMarkerRubricDocument = gql`
    mutation CreateGraderMarkerRubric($assessmentId: ID!, $input: CreateGraderMarkerRubricInput!) {
  createGraderMarkerRubric(assessmentId: $assessmentId, input: $input) {
    markerRubric {
      ...MarkerRubric
    }
  }
}
    ${MarkerRubricFragmentDoc}`;
export type CreateGraderMarkerRubricMutationFn = Apollo.MutationFunction<CreateGraderMarkerRubricMutation, CreateGraderMarkerRubricMutationVariables>;

/**
 * __useCreateGraderMarkerRubricMutation__
 *
 * To run a mutation, you first call `useCreateGraderMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGraderMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGraderMarkerRubricMutation, { data, loading, error }] = useCreateGraderMarkerRubricMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGraderMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<CreateGraderMarkerRubricMutation, CreateGraderMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGraderMarkerRubricMutation, CreateGraderMarkerRubricMutationVariables>(CreateGraderMarkerRubricDocument, options);
      }
export type CreateGraderMarkerRubricMutationHookResult = ReturnType<typeof useCreateGraderMarkerRubricMutation>;
export type CreateGraderMarkerRubricMutationResult = Apollo.MutationResult<CreateGraderMarkerRubricMutation>;
export type CreateGraderMarkerRubricMutationOptions = Apollo.BaseMutationOptions<CreateGraderMarkerRubricMutation, CreateGraderMarkerRubricMutationVariables>;
export const CreateMarkerRubricDocument = gql`
    mutation CreateMarkerRubric($assessmentId: ID!, $input: CreateMarkerRubricInput!) {
  createMarkerRubric(assessmentId: $assessmentId, input: $input) {
    format
    reversedScale
    hasChanges
    id
    kind
    publishedAt
  }
}
    `;
export type CreateMarkerRubricMutationFn = Apollo.MutationFunction<CreateMarkerRubricMutation, CreateMarkerRubricMutationVariables>;

/**
 * __useCreateMarkerRubricMutation__
 *
 * To run a mutation, you first call `useCreateMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarkerRubricMutation, { data, loading, error }] = useCreateMarkerRubricMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarkerRubricMutation, CreateMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarkerRubricMutation, CreateMarkerRubricMutationVariables>(CreateMarkerRubricDocument, options);
      }
export type CreateMarkerRubricMutationHookResult = ReturnType<typeof useCreateMarkerRubricMutation>;
export type CreateMarkerRubricMutationResult = Apollo.MutationResult<CreateMarkerRubricMutation>;
export type CreateMarkerRubricMutationOptions = Apollo.BaseMutationOptions<CreateMarkerRubricMutation, CreateMarkerRubricMutationVariables>;
export const CreateQuestionMarkerRubricDocument = gql`
    mutation CreateQuestionMarkerRubric($assessmentId: ID!, $input: CreateQuestionMarkerRubricInput!) {
  createQuestionMarkerRubric(assessmentId: $assessmentId, input: $input) {
    markerRubric {
      ...MarkerRubric
    }
  }
}
    ${MarkerRubricFragmentDoc}`;
export type CreateQuestionMarkerRubricMutationFn = Apollo.MutationFunction<CreateQuestionMarkerRubricMutation, CreateQuestionMarkerRubricMutationVariables>;

/**
 * __useCreateQuestionMarkerRubricMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMarkerRubricMutation, { data, loading, error }] = useCreateQuestionMarkerRubricMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMarkerRubricMutation, CreateQuestionMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionMarkerRubricMutation, CreateQuestionMarkerRubricMutationVariables>(CreateQuestionMarkerRubricDocument, options);
      }
export type CreateQuestionMarkerRubricMutationHookResult = ReturnType<typeof useCreateQuestionMarkerRubricMutation>;
export type CreateQuestionMarkerRubricMutationResult = Apollo.MutationResult<CreateQuestionMarkerRubricMutation>;
export type CreateQuestionMarkerRubricMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMarkerRubricMutation, CreateQuestionMarkerRubricMutationVariables>;
export const CreateSkillDocument = gql`
    mutation CreateSkill($assessmentId: ID!, $input: CreateSkillInput!) {
  createSkill(assessmentId: $assessmentId, input: $input) {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;
export type CreateSkillMutationFn = Apollo.MutationFunction<CreateSkillMutation, CreateSkillMutationVariables>;

/**
 * __useCreateSkillMutation__
 *
 * To run a mutation, you first call `useCreateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSkillMutation, { data, loading, error }] = useCreateSkillMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSkillMutation(baseOptions?: Apollo.MutationHookOptions<CreateSkillMutation, CreateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSkillMutation, CreateSkillMutationVariables>(CreateSkillDocument, options);
      }
export type CreateSkillMutationHookResult = ReturnType<typeof useCreateSkillMutation>;
export type CreateSkillMutationResult = Apollo.MutationResult<CreateSkillMutation>;
export type CreateSkillMutationOptions = Apollo.BaseMutationOptions<CreateSkillMutation, CreateSkillMutationVariables>;
export const CreateThreadDocument = gql`
    mutation CreateThread($threadId: ID!, $input: ThreadInput!) {
  createThread(threadId: $threadId, input: $input) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;
export type CreateThreadMutationFn = Apollo.MutationFunction<CreateThreadMutation, CreateThreadMutationVariables>;

/**
 * __useCreateThreadMutation__
 *
 * To run a mutation, you first call `useCreateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadMutation, { data, loading, error }] = useCreateThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadMutation, CreateThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadMutation, CreateThreadMutationVariables>(CreateThreadDocument, options);
      }
export type CreateThreadMutationHookResult = ReturnType<typeof useCreateThreadMutation>;
export type CreateThreadMutationResult = Apollo.MutationResult<CreateThreadMutation>;
export type CreateThreadMutationOptions = Apollo.BaseMutationOptions<CreateThreadMutation, CreateThreadMutationVariables>;
export const CriteriaBySkillDocument = gql`
    query CriteriaBySkill($assessmentId: ID!, $skillId: ID!) {
  criteriaBySkill(assessmentId: $assessmentId, skillId: $skillId) {
    ...ReuseCriterion
  }
}
    ${ReuseCriterionFragmentDoc}`;

/**
 * __useCriteriaBySkillQuery__
 *
 * To run a query within a React component, call `useCriteriaBySkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useCriteriaBySkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCriteriaBySkillQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useCriteriaBySkillQuery(baseOptions: Apollo.QueryHookOptions<CriteriaBySkillQuery, CriteriaBySkillQueryVariables> & ({ variables: CriteriaBySkillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>(CriteriaBySkillDocument, options);
      }
export function useCriteriaBySkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>(CriteriaBySkillDocument, options);
        }
export function useCriteriaBySkillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>(CriteriaBySkillDocument, options);
        }
export type CriteriaBySkillQueryHookResult = ReturnType<typeof useCriteriaBySkillQuery>;
export type CriteriaBySkillLazyQueryHookResult = ReturnType<typeof useCriteriaBySkillLazyQuery>;
export type CriteriaBySkillSuspenseQueryHookResult = ReturnType<typeof useCriteriaBySkillSuspenseQuery>;
export type CriteriaBySkillQueryResult = Apollo.QueryResult<CriteriaBySkillQuery, CriteriaBySkillQueryVariables>;
export const DeleteThreadDocument = gql`
    mutation DeleteThread($threadId: ID!) {
  deleteThread(threadId: $threadId) {
    id
  }
}
    `;
export type DeleteThreadMutationFn = Apollo.MutationFunction<DeleteThreadMutation, DeleteThreadMutationVariables>;

/**
 * __useDeleteThreadMutation__
 *
 * To run a mutation, you first call `useDeleteThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThreadMutation, { data, loading, error }] = useDeleteThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useDeleteThreadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThreadMutation, DeleteThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThreadMutation, DeleteThreadMutationVariables>(DeleteThreadDocument, options);
      }
export type DeleteThreadMutationHookResult = ReturnType<typeof useDeleteThreadMutation>;
export type DeleteThreadMutationResult = Apollo.MutationResult<DeleteThreadMutation>;
export type DeleteThreadMutationOptions = Apollo.BaseMutationOptions<DeleteThreadMutation, DeleteThreadMutationVariables>;
export const DownloadWorkAttachmentsDocument = gql`
    mutation DownloadWorkAttachments($answerBlockId: ID!, $blockAttachmentIds: [ID!]!) {
  downloadWorkAttachments(
    answerBlockId: $answerBlockId
    blockAttachmentIds: $blockAttachmentIds
  )
}
    `;
export type DownloadWorkAttachmentsMutationFn = Apollo.MutationFunction<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>;

/**
 * __useDownloadWorkAttachmentsMutation__
 *
 * To run a mutation, you first call `useDownloadWorkAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadWorkAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadWorkAttachmentsMutation, { data, loading, error }] = useDownloadWorkAttachmentsMutation({
 *   variables: {
 *      answerBlockId: // value for 'answerBlockId'
 *      blockAttachmentIds: // value for 'blockAttachmentIds'
 *   },
 * });
 */
export function useDownloadWorkAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>(DownloadWorkAttachmentsDocument, options);
      }
export type DownloadWorkAttachmentsMutationHookResult = ReturnType<typeof useDownloadWorkAttachmentsMutation>;
export type DownloadWorkAttachmentsMutationResult = Apollo.MutationResult<DownloadWorkAttachmentsMutation>;
export type DownloadWorkAttachmentsMutationOptions = Apollo.BaseMutationOptions<DownloadWorkAttachmentsMutation, DownloadWorkAttachmentsMutationVariables>;
export const EditCommentDocument = gql`
    mutation EditComment($commentId: ID!, $content: String!) {
  editComment(commentId: $commentId, content: $content) {
    id
    content
    updatedAt
    createdBy {
      id
      name
      colourset
    }
  }
}
    `;
export type EditCommentMutationFn = Apollo.MutationFunction<EditCommentMutation, EditCommentMutationVariables>;

/**
 * __useEditCommentMutation__
 *
 * To run a mutation, you first call `useEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCommentMutation, { data, loading, error }] = useEditCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useEditCommentMutation(baseOptions?: Apollo.MutationHookOptions<EditCommentMutation, EditCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCommentMutation, EditCommentMutationVariables>(EditCommentDocument, options);
      }
export type EditCommentMutationHookResult = ReturnType<typeof useEditCommentMutation>;
export type EditCommentMutationResult = Apollo.MutationResult<EditCommentMutation>;
export type EditCommentMutationOptions = Apollo.BaseMutationOptions<EditCommentMutation, EditCommentMutationVariables>;
export const EditThreadTitleDocument = gql`
    mutation EditThreadTitle($threadId: ID!, $title: String!) {
  editThreadTitle(threadId: $threadId, title: $title) {
    id
    title
  }
}
    `;
export type EditThreadTitleMutationFn = Apollo.MutationFunction<EditThreadTitleMutation, EditThreadTitleMutationVariables>;

/**
 * __useEditThreadTitleMutation__
 *
 * To run a mutation, you first call `useEditThreadTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditThreadTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editThreadTitleMutation, { data, loading, error }] = useEditThreadTitleMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useEditThreadTitleMutation(baseOptions?: Apollo.MutationHookOptions<EditThreadTitleMutation, EditThreadTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditThreadTitleMutation, EditThreadTitleMutationVariables>(EditThreadTitleDocument, options);
      }
export type EditThreadTitleMutationHookResult = ReturnType<typeof useEditThreadTitleMutation>;
export type EditThreadTitleMutationResult = Apollo.MutationResult<EditThreadTitleMutation>;
export type EditThreadTitleMutationOptions = Apollo.BaseMutationOptions<EditThreadTitleMutation, EditThreadTitleMutationVariables>;
export const EntityThreadsDocument = gql`
    query EntityThreads($entityType: EntityType!, $entityIds: [ID!]!) {
  entityThreads(entityType: $entityType, entityIds: $entityIds) {
    ...Thread
  }
}
    ${ThreadFragmentDoc}`;

/**
 * __useEntityThreadsQuery__
 *
 * To run a query within a React component, call `useEntityThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityThreadsQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useEntityThreadsQuery(baseOptions: Apollo.QueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables> & ({ variables: EntityThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
      }
export function useEntityThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
        }
export function useEntityThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityThreadsQuery, EntityThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityThreadsQuery, EntityThreadsQueryVariables>(EntityThreadsDocument, options);
        }
export type EntityThreadsQueryHookResult = ReturnType<typeof useEntityThreadsQuery>;
export type EntityThreadsLazyQueryHookResult = ReturnType<typeof useEntityThreadsLazyQuery>;
export type EntityThreadsSuspenseQueryHookResult = ReturnType<typeof useEntityThreadsSuspenseQuery>;
export type EntityThreadsQueryResult = Apollo.QueryResult<EntityThreadsQuery, EntityThreadsQueryVariables>;
export const OnEntityThreadsUpdatedDocument = gql`
    subscription onEntityThreadsUpdated($entityId: ID!, $entityType: EntityType!) {
  entityThreadsUpdated(entityId: $entityId, entityType: $entityType) {
    ...EntityThreadEvent
  }
}
    ${EntityThreadEventFragmentDoc}`;

/**
 * __useOnEntityThreadsUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnEntityThreadsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEntityThreadsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEntityThreadsUpdatedSubscription({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useOnEntityThreadsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnEntityThreadsUpdatedSubscription, OnEntityThreadsUpdatedSubscriptionVariables> & ({ variables: OnEntityThreadsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnEntityThreadsUpdatedSubscription, OnEntityThreadsUpdatedSubscriptionVariables>(OnEntityThreadsUpdatedDocument, options);
      }
export type OnEntityThreadsUpdatedSubscriptionHookResult = ReturnType<typeof useOnEntityThreadsUpdatedSubscription>;
export type OnEntityThreadsUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnEntityThreadsUpdatedSubscription>;
export const ExtendedRubricDocument = gql`
    query ExtendedRubric($assessmentId: ID!, $status: MarkerRubricStatus!, $markerRubricId: ID!) {
  extendedRubric(
    assessmentId: $assessmentId
    status: $status
    markerRubricId: $markerRubricId
  ) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __useExtendedRubricQuery__
 *
 * To run a query within a React component, call `useExtendedRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtendedRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtendedRubricQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      status: // value for 'status'
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function useExtendedRubricQuery(baseOptions: Apollo.QueryHookOptions<ExtendedRubricQuery, ExtendedRubricQueryVariables> & ({ variables: ExtendedRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtendedRubricQuery, ExtendedRubricQueryVariables>(ExtendedRubricDocument, options);
      }
export function useExtendedRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtendedRubricQuery, ExtendedRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtendedRubricQuery, ExtendedRubricQueryVariables>(ExtendedRubricDocument, options);
        }
export function useExtendedRubricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtendedRubricQuery, ExtendedRubricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtendedRubricQuery, ExtendedRubricQueryVariables>(ExtendedRubricDocument, options);
        }
export type ExtendedRubricQueryHookResult = ReturnType<typeof useExtendedRubricQuery>;
export type ExtendedRubricLazyQueryHookResult = ReturnType<typeof useExtendedRubricLazyQuery>;
export type ExtendedRubricSuspenseQueryHookResult = ReturnType<typeof useExtendedRubricSuspenseQuery>;
export type ExtendedRubricQueryResult = Apollo.QueryResult<ExtendedRubricQuery, ExtendedRubricQueryVariables>;
export const GraderRouteDocument = gql`
    query GraderRoute($assessmentId: ID!) {
  token
  me {
    id
  }
  workOutcomes(assessmentId: $assessmentId) {
    id
    workId
    groupId
    studentId
    maxScore
    scoreBreakdown {
      ...ScoreBreakdown
    }
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  individualSheet: instructionSheet(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...MarkingSheet
  }
  rubric(assessmentId: $assessmentId) {
    id
    questions {
      ...QuestionRubric
    }
  }
  class(assessmentId: $assessmentId) {
    students {
      ...Enrollment
    }
    groupType
    groups {
      ...Group
    }
  }
}
    ${ScoreBreakdownFragmentDoc}
${AssessmentFragmentDoc}
${MarkingSheetFragmentDoc}
${QuestionRubricFragmentDoc}
${EnrollmentFragmentDoc}
${GroupFragmentDoc}`;

/**
 * __useGraderRouteQuery__
 *
 * To run a query within a React component, call `useGraderRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGraderRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGraderRouteQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGraderRouteQuery(baseOptions: Apollo.QueryHookOptions<GraderRouteQuery, GraderRouteQueryVariables> & ({ variables: GraderRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraderRouteQuery, GraderRouteQueryVariables>(GraderRouteDocument, options);
      }
export function useGraderRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraderRouteQuery, GraderRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraderRouteQuery, GraderRouteQueryVariables>(GraderRouteDocument, options);
        }
export function useGraderRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraderRouteQuery, GraderRouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraderRouteQuery, GraderRouteQueryVariables>(GraderRouteDocument, options);
        }
export type GraderRouteQueryHookResult = ReturnType<typeof useGraderRouteQuery>;
export type GraderRouteLazyQueryHookResult = ReturnType<typeof useGraderRouteLazyQuery>;
export type GraderRouteSuspenseQueryHookResult = ReturnType<typeof useGraderRouteSuspenseQuery>;
export type GraderRouteQueryResult = Apollo.QueryResult<GraderRouteQuery, GraderRouteQueryVariables>;
export const GroupPeerOutcomesDocument = gql`
    query GroupPeerOutcomes($assessmentId: ID!, $groupId: ID!) {
  groupPeerOutcomes(assessmentId: $assessmentId, groupId: $groupId) {
    ...PeerOutcome
  }
}
    ${PeerOutcomeFragmentDoc}`;

/**
 * __useGroupPeerOutcomesQuery__
 *
 * To run a query within a React component, call `useGroupPeerOutcomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPeerOutcomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPeerOutcomesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupPeerOutcomesQuery(baseOptions: Apollo.QueryHookOptions<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables> & ({ variables: GroupPeerOutcomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>(GroupPeerOutcomesDocument, options);
      }
export function useGroupPeerOutcomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>(GroupPeerOutcomesDocument, options);
        }
export function useGroupPeerOutcomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>(GroupPeerOutcomesDocument, options);
        }
export type GroupPeerOutcomesQueryHookResult = ReturnType<typeof useGroupPeerOutcomesQuery>;
export type GroupPeerOutcomesLazyQueryHookResult = ReturnType<typeof useGroupPeerOutcomesLazyQuery>;
export type GroupPeerOutcomesSuspenseQueryHookResult = ReturnType<typeof useGroupPeerOutcomesSuspenseQuery>;
export type GroupPeerOutcomesQueryResult = Apollo.QueryResult<GroupPeerOutcomesQuery, GroupPeerOutcomesQueryVariables>;
export const LinkCommentThreadDocument = gql`
    mutation LinkCommentThread($assessmentId: ID!, $threadId: ID!, $criterionId: Int!) {
  linkCommentThread(
    assessmentId: $assessmentId
    threadId: $threadId
    criterionId: $criterionId
  ) {
    id
    title
    entityType
    entityId
    criterionId
    createdBy {
      id
    }
    metadata {
      charterSectionType
      charterEditorId
    }
    comments {
      id
      content
      updatedAt
      createdBy {
        id
        name
        colourset
      }
    }
  }
}
    `;
export type LinkCommentThreadMutationFn = Apollo.MutationFunction<LinkCommentThreadMutation, LinkCommentThreadMutationVariables>;

/**
 * __useLinkCommentThreadMutation__
 *
 * To run a mutation, you first call `useLinkCommentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCommentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCommentThreadMutation, { data, loading, error }] = useLinkCommentThreadMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      threadId: // value for 'threadId'
 *      criterionId: // value for 'criterionId'
 *   },
 * });
 */
export function useLinkCommentThreadMutation(baseOptions?: Apollo.MutationHookOptions<LinkCommentThreadMutation, LinkCommentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkCommentThreadMutation, LinkCommentThreadMutationVariables>(LinkCommentThreadDocument, options);
      }
export type LinkCommentThreadMutationHookResult = ReturnType<typeof useLinkCommentThreadMutation>;
export type LinkCommentThreadMutationResult = Apollo.MutationResult<LinkCommentThreadMutation>;
export type LinkCommentThreadMutationOptions = Apollo.BaseMutationOptions<LinkCommentThreadMutation, LinkCommentThreadMutationVariables>;
export const MarkFieldOutcomeDocument = gql`
    mutation MarkFieldOutcome($assessmentId: ID!, $input: MarkFieldOutcomeInput!) {
  markFieldOutcome(assessmentId: $assessmentId, input: $input) {
    fieldOutcome {
      id
      score
      markerScore
      rubricOutcome {
        criterionOutcomes {
          ...CriterionOutcome
        }
        score
      }
    }
    questionOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
    workOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
  }
}
    ${CriterionOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type MarkFieldOutcomeMutationFn = Apollo.MutationFunction<MarkFieldOutcomeMutation, MarkFieldOutcomeMutationVariables>;

/**
 * __useMarkFieldOutcomeMutation__
 *
 * To run a mutation, you first call `useMarkFieldOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFieldOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFieldOutcomeMutation, { data, loading, error }] = useMarkFieldOutcomeMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkFieldOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<MarkFieldOutcomeMutation, MarkFieldOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFieldOutcomeMutation, MarkFieldOutcomeMutationVariables>(MarkFieldOutcomeDocument, options);
      }
export type MarkFieldOutcomeMutationHookResult = ReturnType<typeof useMarkFieldOutcomeMutation>;
export type MarkFieldOutcomeMutationResult = Apollo.MutationResult<MarkFieldOutcomeMutation>;
export type MarkFieldOutcomeMutationOptions = Apollo.BaseMutationOptions<MarkFieldOutcomeMutation, MarkFieldOutcomeMutationVariables>;
export const MfaMarkingDocument = gql`
    query MfaMarking($assessmentId: ID!, $studentId: ID!) {
  studentWorkOutcome(assessmentId: $assessmentId, studentId: $studentId) {
    ...WorkOutcome
  }
}
    ${WorkOutcomeFragmentDoc}`;

/**
 * __useMfaMarkingQuery__
 *
 * To run a query within a React component, call `useMfaMarkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfaMarkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfaMarkingQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useMfaMarkingQuery(baseOptions: Apollo.QueryHookOptions<MfaMarkingQuery, MfaMarkingQueryVariables> & ({ variables: MfaMarkingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfaMarkingQuery, MfaMarkingQueryVariables>(MfaMarkingDocument, options);
      }
export function useMfaMarkingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MfaMarkingQuery, MfaMarkingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfaMarkingQuery, MfaMarkingQueryVariables>(MfaMarkingDocument, options);
        }
export function useMfaMarkingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MfaMarkingQuery, MfaMarkingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MfaMarkingQuery, MfaMarkingQueryVariables>(MfaMarkingDocument, options);
        }
export type MfaMarkingQueryHookResult = ReturnType<typeof useMfaMarkingQuery>;
export type MfaMarkingLazyQueryHookResult = ReturnType<typeof useMfaMarkingLazyQuery>;
export type MfaMarkingSuspenseQueryHookResult = ReturnType<typeof useMfaMarkingSuspenseQuery>;
export type MfaMarkingQueryResult = Apollo.QueryResult<MfaMarkingQuery, MfaMarkingQueryVariables>;
export const MarkRouteDocument = gql`
    query MarkRoute($assessmentId: ID!) {
  token
  me {
    id
    email
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  class(assessmentId: $assessmentId) {
    groupType
    groups {
      ...Group
    }
    students {
      ...Enrollment
    }
  }
  workOutcomes(assessmentId: $assessmentId) {
    ...WorkOutcomeScore
  }
  individualSheet: instructionSheet(assessmentId: $assessmentId, kind: INDIVIDUAL) {
    ...MarkingSheet
  }
  groupSheet: instructionSheet(assessmentId: $assessmentId, kind: GROUP) {
    ...MarkingSheet
  }
  rubric(assessmentId: $assessmentId) {
    id
    questions {
      ...QuestionRubric
    }
  }
}
    ${AssessmentFragmentDoc}
${GroupFragmentDoc}
${EnrollmentFragmentDoc}
${WorkOutcomeScoreFragmentDoc}
${MarkingSheetFragmentDoc}
${QuestionRubricFragmentDoc}`;

/**
 * __useMarkRouteQuery__
 *
 * To run a query within a React component, call `useMarkRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkRouteQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useMarkRouteQuery(baseOptions: Apollo.QueryHookOptions<MarkRouteQuery, MarkRouteQueryVariables> & ({ variables: MarkRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkRouteQuery, MarkRouteQueryVariables>(MarkRouteDocument, options);
      }
export function useMarkRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkRouteQuery, MarkRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkRouteQuery, MarkRouteQueryVariables>(MarkRouteDocument, options);
        }
export function useMarkRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarkRouteQuery, MarkRouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarkRouteQuery, MarkRouteQueryVariables>(MarkRouteDocument, options);
        }
export type MarkRouteQueryHookResult = ReturnType<typeof useMarkRouteQuery>;
export type MarkRouteLazyQueryHookResult = ReturnType<typeof useMarkRouteLazyQuery>;
export type MarkRouteSuspenseQueryHookResult = ReturnType<typeof useMarkRouteSuspenseQuery>;
export type MarkRouteQueryResult = Apollo.QueryResult<MarkRouteQuery, MarkRouteQueryVariables>;
export const MarkSubmissionOutcomeDocument = gql`
    mutation MarkSubmissionOutcome($assessmentId: ID!, $input: MarkSubmissionOutcomeInput!) {
  markSubmissionOutcome(assessmentId: $assessmentId, input: $input) {
    submissionOutcome {
      id
      score
      rubricOutcome {
        criterionOutcomes {
          ...CriterionOutcome
        }
        score
      }
    }
    workOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
  }
}
    ${CriterionOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type MarkSubmissionOutcomeMutationFn = Apollo.MutationFunction<MarkSubmissionOutcomeMutation, MarkSubmissionOutcomeMutationVariables>;

/**
 * __useMarkSubmissionOutcomeMutation__
 *
 * To run a mutation, you first call `useMarkSubmissionOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSubmissionOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSubmissionOutcomeMutation, { data, loading, error }] = useMarkSubmissionOutcomeMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkSubmissionOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<MarkSubmissionOutcomeMutation, MarkSubmissionOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSubmissionOutcomeMutation, MarkSubmissionOutcomeMutationVariables>(MarkSubmissionOutcomeDocument, options);
      }
export type MarkSubmissionOutcomeMutationHookResult = ReturnType<typeof useMarkSubmissionOutcomeMutation>;
export type MarkSubmissionOutcomeMutationResult = Apollo.MutationResult<MarkSubmissionOutcomeMutation>;
export type MarkSubmissionOutcomeMutationOptions = Apollo.BaseMutationOptions<MarkSubmissionOutcomeMutation, MarkSubmissionOutcomeMutationVariables>;
export const MarkerRubricDocument = gql`
    query MarkerRubric($assessmentId: ID!, $kind: MarkerRubricKind!, $status: MarkerRubricStatus!) {
  markerRubric(assessmentId: $assessmentId, kind: $kind, status: $status) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __useMarkerRubricQuery__
 *
 * To run a query within a React component, call `useMarkerRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkerRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkerRubricQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      kind: // value for 'kind'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMarkerRubricQuery(baseOptions: Apollo.QueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables> & ({ variables: MarkerRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
      }
export function useMarkerRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
        }
export function useMarkerRubricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarkerRubricQuery, MarkerRubricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarkerRubricQuery, MarkerRubricQueryVariables>(MarkerRubricDocument, options);
        }
export type MarkerRubricQueryHookResult = ReturnType<typeof useMarkerRubricQuery>;
export type MarkerRubricLazyQueryHookResult = ReturnType<typeof useMarkerRubricLazyQuery>;
export type MarkerRubricSuspenseQueryHookResult = ReturnType<typeof useMarkerRubricSuspenseQuery>;
export type MarkerRubricQueryResult = Apollo.QueryResult<MarkerRubricQuery, MarkerRubricQueryVariables>;
export const MarkerRubricRouteDocument = gql`
    query MarkerRubricRoute($assessmentId: ID!, $kind: MarkerRubricKind!) {
  draftMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: $kind
    status: DRAFT
  ) {
    ...MarkerRubric
  }
  publishedMarkerRubric: markerRubric(
    assessmentId: $assessmentId
    kind: $kind
    status: PUBLISHED
  ) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __useMarkerRubricRouteQuery__
 *
 * To run a query within a React component, call `useMarkerRubricRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkerRubricRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkerRubricRouteQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useMarkerRubricRouteQuery(baseOptions: Apollo.QueryHookOptions<MarkerRubricRouteQuery, MarkerRubricRouteQueryVariables> & ({ variables: MarkerRubricRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkerRubricRouteQuery, MarkerRubricRouteQueryVariables>(MarkerRubricRouteDocument, options);
      }
export function useMarkerRubricRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkerRubricRouteQuery, MarkerRubricRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkerRubricRouteQuery, MarkerRubricRouteQueryVariables>(MarkerRubricRouteDocument, options);
        }
export function useMarkerRubricRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarkerRubricRouteQuery, MarkerRubricRouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarkerRubricRouteQuery, MarkerRubricRouteQueryVariables>(MarkerRubricRouteDocument, options);
        }
export type MarkerRubricRouteQueryHookResult = ReturnType<typeof useMarkerRubricRouteQuery>;
export type MarkerRubricRouteLazyQueryHookResult = ReturnType<typeof useMarkerRubricRouteLazyQuery>;
export type MarkerRubricRouteSuspenseQueryHookResult = ReturnType<typeof useMarkerRubricRouteSuspenseQuery>;
export type MarkerRubricRouteQueryResult = Apollo.QueryResult<MarkerRubricRouteQuery, MarkerRubricRouteQueryVariables>;
export const ExtendedRubricRouteDocument = gql`
    query ExtendedRubricRoute($assessmentId: ID!, $markerRubricId: ID!) {
  draftExtendedRubric: extendedRubric(
    assessmentId: $assessmentId
    status: DRAFT
    markerRubricId: $markerRubricId
  ) {
    ...MarkerRubric
  }
  publishedExtendedRubric: extendedRubric(
    assessmentId: $assessmentId
    status: PUBLISHED
    markerRubricId: $markerRubricId
  ) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;

/**
 * __useExtendedRubricRouteQuery__
 *
 * To run a query within a React component, call `useExtendedRubricRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtendedRubricRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtendedRubricRouteQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function useExtendedRubricRouteQuery(baseOptions: Apollo.QueryHookOptions<ExtendedRubricRouteQuery, ExtendedRubricRouteQueryVariables> & ({ variables: ExtendedRubricRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtendedRubricRouteQuery, ExtendedRubricRouteQueryVariables>(ExtendedRubricRouteDocument, options);
      }
export function useExtendedRubricRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtendedRubricRouteQuery, ExtendedRubricRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtendedRubricRouteQuery, ExtendedRubricRouteQueryVariables>(ExtendedRubricRouteDocument, options);
        }
export function useExtendedRubricRouteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtendedRubricRouteQuery, ExtendedRubricRouteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtendedRubricRouteQuery, ExtendedRubricRouteQueryVariables>(ExtendedRubricRouteDocument, options);
        }
export type ExtendedRubricRouteQueryHookResult = ReturnType<typeof useExtendedRubricRouteQuery>;
export type ExtendedRubricRouteLazyQueryHookResult = ReturnType<typeof useExtendedRubricRouteLazyQuery>;
export type ExtendedRubricRouteSuspenseQueryHookResult = ReturnType<typeof useExtendedRubricRouteSuspenseQuery>;
export type ExtendedRubricRouteQueryResult = Apollo.QueryResult<ExtendedRubricRouteQuery, ExtendedRubricRouteQueryVariables>;
export const ModerationDocument = gql`
    query Moderation($assessmentId: ID!) {
  token
  me {
    id
  }
  classWorkGroups(assessmentId: $assessmentId) {
    ...WorkGroup
  }
  feedbackReleaseRules(assessmentId: $assessmentId) {
    ...FeedbackReleaseRule
  }
  moderationPenaltyRules(assessmentId: $assessmentId) {
    ...ModerationPenaltyRule
  }
  finalFeedbackVisibility: feedbackVisibilityForType(
    assessmentId: $assessmentId
    releaseType: FINAL
  ) {
    ...FeedbackVisibility
  }
  provisionalFeedbackVisibility: feedbackVisibilityForType(
    assessmentId: $assessmentId
    releaseType: PROVISIONAL
  ) {
    ...FeedbackVisibility
  }
  studentOutcomes(assessmentId: $assessmentId) {
    ...StudentOutcome
  }
  peerRubric(assessmentId: $assessmentId) {
    ...MarkerRubric
  }
}
    ${WorkGroupFragmentDoc}
${FeedbackReleaseRuleFragmentDoc}
${ModerationPenaltyRuleFragmentDoc}
${FeedbackVisibilityFragmentDoc}
${StudentOutcomeFragmentDoc}
${MarkerRubricFragmentDoc}`;

/**
 * __useModerationQuery__
 *
 * To run a query within a React component, call `useModerationQuery` and pass it any options that fit your needs.
 * When your component renders, `useModerationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModerationQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useModerationQuery(baseOptions: Apollo.QueryHookOptions<ModerationQuery, ModerationQueryVariables> & ({ variables: ModerationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModerationQuery, ModerationQueryVariables>(ModerationDocument, options);
      }
export function useModerationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModerationQuery, ModerationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModerationQuery, ModerationQueryVariables>(ModerationDocument, options);
        }
export function useModerationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModerationQuery, ModerationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModerationQuery, ModerationQueryVariables>(ModerationDocument, options);
        }
export type ModerationQueryHookResult = ReturnType<typeof useModerationQuery>;
export type ModerationLazyQueryHookResult = ReturnType<typeof useModerationLazyQuery>;
export type ModerationSuspenseQueryHookResult = ReturnType<typeof useModerationSuspenseQuery>;
export type ModerationQueryResult = Apollo.QueryResult<ModerationQuery, ModerationQueryVariables>;
export const ModeratorUpdateFieldRubricResponseDocument = gql`
    mutation ModeratorUpdateFieldRubricResponse($assessmentId: ID!, $input: UpdateFieldRubricInput!) {
  updateFieldRubricResponse(assessmentId: $assessmentId, input: $input) {
    fieldRubric {
      ...FieldRubric
      ...FieldRubricResponse
    }
    questionRubric {
      id
      counts {
        ...QuestionResponseCounts
      }
    }
    questionOutcomes {
      ...QuestionOutcomeScore
    }
    fieldOutcomes {
      ...FieldOutcomeScore
    }
    workOutcomes {
      ...WorkOutcomeScore
    }
  }
}
    ${FieldRubricFragmentDoc}
${FieldRubricResponseFragmentDoc}
${QuestionResponseCountsFragmentDoc}
${QuestionOutcomeScoreFragmentDoc}
${FieldOutcomeScoreFragmentDoc}
${WorkOutcomeScoreFragmentDoc}`;
export type ModeratorUpdateFieldRubricResponseMutationFn = Apollo.MutationFunction<ModeratorUpdateFieldRubricResponseMutation, ModeratorUpdateFieldRubricResponseMutationVariables>;

/**
 * __useModeratorUpdateFieldRubricResponseMutation__
 *
 * To run a mutation, you first call `useModeratorUpdateFieldRubricResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModeratorUpdateFieldRubricResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderatorUpdateFieldRubricResponseMutation, { data, loading, error }] = useModeratorUpdateFieldRubricResponseMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModeratorUpdateFieldRubricResponseMutation(baseOptions?: Apollo.MutationHookOptions<ModeratorUpdateFieldRubricResponseMutation, ModeratorUpdateFieldRubricResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModeratorUpdateFieldRubricResponseMutation, ModeratorUpdateFieldRubricResponseMutationVariables>(ModeratorUpdateFieldRubricResponseDocument, options);
      }
export type ModeratorUpdateFieldRubricResponseMutationHookResult = ReturnType<typeof useModeratorUpdateFieldRubricResponseMutation>;
export type ModeratorUpdateFieldRubricResponseMutationResult = Apollo.MutationResult<ModeratorUpdateFieldRubricResponseMutation>;
export type ModeratorUpdateFieldRubricResponseMutationOptions = Apollo.BaseMutationOptions<ModeratorUpdateFieldRubricResponseMutation, ModeratorUpdateFieldRubricResponseMutationVariables>;
export const PastMarkerRubricsDocument = gql`
    query PastMarkerRubrics($assessmentId: ID!) {
  pastMarkerRubrics(assessmentId: $assessmentId) {
    ...PastMarkerRubric
  }
}
    ${PastMarkerRubricFragmentDoc}`;

/**
 * __usePastMarkerRubricsQuery__
 *
 * To run a query within a React component, call `usePastMarkerRubricsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastMarkerRubricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastMarkerRubricsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function usePastMarkerRubricsQuery(baseOptions: Apollo.QueryHookOptions<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables> & ({ variables: PastMarkerRubricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>(PastMarkerRubricsDocument, options);
      }
export function usePastMarkerRubricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>(PastMarkerRubricsDocument, options);
        }
export function usePastMarkerRubricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>(PastMarkerRubricsDocument, options);
        }
export type PastMarkerRubricsQueryHookResult = ReturnType<typeof usePastMarkerRubricsQuery>;
export type PastMarkerRubricsLazyQueryHookResult = ReturnType<typeof usePastMarkerRubricsLazyQuery>;
export type PastMarkerRubricsSuspenseQueryHookResult = ReturnType<typeof usePastMarkerRubricsSuspenseQuery>;
export type PastMarkerRubricsQueryResult = Apollo.QueryResult<PastMarkerRubricsQuery, PastMarkerRubricsQueryVariables>;
export const PublishMarkerRubricDocument = gql`
    mutation PublishMarkerRubric($markerRubricId: ID!) {
  publishMarkerRubric(markerRubricId: $markerRubricId) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;
export type PublishMarkerRubricMutationFn = Apollo.MutationFunction<PublishMarkerRubricMutation, PublishMarkerRubricMutationVariables>;

/**
 * __usePublishMarkerRubricMutation__
 *
 * To run a mutation, you first call `usePublishMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMarkerRubricMutation, { data, loading, error }] = usePublishMarkerRubricMutation({
 *   variables: {
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function usePublishMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<PublishMarkerRubricMutation, PublishMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishMarkerRubricMutation, PublishMarkerRubricMutationVariables>(PublishMarkerRubricDocument, options);
      }
export type PublishMarkerRubricMutationHookResult = ReturnType<typeof usePublishMarkerRubricMutation>;
export type PublishMarkerRubricMutationResult = Apollo.MutationResult<PublishMarkerRubricMutation>;
export type PublishMarkerRubricMutationOptions = Apollo.BaseMutationOptions<PublishMarkerRubricMutation, PublishMarkerRubricMutationVariables>;
export const QuestionRubricDocument = gql`
    query QuestionRubric($questionRubricId: ID!) {
  questionRubric(questionRubricId: $questionRubricId) {
    fieldRubrics {
      ...FieldRubricResponse
    }
  }
}
    ${FieldRubricResponseFragmentDoc}`;

/**
 * __useQuestionRubricQuery__
 *
 * To run a query within a React component, call `useQuestionRubricQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionRubricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionRubricQuery({
 *   variables: {
 *      questionRubricId: // value for 'questionRubricId'
 *   },
 * });
 */
export function useQuestionRubricQuery(baseOptions: Apollo.QueryHookOptions<QuestionRubricQuery, QuestionRubricQueryVariables> & ({ variables: QuestionRubricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionRubricQuery, QuestionRubricQueryVariables>(QuestionRubricDocument, options);
      }
export function useQuestionRubricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionRubricQuery, QuestionRubricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionRubricQuery, QuestionRubricQueryVariables>(QuestionRubricDocument, options);
        }
export function useQuestionRubricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionRubricQuery, QuestionRubricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionRubricQuery, QuestionRubricQueryVariables>(QuestionRubricDocument, options);
        }
export type QuestionRubricQueryHookResult = ReturnType<typeof useQuestionRubricQuery>;
export type QuestionRubricLazyQueryHookResult = ReturnType<typeof useQuestionRubricLazyQuery>;
export type QuestionRubricSuspenseQueryHookResult = ReturnType<typeof useQuestionRubricSuspenseQuery>;
export type QuestionRubricQueryResult = Apollo.QueryResult<QuestionRubricQuery, QuestionRubricQueryVariables>;
export const ReleaseFeedbackForEveryoneDocument = gql`
    mutation ReleaseFeedbackForEveryone($assessmentId: ID!, $feedbackVisibility: FeedbackVisibilityInput, $releaseType: FeedbackReleaseType) {
  releaseFeedbackForEveryone(
    assessmentId: $assessmentId
    feedbackVisibility: $feedbackVisibility
    releaseType: $releaseType
  ) {
    feedbackReleaseRules {
      ...FeedbackReleaseRule
    }
    studentOutcomes {
      ...StudentOutcome
    }
  }
}
    ${FeedbackReleaseRuleFragmentDoc}
${StudentOutcomeFragmentDoc}`;
export type ReleaseFeedbackForEveryoneMutationFn = Apollo.MutationFunction<ReleaseFeedbackForEveryoneMutation, ReleaseFeedbackForEveryoneMutationVariables>;

/**
 * __useReleaseFeedbackForEveryoneMutation__
 *
 * To run a mutation, you first call `useReleaseFeedbackForEveryoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseFeedbackForEveryoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseFeedbackForEveryoneMutation, { data, loading, error }] = useReleaseFeedbackForEveryoneMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      feedbackVisibility: // value for 'feedbackVisibility'
 *      releaseType: // value for 'releaseType'
 *   },
 * });
 */
export function useReleaseFeedbackForEveryoneMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseFeedbackForEveryoneMutation, ReleaseFeedbackForEveryoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseFeedbackForEveryoneMutation, ReleaseFeedbackForEveryoneMutationVariables>(ReleaseFeedbackForEveryoneDocument, options);
      }
export type ReleaseFeedbackForEveryoneMutationHookResult = ReturnType<typeof useReleaseFeedbackForEveryoneMutation>;
export type ReleaseFeedbackForEveryoneMutationResult = Apollo.MutationResult<ReleaseFeedbackForEveryoneMutation>;
export type ReleaseFeedbackForEveryoneMutationOptions = Apollo.BaseMutationOptions<ReleaseFeedbackForEveryoneMutation, ReleaseFeedbackForEveryoneMutationVariables>;
export const RemoveMarkerRubricDocument = gql`
    mutation RemoveMarkerRubric($markerRubricId: ID!) {
  removeMarkerRubric(markerRubricId: $markerRubricId) {
    id
  }
}
    `;
export type RemoveMarkerRubricMutationFn = Apollo.MutationFunction<RemoveMarkerRubricMutation, RemoveMarkerRubricMutationVariables>;

/**
 * __useRemoveMarkerRubricMutation__
 *
 * To run a mutation, you first call `useRemoveMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarkerRubricMutation, { data, loading, error }] = useRemoveMarkerRubricMutation({
 *   variables: {
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function useRemoveMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarkerRubricMutation, RemoveMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMarkerRubricMutation, RemoveMarkerRubricMutationVariables>(RemoveMarkerRubricDocument, options);
      }
export type RemoveMarkerRubricMutationHookResult = ReturnType<typeof useRemoveMarkerRubricMutation>;
export type RemoveMarkerRubricMutationResult = Apollo.MutationResult<RemoveMarkerRubricMutation>;
export type RemoveMarkerRubricMutationOptions = Apollo.BaseMutationOptions<RemoveMarkerRubricMutation, RemoveMarkerRubricMutationVariables>;
export const RemoveMarkerRubricOutcomesDocument = gql`
    mutation RemoveMarkerRubricOutcomes($markerRubricId: ID!) {
  removeMarkerRubricOutcomes(markerRubricId: $markerRubricId) {
    outcomesDeleted
  }
}
    `;
export type RemoveMarkerRubricOutcomesMutationFn = Apollo.MutationFunction<RemoveMarkerRubricOutcomesMutation, RemoveMarkerRubricOutcomesMutationVariables>;

/**
 * __useRemoveMarkerRubricOutcomesMutation__
 *
 * To run a mutation, you first call `useRemoveMarkerRubricOutcomesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarkerRubricOutcomesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarkerRubricOutcomesMutation, { data, loading, error }] = useRemoveMarkerRubricOutcomesMutation({
 *   variables: {
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function useRemoveMarkerRubricOutcomesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarkerRubricOutcomesMutation, RemoveMarkerRubricOutcomesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMarkerRubricOutcomesMutation, RemoveMarkerRubricOutcomesMutationVariables>(RemoveMarkerRubricOutcomesDocument, options);
      }
export type RemoveMarkerRubricOutcomesMutationHookResult = ReturnType<typeof useRemoveMarkerRubricOutcomesMutation>;
export type RemoveMarkerRubricOutcomesMutationResult = Apollo.MutationResult<RemoveMarkerRubricOutcomesMutation>;
export type RemoveMarkerRubricOutcomesMutationOptions = Apollo.BaseMutationOptions<RemoveMarkerRubricOutcomesMutation, RemoveMarkerRubricOutcomesMutationVariables>;
export const ResetFeedbackReleaseRuleDocument = gql`
    mutation ResetFeedbackReleaseRule($assessmentId: ID!, $releaseType: FeedbackReleaseType) {
  resetFeedbackReleaseRules(
    assessmentId: $assessmentId
    releaseType: $releaseType
  ) {
    ...FeedbackReleaseRule
  }
}
    ${FeedbackReleaseRuleFragmentDoc}`;
export type ResetFeedbackReleaseRuleMutationFn = Apollo.MutationFunction<ResetFeedbackReleaseRuleMutation, ResetFeedbackReleaseRuleMutationVariables>;

/**
 * __useResetFeedbackReleaseRuleMutation__
 *
 * To run a mutation, you first call `useResetFeedbackReleaseRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetFeedbackReleaseRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetFeedbackReleaseRuleMutation, { data, loading, error }] = useResetFeedbackReleaseRuleMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      releaseType: // value for 'releaseType'
 *   },
 * });
 */
export function useResetFeedbackReleaseRuleMutation(baseOptions?: Apollo.MutationHookOptions<ResetFeedbackReleaseRuleMutation, ResetFeedbackReleaseRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetFeedbackReleaseRuleMutation, ResetFeedbackReleaseRuleMutationVariables>(ResetFeedbackReleaseRuleDocument, options);
      }
export type ResetFeedbackReleaseRuleMutationHookResult = ReturnType<typeof useResetFeedbackReleaseRuleMutation>;
export type ResetFeedbackReleaseRuleMutationResult = Apollo.MutationResult<ResetFeedbackReleaseRuleMutation>;
export type ResetFeedbackReleaseRuleMutationOptions = Apollo.BaseMutationOptions<ResetFeedbackReleaseRuleMutation, ResetFeedbackReleaseRuleMutationVariables>;
export const ResetQuestionModerationChangesDocument = gql`
    mutation ResetQuestionModerationChanges($assessmentId: ID!) {
  resetQuestionModerationChanges(assessmentId: $assessmentId) {
    fieldRubrics {
      ...FieldRubric
      ...FieldRubricResponse
    }
    studentOutcomes {
      ...StudentOutcome
    }
    questionOutcomes {
      ...QuestionOutcomeScore
    }
    questionRubrics {
      id
      counts {
        ...QuestionResponseCounts
      }
    }
  }
}
    ${FieldRubricFragmentDoc}
${FieldRubricResponseFragmentDoc}
${StudentOutcomeFragmentDoc}
${QuestionOutcomeScoreFragmentDoc}
${QuestionResponseCountsFragmentDoc}`;
export type ResetQuestionModerationChangesMutationFn = Apollo.MutationFunction<ResetQuestionModerationChangesMutation, ResetQuestionModerationChangesMutationVariables>;

/**
 * __useResetQuestionModerationChangesMutation__
 *
 * To run a mutation, you first call `useResetQuestionModerationChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetQuestionModerationChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetQuestionModerationChangesMutation, { data, loading, error }] = useResetQuestionModerationChangesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResetQuestionModerationChangesMutation(baseOptions?: Apollo.MutationHookOptions<ResetQuestionModerationChangesMutation, ResetQuestionModerationChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetQuestionModerationChangesMutation, ResetQuestionModerationChangesMutationVariables>(ResetQuestionModerationChangesDocument, options);
      }
export type ResetQuestionModerationChangesMutationHookResult = ReturnType<typeof useResetQuestionModerationChangesMutation>;
export type ResetQuestionModerationChangesMutationResult = Apollo.MutationResult<ResetQuestionModerationChangesMutation>;
export type ResetQuestionModerationChangesMutationOptions = Apollo.BaseMutationOptions<ResetQuestionModerationChangesMutation, ResetQuestionModerationChangesMutationVariables>;
export const ResetRubricOutcomeForFieldDocument = gql`
    mutation ResetRubricOutcomeForField($assessmentId: ID!, $markerRubricId: ID!, $fieldOutcomeId: ID!) {
  resetRubricOutcomeForField(
    assessmentId: $assessmentId
    markerRubricId: $markerRubricId
    fieldOutcomeId: $fieldOutcomeId
  ) {
    fieldOutcome {
      id
      score
      markerScore
      rubricOutcome {
        criterionOutcomes {
          ...CriterionOutcome
        }
        score
      }
    }
    questionOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
    workOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
    criterionOutcomesDeleted
  }
}
    ${CriterionOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type ResetRubricOutcomeForFieldMutationFn = Apollo.MutationFunction<ResetRubricOutcomeForFieldMutation, ResetRubricOutcomeForFieldMutationVariables>;

/**
 * __useResetRubricOutcomeForFieldMutation__
 *
 * To run a mutation, you first call `useResetRubricOutcomeForFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetRubricOutcomeForFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetRubricOutcomeForFieldMutation, { data, loading, error }] = useResetRubricOutcomeForFieldMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      markerRubricId: // value for 'markerRubricId'
 *      fieldOutcomeId: // value for 'fieldOutcomeId'
 *   },
 * });
 */
export function useResetRubricOutcomeForFieldMutation(baseOptions?: Apollo.MutationHookOptions<ResetRubricOutcomeForFieldMutation, ResetRubricOutcomeForFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetRubricOutcomeForFieldMutation, ResetRubricOutcomeForFieldMutationVariables>(ResetRubricOutcomeForFieldDocument, options);
      }
export type ResetRubricOutcomeForFieldMutationHookResult = ReturnType<typeof useResetRubricOutcomeForFieldMutation>;
export type ResetRubricOutcomeForFieldMutationResult = Apollo.MutationResult<ResetRubricOutcomeForFieldMutation>;
export type ResetRubricOutcomeForFieldMutationOptions = Apollo.BaseMutationOptions<ResetRubricOutcomeForFieldMutation, ResetRubricOutcomeForFieldMutationVariables>;
export const ResetRubricOutcomeForSubmissionDocument = gql`
    mutation ResetRubricOutcomeForSubmission($assessmentId: ID!, $markerRubricId: ID!, $submissionOutcomeId: ID!) {
  resetRubricOutcomeForSubmission(
    assessmentId: $assessmentId
    markerRubricId: $markerRubricId
    submissionOutcomeId: $submissionOutcomeId
  ) {
    submissionOutcome {
      id
      score
      rubricOutcome {
        criterionOutcomes {
          ...CriterionOutcome
        }
        score
      }
    }
    workOutcome {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
    criterionOutcomesDeleted
  }
}
    ${CriterionOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type ResetRubricOutcomeForSubmissionMutationFn = Apollo.MutationFunction<ResetRubricOutcomeForSubmissionMutation, ResetRubricOutcomeForSubmissionMutationVariables>;

/**
 * __useResetRubricOutcomeForSubmissionMutation__
 *
 * To run a mutation, you first call `useResetRubricOutcomeForSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetRubricOutcomeForSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetRubricOutcomeForSubmissionMutation, { data, loading, error }] = useResetRubricOutcomeForSubmissionMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      markerRubricId: // value for 'markerRubricId'
 *      submissionOutcomeId: // value for 'submissionOutcomeId'
 *   },
 * });
 */
export function useResetRubricOutcomeForSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<ResetRubricOutcomeForSubmissionMutation, ResetRubricOutcomeForSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetRubricOutcomeForSubmissionMutation, ResetRubricOutcomeForSubmissionMutationVariables>(ResetRubricOutcomeForSubmissionDocument, options);
      }
export type ResetRubricOutcomeForSubmissionMutationHookResult = ReturnType<typeof useResetRubricOutcomeForSubmissionMutation>;
export type ResetRubricOutcomeForSubmissionMutationResult = Apollo.MutationResult<ResetRubricOutcomeForSubmissionMutation>;
export type ResetRubricOutcomeForSubmissionMutationOptions = Apollo.BaseMutationOptions<ResetRubricOutcomeForSubmissionMutation, ResetRubricOutcomeForSubmissionMutationVariables>;
export const ResetScoreModerationChangesDocument = gql`
    mutation ResetScoreModerationChanges($assessmentId: ID!) {
  resetScoreModerationChanges(assessmentId: $assessmentId) {
    studentOutcomes {
      ...StudentOutcome
    }
    workOutcomes {
      id
      scoreBreakdown {
        ...ScoreBreakdown
      }
    }
  }
}
    ${StudentOutcomeFragmentDoc}
${ScoreBreakdownFragmentDoc}`;
export type ResetScoreModerationChangesMutationFn = Apollo.MutationFunction<ResetScoreModerationChangesMutation, ResetScoreModerationChangesMutationVariables>;

/**
 * __useResetScoreModerationChangesMutation__
 *
 * To run a mutation, you first call `useResetScoreModerationChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetScoreModerationChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetScoreModerationChangesMutation, { data, loading, error }] = useResetScoreModerationChangesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResetScoreModerationChangesMutation(baseOptions?: Apollo.MutationHookOptions<ResetScoreModerationChangesMutation, ResetScoreModerationChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetScoreModerationChangesMutation, ResetScoreModerationChangesMutationVariables>(ResetScoreModerationChangesDocument, options);
      }
export type ResetScoreModerationChangesMutationHookResult = ReturnType<typeof useResetScoreModerationChangesMutation>;
export type ResetScoreModerationChangesMutationResult = Apollo.MutationResult<ResetScoreModerationChangesMutation>;
export type ResetScoreModerationChangesMutationOptions = Apollo.BaseMutationOptions<ResetScoreModerationChangesMutation, ResetScoreModerationChangesMutationVariables>;
export const SimilarityDocument = gql`
    query Similarity($submissionType: SubmissionType!, $workId: ID!) {
  latestResult(submissionType: $submissionType, workId: $workId) {
    id
    heraResultId
    similarity {
      display
      label
      value
    }
  }
}
    `;

/**
 * __useSimilarityQuery__
 *
 * To run a query within a React component, call `useSimilarityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimilarityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimilarityQuery({
 *   variables: {
 *      submissionType: // value for 'submissionType'
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useSimilarityQuery(baseOptions: Apollo.QueryHookOptions<SimilarityQuery, SimilarityQueryVariables> & ({ variables: SimilarityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
      }
export function useSimilarityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimilarityQuery, SimilarityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
        }
export function useSimilaritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimilarityQuery, SimilarityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimilarityQuery, SimilarityQueryVariables>(SimilarityDocument, options);
        }
export type SimilarityQueryHookResult = ReturnType<typeof useSimilarityQuery>;
export type SimilarityLazyQueryHookResult = ReturnType<typeof useSimilarityLazyQuery>;
export type SimilaritySuspenseQueryHookResult = ReturnType<typeof useSimilaritySuspenseQuery>;
export type SimilarityQueryResult = Apollo.QueryResult<SimilarityQuery, SimilarityQueryVariables>;
export const SkillsDocument = gql`
    query Skills {
  skills {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;

/**
 * __useSkillsQuery__
 *
 * To run a query within a React component, call `useSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSkillsQuery(baseOptions?: Apollo.QueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
      }
export function useSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
        }
export function useSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
        }
export type SkillsQueryHookResult = ReturnType<typeof useSkillsQuery>;
export type SkillsLazyQueryHookResult = ReturnType<typeof useSkillsLazyQuery>;
export type SkillsSuspenseQueryHookResult = ReturnType<typeof useSkillsSuspenseQuery>;
export type SkillsQueryResult = Apollo.QueryResult<SkillsQuery, SkillsQueryVariables>;
export const SkillsByAssessmentDocument = gql`
    query SkillsByAssessment($assessmentId: ID!) {
  skillsByAssessment(assessmentId: $assessmentId) {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;

/**
 * __useSkillsByAssessmentQuery__
 *
 * To run a query within a React component, call `useSkillsByAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillsByAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillsByAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useSkillsByAssessmentQuery(baseOptions: Apollo.QueryHookOptions<SkillsByAssessmentQuery, SkillsByAssessmentQueryVariables> & ({ variables: SkillsByAssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillsByAssessmentQuery, SkillsByAssessmentQueryVariables>(SkillsByAssessmentDocument, options);
      }
export function useSkillsByAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillsByAssessmentQuery, SkillsByAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillsByAssessmentQuery, SkillsByAssessmentQueryVariables>(SkillsByAssessmentDocument, options);
        }
export function useSkillsByAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillsByAssessmentQuery, SkillsByAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillsByAssessmentQuery, SkillsByAssessmentQueryVariables>(SkillsByAssessmentDocument, options);
        }
export type SkillsByAssessmentQueryHookResult = ReturnType<typeof useSkillsByAssessmentQuery>;
export type SkillsByAssessmentLazyQueryHookResult = ReturnType<typeof useSkillsByAssessmentLazyQuery>;
export type SkillsByAssessmentSuspenseQueryHookResult = ReturnType<typeof useSkillsByAssessmentSuspenseQuery>;
export type SkillsByAssessmentQueryResult = Apollo.QueryResult<SkillsByAssessmentQuery, SkillsByAssessmentQueryVariables>;
export const SnapshotFieldOutcomeDocument = gql`
    mutation snapshotFieldOutcome($fieldOutcomeId: ID!, $input: SnapshotFieldOutcomeInput!) {
  snapshotFieldOutcome(fieldOutcomeId: $fieldOutcomeId, input: $input) {
    ...FieldOutcome
  }
}
    ${FieldOutcomeFragmentDoc}`;
export type SnapshotFieldOutcomeMutationFn = Apollo.MutationFunction<SnapshotFieldOutcomeMutation, SnapshotFieldOutcomeMutationVariables>;

/**
 * __useSnapshotFieldOutcomeMutation__
 *
 * To run a mutation, you first call `useSnapshotFieldOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnapshotFieldOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snapshotFieldOutcomeMutation, { data, loading, error }] = useSnapshotFieldOutcomeMutation({
 *   variables: {
 *      fieldOutcomeId: // value for 'fieldOutcomeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnapshotFieldOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<SnapshotFieldOutcomeMutation, SnapshotFieldOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnapshotFieldOutcomeMutation, SnapshotFieldOutcomeMutationVariables>(SnapshotFieldOutcomeDocument, options);
      }
export type SnapshotFieldOutcomeMutationHookResult = ReturnType<typeof useSnapshotFieldOutcomeMutation>;
export type SnapshotFieldOutcomeMutationResult = Apollo.MutationResult<SnapshotFieldOutcomeMutation>;
export type SnapshotFieldOutcomeMutationOptions = Apollo.BaseMutationOptions<SnapshotFieldOutcomeMutation, SnapshotFieldOutcomeMutationVariables>;
export const SnapshotSubmissionOutcomeDocument = gql`
    mutation snapshotSubmissionOutcome($submissionOutcomeId: ID!, $input: SnapshotSubmissionOutcomeInput!) {
  snapshotSubmissionOutcome(
    submissionOutcomeId: $submissionOutcomeId
    input: $input
  ) {
    ...SubmissionOutcome
  }
}
    ${SubmissionOutcomeFragmentDoc}`;
export type SnapshotSubmissionOutcomeMutationFn = Apollo.MutationFunction<SnapshotSubmissionOutcomeMutation, SnapshotSubmissionOutcomeMutationVariables>;

/**
 * __useSnapshotSubmissionOutcomeMutation__
 *
 * To run a mutation, you first call `useSnapshotSubmissionOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnapshotSubmissionOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snapshotSubmissionOutcomeMutation, { data, loading, error }] = useSnapshotSubmissionOutcomeMutation({
 *   variables: {
 *      submissionOutcomeId: // value for 'submissionOutcomeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnapshotSubmissionOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<SnapshotSubmissionOutcomeMutation, SnapshotSubmissionOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnapshotSubmissionOutcomeMutation, SnapshotSubmissionOutcomeMutationVariables>(SnapshotSubmissionOutcomeDocument, options);
      }
export type SnapshotSubmissionOutcomeMutationHookResult = ReturnType<typeof useSnapshotSubmissionOutcomeMutation>;
export type SnapshotSubmissionOutcomeMutationResult = Apollo.MutationResult<SnapshotSubmissionOutcomeMutation>;
export type SnapshotSubmissionOutcomeMutationOptions = Apollo.BaseMutationOptions<SnapshotSubmissionOutcomeMutation, SnapshotSubmissionOutcomeMutationVariables>;
export const StudentOutcomesDocument = gql`
    query StudentOutcomes($assessmentId: ID!) {
  studentOutcomes(assessmentId: $assessmentId) {
    ...StudentOutcome
  }
}
    ${StudentOutcomeFragmentDoc}`;

/**
 * __useStudentOutcomesQuery__
 *
 * To run a query within a React component, call `useStudentOutcomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentOutcomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOutcomesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useStudentOutcomesQuery(baseOptions: Apollo.QueryHookOptions<StudentOutcomesQuery, StudentOutcomesQueryVariables> & ({ variables: StudentOutcomesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentOutcomesQuery, StudentOutcomesQueryVariables>(StudentOutcomesDocument, options);
      }
export function useStudentOutcomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentOutcomesQuery, StudentOutcomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentOutcomesQuery, StudentOutcomesQueryVariables>(StudentOutcomesDocument, options);
        }
export function useStudentOutcomesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentOutcomesQuery, StudentOutcomesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentOutcomesQuery, StudentOutcomesQueryVariables>(StudentOutcomesDocument, options);
        }
export type StudentOutcomesQueryHookResult = ReturnType<typeof useStudentOutcomesQuery>;
export type StudentOutcomesLazyQueryHookResult = ReturnType<typeof useStudentOutcomesLazyQuery>;
export type StudentOutcomesSuspenseQueryHookResult = ReturnType<typeof useStudentOutcomesSuspenseQuery>;
export type StudentOutcomesQueryResult = Apollo.QueryResult<StudentOutcomesQuery, StudentOutcomesQueryVariables>;
export const StudentOutcomesUpdatedDocument = gql`
    subscription StudentOutcomesUpdated($assessmentId: ID!) {
  studentOutcomesUpdated(assessmentId: $assessmentId) {
    id
    studentId
    individualPenalty
    groupPenalty
    finalScore
    groupWorkOutcome {
      ...WorkOutcomeUpdated
    }
    individualWorkOutcome {
      ...WorkOutcomeUpdated
    }
    base {
      ...ComponentBreakdown
    }
    provisional {
      ...ComponentBreakdown
    }
    final {
      ...ComponentBreakdown
    }
  }
}
    ${WorkOutcomeUpdatedFragmentDoc}
${ComponentBreakdownFragmentDoc}`;

/**
 * __useStudentOutcomesUpdatedSubscription__
 *
 * To run a query within a React component, call `useStudentOutcomesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStudentOutcomesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentOutcomesUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useStudentOutcomesUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<StudentOutcomesUpdatedSubscription, StudentOutcomesUpdatedSubscriptionVariables> & ({ variables: StudentOutcomesUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<StudentOutcomesUpdatedSubscription, StudentOutcomesUpdatedSubscriptionVariables>(StudentOutcomesUpdatedDocument, options);
      }
export type StudentOutcomesUpdatedSubscriptionHookResult = ReturnType<typeof useStudentOutcomesUpdatedSubscription>;
export type StudentOutcomesUpdatedSubscriptionResult = Apollo.SubscriptionResult<StudentOutcomesUpdatedSubscription>;
export const UnlinkCommentThreadDocument = gql`
    mutation UnlinkCommentThread($assessmentId: ID!, $threadId: ID!) {
  unlinkCommentThread(assessmentId: $assessmentId, threadId: $threadId) {
    id
    title
    entityType
    entityId
    criterionId
    createdBy {
      id
    }
    metadata {
      charterSectionType
      charterEditorId
    }
    comments {
      id
      content
      updatedAt
      createdBy {
        id
        name
        colourset
      }
    }
  }
}
    `;
export type UnlinkCommentThreadMutationFn = Apollo.MutationFunction<UnlinkCommentThreadMutation, UnlinkCommentThreadMutationVariables>;

/**
 * __useUnlinkCommentThreadMutation__
 *
 * To run a mutation, you first call `useUnlinkCommentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkCommentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkCommentThreadMutation, { data, loading, error }] = useUnlinkCommentThreadMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useUnlinkCommentThreadMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkCommentThreadMutation, UnlinkCommentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkCommentThreadMutation, UnlinkCommentThreadMutationVariables>(UnlinkCommentThreadDocument, options);
      }
export type UnlinkCommentThreadMutationHookResult = ReturnType<typeof useUnlinkCommentThreadMutation>;
export type UnlinkCommentThreadMutationResult = Apollo.MutationResult<UnlinkCommentThreadMutation>;
export type UnlinkCommentThreadMutationOptions = Apollo.BaseMutationOptions<UnlinkCommentThreadMutation, UnlinkCommentThreadMutationVariables>;
export const UpdateFeedbackReleaseRulesDocument = gql`
    mutation UpdateFeedbackReleaseRules($assessmentId: ID!, $rules: [FeedbackReleaseRuleInput!]!, $releaseType: FeedbackReleaseType) {
  updateFeedbackReleaseRules(
    assessmentId: $assessmentId
    rules: $rules
    releaseType: $releaseType
  ) {
    ...FeedbackReleaseRule
  }
}
    ${FeedbackReleaseRuleFragmentDoc}`;
export type UpdateFeedbackReleaseRulesMutationFn = Apollo.MutationFunction<UpdateFeedbackReleaseRulesMutation, UpdateFeedbackReleaseRulesMutationVariables>;

/**
 * __useUpdateFeedbackReleaseRulesMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackReleaseRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackReleaseRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackReleaseRulesMutation, { data, loading, error }] = useUpdateFeedbackReleaseRulesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      rules: // value for 'rules'
 *      releaseType: // value for 'releaseType'
 *   },
 * });
 */
export function useUpdateFeedbackReleaseRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackReleaseRulesMutation, UpdateFeedbackReleaseRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackReleaseRulesMutation, UpdateFeedbackReleaseRulesMutationVariables>(UpdateFeedbackReleaseRulesDocument, options);
      }
export type UpdateFeedbackReleaseRulesMutationHookResult = ReturnType<typeof useUpdateFeedbackReleaseRulesMutation>;
export type UpdateFeedbackReleaseRulesMutationResult = Apollo.MutationResult<UpdateFeedbackReleaseRulesMutation>;
export type UpdateFeedbackReleaseRulesMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackReleaseRulesMutation, UpdateFeedbackReleaseRulesMutationVariables>;
export const UpdateFeedbackVisibilityDocument = gql`
    mutation UpdateFeedbackVisibility($assessmentId: ID!, $input: FeedbackVisibilityInput!, $releaseType: FeedbackReleaseType) {
  updateFeedbackVisibility(
    assessmentId: $assessmentId
    input: $input
    releaseType: $releaseType
  ) {
    ...FeedbackVisibility
  }
}
    ${FeedbackVisibilityFragmentDoc}`;
export type UpdateFeedbackVisibilityMutationFn = Apollo.MutationFunction<UpdateFeedbackVisibilityMutation, UpdateFeedbackVisibilityMutationVariables>;

/**
 * __useUpdateFeedbackVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackVisibilityMutation, { data, loading, error }] = useUpdateFeedbackVisibilityMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *      releaseType: // value for 'releaseType'
 *   },
 * });
 */
export function useUpdateFeedbackVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackVisibilityMutation, UpdateFeedbackVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackVisibilityMutation, UpdateFeedbackVisibilityMutationVariables>(UpdateFeedbackVisibilityDocument, options);
      }
export type UpdateFeedbackVisibilityMutationHookResult = ReturnType<typeof useUpdateFeedbackVisibilityMutation>;
export type UpdateFeedbackVisibilityMutationResult = Apollo.MutationResult<UpdateFeedbackVisibilityMutation>;
export type UpdateFeedbackVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackVisibilityMutation, UpdateFeedbackVisibilityMutationVariables>;
export const UpdateFieldRubricResponseDocument = gql`
    mutation UpdateFieldRubricResponse($assessmentId: ID!, $input: UpdateFieldRubricInput!) {
  updateFieldRubricResponse(assessmentId: $assessmentId, input: $input) {
    fieldRubric {
      ...FieldRubric
    }
    questionOutcomes {
      ...QuestionOutcomeScore
    }
    fieldOutcomes {
      ...FieldOutcomeScore
      answer
      answers
    }
    workOutcomes {
      ...WorkOutcomeScore
    }
  }
}
    ${FieldRubricFragmentDoc}
${QuestionOutcomeScoreFragmentDoc}
${FieldOutcomeScoreFragmentDoc}
${WorkOutcomeScoreFragmentDoc}`;
export type UpdateFieldRubricResponseMutationFn = Apollo.MutationFunction<UpdateFieldRubricResponseMutation, UpdateFieldRubricResponseMutationVariables>;

/**
 * __useUpdateFieldRubricResponseMutation__
 *
 * To run a mutation, you first call `useUpdateFieldRubricResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldRubricResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldRubricResponseMutation, { data, loading, error }] = useUpdateFieldRubricResponseMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFieldRubricResponseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldRubricResponseMutation, UpdateFieldRubricResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldRubricResponseMutation, UpdateFieldRubricResponseMutationVariables>(UpdateFieldRubricResponseDocument, options);
      }
export type UpdateFieldRubricResponseMutationHookResult = ReturnType<typeof useUpdateFieldRubricResponseMutation>;
export type UpdateFieldRubricResponseMutationResult = Apollo.MutationResult<UpdateFieldRubricResponseMutation>;
export type UpdateFieldRubricResponseMutationOptions = Apollo.BaseMutationOptions<UpdateFieldRubricResponseMutation, UpdateFieldRubricResponseMutationVariables>;
export const UpdateMarkerRubricDocument = gql`
    mutation updateMarkerRubric($input: MarkerRubricInput!, $markerRubricId: ID!) {
  updateMarkerRubric(markerRubricId: $markerRubricId, input: $input) {
    ...MarkerRubric
  }
}
    ${MarkerRubricFragmentDoc}`;
export type UpdateMarkerRubricMutationFn = Apollo.MutationFunction<UpdateMarkerRubricMutation, UpdateMarkerRubricMutationVariables>;

/**
 * __useUpdateMarkerRubricMutation__
 *
 * To run a mutation, you first call `useUpdateMarkerRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarkerRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarkerRubricMutation, { data, loading, error }] = useUpdateMarkerRubricMutation({
 *   variables: {
 *      input: // value for 'input'
 *      markerRubricId: // value for 'markerRubricId'
 *   },
 * });
 */
export function useUpdateMarkerRubricMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarkerRubricMutation, UpdateMarkerRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarkerRubricMutation, UpdateMarkerRubricMutationVariables>(UpdateMarkerRubricDocument, options);
      }
export type UpdateMarkerRubricMutationHookResult = ReturnType<typeof useUpdateMarkerRubricMutation>;
export type UpdateMarkerRubricMutationResult = Apollo.MutationResult<UpdateMarkerRubricMutation>;
export type UpdateMarkerRubricMutationOptions = Apollo.BaseMutationOptions<UpdateMarkerRubricMutation, UpdateMarkerRubricMutationVariables>;
export const UpdateModerationPenaltyRulesDocument = gql`
    mutation UpdateModerationPenaltyRules($assessmentId: ID!, $rules: [ModerationPenaltyRuleInput!]!) {
  updateModerationPenaltyRules(assessmentId: $assessmentId, rules: $rules) {
    ...ModerationPenaltyRule
  }
}
    ${ModerationPenaltyRuleFragmentDoc}`;
export type UpdateModerationPenaltyRulesMutationFn = Apollo.MutationFunction<UpdateModerationPenaltyRulesMutation, UpdateModerationPenaltyRulesMutationVariables>;

/**
 * __useUpdateModerationPenaltyRulesMutation__
 *
 * To run a mutation, you first call `useUpdateModerationPenaltyRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModerationPenaltyRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModerationPenaltyRulesMutation, { data, loading, error }] = useUpdateModerationPenaltyRulesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useUpdateModerationPenaltyRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModerationPenaltyRulesMutation, UpdateModerationPenaltyRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModerationPenaltyRulesMutation, UpdateModerationPenaltyRulesMutationVariables>(UpdateModerationPenaltyRulesDocument, options);
      }
export type UpdateModerationPenaltyRulesMutationHookResult = ReturnType<typeof useUpdateModerationPenaltyRulesMutation>;
export type UpdateModerationPenaltyRulesMutationResult = Apollo.MutationResult<UpdateModerationPenaltyRulesMutation>;
export type UpdateModerationPenaltyRulesMutationOptions = Apollo.BaseMutationOptions<UpdateModerationPenaltyRulesMutation, UpdateModerationPenaltyRulesMutationVariables>;
export const UpdateQuestionRubricDocument = gql`
    mutation UpdateQuestionRubric($assessmentId: ID!, $input: UpdateQuestionRubricInput!) {
  updateQuestionRubric(assessmentId: $assessmentId, input: $input) {
    questionRubric {
      id
      fieldRubrics {
        ...FieldRubric
        ...FieldRubricResponse
      }
    }
    questionOutcomes {
      ...QuestionOutcomeScore
    }
    fieldOutcomes {
      ...FieldOutcomeScore
      answer
      answers
    }
    workOutcomes {
      ...WorkOutcomeScore
    }
  }
}
    ${FieldRubricFragmentDoc}
${FieldRubricResponseFragmentDoc}
${QuestionOutcomeScoreFragmentDoc}
${FieldOutcomeScoreFragmentDoc}
${WorkOutcomeScoreFragmentDoc}`;
export type UpdateQuestionRubricMutationFn = Apollo.MutationFunction<UpdateQuestionRubricMutation, UpdateQuestionRubricMutationVariables>;

/**
 * __useUpdateQuestionRubricMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionRubricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionRubricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionRubricMutation, { data, loading, error }] = useUpdateQuestionRubricMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionRubricMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionRubricMutation, UpdateQuestionRubricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionRubricMutation, UpdateQuestionRubricMutationVariables>(UpdateQuestionRubricDocument, options);
      }
export type UpdateQuestionRubricMutationHookResult = ReturnType<typeof useUpdateQuestionRubricMutation>;
export type UpdateQuestionRubricMutationResult = Apollo.MutationResult<UpdateQuestionRubricMutation>;
export type UpdateQuestionRubricMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionRubricMutation, UpdateQuestionRubricMutationVariables>;
export const UpdateStudentOutcomeScoreDocument = gql`
    mutation updateStudentOutcomeScore($assessmentId: ID!, $studentId: ID!, $input: UpdateStudentOutcomeScoreInput!) {
  updateStudentOutcomeScore(
    assessmentId: $assessmentId
    studentId: $studentId
    input: $input
  ) {
    studentOutcome {
      ...StudentOutcome
    }
  }
}
    ${StudentOutcomeFragmentDoc}`;
export type UpdateStudentOutcomeScoreMutationFn = Apollo.MutationFunction<UpdateStudentOutcomeScoreMutation, UpdateStudentOutcomeScoreMutationVariables>;

/**
 * __useUpdateStudentOutcomeScoreMutation__
 *
 * To run a mutation, you first call `useUpdateStudentOutcomeScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentOutcomeScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentOutcomeScoreMutation, { data, loading, error }] = useUpdateStudentOutcomeScoreMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      studentId: // value for 'studentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudentOutcomeScoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentOutcomeScoreMutation, UpdateStudentOutcomeScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentOutcomeScoreMutation, UpdateStudentOutcomeScoreMutationVariables>(UpdateStudentOutcomeScoreDocument, options);
      }
export type UpdateStudentOutcomeScoreMutationHookResult = ReturnType<typeof useUpdateStudentOutcomeScoreMutation>;
export type UpdateStudentOutcomeScoreMutationResult = Apollo.MutationResult<UpdateStudentOutcomeScoreMutation>;
export type UpdateStudentOutcomeScoreMutationOptions = Apollo.BaseMutationOptions<UpdateStudentOutcomeScoreMutation, UpdateStudentOutcomeScoreMutationVariables>;
export const UpdateWorkOutcomeScoreDocument = gql`
    mutation updateWorkOutcomeScore($assessmentId: ID!, $input: UpdateWorkOutcomeScoreInput!) {
  updateWorkOutcomeScore(assessmentId: $assessmentId, input: $input) {
    studentOutcomes {
      ...StudentOutcome
    }
  }
}
    ${StudentOutcomeFragmentDoc}`;
export type UpdateWorkOutcomeScoreMutationFn = Apollo.MutationFunction<UpdateWorkOutcomeScoreMutation, UpdateWorkOutcomeScoreMutationVariables>;

/**
 * __useUpdateWorkOutcomeScoreMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOutcomeScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOutcomeScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOutcomeScoreMutation, { data, loading, error }] = useUpdateWorkOutcomeScoreMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkOutcomeScoreMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOutcomeScoreMutation, UpdateWorkOutcomeScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOutcomeScoreMutation, UpdateWorkOutcomeScoreMutationVariables>(UpdateWorkOutcomeScoreDocument, options);
      }
export type UpdateWorkOutcomeScoreMutationHookResult = ReturnType<typeof useUpdateWorkOutcomeScoreMutation>;
export type UpdateWorkOutcomeScoreMutationResult = Apollo.MutationResult<UpdateWorkOutcomeScoreMutation>;
export type UpdateWorkOutcomeScoreMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOutcomeScoreMutation, UpdateWorkOutcomeScoreMutationVariables>;
export const WorkOutcomeDocument = gql`
    query WorkOutcome($workId: ID!) {
  workOutcome(workId: $workId) {
    ...WorkOutcome
  }
  work(workId: $workId) {
    student {
      id
    }
    group {
      id
      members {
        id
      }
    }
    answerBlocks {
      nodeId
      id
    }
  }
}
    ${WorkOutcomeFragmentDoc}`;

/**
 * __useWorkOutcomeQuery__
 *
 * To run a query within a React component, call `useWorkOutcomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOutcomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOutcomeQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useWorkOutcomeQuery(baseOptions: Apollo.QueryHookOptions<WorkOutcomeQuery, WorkOutcomeQueryVariables> & ({ variables: WorkOutcomeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOutcomeQuery, WorkOutcomeQueryVariables>(WorkOutcomeDocument, options);
      }
export function useWorkOutcomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOutcomeQuery, WorkOutcomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOutcomeQuery, WorkOutcomeQueryVariables>(WorkOutcomeDocument, options);
        }
export function useWorkOutcomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkOutcomeQuery, WorkOutcomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkOutcomeQuery, WorkOutcomeQueryVariables>(WorkOutcomeDocument, options);
        }
export type WorkOutcomeQueryHookResult = ReturnType<typeof useWorkOutcomeQuery>;
export type WorkOutcomeLazyQueryHookResult = ReturnType<typeof useWorkOutcomeLazyQuery>;
export type WorkOutcomeSuspenseQueryHookResult = ReturnType<typeof useWorkOutcomeSuspenseQuery>;
export type WorkOutcomeQueryResult = Apollo.QueryResult<WorkOutcomeQuery, WorkOutcomeQueryVariables>;
export const WorkOutcomeSubmissionDocument = gql`
    query WorkOutcomeSubmission($workId: ID!) {
  workOutcome(workId: $workId) {
    id
    latestSubmissionOutcome {
      ...SubmissionOutcome
    }
  }
}
    ${SubmissionOutcomeFragmentDoc}`;

/**
 * __useWorkOutcomeSubmissionQuery__
 *
 * To run a query within a React component, call `useWorkOutcomeSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOutcomeSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOutcomeSubmissionQuery({
 *   variables: {
 *      workId: // value for 'workId'
 *   },
 * });
 */
export function useWorkOutcomeSubmissionQuery(baseOptions: Apollo.QueryHookOptions<WorkOutcomeSubmissionQuery, WorkOutcomeSubmissionQueryVariables> & ({ variables: WorkOutcomeSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkOutcomeSubmissionQuery, WorkOutcomeSubmissionQueryVariables>(WorkOutcomeSubmissionDocument, options);
      }
export function useWorkOutcomeSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkOutcomeSubmissionQuery, WorkOutcomeSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkOutcomeSubmissionQuery, WorkOutcomeSubmissionQueryVariables>(WorkOutcomeSubmissionDocument, options);
        }
export function useWorkOutcomeSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkOutcomeSubmissionQuery, WorkOutcomeSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkOutcomeSubmissionQuery, WorkOutcomeSubmissionQueryVariables>(WorkOutcomeSubmissionDocument, options);
        }
export type WorkOutcomeSubmissionQueryHookResult = ReturnType<typeof useWorkOutcomeSubmissionQuery>;
export type WorkOutcomeSubmissionLazyQueryHookResult = ReturnType<typeof useWorkOutcomeSubmissionLazyQuery>;
export type WorkOutcomeSubmissionSuspenseQueryHookResult = ReturnType<typeof useWorkOutcomeSubmissionSuspenseQuery>;
export type WorkOutcomeSubmissionQueryResult = Apollo.QueryResult<WorkOutcomeSubmissionQuery, WorkOutcomeSubmissionQueryVariables>;
export const CaptureOnboardingInputDocument = gql`
    mutation CaptureOnboardingInput($subjectId: ID!, $subjectRole: SubjectRole!, $discipline: Discipline) {
  captureOnboardingInput(
    subjectId: $subjectId
    subjectRole: $subjectRole
    discipline: $discipline
  ) {
    ...OnboardingPayload
  }
}
    ${OnboardingPayloadFragmentDoc}`;
export type CaptureOnboardingInputMutationFn = Apollo.MutationFunction<CaptureOnboardingInputMutation, CaptureOnboardingInputMutationVariables>;

/**
 * __useCaptureOnboardingInputMutation__
 *
 * To run a mutation, you first call `useCaptureOnboardingInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureOnboardingInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureOnboardingInputMutation, { data, loading, error }] = useCaptureOnboardingInputMutation({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *      subjectRole: // value for 'subjectRole'
 *      discipline: // value for 'discipline'
 *   },
 * });
 */
export function useCaptureOnboardingInputMutation(baseOptions?: Apollo.MutationHookOptions<CaptureOnboardingInputMutation, CaptureOnboardingInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CaptureOnboardingInputMutation, CaptureOnboardingInputMutationVariables>(CaptureOnboardingInputDocument, options);
      }
export type CaptureOnboardingInputMutationHookResult = ReturnType<typeof useCaptureOnboardingInputMutation>;
export type CaptureOnboardingInputMutationResult = Apollo.MutationResult<CaptureOnboardingInputMutation>;
export type CaptureOnboardingInputMutationOptions = Apollo.BaseMutationOptions<CaptureOnboardingInputMutation, CaptureOnboardingInputMutationVariables>;
export const SaveGlobalUserSettingsDocument = gql`
    mutation SaveGlobalUserSettings($userSettingsInput: GlobalUserSettingsInput!) {
  saveGlobalUserSettings(userSettingsInput: $userSettingsInput) {
    userSettings {
      showIaOnboarding
    }
  }
}
    `;
export type SaveGlobalUserSettingsMutationFn = Apollo.MutationFunction<SaveGlobalUserSettingsMutation, SaveGlobalUserSettingsMutationVariables>;

/**
 * __useSaveGlobalUserSettingsMutation__
 *
 * To run a mutation, you first call `useSaveGlobalUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalUserSettingsMutation, { data, loading, error }] = useSaveGlobalUserSettingsMutation({
 *   variables: {
 *      userSettingsInput: // value for 'userSettingsInput'
 *   },
 * });
 */
export function useSaveGlobalUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveGlobalUserSettingsMutation, SaveGlobalUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGlobalUserSettingsMutation, SaveGlobalUserSettingsMutationVariables>(SaveGlobalUserSettingsDocument, options);
      }
export type SaveGlobalUserSettingsMutationHookResult = ReturnType<typeof useSaveGlobalUserSettingsMutation>;
export type SaveGlobalUserSettingsMutationResult = Apollo.MutationResult<SaveGlobalUserSettingsMutation>;
export type SaveGlobalUserSettingsMutationOptions = Apollo.BaseMutationOptions<SaveGlobalUserSettingsMutation, SaveGlobalUserSettingsMutationVariables>;
export const AddTagDocument = gql`
    mutation AddTag($enrollmentId: ID!, $text: String!, $column: Int!) {
  addTag(enrollmentId: $enrollmentId, text: $text, column: $column) {
    text
    column
  }
}
    `;
export type AddTagMutationFn = Apollo.MutationFunction<AddTagMutation, AddTagMutationVariables>;

/**
 * __useAddTagMutation__
 *
 * To run a mutation, you first call `useAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagMutation, { data, loading, error }] = useAddTagMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *      text: // value for 'text'
 *      column: // value for 'column'
 *   },
 * });
 */
export function useAddTagMutation(baseOptions?: Apollo.MutationHookOptions<AddTagMutation, AddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagMutation, AddTagMutationVariables>(AddTagDocument, options);
      }
export type AddTagMutationHookResult = ReturnType<typeof useAddTagMutation>;
export type AddTagMutationResult = Apollo.MutationResult<AddTagMutation>;
export type AddTagMutationOptions = Apollo.BaseMutationOptions<AddTagMutation, AddTagMutationVariables>;
export const AssessmentProjectIssuesDocument = gql`
    query AssessmentProjectIssues($assessmentId: ID!) {
  assessmentProjectIssues(assessmentId: $assessmentId) {
    ...ProjectIssue
  }
}
    ${ProjectIssueFragmentDoc}`;

/**
 * __useAssessmentProjectIssuesQuery__
 *
 * To run a query within a React component, call `useAssessmentProjectIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentProjectIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentProjectIssuesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentProjectIssuesQuery(baseOptions: Apollo.QueryHookOptions<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables> & ({ variables: AssessmentProjectIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>(AssessmentProjectIssuesDocument, options);
      }
export function useAssessmentProjectIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>(AssessmentProjectIssuesDocument, options);
        }
export function useAssessmentProjectIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>(AssessmentProjectIssuesDocument, options);
        }
export type AssessmentProjectIssuesQueryHookResult = ReturnType<typeof useAssessmentProjectIssuesQuery>;
export type AssessmentProjectIssuesLazyQueryHookResult = ReturnType<typeof useAssessmentProjectIssuesLazyQuery>;
export type AssessmentProjectIssuesSuspenseQueryHookResult = ReturnType<typeof useAssessmentProjectIssuesSuspenseQuery>;
export type AssessmentProjectIssuesQueryResult = Apollo.QueryResult<AssessmentProjectIssuesQuery, AssessmentProjectIssuesQueryVariables>;
export const BulkAddTagDocument = gql`
    mutation BulkAddTag($enrollmentIds: [ID!]!, $text: String!, $tab: ClassTab!) {
  bulkAddTag(enrollmentIds: $enrollmentIds, text: $text, tab: $tab) {
    text
    tab
  }
}
    `;
export type BulkAddTagMutationFn = Apollo.MutationFunction<BulkAddTagMutation, BulkAddTagMutationVariables>;

/**
 * __useBulkAddTagMutation__
 *
 * To run a mutation, you first call `useBulkAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddTagMutation, { data, loading, error }] = useBulkAddTagMutation({
 *   variables: {
 *      enrollmentIds: // value for 'enrollmentIds'
 *      text: // value for 'text'
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useBulkAddTagMutation(baseOptions?: Apollo.MutationHookOptions<BulkAddTagMutation, BulkAddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAddTagMutation, BulkAddTagMutationVariables>(BulkAddTagDocument, options);
      }
export type BulkAddTagMutationHookResult = ReturnType<typeof useBulkAddTagMutation>;
export type BulkAddTagMutationResult = Apollo.MutationResult<BulkAddTagMutation>;
export type BulkAddTagMutationOptions = Apollo.BaseMutationOptions<BulkAddTagMutation, BulkAddTagMutationVariables>;
export const BulkRemoveTagDocument = gql`
    mutation BulkRemoveTag($enrollmentIds: [ID!]!, $text: String!, $tab: ClassTab!) {
  bulkRemoveTag(enrollmentIds: $enrollmentIds, text: $text, tab: $tab)
}
    `;
export type BulkRemoveTagMutationFn = Apollo.MutationFunction<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>;

/**
 * __useBulkRemoveTagMutation__
 *
 * To run a mutation, you first call `useBulkRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveTagMutation, { data, loading, error }] = useBulkRemoveTagMutation({
 *   variables: {
 *      enrollmentIds: // value for 'enrollmentIds'
 *      text: // value for 'text'
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useBulkRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>(BulkRemoveTagDocument, options);
      }
export type BulkRemoveTagMutationHookResult = ReturnType<typeof useBulkRemoveTagMutation>;
export type BulkRemoveTagMutationResult = Apollo.MutationResult<BulkRemoveTagMutation>;
export type BulkRemoveTagMutationOptions = Apollo.BaseMutationOptions<BulkRemoveTagMutation, BulkRemoveTagMutationVariables>;
export const DownloadSubmissionsDocument = gql`
    mutation DownloadSubmissions($assessmentId: ID!, $submissions: [SubmissionDetailInput!]!, $preferPdf: Boolean) {
  downloadSubmissions(
    assessmentId: $assessmentId
    submissions: $submissions
    preferPdf: $preferPdf
  )
}
    `;
export type DownloadSubmissionsMutationFn = Apollo.MutationFunction<DownloadSubmissionsMutation, DownloadSubmissionsMutationVariables>;

/**
 * __useDownloadSubmissionsMutation__
 *
 * To run a mutation, you first call `useDownloadSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadSubmissionsMutation, { data, loading, error }] = useDownloadSubmissionsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      submissions: // value for 'submissions'
 *      preferPdf: // value for 'preferPdf'
 *   },
 * });
 */
export function useDownloadSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadSubmissionsMutation, DownloadSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadSubmissionsMutation, DownloadSubmissionsMutationVariables>(DownloadSubmissionsDocument, options);
      }
export type DownloadSubmissionsMutationHookResult = ReturnType<typeof useDownloadSubmissionsMutation>;
export type DownloadSubmissionsMutationResult = Apollo.MutationResult<DownloadSubmissionsMutation>;
export type DownloadSubmissionsMutationOptions = Apollo.BaseMutationOptions<DownloadSubmissionsMutation, DownloadSubmissionsMutationVariables>;
export const DownloadWorkArtifactsDocument = gql`
    mutation DownloadWorkArtifacts($assessmentId: ID!, $workArtifacts: [WorkArtifactDetailInput!]!) {
  downloadWorkArtifacts(
    assessmentId: $assessmentId
    workArtifacts: $workArtifacts
  )
}
    `;
export type DownloadWorkArtifactsMutationFn = Apollo.MutationFunction<DownloadWorkArtifactsMutation, DownloadWorkArtifactsMutationVariables>;

/**
 * __useDownloadWorkArtifactsMutation__
 *
 * To run a mutation, you first call `useDownloadWorkArtifactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadWorkArtifactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadWorkArtifactsMutation, { data, loading, error }] = useDownloadWorkArtifactsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workArtifacts: // value for 'workArtifacts'
 *   },
 * });
 */
export function useDownloadWorkArtifactsMutation(baseOptions?: Apollo.MutationHookOptions<DownloadWorkArtifactsMutation, DownloadWorkArtifactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadWorkArtifactsMutation, DownloadWorkArtifactsMutationVariables>(DownloadWorkArtifactsDocument, options);
      }
export type DownloadWorkArtifactsMutationHookResult = ReturnType<typeof useDownloadWorkArtifactsMutation>;
export type DownloadWorkArtifactsMutationResult = Apollo.MutationResult<DownloadWorkArtifactsMutation>;
export type DownloadWorkArtifactsMutationOptions = Apollo.BaseMutationOptions<DownloadWorkArtifactsMutation, DownloadWorkArtifactsMutationVariables>;
export const EnrollmentsUpdatedDocument = gql`
    subscription EnrollmentsUpdated($assessmentId: ID!) {
  enrollmentsUpdated(assessmentId: $assessmentId)
}
    `;

/**
 * __useEnrollmentsUpdatedSubscription__
 *
 * To run a query within a React component, call `useEnrollmentsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnrollmentsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrollmentsUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useEnrollmentsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<EnrollmentsUpdatedSubscription, EnrollmentsUpdatedSubscriptionVariables> & ({ variables: EnrollmentsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EnrollmentsUpdatedSubscription, EnrollmentsUpdatedSubscriptionVariables>(EnrollmentsUpdatedDocument, options);
      }
export type EnrollmentsUpdatedSubscriptionHookResult = ReturnType<typeof useEnrollmentsUpdatedSubscription>;
export type EnrollmentsUpdatedSubscriptionResult = Apollo.SubscriptionResult<EnrollmentsUpdatedSubscription>;
export const ForceSubmissionsV2Document = gql`
    mutation forceSubmissionsV2($assessmentId: ID!, $workIds: [ID]!, $type: SubmissionType!, $submittedAt: DateTime!) {
  forceSubmissionsV2(
    assessmentId: $assessmentId
    workIds: $workIds
    type: $type
    submittedAt: $submittedAt
  ) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export type ForceSubmissionsV2MutationFn = Apollo.MutationFunction<ForceSubmissionsV2Mutation, ForceSubmissionsV2MutationVariables>;

/**
 * __useForceSubmissionsV2Mutation__
 *
 * To run a mutation, you first call `useForceSubmissionsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceSubmissionsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceSubmissionsV2Mutation, { data, loading, error }] = useForceSubmissionsV2Mutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workIds: // value for 'workIds'
 *      type: // value for 'type'
 *      submittedAt: // value for 'submittedAt'
 *   },
 * });
 */
export function useForceSubmissionsV2Mutation(baseOptions?: Apollo.MutationHookOptions<ForceSubmissionsV2Mutation, ForceSubmissionsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceSubmissionsV2Mutation, ForceSubmissionsV2MutationVariables>(ForceSubmissionsV2Document, options);
      }
export type ForceSubmissionsV2MutationHookResult = ReturnType<typeof useForceSubmissionsV2Mutation>;
export type ForceSubmissionsV2MutationResult = Apollo.MutationResult<ForceSubmissionsV2Mutation>;
export type ForceSubmissionsV2MutationOptions = Apollo.BaseMutationOptions<ForceSubmissionsV2Mutation, ForceSubmissionsV2MutationVariables>;
export const ForceSubmissionsDocument = gql`
    mutation forceSubmissions($assessmentId: ID!, $workIds: [ID]!, $type: SubmissionType!, $submittedAt: DateTime!) {
  forceSubmissions(
    assessmentId: $assessmentId
    workIds: $workIds
    type: $type
    submittedAt: $submittedAt
  ) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export type ForceSubmissionsMutationFn = Apollo.MutationFunction<ForceSubmissionsMutation, ForceSubmissionsMutationVariables>;

/**
 * __useForceSubmissionsMutation__
 *
 * To run a mutation, you first call `useForceSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceSubmissionsMutation, { data, loading, error }] = useForceSubmissionsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      workIds: // value for 'workIds'
 *      type: // value for 'type'
 *      submittedAt: // value for 'submittedAt'
 *   },
 * });
 */
export function useForceSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<ForceSubmissionsMutation, ForceSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceSubmissionsMutation, ForceSubmissionsMutationVariables>(ForceSubmissionsDocument, options);
      }
export type ForceSubmissionsMutationHookResult = ReturnType<typeof useForceSubmissionsMutation>;
export type ForceSubmissionsMutationResult = Apollo.MutationResult<ForceSubmissionsMutation>;
export type ForceSubmissionsMutationOptions = Apollo.BaseMutationOptions<ForceSubmissionsMutation, ForceSubmissionsMutationVariables>;
export const InsertSyncRosterJobDocument = gql`
    mutation InsertSyncRosterJob($assessmentId: ID!, $withExtensions: Boolean, $extensionConflictAction: ExtensionConflictActionType) {
  insertSyncRosterJob(
    assessmentId: $assessmentId
    withExtensions: $withExtensions
    extensionConflictAction: $extensionConflictAction
  ) {
    ...BackgroundJob
  }
}
    ${BackgroundJobFragmentDoc}`;
export type InsertSyncRosterJobMutationFn = Apollo.MutationFunction<InsertSyncRosterJobMutation, InsertSyncRosterJobMutationVariables>;

/**
 * __useInsertSyncRosterJobMutation__
 *
 * To run a mutation, you first call `useInsertSyncRosterJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSyncRosterJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSyncRosterJobMutation, { data, loading, error }] = useInsertSyncRosterJobMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      withExtensions: // value for 'withExtensions'
 *      extensionConflictAction: // value for 'extensionConflictAction'
 *   },
 * });
 */
export function useInsertSyncRosterJobMutation(baseOptions?: Apollo.MutationHookOptions<InsertSyncRosterJobMutation, InsertSyncRosterJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSyncRosterJobMutation, InsertSyncRosterJobMutationVariables>(InsertSyncRosterJobDocument, options);
      }
export type InsertSyncRosterJobMutationHookResult = ReturnType<typeof useInsertSyncRosterJobMutation>;
export type InsertSyncRosterJobMutationResult = Apollo.MutationResult<InsertSyncRosterJobMutation>;
export type InsertSyncRosterJobMutationOptions = Apollo.BaseMutationOptions<InsertSyncRosterJobMutation, InsertSyncRosterJobMutationVariables>;
export const RemoveTagDocument = gql`
    mutation RemoveTag($enrollmentId: ID!, $text: String!, $column: Int!) {
  removeTag(enrollmentId: $enrollmentId, text: $text, column: $column)
}
    `;
export type RemoveTagMutationFn = Apollo.MutationFunction<RemoveTagMutation, RemoveTagMutationVariables>;

/**
 * __useRemoveTagMutation__
 *
 * To run a mutation, you first call `useRemoveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagMutation, { data, loading, error }] = useRemoveTagMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *      text: // value for 'text'
 *      column: // value for 'column'
 *   },
 * });
 */
export function useRemoveTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagMutation, RemoveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagMutation, RemoveTagMutationVariables>(RemoveTagDocument, options);
      }
export type RemoveTagMutationHookResult = ReturnType<typeof useRemoveTagMutation>;
export type RemoveTagMutationResult = Apollo.MutationResult<RemoveTagMutation>;
export type RemoveTagMutationOptions = Apollo.BaseMutationOptions<RemoveTagMutation, RemoveTagMutationVariables>;
export const ResultsUpdatedDocument = gql`
    subscription ResultsUpdated($assessmentId: ID!) {
  resultsUpdated(assessmentId: $assessmentId) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;

/**
 * __useResultsUpdatedSubscription__
 *
 * To run a query within a React component, call `useResultsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResultsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultsUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useResultsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ResultsUpdatedSubscription, ResultsUpdatedSubscriptionVariables> & ({ variables: ResultsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResultsUpdatedSubscription, ResultsUpdatedSubscriptionVariables>(ResultsUpdatedDocument, options);
      }
export type ResultsUpdatedSubscriptionHookResult = ReturnType<typeof useResultsUpdatedSubscription>;
export type ResultsUpdatedSubscriptionResult = Apollo.SubscriptionResult<ResultsUpdatedSubscription>;
export const SendEmailsToClassDocument = gql`
    mutation sendEmailsToClass($assessmentId: ID!, $submissionIds: [ID]!) {
  sendEmailsToClass(assessmentId: $assessmentId, submissionIds: $submissionIds)
}
    `;
export type SendEmailsToClassMutationFn = Apollo.MutationFunction<SendEmailsToClassMutation, SendEmailsToClassMutationVariables>;

/**
 * __useSendEmailsToClassMutation__
 *
 * To run a mutation, you first call `useSendEmailsToClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailsToClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailsToClassMutation, { data, loading, error }] = useSendEmailsToClassMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      submissionIds: // value for 'submissionIds'
 *   },
 * });
 */
export function useSendEmailsToClassMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailsToClassMutation, SendEmailsToClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailsToClassMutation, SendEmailsToClassMutationVariables>(SendEmailsToClassDocument, options);
      }
export type SendEmailsToClassMutationHookResult = ReturnType<typeof useSendEmailsToClassMutation>;
export type SendEmailsToClassMutationResult = Apollo.MutationResult<SendEmailsToClassMutation>;
export type SendEmailsToClassMutationOptions = Apollo.BaseMutationOptions<SendEmailsToClassMutation, SendEmailsToClassMutationVariables>;
export const SyncGradesDocument = gql`
    mutation SyncGrades($assessmentId: ID!) {
  syncGrades(assessmentId: $assessmentId)
}
    `;
export type SyncGradesMutationFn = Apollo.MutationFunction<SyncGradesMutation, SyncGradesMutationVariables>;

/**
 * __useSyncGradesMutation__
 *
 * To run a mutation, you first call `useSyncGradesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncGradesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncGradesMutation, { data, loading, error }] = useSyncGradesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useSyncGradesMutation(baseOptions?: Apollo.MutationHookOptions<SyncGradesMutation, SyncGradesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncGradesMutation, SyncGradesMutationVariables>(SyncGradesDocument, options);
      }
export type SyncGradesMutationHookResult = ReturnType<typeof useSyncGradesMutation>;
export type SyncGradesMutationResult = Apollo.MutationResult<SyncGradesMutation>;
export type SyncGradesMutationOptions = Apollo.BaseMutationOptions<SyncGradesMutation, SyncGradesMutationVariables>;
export const SyncRosterDocument = gql`
    mutation SyncRoster($assessmentId: ID!, $withExtensions: Boolean, $extensionConflictAction: ExtensionConflictActionType) {
  syncRoster(
    assessmentId: $assessmentId
    withExtensions: $withExtensions
    extensionConflictAction: $extensionConflictAction
  ) {
    ...Enrollment
  }
}
    ${EnrollmentFragmentDoc}`;
export type SyncRosterMutationFn = Apollo.MutationFunction<SyncRosterMutation, SyncRosterMutationVariables>;

/**
 * __useSyncRosterMutation__
 *
 * To run a mutation, you first call `useSyncRosterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncRosterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncRosterMutation, { data, loading, error }] = useSyncRosterMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      withExtensions: // value for 'withExtensions'
 *      extensionConflictAction: // value for 'extensionConflictAction'
 *   },
 * });
 */
export function useSyncRosterMutation(baseOptions?: Apollo.MutationHookOptions<SyncRosterMutation, SyncRosterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncRosterMutation, SyncRosterMutationVariables>(SyncRosterDocument, options);
      }
export type SyncRosterMutationHookResult = ReturnType<typeof useSyncRosterMutation>;
export type SyncRosterMutationResult = Apollo.MutationResult<SyncRosterMutation>;
export type SyncRosterMutationOptions = Apollo.BaseMutationOptions<SyncRosterMutation, SyncRosterMutationVariables>;
export const UpdateStudentSettingsDocument = gql`
    mutation UpdateStudentSettings($assessmentId: ID!, $settings: [StudentSettingsInput]!) {
  updateStudentSettings(assessmentId: $assessmentId, settings: $settings) {
    ...WorkSettings
    studentId
  }
}
    ${WorkSettingsFragmentDoc}`;
export type UpdateStudentSettingsMutationFn = Apollo.MutationFunction<UpdateStudentSettingsMutation, UpdateStudentSettingsMutationVariables>;

/**
 * __useUpdateStudentSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateStudentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentSettingsMutation, { data, loading, error }] = useUpdateStudentSettingsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateStudentSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentSettingsMutation, UpdateStudentSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentSettingsMutation, UpdateStudentSettingsMutationVariables>(UpdateStudentSettingsDocument, options);
      }
export type UpdateStudentSettingsMutationHookResult = ReturnType<typeof useUpdateStudentSettingsMutation>;
export type UpdateStudentSettingsMutationResult = Apollo.MutationResult<UpdateStudentSettingsMutation>;
export type UpdateStudentSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateStudentSettingsMutation, UpdateStudentSettingsMutationVariables>;
export const UpdateWorkSettingsDocument = gql`
    mutation UpdateWorkSettings($assessmentId: ID!, $enrollmentId: ID!, $dueDate: DateTime, $timeLimit: Int) {
  updateWorkSettings(
    assessmentId: $assessmentId
    enrollmentId: $enrollmentId
    dueDate: $dueDate
    timeLimit: $timeLimit
  ) {
    id
    dueDate
    timeLimit
  }
}
    `;
export type UpdateWorkSettingsMutationFn = Apollo.MutationFunction<UpdateWorkSettingsMutation, UpdateWorkSettingsMutationVariables>;

/**
 * __useUpdateWorkSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkSettingsMutation, { data, loading, error }] = useUpdateWorkSettingsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      enrollmentId: // value for 'enrollmentId'
 *      dueDate: // value for 'dueDate'
 *      timeLimit: // value for 'timeLimit'
 *   },
 * });
 */
export function useUpdateWorkSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkSettingsMutation, UpdateWorkSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkSettingsMutation, UpdateWorkSettingsMutationVariables>(UpdateWorkSettingsDocument, options);
      }
export type UpdateWorkSettingsMutationHookResult = ReturnType<typeof useUpdateWorkSettingsMutation>;
export type UpdateWorkSettingsMutationResult = Apollo.MutationResult<UpdateWorkSettingsMutation>;
export type UpdateWorkSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkSettingsMutation, UpdateWorkSettingsMutationVariables>;
export const UpdateEnrollmentsStatusDocument = gql`
    mutation UpdateEnrollmentsStatus($enrollmentIds: [ID!]!, $withdrawn: Boolean!, $assessmentId: ID!) {
  updateEnrollmentsStatus(
    assessmentId: $assessmentId
    enrollmentIds: $enrollmentIds
    withdrawn: $withdrawn
  ) {
    ...Enrollment
  }
}
    ${EnrollmentFragmentDoc}`;
export type UpdateEnrollmentsStatusMutationFn = Apollo.MutationFunction<UpdateEnrollmentsStatusMutation, UpdateEnrollmentsStatusMutationVariables>;

/**
 * __useUpdateEnrollmentsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEnrollmentsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnrollmentsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnrollmentsStatusMutation, { data, loading, error }] = useUpdateEnrollmentsStatusMutation({
 *   variables: {
 *      enrollmentIds: // value for 'enrollmentIds'
 *      withdrawn: // value for 'withdrawn'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useUpdateEnrollmentsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnrollmentsStatusMutation, UpdateEnrollmentsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnrollmentsStatusMutation, UpdateEnrollmentsStatusMutationVariables>(UpdateEnrollmentsStatusDocument, options);
      }
export type UpdateEnrollmentsStatusMutationHookResult = ReturnType<typeof useUpdateEnrollmentsStatusMutation>;
export type UpdateEnrollmentsStatusMutationResult = Apollo.MutationResult<UpdateEnrollmentsStatusMutation>;
export type UpdateEnrollmentsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEnrollmentsStatusMutation, UpdateEnrollmentsStatusMutationVariables>;
export const WorksSettingsUpdatedDocument = gql`
    subscription WorksSettingsUpdated($assessmentId: ID!) {
  worksSettingsUpdated(assessmentId: $assessmentId) {
    ...WorkSettings
  }
}
    ${WorkSettingsFragmentDoc}`;

/**
 * __useWorksSettingsUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorksSettingsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorksSettingsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksSettingsUpdatedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useWorksSettingsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorksSettingsUpdatedSubscription, WorksSettingsUpdatedSubscriptionVariables> & ({ variables: WorksSettingsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorksSettingsUpdatedSubscription, WorksSettingsUpdatedSubscriptionVariables>(WorksSettingsUpdatedDocument, options);
      }
export type WorksSettingsUpdatedSubscriptionHookResult = ReturnType<typeof useWorksSettingsUpdatedSubscription>;
export type WorksSettingsUpdatedSubscriptionResult = Apollo.SubscriptionResult<WorksSettingsUpdatedSubscription>;
export const AppendTagsForQuestionsDocument = gql`
    mutation AppendTagsForQuestions($id: [ID!]!, $input: [TagInput!]!) {
  appendTagsForQuestions(questionIds: $id, input: $input) {
    id
    cacheId
    tags {
      id
      name
    }
  }
}
    `;
export type AppendTagsForQuestionsMutationFn = Apollo.MutationFunction<AppendTagsForQuestionsMutation, AppendTagsForQuestionsMutationVariables>;

/**
 * __useAppendTagsForQuestionsMutation__
 *
 * To run a mutation, you first call `useAppendTagsForQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendTagsForQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendTagsForQuestionsMutation, { data, loading, error }] = useAppendTagsForQuestionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppendTagsForQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<AppendTagsForQuestionsMutation, AppendTagsForQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendTagsForQuestionsMutation, AppendTagsForQuestionsMutationVariables>(AppendTagsForQuestionsDocument, options);
      }
export type AppendTagsForQuestionsMutationHookResult = ReturnType<typeof useAppendTagsForQuestionsMutation>;
export type AppendTagsForQuestionsMutationResult = Apollo.MutationResult<AppendTagsForQuestionsMutation>;
export type AppendTagsForQuestionsMutationOptions = Apollo.BaseMutationOptions<AppendTagsForQuestionsMutation, AppendTagsForQuestionsMutationVariables>;
export const ArchiveQuestionDocument = gql`
    mutation ArchiveQuestion($questionId: ID!) {
  archiveQuestion(questionId: $questionId) {
    ...LibraryQuestionOverview
  }
}
    ${LibraryQuestionOverviewFragmentDoc}`;
export type ArchiveQuestionMutationFn = Apollo.MutationFunction<ArchiveQuestionMutation, ArchiveQuestionMutationVariables>;

/**
 * __useArchiveQuestionMutation__
 *
 * To run a mutation, you first call `useArchiveQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveQuestionMutation, { data, loading, error }] = useArchiveQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useArchiveQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveQuestionMutation, ArchiveQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveQuestionMutation, ArchiveQuestionMutationVariables>(ArchiveQuestionDocument, options);
      }
export type ArchiveQuestionMutationHookResult = ReturnType<typeof useArchiveQuestionMutation>;
export type ArchiveQuestionMutationResult = Apollo.MutationResult<ArchiveQuestionMutation>;
export type ArchiveQuestionMutationOptions = Apollo.BaseMutationOptions<ArchiveQuestionMutation, ArchiveQuestionMutationVariables>;
export const CopyQuestionDocument = gql`
    mutation CopyQuestion($questionId: ID!) {
  copyQuestion(questionId: $questionId) {
    ...LibraryQuestionOverview
  }
}
    ${LibraryQuestionOverviewFragmentDoc}`;
export type CopyQuestionMutationFn = Apollo.MutationFunction<CopyQuestionMutation, CopyQuestionMutationVariables>;

/**
 * __useCopyQuestionMutation__
 *
 * To run a mutation, you first call `useCopyQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyQuestionMutation, { data, loading, error }] = useCopyQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useCopyQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CopyQuestionMutation, CopyQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyQuestionMutation, CopyQuestionMutationVariables>(CopyQuestionDocument, options);
      }
export type CopyQuestionMutationHookResult = ReturnType<typeof useCopyQuestionMutation>;
export type CopyQuestionMutationResult = Apollo.MutationResult<CopyQuestionMutation>;
export type CopyQuestionMutationOptions = Apollo.BaseMutationOptions<CopyQuestionMutation, CopyQuestionMutationVariables>;
export const CreateQuestionDocument = gql`
    mutation CreateQuestion($assessmentId: ID!, $childrenQuestions: [QuestionAttributes!], $input: QuestionAttributes!, $subjectId: ID!) {
  createQuestion(
    assessmentId: $assessmentId
    childrenQuestions: $childrenQuestions
    input: $input
    subjectId: $subjectId
  ) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      childrenQuestions: // value for 'childrenQuestions'
 *      input: // value for 'input'
 *      subjectId: // value for 'subjectId'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, options);
      }
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const CreateQuestionSelectionDocument = gql`
    mutation CreateQuestionSelection($input: QuestionSelectionInput!) {
  createQuestionSelection(input: $input) {
    selection {
      ...QuestionSelection
    }
    incompleteRuleIndex
    selectedQuestionCount
    requiredQuestionCount
  }
}
    ${QuestionSelectionFragmentDoc}`;
export type CreateQuestionSelectionMutationFn = Apollo.MutationFunction<CreateQuestionSelectionMutation, CreateQuestionSelectionMutationVariables>;

/**
 * __useCreateQuestionSelectionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionSelectionMutation, { data, loading, error }] = useCreateQuestionSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionSelectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionSelectionMutation, CreateQuestionSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionSelectionMutation, CreateQuestionSelectionMutationVariables>(CreateQuestionSelectionDocument, options);
      }
export type CreateQuestionSelectionMutationHookResult = ReturnType<typeof useCreateQuestionSelectionMutation>;
export type CreateQuestionSelectionMutationResult = Apollo.MutationResult<CreateQuestionSelectionMutation>;
export type CreateQuestionSelectionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionSelectionMutation, CreateQuestionSelectionMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($name: String!) {
  createTag(name: $name) {
    id
    name
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const FindSimilarQuestionsDocument = gql`
    mutation FindSimilarQuestions($input: FindSimilarQuestionsInput!) {
  findSimilarQuestions(input: $input) {
    questions {
      id
      cacheId
    }
    incompleteReplacement
  }
}
    `;
export type FindSimilarQuestionsMutationFn = Apollo.MutationFunction<FindSimilarQuestionsMutation, FindSimilarQuestionsMutationVariables>;

/**
 * __useFindSimilarQuestionsMutation__
 *
 * To run a mutation, you first call `useFindSimilarQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindSimilarQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findSimilarQuestionsMutation, { data, loading, error }] = useFindSimilarQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindSimilarQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<FindSimilarQuestionsMutation, FindSimilarQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindSimilarQuestionsMutation, FindSimilarQuestionsMutationVariables>(FindSimilarQuestionsDocument, options);
      }
export type FindSimilarQuestionsMutationHookResult = ReturnType<typeof useFindSimilarQuestionsMutation>;
export type FindSimilarQuestionsMutationResult = Apollo.MutationResult<FindSimilarQuestionsMutation>;
export type FindSimilarQuestionsMutationOptions = Apollo.BaseMutationOptions<FindSimilarQuestionsMutation, FindSimilarQuestionsMutationVariables>;
export const LibraryQuestionDocument = gql`
    query LibraryQuestion($id: ID!) {
  question(questionId: $id) {
    ...LibraryQuestion
  }
  questionTagCategories {
    ...QuestionTagCategory
  }
}
    ${LibraryQuestionFragmentDoc}
${QuestionTagCategoryFragmentDoc}`;

/**
 * __useLibraryQuestionQuery__
 *
 * To run a query within a React component, call `useLibraryQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLibraryQuestionQuery(baseOptions: Apollo.QueryHookOptions<LibraryQuestionQuery, LibraryQuestionQueryVariables> & ({ variables: LibraryQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryQuestionQuery, LibraryQuestionQueryVariables>(LibraryQuestionDocument, options);
      }
export function useLibraryQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryQuestionQuery, LibraryQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryQuestionQuery, LibraryQuestionQueryVariables>(LibraryQuestionDocument, options);
        }
export function useLibraryQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryQuestionQuery, LibraryQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryQuestionQuery, LibraryQuestionQueryVariables>(LibraryQuestionDocument, options);
        }
export type LibraryQuestionQueryHookResult = ReturnType<typeof useLibraryQuestionQuery>;
export type LibraryQuestionLazyQueryHookResult = ReturnType<typeof useLibraryQuestionLazyQuery>;
export type LibraryQuestionSuspenseQueryHookResult = ReturnType<typeof useLibraryQuestionSuspenseQuery>;
export type LibraryQuestionQueryResult = Apollo.QueryResult<LibraryQuestionQuery, LibraryQuestionQueryVariables>;
export const LibraryQuestionsDocument = gql`
    query LibraryQuestions($assessmentId: ID!) {
  libraryQuestions {
    ...LibraryQuestionOverview
  }
  assessment(assessmentId: $assessmentId) {
    subjectId
    name
  }
  task(assessmentId: $assessmentId) {
    id
    blocks {
      id
      libraryQuestionId
      questionSelection {
        sets {
          ...QuestionSet
        }
      }
    }
  }
}
    ${LibraryQuestionOverviewFragmentDoc}
${QuestionSetFragmentDoc}`;

/**
 * __useLibraryQuestionsQuery__
 *
 * To run a query within a React component, call `useLibraryQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryQuestionsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useLibraryQuestionsQuery(baseOptions: Apollo.QueryHookOptions<LibraryQuestionsQuery, LibraryQuestionsQueryVariables> & ({ variables: LibraryQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>(LibraryQuestionsDocument, options);
      }
export function useLibraryQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>(LibraryQuestionsDocument, options);
        }
export function useLibraryQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>(LibraryQuestionsDocument, options);
        }
export type LibraryQuestionsQueryHookResult = ReturnType<typeof useLibraryQuestionsQuery>;
export type LibraryQuestionsLazyQueryHookResult = ReturnType<typeof useLibraryQuestionsLazyQuery>;
export type LibraryQuestionsSuspenseQueryHookResult = ReturnType<typeof useLibraryQuestionsSuspenseQuery>;
export type LibraryQuestionsQueryResult = Apollo.QueryResult<LibraryQuestionsQuery, LibraryQuestionsQueryVariables>;
export const PublishImportedQuestionsDocument = gql`
    mutation PublishImportedQuestions($input: PublishImportedQuestionsInput!) {
  publishImportedQuestions(input: $input) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
export type PublishImportedQuestionsMutationFn = Apollo.MutationFunction<PublishImportedQuestionsMutation, PublishImportedQuestionsMutationVariables>;

/**
 * __usePublishImportedQuestionsMutation__
 *
 * To run a mutation, you first call `usePublishImportedQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishImportedQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishImportedQuestionsMutation, { data, loading, error }] = usePublishImportedQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishImportedQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<PublishImportedQuestionsMutation, PublishImportedQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishImportedQuestionsMutation, PublishImportedQuestionsMutationVariables>(PublishImportedQuestionsDocument, options);
      }
export type PublishImportedQuestionsMutationHookResult = ReturnType<typeof usePublishImportedQuestionsMutation>;
export type PublishImportedQuestionsMutationResult = Apollo.MutationResult<PublishImportedQuestionsMutation>;
export type PublishImportedQuestionsMutationOptions = Apollo.BaseMutationOptions<PublishImportedQuestionsMutation, PublishImportedQuestionsMutationVariables>;
export const QuestionContentDocument = gql`
    query QuestionContent($questionId: ID!) {
  question(questionId: $questionId) {
    id
    cacheId
    body {
      ...QuestionBody
    }
    childrenQuestions {
      ...LibraryQuestionOverview
      body {
        ...QuestionBody
      }
    }
  }
}
    ${QuestionBodyFragmentDoc}
${LibraryQuestionOverviewFragmentDoc}`;

/**
 * __useQuestionContentQuery__
 *
 * To run a query within a React component, call `useQuestionContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionContentQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useQuestionContentQuery(baseOptions: Apollo.QueryHookOptions<QuestionContentQuery, QuestionContentQueryVariables> & ({ variables: QuestionContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionContentQuery, QuestionContentQueryVariables>(QuestionContentDocument, options);
      }
export function useQuestionContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionContentQuery, QuestionContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionContentQuery, QuestionContentQueryVariables>(QuestionContentDocument, options);
        }
export function useQuestionContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionContentQuery, QuestionContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionContentQuery, QuestionContentQueryVariables>(QuestionContentDocument, options);
        }
export type QuestionContentQueryHookResult = ReturnType<typeof useQuestionContentQuery>;
export type QuestionContentLazyQueryHookResult = ReturnType<typeof useQuestionContentLazyQuery>;
export type QuestionContentSuspenseQueryHookResult = ReturnType<typeof useQuestionContentSuspenseQuery>;
export type QuestionContentQueryResult = Apollo.QueryResult<QuestionContentQuery, QuestionContentQueryVariables>;
export const QuestionSelectionDocument = gql`
    query QuestionSelection($questionSelectionId: ID!, $assessmentId: ID!) {
  questionSelection(questionSelectionId: $questionSelectionId) {
    ...QuestionSelection
  }
  assessment(assessmentId: $assessmentId) {
    subjectId
    name
  }
  task(assessmentId: $assessmentId) {
    id
  }
}
    ${QuestionSelectionFragmentDoc}`;

/**
 * __useQuestionSelectionQuery__
 *
 * To run a query within a React component, call `useQuestionSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionSelectionQuery({
 *   variables: {
 *      questionSelectionId: // value for 'questionSelectionId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useQuestionSelectionQuery(baseOptions: Apollo.QueryHookOptions<QuestionSelectionQuery, QuestionSelectionQueryVariables> & ({ variables: QuestionSelectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionSelectionQuery, QuestionSelectionQueryVariables>(QuestionSelectionDocument, options);
      }
export function useQuestionSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionSelectionQuery, QuestionSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionSelectionQuery, QuestionSelectionQueryVariables>(QuestionSelectionDocument, options);
        }
export function useQuestionSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionSelectionQuery, QuestionSelectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionSelectionQuery, QuestionSelectionQueryVariables>(QuestionSelectionDocument, options);
        }
export type QuestionSelectionQueryHookResult = ReturnType<typeof useQuestionSelectionQuery>;
export type QuestionSelectionLazyQueryHookResult = ReturnType<typeof useQuestionSelectionLazyQuery>;
export type QuestionSelectionSuspenseQueryHookResult = ReturnType<typeof useQuestionSelectionSuspenseQuery>;
export type QuestionSelectionQueryResult = Apollo.QueryResult<QuestionSelectionQuery, QuestionSelectionQueryVariables>;
export const QuestionVersionDocument = gql`
    query QuestionVersion($versionId: ID!) {
  questionVersion(versionId: $versionId) {
    ...QuestionVersion
  }
}
    ${QuestionVersionFragmentDoc}`;

/**
 * __useQuestionVersionQuery__
 *
 * To run a query within a React component, call `useQuestionVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionVersionQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useQuestionVersionQuery(baseOptions: Apollo.QueryHookOptions<QuestionVersionQuery, QuestionVersionQueryVariables> & ({ variables: QuestionVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionVersionQuery, QuestionVersionQueryVariables>(QuestionVersionDocument, options);
      }
export function useQuestionVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionVersionQuery, QuestionVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionVersionQuery, QuestionVersionQueryVariables>(QuestionVersionDocument, options);
        }
export function useQuestionVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionVersionQuery, QuestionVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionVersionQuery, QuestionVersionQueryVariables>(QuestionVersionDocument, options);
        }
export type QuestionVersionQueryHookResult = ReturnType<typeof useQuestionVersionQuery>;
export type QuestionVersionLazyQueryHookResult = ReturnType<typeof useQuestionVersionLazyQuery>;
export type QuestionVersionSuspenseQueryHookResult = ReturnType<typeof useQuestionVersionSuspenseQuery>;
export type QuestionVersionQueryResult = Apollo.QueryResult<QuestionVersionQuery, QuestionVersionQueryVariables>;
export const RegenerateQuestionSetDocument = gql`
    mutation RegenerateQuestionSet($input: RegenerateQuestionSetInput!) {
  regenerateQuestionSet(input: $input) {
    questionSet {
      ...QuestionSet
    }
    incompleteReplacement
  }
}
    ${QuestionSetFragmentDoc}`;
export type RegenerateQuestionSetMutationFn = Apollo.MutationFunction<RegenerateQuestionSetMutation, RegenerateQuestionSetMutationVariables>;

/**
 * __useRegenerateQuestionSetMutation__
 *
 * To run a mutation, you first call `useRegenerateQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateQuestionSetMutation, { data, loading, error }] = useRegenerateQuestionSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateQuestionSetMutation, RegenerateQuestionSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateQuestionSetMutation, RegenerateQuestionSetMutationVariables>(RegenerateQuestionSetDocument, options);
      }
export type RegenerateQuestionSetMutationHookResult = ReturnType<typeof useRegenerateQuestionSetMutation>;
export type RegenerateQuestionSetMutationResult = Apollo.MutationResult<RegenerateQuestionSetMutation>;
export type RegenerateQuestionSetMutationOptions = Apollo.BaseMutationOptions<RegenerateQuestionSetMutation, RegenerateQuestionSetMutationVariables>;
export const RegisterQuestionSourceFileDocument = gql`
    mutation RegisterQuestionSourceFile($input: RegisterQuestionSourceFileInput!) {
  registerQuestionSourceFile(input: $input) {
    ...QuestionSourceFile
  }
}
    ${QuestionSourceFileFragmentDoc}`;
export type RegisterQuestionSourceFileMutationFn = Apollo.MutationFunction<RegisterQuestionSourceFileMutation, RegisterQuestionSourceFileMutationVariables>;

/**
 * __useRegisterQuestionSourceFileMutation__
 *
 * To run a mutation, you first call `useRegisterQuestionSourceFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterQuestionSourceFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerQuestionSourceFileMutation, { data, loading, error }] = useRegisterQuestionSourceFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterQuestionSourceFileMutation(baseOptions?: Apollo.MutationHookOptions<RegisterQuestionSourceFileMutation, RegisterQuestionSourceFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterQuestionSourceFileMutation, RegisterQuestionSourceFileMutationVariables>(RegisterQuestionSourceFileDocument, options);
      }
export type RegisterQuestionSourceFileMutationHookResult = ReturnType<typeof useRegisterQuestionSourceFileMutation>;
export type RegisterQuestionSourceFileMutationResult = Apollo.MutationResult<RegisterQuestionSourceFileMutation>;
export type RegisterQuestionSourceFileMutationOptions = Apollo.BaseMutationOptions<RegisterQuestionSourceFileMutation, RegisterQuestionSourceFileMutationVariables>;
export const RemoveQuestionsUniformlyDocument = gql`
    mutation RemoveQuestionsUniformly($input: RemoveQuestionsUniformlyInput!) {
  removeQuestionsUniformly(input: $input) {
    ...QuestionSelection
  }
}
    ${QuestionSelectionFragmentDoc}`;
export type RemoveQuestionsUniformlyMutationFn = Apollo.MutationFunction<RemoveQuestionsUniformlyMutation, RemoveQuestionsUniformlyMutationVariables>;

/**
 * __useRemoveQuestionsUniformlyMutation__
 *
 * To run a mutation, you first call `useRemoveQuestionsUniformlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuestionsUniformlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuestionsUniformlyMutation, { data, loading, error }] = useRemoveQuestionsUniformlyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveQuestionsUniformlyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQuestionsUniformlyMutation, RemoveQuestionsUniformlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQuestionsUniformlyMutation, RemoveQuestionsUniformlyMutationVariables>(RemoveQuestionsUniformlyDocument, options);
      }
export type RemoveQuestionsUniformlyMutationHookResult = ReturnType<typeof useRemoveQuestionsUniformlyMutation>;
export type RemoveQuestionsUniformlyMutationResult = Apollo.MutationResult<RemoveQuestionsUniformlyMutation>;
export type RemoveQuestionsUniformlyMutationOptions = Apollo.BaseMutationOptions<RemoveQuestionsUniformlyMutation, RemoveQuestionsUniformlyMutationVariables>;
export const ReplaceQuestionInSetDocument = gql`
    mutation ReplaceQuestionInSet($input: ReplaceQuestionInSetInput!) {
  replaceQuestionInSet(input: $input) {
    ...QuestionSet
  }
}
    ${QuestionSetFragmentDoc}`;
export type ReplaceQuestionInSetMutationFn = Apollo.MutationFunction<ReplaceQuestionInSetMutation, ReplaceQuestionInSetMutationVariables>;

/**
 * __useReplaceQuestionInSetMutation__
 *
 * To run a mutation, you first call `useReplaceQuestionInSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceQuestionInSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceQuestionInSetMutation, { data, loading, error }] = useReplaceQuestionInSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceQuestionInSetMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceQuestionInSetMutation, ReplaceQuestionInSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceQuestionInSetMutation, ReplaceQuestionInSetMutationVariables>(ReplaceQuestionInSetDocument, options);
      }
export type ReplaceQuestionInSetMutationHookResult = ReturnType<typeof useReplaceQuestionInSetMutation>;
export type ReplaceQuestionInSetMutationResult = Apollo.MutationResult<ReplaceQuestionInSetMutation>;
export type ReplaceQuestionInSetMutationOptions = Apollo.BaseMutationOptions<ReplaceQuestionInSetMutation, ReplaceQuestionInSetMutationVariables>;
export const UpdateQuestionAttributesDocument = gql`
    mutation UpdateQuestionAttributes($questionIds: [ID!]!, $input: QuestionAttributesInput!) {
  updateQuestionAttributes(questionIds: $questionIds, input: $input) {
    ...LibraryQuestionOverview
  }
}
    ${LibraryQuestionOverviewFragmentDoc}`;
export type UpdateQuestionAttributesMutationFn = Apollo.MutationFunction<UpdateQuestionAttributesMutation, UpdateQuestionAttributesMutationVariables>;

/**
 * __useUpdateQuestionAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionAttributesMutation, { data, loading, error }] = useUpdateQuestionAttributesMutation({
 *   variables: {
 *      questionIds: // value for 'questionIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionAttributesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionAttributesMutation, UpdateQuestionAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionAttributesMutation, UpdateQuestionAttributesMutationVariables>(UpdateQuestionAttributesDocument, options);
      }
export type UpdateQuestionAttributesMutationHookResult = ReturnType<typeof useUpdateQuestionAttributesMutation>;
export type UpdateQuestionAttributesMutationResult = Apollo.MutationResult<UpdateQuestionAttributesMutation>;
export type UpdateQuestionAttributesMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionAttributesMutation, UpdateQuestionAttributesMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation UpdateQuestion($questionId: ID!, $input: QuestionAttributesInput!) {
  updateQuestion(questionId: $questionId, input: $input) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<UpdateQuestionMutation, UpdateQuestionMutationVariables>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionMutation, UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
      }
export type UpdateQuestionMutationHookResult = ReturnType<typeof useUpdateQuestionMutation>;
export type UpdateQuestionMutationResult = Apollo.MutationResult<UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const UpdateQuestionSourceFileDocument = gql`
    mutation UpdateQuestionSourceFile($input: UpdateQuestionSourceFileInput!) {
  updateQuestionSourceFile(input: $input) {
    ...QuestionSourceFile
  }
}
    ${QuestionSourceFileFragmentDoc}`;
export type UpdateQuestionSourceFileMutationFn = Apollo.MutationFunction<UpdateQuestionSourceFileMutation, UpdateQuestionSourceFileMutationVariables>;

/**
 * __useUpdateQuestionSourceFileMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionSourceFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionSourceFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionSourceFileMutation, { data, loading, error }] = useUpdateQuestionSourceFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionSourceFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionSourceFileMutation, UpdateQuestionSourceFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionSourceFileMutation, UpdateQuestionSourceFileMutationVariables>(UpdateQuestionSourceFileDocument, options);
      }
export type UpdateQuestionSourceFileMutationHookResult = ReturnType<typeof useUpdateQuestionSourceFileMutation>;
export type UpdateQuestionSourceFileMutationResult = Apollo.MutationResult<UpdateQuestionSourceFileMutation>;
export type UpdateQuestionSourceFileMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionSourceFileMutation, UpdateQuestionSourceFileMutationVariables>;
export const UpdateQuestionVersionDocument = gql`
    mutation updateQuestionVersion($input: UpdateQuestionVersionInput!, $childrenQuestions: [UpdateQuestionVersionInput!]!) {
  updateQuestionVersion(input: $input, childrenQuestions: $childrenQuestions) {
    ...LibraryQuestion
  }
}
    ${LibraryQuestionFragmentDoc}`;
export type UpdateQuestionVersionMutationFn = Apollo.MutationFunction<UpdateQuestionVersionMutation, UpdateQuestionVersionMutationVariables>;

/**
 * __useUpdateQuestionVersionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionVersionMutation, { data, loading, error }] = useUpdateQuestionVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      childrenQuestions: // value for 'childrenQuestions'
 *   },
 * });
 */
export function useUpdateQuestionVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionVersionMutation, UpdateQuestionVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionVersionMutation, UpdateQuestionVersionMutationVariables>(UpdateQuestionVersionDocument, options);
      }
export type UpdateQuestionVersionMutationHookResult = ReturnType<typeof useUpdateQuestionVersionMutation>;
export type UpdateQuestionVersionMutationResult = Apollo.MutationResult<UpdateQuestionVersionMutation>;
export type UpdateQuestionVersionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionVersionMutation, UpdateQuestionVersionMutationVariables>;
export const UpdateTagsForQuestionDocument = gql`
    mutation UpdateTagsForQuestion($questionId: ID!, $input: [TagInput!]!) {
  updateTagsForQuestion(questionId: $questionId, input: $input) {
    id
    cacheId
    tags {
      ...QuestionTag
    }
  }
}
    ${QuestionTagFragmentDoc}`;
export type UpdateTagsForQuestionMutationFn = Apollo.MutationFunction<UpdateTagsForQuestionMutation, UpdateTagsForQuestionMutationVariables>;

/**
 * __useUpdateTagsForQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateTagsForQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagsForQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagsForQuestionMutation, { data, loading, error }] = useUpdateTagsForQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagsForQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagsForQuestionMutation, UpdateTagsForQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagsForQuestionMutation, UpdateTagsForQuestionMutationVariables>(UpdateTagsForQuestionDocument, options);
      }
export type UpdateTagsForQuestionMutationHookResult = ReturnType<typeof useUpdateTagsForQuestionMutation>;
export type UpdateTagsForQuestionMutationResult = Apollo.MutationResult<UpdateTagsForQuestionMutation>;
export type UpdateTagsForQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateTagsForQuestionMutation, UpdateTagsForQuestionMutationVariables>;
export const AssessmentSentimentDocument = gql`
    query AssessmentSentiment($assessmentId: ID!) {
  assessmentSentimentChecks(assessmentId: $assessmentId) {
    ...SentimentCheck
  }
}
    ${SentimentCheckFragmentDoc}`;

/**
 * __useAssessmentSentimentQuery__
 *
 * To run a query within a React component, call `useAssessmentSentimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentSentimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentSentimentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentSentimentQuery(baseOptions: Apollo.QueryHookOptions<AssessmentSentimentQuery, AssessmentSentimentQueryVariables> & ({ variables: AssessmentSentimentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>(AssessmentSentimentDocument, options);
      }
export function useAssessmentSentimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>(AssessmentSentimentDocument, options);
        }
export function useAssessmentSentimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>(AssessmentSentimentDocument, options);
        }
export type AssessmentSentimentQueryHookResult = ReturnType<typeof useAssessmentSentimentQuery>;
export type AssessmentSentimentLazyQueryHookResult = ReturnType<typeof useAssessmentSentimentLazyQuery>;
export type AssessmentSentimentSuspenseQueryHookResult = ReturnType<typeof useAssessmentSentimentSuspenseQuery>;
export type AssessmentSentimentQueryResult = Apollo.QueryResult<AssessmentSentimentQuery, AssessmentSentimentQueryVariables>;
export const SentimentDocument = gql`
    query Sentiment($assessmentId: ID!, $groupId: ID!) {
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  groupSentimentChecks(assessmentId: $assessmentId, groupId: $groupId) {
    ...SentimentCheck
  }
  class(assessmentId: $assessmentId) {
    groups {
      ...Group
    }
  }
}
    ${AssessmentFragmentDoc}
${SentimentCheckFragmentDoc}
${GroupFragmentDoc}`;

/**
 * __useSentimentQuery__
 *
 * To run a query within a React component, call `useSentimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentimentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useSentimentQuery(baseOptions: Apollo.QueryHookOptions<SentimentQuery, SentimentQueryVariables> & ({ variables: SentimentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentimentQuery, SentimentQueryVariables>(SentimentDocument, options);
      }
export function useSentimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentimentQuery, SentimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentimentQuery, SentimentQueryVariables>(SentimentDocument, options);
        }
export function useSentimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SentimentQuery, SentimentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentimentQuery, SentimentQueryVariables>(SentimentDocument, options);
        }
export type SentimentQueryHookResult = ReturnType<typeof useSentimentQuery>;
export type SentimentLazyQueryHookResult = ReturnType<typeof useSentimentLazyQuery>;
export type SentimentSuspenseQueryHookResult = ReturnType<typeof useSentimentSuspenseQuery>;
export type SentimentQueryResult = Apollo.QueryResult<SentimentQuery, SentimentQueryVariables>;
export const AddLibraryQuestionsToTaskDocument = gql`
    mutation AddLibraryQuestionsToTask($taskId: ID!, $questionIds: [ID!]!) {
  addLibraryQuestionsToTask(taskId: $taskId, questionIds: $questionIds) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type AddLibraryQuestionsToTaskMutationFn = Apollo.MutationFunction<AddLibraryQuestionsToTaskMutation, AddLibraryQuestionsToTaskMutationVariables>;

/**
 * __useAddLibraryQuestionsToTaskMutation__
 *
 * To run a mutation, you first call `useAddLibraryQuestionsToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLibraryQuestionsToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLibraryQuestionsToTaskMutation, { data, loading, error }] = useAddLibraryQuestionsToTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      questionIds: // value for 'questionIds'
 *   },
 * });
 */
export function useAddLibraryQuestionsToTaskMutation(baseOptions?: Apollo.MutationHookOptions<AddLibraryQuestionsToTaskMutation, AddLibraryQuestionsToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLibraryQuestionsToTaskMutation, AddLibraryQuestionsToTaskMutationVariables>(AddLibraryQuestionsToTaskDocument, options);
      }
export type AddLibraryQuestionsToTaskMutationHookResult = ReturnType<typeof useAddLibraryQuestionsToTaskMutation>;
export type AddLibraryQuestionsToTaskMutationResult = Apollo.MutationResult<AddLibraryQuestionsToTaskMutation>;
export type AddLibraryQuestionsToTaskMutationOptions = Apollo.BaseMutationOptions<AddLibraryQuestionsToTaskMutation, AddLibraryQuestionsToTaskMutationVariables>;
export const AddQuestionBanksToAssessmentDocument = gql`
    mutation AddQuestionBanksToAssessment($taskId: ID!, $assessmentId: ID!, $input: [AddQuestionBanksToAssessmentInput!]!) {
  addQuestionBanksToAssessment(
    taskId: $taskId
    assessmentId: $assessmentId
    input: $input
  ) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type AddQuestionBanksToAssessmentMutationFn = Apollo.MutationFunction<AddQuestionBanksToAssessmentMutation, AddQuestionBanksToAssessmentMutationVariables>;

/**
 * __useAddQuestionBanksToAssessmentMutation__
 *
 * To run a mutation, you first call `useAddQuestionBanksToAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionBanksToAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionBanksToAssessmentMutation, { data, loading, error }] = useAddQuestionBanksToAssessmentMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQuestionBanksToAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<AddQuestionBanksToAssessmentMutation, AddQuestionBanksToAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuestionBanksToAssessmentMutation, AddQuestionBanksToAssessmentMutationVariables>(AddQuestionBanksToAssessmentDocument, options);
      }
export type AddQuestionBanksToAssessmentMutationHookResult = ReturnType<typeof useAddQuestionBanksToAssessmentMutation>;
export type AddQuestionBanksToAssessmentMutationResult = Apollo.MutationResult<AddQuestionBanksToAssessmentMutation>;
export type AddQuestionBanksToAssessmentMutationOptions = Apollo.BaseMutationOptions<AddQuestionBanksToAssessmentMutation, AddQuestionBanksToAssessmentMutationVariables>;
export const AddQuestionSelectionToTaskDocument = gql`
    mutation AddQuestionSelectionToTask($taskId: ID!, $questionSelectionId: ID!) {
  addQuestionSelectionToTask(
    taskId: $taskId
    questionSelectionId: $questionSelectionId
  ) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type AddQuestionSelectionToTaskMutationFn = Apollo.MutationFunction<AddQuestionSelectionToTaskMutation, AddQuestionSelectionToTaskMutationVariables>;

/**
 * __useAddQuestionSelectionToTaskMutation__
 *
 * To run a mutation, you first call `useAddQuestionSelectionToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQuestionSelectionToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQuestionSelectionToTaskMutation, { data, loading, error }] = useAddQuestionSelectionToTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      questionSelectionId: // value for 'questionSelectionId'
 *   },
 * });
 */
export function useAddQuestionSelectionToTaskMutation(baseOptions?: Apollo.MutationHookOptions<AddQuestionSelectionToTaskMutation, AddQuestionSelectionToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQuestionSelectionToTaskMutation, AddQuestionSelectionToTaskMutationVariables>(AddQuestionSelectionToTaskDocument, options);
      }
export type AddQuestionSelectionToTaskMutationHookResult = ReturnType<typeof useAddQuestionSelectionToTaskMutation>;
export type AddQuestionSelectionToTaskMutationResult = Apollo.MutationResult<AddQuestionSelectionToTaskMutation>;
export type AddQuestionSelectionToTaskMutationOptions = Apollo.BaseMutationOptions<AddQuestionSelectionToTaskMutation, AddQuestionSelectionToTaskMutationVariables>;
export const AssessmentAccessCodesDocument = gql`
    query AssessmentAccessCodes($assessmentId: ID!) {
  assessmentAccessCodes(assessmentId: $assessmentId) {
    ...AccessCode
  }
}
    ${AccessCodeFragmentDoc}`;

/**
 * __useAssessmentAccessCodesQuery__
 *
 * To run a query within a React component, call `useAssessmentAccessCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentAccessCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentAccessCodesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentAccessCodesQuery(baseOptions: Apollo.QueryHookOptions<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables> & ({ variables: AssessmentAccessCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>(AssessmentAccessCodesDocument, options);
      }
export function useAssessmentAccessCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>(AssessmentAccessCodesDocument, options);
        }
export function useAssessmentAccessCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>(AssessmentAccessCodesDocument, options);
        }
export type AssessmentAccessCodesQueryHookResult = ReturnType<typeof useAssessmentAccessCodesQuery>;
export type AssessmentAccessCodesLazyQueryHookResult = ReturnType<typeof useAssessmentAccessCodesLazyQuery>;
export type AssessmentAccessCodesSuspenseQueryHookResult = ReturnType<typeof useAssessmentAccessCodesSuspenseQuery>;
export type AssessmentAccessCodesQueryResult = Apollo.QueryResult<AssessmentAccessCodesQuery, AssessmentAccessCodesQueryVariables>;
export const AssessmentSettingsDocument = gql`
    subscription AssessmentSettings($assessmentId: ID!) {
  assessmentSettings(assessmentId: $assessmentId) {
    ...AssessmentSettings
  }
}
    ${AssessmentSettingsFragmentDoc}`;

/**
 * __useAssessmentSettingsSubscription__
 *
 * To run a query within a React component, call `useAssessmentSettingsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentSettingsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentSettingsSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentSettingsSubscription(baseOptions: Apollo.SubscriptionHookOptions<AssessmentSettingsSubscription, AssessmentSettingsSubscriptionVariables> & ({ variables: AssessmentSettingsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AssessmentSettingsSubscription, AssessmentSettingsSubscriptionVariables>(AssessmentSettingsDocument, options);
      }
export type AssessmentSettingsSubscriptionHookResult = ReturnType<typeof useAssessmentSettingsSubscription>;
export type AssessmentSettingsSubscriptionResult = Apollo.SubscriptionResult<AssessmentSettingsSubscription>;
export const CancelReleaseDocument = gql`
    mutation CancelRelease($assessmentId: ID!, $sheetId: ID!) {
  cancelRelease(assessmentId: $assessmentId, sheetId: $sheetId) {
    task {
      ...TaskStatus
    }
  }
}
    ${TaskStatusFragmentDoc}`;
export type CancelReleaseMutationFn = Apollo.MutationFunction<CancelReleaseMutation, CancelReleaseMutationVariables>;

/**
 * __useCancelReleaseMutation__
 *
 * To run a mutation, you first call `useCancelReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReleaseMutation, { data, loading, error }] = useCancelReleaseMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function useCancelReleaseMutation(baseOptions?: Apollo.MutationHookOptions<CancelReleaseMutation, CancelReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReleaseMutation, CancelReleaseMutationVariables>(CancelReleaseDocument, options);
      }
export type CancelReleaseMutationHookResult = ReturnType<typeof useCancelReleaseMutation>;
export type CancelReleaseMutationResult = Apollo.MutationResult<CancelReleaseMutation>;
export type CancelReleaseMutationOptions = Apollo.BaseMutationOptions<CancelReleaseMutation, CancelReleaseMutationVariables>;
export const CreatePrintArchiveDocument = gql`
    mutation CreatePrintArchive($taskId: ID!, $input: PrintArchiveInput!) {
  createPrintArchive(taskId: $taskId, input: $input)
}
    `;
export type CreatePrintArchiveMutationFn = Apollo.MutationFunction<CreatePrintArchiveMutation, CreatePrintArchiveMutationVariables>;

/**
 * __useCreatePrintArchiveMutation__
 *
 * To run a mutation, you first call `useCreatePrintArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrintArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrintArchiveMutation, { data, loading, error }] = useCreatePrintArchiveMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrintArchiveMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrintArchiveMutation, CreatePrintArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrintArchiveMutation, CreatePrintArchiveMutationVariables>(CreatePrintArchiveDocument, options);
      }
export type CreatePrintArchiveMutationHookResult = ReturnType<typeof useCreatePrintArchiveMutation>;
export type CreatePrintArchiveMutationResult = Apollo.MutationResult<CreatePrintArchiveMutation>;
export type CreatePrintArchiveMutationOptions = Apollo.BaseMutationOptions<CreatePrintArchiveMutation, CreatePrintArchiveMutationVariables>;
export const CreateResourceDocument = gql`
    mutation CreateResource($assessmentId: ID!, $taskId: ID, $url: String!, $name: String!, $mediaId: ID) {
  createResource(
    assessmentId: $assessmentId
    taskId: $taskId
    url: $url
    name: $name
    mediaId: $mediaId
  ) {
    ...Resource
  }
}
    ${ResourceFragmentDoc}`;
export type CreateResourceMutationFn = Apollo.MutationFunction<CreateResourceMutation, CreateResourceMutationVariables>;

/**
 * __useCreateResourceMutation__
 *
 * To run a mutation, you first call `useCreateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceMutation, { data, loading, error }] = useCreateResourceMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskId: // value for 'taskId'
 *      url: // value for 'url'
 *      name: // value for 'name'
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useCreateResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceMutation, CreateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceMutation, CreateResourceMutationVariables>(CreateResourceDocument, options);
      }
export type CreateResourceMutationHookResult = ReturnType<typeof useCreateResourceMutation>;
export type CreateResourceMutationResult = Apollo.MutationResult<CreateResourceMutation>;
export type CreateResourceMutationOptions = Apollo.BaseMutationOptions<CreateResourceMutation, CreateResourceMutationVariables>;
export const CreateTaskBlockDocument = gql`
    mutation CreateTaskBlock($taskId: ID!, $input: CreateTaskBlockInput!) {
  createTaskBlock(taskId: $taskId, input: $input) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type CreateTaskBlockMutationFn = Apollo.MutationFunction<CreateTaskBlockMutation, CreateTaskBlockMutationVariables>;

/**
 * __useCreateTaskBlockMutation__
 *
 * To run a mutation, you first call `useCreateTaskBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskBlockMutation, { data, loading, error }] = useCreateTaskBlockMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskBlockMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskBlockMutation, CreateTaskBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskBlockMutation, CreateTaskBlockMutationVariables>(CreateTaskBlockDocument, options);
      }
export type CreateTaskBlockMutationHookResult = ReturnType<typeof useCreateTaskBlockMutation>;
export type CreateTaskBlockMutationResult = Apollo.MutationResult<CreateTaskBlockMutation>;
export type CreateTaskBlockMutationOptions = Apollo.BaseMutationOptions<CreateTaskBlockMutation, CreateTaskBlockMutationVariables>;
export const CreateTaskSaveDocument = gql`
    mutation CreateTaskSave($assessmentId: ID!, $content: String!, $editor: EditorType, $taskId: ID) {
  createTaskSave(
    assessmentId: $assessmentId
    content: $content
    editor: $editor
    taskId: $taskId
  ) {
    id
    serverId
    version
    rawContent
  }
}
    `;
export type CreateTaskSaveMutationFn = Apollo.MutationFunction<CreateTaskSaveMutation, CreateTaskSaveMutationVariables>;

/**
 * __useCreateTaskSaveMutation__
 *
 * To run a mutation, you first call `useCreateTaskSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskSaveMutation, { data, loading, error }] = useCreateTaskSaveMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      content: // value for 'content'
 *      editor: // value for 'editor'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCreateTaskSaveMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskSaveMutation, CreateTaskSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskSaveMutation, CreateTaskSaveMutationVariables>(CreateTaskSaveDocument, options);
      }
export type CreateTaskSaveMutationHookResult = ReturnType<typeof useCreateTaskSaveMutation>;
export type CreateTaskSaveMutationResult = Apollo.MutationResult<CreateTaskSaveMutation>;
export type CreateTaskSaveMutationOptions = Apollo.BaseMutationOptions<CreateTaskSaveMutation, CreateTaskSaveMutationVariables>;
export const DeleteResourceDocument = gql`
    mutation DeleteResource($id: ID!) {
  deleteResource(id: $id) {
    id
    invalidated
  }
}
    `;
export type DeleteResourceMutationFn = Apollo.MutationFunction<DeleteResourceMutation, DeleteResourceMutationVariables>;

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceMutation, DeleteResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceMutation, DeleteResourceMutationVariables>(DeleteResourceDocument, options);
      }
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>;
export type DeleteResourceMutationResult = Apollo.MutationResult<DeleteResourceMutation>;
export type DeleteResourceMutationOptions = Apollo.BaseMutationOptions<DeleteResourceMutation, DeleteResourceMutationVariables>;
export const DuplicateTaskBlockDocument = gql`
    mutation DuplicateTaskBlock($taskBlockId: ID!) {
  duplicateTaskBlock(taskBlockId: $taskBlockId) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type DuplicateTaskBlockMutationFn = Apollo.MutationFunction<DuplicateTaskBlockMutation, DuplicateTaskBlockMutationVariables>;

/**
 * __useDuplicateTaskBlockMutation__
 *
 * To run a mutation, you first call `useDuplicateTaskBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTaskBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTaskBlockMutation, { data, loading, error }] = useDuplicateTaskBlockMutation({
 *   variables: {
 *      taskBlockId: // value for 'taskBlockId'
 *   },
 * });
 */
export function useDuplicateTaskBlockMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateTaskBlockMutation, DuplicateTaskBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateTaskBlockMutation, DuplicateTaskBlockMutationVariables>(DuplicateTaskBlockDocument, options);
      }
export type DuplicateTaskBlockMutationHookResult = ReturnType<typeof useDuplicateTaskBlockMutation>;
export type DuplicateTaskBlockMutationResult = Apollo.MutationResult<DuplicateTaskBlockMutation>;
export type DuplicateTaskBlockMutationOptions = Apollo.BaseMutationOptions<DuplicateTaskBlockMutation, DuplicateTaskBlockMutationVariables>;
export const EditTaskDocument = gql`
    mutation EditTask($assessmentId: ID!) {
  editTask(assessmentId: $assessmentId) {
    ...TaskStatus
  }
}
    ${TaskStatusFragmentDoc}`;
export type EditTaskMutationFn = Apollo.MutationFunction<EditTaskMutation, EditTaskMutationVariables>;

/**
 * __useEditTaskMutation__
 *
 * To run a mutation, you first call `useEditTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskMutation, { data, loading, error }] = useEditTaskMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useEditTaskMutation(baseOptions?: Apollo.MutationHookOptions<EditTaskMutation, EditTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTaskMutation, EditTaskMutationVariables>(EditTaskDocument, options);
      }
export type EditTaskMutationHookResult = ReturnType<typeof useEditTaskMutation>;
export type EditTaskMutationResult = Apollo.MutationResult<EditTaskMutation>;
export type EditTaskMutationOptions = Apollo.BaseMutationOptions<EditTaskMutation, EditTaskMutationVariables>;
export const EditTaskV2Document = gql`
    mutation EditTaskV2($taskId: ID!) {
  editTaskV2(taskId: $taskId) {
    ...HubTask
  }
}
    ${HubTaskFragmentDoc}`;
export type EditTaskV2MutationFn = Apollo.MutationFunction<EditTaskV2Mutation, EditTaskV2MutationVariables>;

/**
 * __useEditTaskV2Mutation__
 *
 * To run a mutation, you first call `useEditTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskV2Mutation, { data, loading, error }] = useEditTaskV2Mutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useEditTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<EditTaskV2Mutation, EditTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTaskV2Mutation, EditTaskV2MutationVariables>(EditTaskV2Document, options);
      }
export type EditTaskV2MutationHookResult = ReturnType<typeof useEditTaskV2Mutation>;
export type EditTaskV2MutationResult = Apollo.MutationResult<EditTaskV2Mutation>;
export type EditTaskV2MutationOptions = Apollo.BaseMutationOptions<EditTaskV2Mutation, EditTaskV2MutationVariables>;
export const GenerateReportDocument = gql`
    mutation GenerateReport($kind: String!, $assessmentId: ID!, $workId: ID, $anonymousName: String) {
  generateReport(
    kind: $kind
    assessmentId: $assessmentId
    workId: $workId
    anonymousName: $anonymousName
  ) {
    id
    assessmentId
    conflict
    resultUrl
    insertedAt
  }
}
    `;
export type GenerateReportMutationFn = Apollo.MutationFunction<GenerateReportMutation, GenerateReportMutationVariables>;

/**
 * __useGenerateReportMutation__
 *
 * To run a mutation, you first call `useGenerateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportMutation, { data, loading, error }] = useGenerateReportMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      assessmentId: // value for 'assessmentId'
 *      workId: // value for 'workId'
 *      anonymousName: // value for 'anonymousName'
 *   },
 * });
 */
export function useGenerateReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportMutation, GenerateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportMutation, GenerateReportMutationVariables>(GenerateReportDocument, options);
      }
export type GenerateReportMutationHookResult = ReturnType<typeof useGenerateReportMutation>;
export type GenerateReportMutationResult = Apollo.MutationResult<GenerateReportMutation>;
export type GenerateReportMutationOptions = Apollo.BaseMutationOptions<GenerateReportMutation, GenerateReportMutationVariables>;
export const HasSubmissionDocument = gql`
    subscription HasSubmission($assessmentId: ID!) {
  hasSubmission(assessmentId: $assessmentId)
}
    `;

/**
 * __useHasSubmissionSubscription__
 *
 * To run a query within a React component, call `useHasSubmissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHasSubmissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSubmissionSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useHasSubmissionSubscription(baseOptions: Apollo.SubscriptionHookOptions<HasSubmissionSubscription, HasSubmissionSubscriptionVariables> & ({ variables: HasSubmissionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HasSubmissionSubscription, HasSubmissionSubscriptionVariables>(HasSubmissionDocument, options);
      }
export type HasSubmissionSubscriptionHookResult = ReturnType<typeof useHasSubmissionSubscription>;
export type HasSubmissionSubscriptionResult = Apollo.SubscriptionResult<HasSubmissionSubscription>;
export const ImportLibraryQuestionDocument = gql`
    mutation ImportLibraryQuestion($input: ImportLibraryQuestionInput!) {
  importLibraryQuestion(input: $input) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type ImportLibraryQuestionMutationFn = Apollo.MutationFunction<ImportLibraryQuestionMutation, ImportLibraryQuestionMutationVariables>;

/**
 * __useImportLibraryQuestionMutation__
 *
 * To run a mutation, you first call `useImportLibraryQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLibraryQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLibraryQuestionMutation, { data, loading, error }] = useImportLibraryQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportLibraryQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ImportLibraryQuestionMutation, ImportLibraryQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportLibraryQuestionMutation, ImportLibraryQuestionMutationVariables>(ImportLibraryQuestionDocument, options);
      }
export type ImportLibraryQuestionMutationHookResult = ReturnType<typeof useImportLibraryQuestionMutation>;
export type ImportLibraryQuestionMutationResult = Apollo.MutationResult<ImportLibraryQuestionMutation>;
export type ImportLibraryQuestionMutationOptions = Apollo.BaseMutationOptions<ImportLibraryQuestionMutation, ImportLibraryQuestionMutationVariables>;
export const InstructionSheetDocument = gql`
    query InstructionSheet($assessmentId: ID!, $taskId: ID, $taskKind: TaskKind) {
  assessment(assessmentId: $assessmentId) {
    name
    settings {
      ...AssessmentSettings
    }
  }
  task(assessmentId: $assessmentId, taskId: $taskId) {
    ...Task
  }
  instructionSheet(assessmentId: $assessmentId, kind: $taskKind) {
    ...InstructionSheet
  }
  futureSheet(assessmentId: $assessmentId, kind: $taskKind) {
    ...InstructionSheetWithRequirements
  }
}
    ${AssessmentSettingsFragmentDoc}
${TaskFragmentDoc}
${InstructionSheetFragmentDoc}
${InstructionSheetWithRequirementsFragmentDoc}`;

/**
 * __useInstructionSheetQuery__
 *
 * To run a query within a React component, call `useInstructionSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstructionSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstructionSheetQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskId: // value for 'taskId'
 *      taskKind: // value for 'taskKind'
 *   },
 * });
 */
export function useInstructionSheetQuery(baseOptions: Apollo.QueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables> & ({ variables: InstructionSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
      }
export function useInstructionSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
        }
export function useInstructionSheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InstructionSheetQuery, InstructionSheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InstructionSheetQuery, InstructionSheetQueryVariables>(InstructionSheetDocument, options);
        }
export type InstructionSheetQueryHookResult = ReturnType<typeof useInstructionSheetQuery>;
export type InstructionSheetLazyQueryHookResult = ReturnType<typeof useInstructionSheetLazyQuery>;
export type InstructionSheetSuspenseQueryHookResult = ReturnType<typeof useInstructionSheetSuspenseQuery>;
export type InstructionSheetQueryResult = Apollo.QueryResult<InstructionSheetQuery, InstructionSheetQueryVariables>;
export const PrintArchiveUrlDocument = gql`
    query PrintArchiveUrl($taskId: ID!, $archiveId: ID!) {
  printArchiveUrl(taskId: $taskId, archiveId: $archiveId)
}
    `;

/**
 * __usePrintArchiveUrlQuery__
 *
 * To run a query within a React component, call `usePrintArchiveUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintArchiveUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintArchiveUrlQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      archiveId: // value for 'archiveId'
 *   },
 * });
 */
export function usePrintArchiveUrlQuery(baseOptions: Apollo.QueryHookOptions<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables> & ({ variables: PrintArchiveUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>(PrintArchiveUrlDocument, options);
      }
export function usePrintArchiveUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>(PrintArchiveUrlDocument, options);
        }
export function usePrintArchiveUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>(PrintArchiveUrlDocument, options);
        }
export type PrintArchiveUrlQueryHookResult = ReturnType<typeof usePrintArchiveUrlQuery>;
export type PrintArchiveUrlLazyQueryHookResult = ReturnType<typeof usePrintArchiveUrlLazyQuery>;
export type PrintArchiveUrlSuspenseQueryHookResult = ReturnType<typeof usePrintArchiveUrlSuspenseQuery>;
export type PrintArchiveUrlQueryResult = Apollo.QueryResult<PrintArchiveUrlQuery, PrintArchiveUrlQueryVariables>;
export const CreateFileOriginDocument = gql`
    mutation CreateFileOrigin($input: CreateQuestionBankFileOriginInput!) {
  createFileOrigin(input: $input) {
    ...QuestionBankFileOrigin
  }
}
    ${QuestionBankFileOriginFragmentDoc}`;
export type CreateFileOriginMutationFn = Apollo.MutationFunction<CreateFileOriginMutation, CreateFileOriginMutationVariables>;

/**
 * __useCreateFileOriginMutation__
 *
 * To run a mutation, you first call `useCreateFileOriginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileOriginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileOriginMutation, { data, loading, error }] = useCreateFileOriginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileOriginMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileOriginMutation, CreateFileOriginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileOriginMutation, CreateFileOriginMutationVariables>(CreateFileOriginDocument, options);
      }
export type CreateFileOriginMutationHookResult = ReturnType<typeof useCreateFileOriginMutation>;
export type CreateFileOriginMutationResult = Apollo.MutationResult<CreateFileOriginMutation>;
export type CreateFileOriginMutationOptions = Apollo.BaseMutationOptions<CreateFileOriginMutation, CreateFileOriginMutationVariables>;
export const CreateQuestionBankDocument = gql`
    mutation CreateQuestionBank($questionBank: CreateQuestionBankInput!) {
  createQuestionBank(questionBank: $questionBank) {
    ...QuestionBank
  }
}
    ${QuestionBankFragmentDoc}`;
export type CreateQuestionBankMutationFn = Apollo.MutationFunction<CreateQuestionBankMutation, CreateQuestionBankMutationVariables>;

/**
 * __useCreateQuestionBankMutation__
 *
 * To run a mutation, you first call `useCreateQuestionBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionBankMutation, { data, loading, error }] = useCreateQuestionBankMutation({
 *   variables: {
 *      questionBank: // value for 'questionBank'
 *   },
 * });
 */
export function useCreateQuestionBankMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionBankMutation, CreateQuestionBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionBankMutation, CreateQuestionBankMutationVariables>(CreateQuestionBankDocument, options);
      }
export type CreateQuestionBankMutationHookResult = ReturnType<typeof useCreateQuestionBankMutation>;
export type CreateQuestionBankMutationResult = Apollo.MutationResult<CreateQuestionBankMutation>;
export type CreateQuestionBankMutationOptions = Apollo.BaseMutationOptions<CreateQuestionBankMutation, CreateQuestionBankMutationVariables>;
export const UpdateFileOriginDocument = gql`
    mutation UpdateFileOrigin($input: UpdateQuestionBankFileOriginInput!) {
  updateFileOrigin(input: $input) {
    ...QuestionBankFileOrigin
  }
}
    ${QuestionBankFileOriginFragmentDoc}`;
export type UpdateFileOriginMutationFn = Apollo.MutationFunction<UpdateFileOriginMutation, UpdateFileOriginMutationVariables>;

/**
 * __useUpdateFileOriginMutation__
 *
 * To run a mutation, you first call `useUpdateFileOriginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileOriginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileOriginMutation, { data, loading, error }] = useUpdateFileOriginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileOriginMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileOriginMutation, UpdateFileOriginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileOriginMutation, UpdateFileOriginMutationVariables>(UpdateFileOriginDocument, options);
      }
export type UpdateFileOriginMutationHookResult = ReturnType<typeof useUpdateFileOriginMutation>;
export type UpdateFileOriginMutationResult = Apollo.MutationResult<UpdateFileOriginMutation>;
export type UpdateFileOriginMutationOptions = Apollo.BaseMutationOptions<UpdateFileOriginMutation, UpdateFileOriginMutationVariables>;
export const UpdateQuestionBanksCategoryDocument = gql`
    mutation UpdateQuestionBanksCategory($input: UpdateQuestionBanksCategoryInput!) {
  updateQuestionBanksCategory(input: $input) {
    ...QuestionBank
  }
}
    ${QuestionBankFragmentDoc}`;
export type UpdateQuestionBanksCategoryMutationFn = Apollo.MutationFunction<UpdateQuestionBanksCategoryMutation, UpdateQuestionBanksCategoryMutationVariables>;

/**
 * __useUpdateQuestionBanksCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionBanksCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionBanksCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionBanksCategoryMutation, { data, loading, error }] = useUpdateQuestionBanksCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionBanksCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionBanksCategoryMutation, UpdateQuestionBanksCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionBanksCategoryMutation, UpdateQuestionBanksCategoryMutationVariables>(UpdateQuestionBanksCategoryDocument, options);
      }
export type UpdateQuestionBanksCategoryMutationHookResult = ReturnType<typeof useUpdateQuestionBanksCategoryMutation>;
export type UpdateQuestionBanksCategoryMutationResult = Apollo.MutationResult<UpdateQuestionBanksCategoryMutation>;
export type UpdateQuestionBanksCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionBanksCategoryMutation, UpdateQuestionBanksCategoryMutationVariables>;
export const QuestionTreeDocument = gql`
    query QuestionTree($assessmentId: ID!, $taskId: ID!, $input: [QuestionSelectionFilterInput!]!) {
  assessment(assessmentId: $assessmentId) {
    id
    name
  }
  questionTree(taskId: $taskId, selectionInput: $input) {
    ...QuestionBlock
  }
}
    ${QuestionBlockFragmentDoc}`;

/**
 * __useQuestionTreeQuery__
 *
 * To run a query within a React component, call `useQuestionTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionTreeQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuestionTreeQuery(baseOptions: Apollo.QueryHookOptions<QuestionTreeQuery, QuestionTreeQueryVariables> & ({ variables: QuestionTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionTreeQuery, QuestionTreeQueryVariables>(QuestionTreeDocument, options);
      }
export function useQuestionTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionTreeQuery, QuestionTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionTreeQuery, QuestionTreeQueryVariables>(QuestionTreeDocument, options);
        }
export function useQuestionTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionTreeQuery, QuestionTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionTreeQuery, QuestionTreeQueryVariables>(QuestionTreeDocument, options);
        }
export type QuestionTreeQueryHookResult = ReturnType<typeof useQuestionTreeQuery>;
export type QuestionTreeLazyQueryHookResult = ReturnType<typeof useQuestionTreeLazyQuery>;
export type QuestionTreeSuspenseQueryHookResult = ReturnType<typeof useQuestionTreeSuspenseQuery>;
export type QuestionTreeQueryResult = Apollo.QueryResult<QuestionTreeQuery, QuestionTreeQueryVariables>;
export const ReleaseTaskDocument = gql`
    mutation ReleaseTask($assessmentId: ID!, $saveId: ID!, $scheduleTimestamp: DateTime) {
  releaseTask(
    assessmentId: $assessmentId
    saveId: $saveId
    scheduleTimestamp: $scheduleTimestamp
  ) {
    ...InstructionSheetWithRequirements
  }
}
    ${InstructionSheetWithRequirementsFragmentDoc}`;
export type ReleaseTaskMutationFn = Apollo.MutationFunction<ReleaseTaskMutation, ReleaseTaskMutationVariables>;

/**
 * __useReleaseTaskMutation__
 *
 * To run a mutation, you first call `useReleaseTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseTaskMutation, { data, loading, error }] = useReleaseTaskMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      saveId: // value for 'saveId'
 *      scheduleTimestamp: // value for 'scheduleTimestamp'
 *   },
 * });
 */
export function useReleaseTaskMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseTaskMutation, ReleaseTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseTaskMutation, ReleaseTaskMutationVariables>(ReleaseTaskDocument, options);
      }
export type ReleaseTaskMutationHookResult = ReturnType<typeof useReleaseTaskMutation>;
export type ReleaseTaskMutationResult = Apollo.MutationResult<ReleaseTaskMutation>;
export type ReleaseTaskMutationOptions = Apollo.BaseMutationOptions<ReleaseTaskMutation, ReleaseTaskMutationVariables>;
export const SaveQuestionStateDocument = gql`
    mutation SaveQuestionState($questionId: ID!, $input: SaveQuestionStateInput!) {
  saveQuestionState(questionId: $questionId, input: $input) {
    ...Question
  }
}
    ${QuestionFragmentDoc}`;
export type SaveQuestionStateMutationFn = Apollo.MutationFunction<SaveQuestionStateMutation, SaveQuestionStateMutationVariables>;

/**
 * __useSaveQuestionStateMutation__
 *
 * To run a mutation, you first call `useSaveQuestionStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuestionStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuestionStateMutation, { data, loading, error }] = useSaveQuestionStateMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQuestionStateMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuestionStateMutation, SaveQuestionStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuestionStateMutation, SaveQuestionStateMutationVariables>(SaveQuestionStateDocument, options);
      }
export type SaveQuestionStateMutationHookResult = ReturnType<typeof useSaveQuestionStateMutation>;
export type SaveQuestionStateMutationResult = Apollo.MutationResult<SaveQuestionStateMutation>;
export type SaveQuestionStateMutationOptions = Apollo.BaseMutationOptions<SaveQuestionStateMutation, SaveQuestionStateMutationVariables>;
export const SetupAccessCodeDocument = gql`
    mutation SetupAccessCode($input: AccessCodeInput!, $assessmentId: ID!) {
  setupAccessCode(input: $input, assessmentId: $assessmentId) {
    ...AccessCode
  }
}
    ${AccessCodeFragmentDoc}`;
export type SetupAccessCodeMutationFn = Apollo.MutationFunction<SetupAccessCodeMutation, SetupAccessCodeMutationVariables>;

/**
 * __useSetupAccessCodeMutation__
 *
 * To run a mutation, you first call `useSetupAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupAccessCodeMutation, { data, loading, error }] = useSetupAccessCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useSetupAccessCodeMutation(baseOptions?: Apollo.MutationHookOptions<SetupAccessCodeMutation, SetupAccessCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupAccessCodeMutation, SetupAccessCodeMutationVariables>(SetupAccessCodeDocument, options);
      }
export type SetupAccessCodeMutationHookResult = ReturnType<typeof useSetupAccessCodeMutation>;
export type SetupAccessCodeMutationResult = Apollo.MutationResult<SetupAccessCodeMutation>;
export type SetupAccessCodeMutationOptions = Apollo.BaseMutationOptions<SetupAccessCodeMutation, SetupAccessCodeMutationVariables>;
export const SetupTaskDocument = gql`
    mutation SetupTask($assessmentId: ID!, $kind: TaskKind!) {
  setupTask(assessmentId: $assessmentId, kind: $kind) {
    ...HubTask
  }
}
    ${HubTaskFragmentDoc}`;
export type SetupTaskMutationFn = Apollo.MutationFunction<SetupTaskMutation, SetupTaskMutationVariables>;

/**
 * __useSetupTaskMutation__
 *
 * To run a mutation, you first call `useSetupTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupTaskMutation, { data, loading, error }] = useSetupTaskMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useSetupTaskMutation(baseOptions?: Apollo.MutationHookOptions<SetupTaskMutation, SetupTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupTaskMutation, SetupTaskMutationVariables>(SetupTaskDocument, options);
      }
export type SetupTaskMutationHookResult = ReturnType<typeof useSetupTaskMutation>;
export type SetupTaskMutationResult = Apollo.MutationResult<SetupTaskMutation>;
export type SetupTaskMutationOptions = Apollo.BaseMutationOptions<SetupTaskMutation, SetupTaskMutationVariables>;
export const SheetReleasedDocument = gql`
    subscription SheetReleased($assessmentId: ID!) {
  sheetReleased(assessmentId: $assessmentId) {
    ...InstructionSheet
  }
}
    ${InstructionSheetFragmentDoc}`;

/**
 * __useSheetReleasedSubscription__
 *
 * To run a query within a React component, call `useSheetReleasedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSheetReleasedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSheetReleasedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useSheetReleasedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SheetReleasedSubscription, SheetReleasedSubscriptionVariables> & ({ variables: SheetReleasedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SheetReleasedSubscription, SheetReleasedSubscriptionVariables>(SheetReleasedDocument, options);
      }
export type SheetReleasedSubscriptionHookResult = ReturnType<typeof useSheetReleasedSubscription>;
export type SheetReleasedSubscriptionResult = Apollo.SubscriptionResult<SheetReleasedSubscription>;
export const SwapResourceDocument = gql`
    mutation SwapResource($id: ID!, $swapId: ID!) {
  swapResource(firstId: $id, secondId: $swapId)
}
    `;
export type SwapResourceMutationFn = Apollo.MutationFunction<SwapResourceMutation, SwapResourceMutationVariables>;

/**
 * __useSwapResourceMutation__
 *
 * To run a mutation, you first call `useSwapResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapResourceMutation, { data, loading, error }] = useSwapResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      swapId: // value for 'swapId'
 *   },
 * });
 */
export function useSwapResourceMutation(baseOptions?: Apollo.MutationHookOptions<SwapResourceMutation, SwapResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwapResourceMutation, SwapResourceMutationVariables>(SwapResourceDocument, options);
      }
export type SwapResourceMutationHookResult = ReturnType<typeof useSwapResourceMutation>;
export type SwapResourceMutationResult = Apollo.MutationResult<SwapResourceMutation>;
export type SwapResourceMutationOptions = Apollo.BaseMutationOptions<SwapResourceMutation, SwapResourceMutationVariables>;
export const TaskDocument = gql`
    query Task($assessmentId: ID!, $taskId: ID) {
  token
  me {
    ...User
  }
  institution {
    ...Institution
  }
  featureFlags(assessmentId: $assessmentId) {
    ...FeatureFlags
  }
  assessment(assessmentId: $assessmentId) {
    ...Assessment
  }
  class(assessmentId: $assessmentId) {
    id
    students {
      ...GroupEnrollment
    }
    groups {
      ...Group
    }
  }
  task(assessmentId: $assessmentId, taskId: $taskId) {
    ...Task
  }
  instructionSheet(assessmentId: $assessmentId) {
    ...InstructionSheet
  }
  futureSheet(assessmentId: $assessmentId) {
    ...InstructionSheetWithRequirements
  }
  userSettings(assessmentId: $assessmentId) {
    ...UserSettings
  }
}
    ${UserFragmentDoc}
${InstitutionFragmentDoc}
${FeatureFlagsFragmentDoc}
${AssessmentFragmentDoc}
${GroupEnrollmentFragmentDoc}
${GroupFragmentDoc}
${TaskFragmentDoc}
${InstructionSheetFragmentDoc}
${InstructionSheetWithRequirementsFragmentDoc}
${UserSettingsFragmentDoc}`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables> & ({ variables: TaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export function useTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskSuspenseQueryHookResult = ReturnType<typeof useTaskSuspenseQuery>;
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>;
export const UnlinkLibraryQuestionDocument = gql`
    mutation UnlinkLibraryQuestion($input: UnlinkLibraryQuestionInput!) {
  unlinkLibraryQuestion(input: $input) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type UnlinkLibraryQuestionMutationFn = Apollo.MutationFunction<UnlinkLibraryQuestionMutation, UnlinkLibraryQuestionMutationVariables>;

/**
 * __useUnlinkLibraryQuestionMutation__
 *
 * To run a mutation, you first call `useUnlinkLibraryQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkLibraryQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkLibraryQuestionMutation, { data, loading, error }] = useUnlinkLibraryQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkLibraryQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkLibraryQuestionMutation, UnlinkLibraryQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkLibraryQuestionMutation, UnlinkLibraryQuestionMutationVariables>(UnlinkLibraryQuestionDocument, options);
      }
export type UnlinkLibraryQuestionMutationHookResult = ReturnType<typeof useUnlinkLibraryQuestionMutation>;
export type UnlinkLibraryQuestionMutationResult = Apollo.MutationResult<UnlinkLibraryQuestionMutation>;
export type UnlinkLibraryQuestionMutationOptions = Apollo.BaseMutationOptions<UnlinkLibraryQuestionMutation, UnlinkLibraryQuestionMutationVariables>;
export const UpdateAssessmentNameDocument = gql`
    mutation UpdateAssessmentName($assessmentId: ID!, $name: String!) {
  updateAssessmentName(assessmentId: $assessmentId, name: $name) {
    id
    name
  }
}
    `;
export type UpdateAssessmentNameMutationFn = Apollo.MutationFunction<UpdateAssessmentNameMutation, UpdateAssessmentNameMutationVariables>;

/**
 * __useUpdateAssessmentNameMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentNameMutation, { data, loading, error }] = useUpdateAssessmentNameMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateAssessmentNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentNameMutation, UpdateAssessmentNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentNameMutation, UpdateAssessmentNameMutationVariables>(UpdateAssessmentNameDocument, options);
      }
export type UpdateAssessmentNameMutationHookResult = ReturnType<typeof useUpdateAssessmentNameMutation>;
export type UpdateAssessmentNameMutationResult = Apollo.MutationResult<UpdateAssessmentNameMutation>;
export type UpdateAssessmentNameMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentNameMutation, UpdateAssessmentNameMutationVariables>;
export const UpdateAssessmentSettingsDocument = gql`
    mutation UpdateAssessmentSettings($assessmentId: ID!, $input: AssessmentSettingsInput!) {
  updateAssessmentSettings(assessmentId: $assessmentId, input: $input) {
    ...Assessment
  }
}
    ${AssessmentFragmentDoc}`;
export type UpdateAssessmentSettingsMutationFn = Apollo.MutationFunction<UpdateAssessmentSettingsMutation, UpdateAssessmentSettingsMutationVariables>;

/**
 * __useUpdateAssessmentSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentSettingsMutation, { data, loading, error }] = useUpdateAssessmentSettingsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssessmentSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentSettingsMutation, UpdateAssessmentSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentSettingsMutation, UpdateAssessmentSettingsMutationVariables>(UpdateAssessmentSettingsDocument, options);
      }
export type UpdateAssessmentSettingsMutationHookResult = ReturnType<typeof useUpdateAssessmentSettingsMutation>;
export type UpdateAssessmentSettingsMutationResult = Apollo.MutationResult<UpdateAssessmentSettingsMutation>;
export type UpdateAssessmentSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentSettingsMutation, UpdateAssessmentSettingsMutationVariables>;
export const UpdateRequirementsDocument = gql`
    mutation UpdateRequirements($assessmentId: ID!, $requirements: RequirementsInput!) {
  updateRequirements(assessmentId: $assessmentId, requirements: $requirements) {
    ...Requirements
  }
}
    ${RequirementsFragmentDoc}`;
export type UpdateRequirementsMutationFn = Apollo.MutationFunction<UpdateRequirementsMutation, UpdateRequirementsMutationVariables>;

/**
 * __useUpdateRequirementsMutation__
 *
 * To run a mutation, you first call `useUpdateRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequirementsMutation, { data, loading, error }] = useUpdateRequirementsMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      requirements: // value for 'requirements'
 *   },
 * });
 */
export function useUpdateRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequirementsMutation, UpdateRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequirementsMutation, UpdateRequirementsMutationVariables>(UpdateRequirementsDocument, options);
      }
export type UpdateRequirementsMutationHookResult = ReturnType<typeof useUpdateRequirementsMutation>;
export type UpdateRequirementsMutationResult = Apollo.MutationResult<UpdateRequirementsMutation>;
export type UpdateRequirementsMutationOptions = Apollo.BaseMutationOptions<UpdateRequirementsMutation, UpdateRequirementsMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation UpdateResource($id: ID!, $name: String, $url: String, $notes: String) {
  updateResource(id: $id, name: $name, url: $url, notes: $notes) {
    ...Resource
  }
}
    ${ResourceFragmentDoc}`;
export type UpdateResourceMutationFn = Apollo.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const UpdateTaskBlockDocument = gql`
    mutation UpdateTaskBlock($taskBlockId: ID!, $input: UpdateTaskBlockInput!) {
  updateTaskBlock(taskBlockId: $taskBlockId, input: $input) {
    id
    points
    deleted
    hidden
    shuffle
  }
}
    `;
export type UpdateTaskBlockMutationFn = Apollo.MutationFunction<UpdateTaskBlockMutation, UpdateTaskBlockMutationVariables>;

/**
 * __useUpdateTaskBlockMutation__
 *
 * To run a mutation, you first call `useUpdateTaskBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskBlockMutation, { data, loading, error }] = useUpdateTaskBlockMutation({
 *   variables: {
 *      taskBlockId: // value for 'taskBlockId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskBlockMutation, UpdateTaskBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskBlockMutation, UpdateTaskBlockMutationVariables>(UpdateTaskBlockDocument, options);
      }
export type UpdateTaskBlockMutationHookResult = ReturnType<typeof useUpdateTaskBlockMutation>;
export type UpdateTaskBlockMutationResult = Apollo.MutationResult<UpdateTaskBlockMutation>;
export type UpdateTaskBlockMutationOptions = Apollo.BaseMutationOptions<UpdateTaskBlockMutation, UpdateTaskBlockMutationVariables>;
export const UpdateTaskBlocksDocument = gql`
    mutation UpdateTaskBlocks($taskBlocksList: [UpdateTaskBlocksInput!]!) {
  updateTaskBlocks(taskBlockList: $taskBlocksList) {
    ...TaskBlock
  }
}
    ${TaskBlockFragmentDoc}`;
export type UpdateTaskBlocksMutationFn = Apollo.MutationFunction<UpdateTaskBlocksMutation, UpdateTaskBlocksMutationVariables>;

/**
 * __useUpdateTaskBlocksMutation__
 *
 * To run a mutation, you first call `useUpdateTaskBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskBlocksMutation, { data, loading, error }] = useUpdateTaskBlocksMutation({
 *   variables: {
 *      taskBlocksList: // value for 'taskBlocksList'
 *   },
 * });
 */
export function useUpdateTaskBlocksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskBlocksMutation, UpdateTaskBlocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskBlocksMutation, UpdateTaskBlocksMutationVariables>(UpdateTaskBlocksDocument, options);
      }
export type UpdateTaskBlocksMutationHookResult = ReturnType<typeof useUpdateTaskBlocksMutation>;
export type UpdateTaskBlocksMutationResult = Apollo.MutationResult<UpdateTaskBlocksMutation>;
export type UpdateTaskBlocksMutationOptions = Apollo.BaseMutationOptions<UpdateTaskBlocksMutation, UpdateTaskBlocksMutationVariables>;
export const UpdateTaskFormatDocument = gql`
    mutation UpdateTaskFormat($taskId: ID!, $format: TaskFormat!) {
  updateTaskFormat(taskId: $taskId, format: $format) {
    id
    format
  }
}
    `;
export type UpdateTaskFormatMutationFn = Apollo.MutationFunction<UpdateTaskFormatMutation, UpdateTaskFormatMutationVariables>;

/**
 * __useUpdateTaskFormatMutation__
 *
 * To run a mutation, you first call `useUpdateTaskFormatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskFormatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskFormatMutation, { data, loading, error }] = useUpdateTaskFormatMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useUpdateTaskFormatMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskFormatMutation, UpdateTaskFormatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskFormatMutation, UpdateTaskFormatMutationVariables>(UpdateTaskFormatDocument, options);
      }
export type UpdateTaskFormatMutationHookResult = ReturnType<typeof useUpdateTaskFormatMutation>;
export type UpdateTaskFormatMutationResult = Apollo.MutationResult<UpdateTaskFormatMutation>;
export type UpdateTaskFormatMutationOptions = Apollo.BaseMutationOptions<UpdateTaskFormatMutation, UpdateTaskFormatMutationVariables>;
export const CopyAssessmentDocument = gql`
    mutation CopyAssessment($destinationAssessmentId: ID!, $sourceInstructionSheetId: ID!) {
  copyAssessment(
    destinationAssessmentId: $destinationAssessmentId
    sourceInstructionSheetId: $sourceInstructionSheetId
  ) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;
export type CopyAssessmentMutationFn = Apollo.MutationFunction<CopyAssessmentMutation, CopyAssessmentMutationVariables>;

/**
 * __useCopyAssessmentMutation__
 *
 * To run a mutation, you first call `useCopyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyAssessmentMutation, { data, loading, error }] = useCopyAssessmentMutation({
 *   variables: {
 *      destinationAssessmentId: // value for 'destinationAssessmentId'
 *      sourceInstructionSheetId: // value for 'sourceInstructionSheetId'
 *   },
 * });
 */
export function useCopyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<CopyAssessmentMutation, CopyAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyAssessmentMutation, CopyAssessmentMutationVariables>(CopyAssessmentDocument, options);
      }
export type CopyAssessmentMutationHookResult = ReturnType<typeof useCopyAssessmentMutation>;
export type CopyAssessmentMutationResult = Apollo.MutationResult<CopyAssessmentMutation>;
export type CopyAssessmentMutationOptions = Apollo.BaseMutationOptions<CopyAssessmentMutation, CopyAssessmentMutationVariables>;
export const PastAssessmentsDocument = gql`
    query PastAssessments {
  pastInstructionSheets {
    assessment {
      name
      id
      subject {
        ...Subject
      }
      settings {
        ...AssessmentSettings
      }
    }
    sheet {
      id
      serverId
      kind
      format
    }
  }
}
    ${SubjectFragmentDoc}
${AssessmentSettingsFragmentDoc}`;

/**
 * __usePastAssessmentsQuery__
 *
 * To run a query within a React component, call `usePastAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastAssessmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePastAssessmentsQuery(baseOptions?: Apollo.QueryHookOptions<PastAssessmentsQuery, PastAssessmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastAssessmentsQuery, PastAssessmentsQueryVariables>(PastAssessmentsDocument, options);
      }
export function usePastAssessmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastAssessmentsQuery, PastAssessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastAssessmentsQuery, PastAssessmentsQueryVariables>(PastAssessmentsDocument, options);
        }
export function usePastAssessmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastAssessmentsQuery, PastAssessmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PastAssessmentsQuery, PastAssessmentsQueryVariables>(PastAssessmentsDocument, options);
        }
export type PastAssessmentsQueryHookResult = ReturnType<typeof usePastAssessmentsQuery>;
export type PastAssessmentsLazyQueryHookResult = ReturnType<typeof usePastAssessmentsLazyQuery>;
export type PastAssessmentsSuspenseQueryHookResult = ReturnType<typeof usePastAssessmentsSuspenseQuery>;
export type PastAssessmentsQueryResult = Apollo.QueryResult<PastAssessmentsQuery, PastAssessmentsQueryVariables>;
export const PastInstructionSheetDocument = gql`
    query PastInstructionSheet($assessmentId: ID!, $sheetId: ID!) {
  instructionSheet(assessmentId: $assessmentId, sheetId: $sheetId) {
    ...InstructionSheet
  }
}
    ${InstructionSheetFragmentDoc}`;

/**
 * __usePastInstructionSheetQuery__
 *
 * To run a query within a React component, call `usePastInstructionSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePastInstructionSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePastInstructionSheetQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function usePastInstructionSheetQuery(baseOptions: Apollo.QueryHookOptions<PastInstructionSheetQuery, PastInstructionSheetQueryVariables> & ({ variables: PastInstructionSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>(PastInstructionSheetDocument, options);
      }
export function usePastInstructionSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>(PastInstructionSheetDocument, options);
        }
export function usePastInstructionSheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>(PastInstructionSheetDocument, options);
        }
export type PastInstructionSheetQueryHookResult = ReturnType<typeof usePastInstructionSheetQuery>;
export type PastInstructionSheetLazyQueryHookResult = ReturnType<typeof usePastInstructionSheetLazyQuery>;
export type PastInstructionSheetSuspenseQueryHookResult = ReturnType<typeof usePastInstructionSheetSuspenseQuery>;
export type PastInstructionSheetQueryResult = Apollo.QueryResult<PastInstructionSheetQuery, PastInstructionSheetQueryVariables>;